export default {
  // 酒店知识库独立语言块，保留原有语言内容。
  hotelKnowledge: {
    "title": "Basis pengetahuan hotel",
    "tip": "Kelola pertanyaan dan jawaban untuk hotel saat ini.",
    "created": "Waktu dibuat",
    "updated": "Waktu diperbarui",
    "to": "hingga",
    "startDate": "Tanggal mulai",
    "endDate": "Tanggal akhir",
    "question": "Pertanyaan",
    "answer": "Jawaban",
    "tags": "Tag",
    "questionSearch": "Cari pertanyaan berdasarkan kata kunci",
    "tagSearch": "Cari tag berdasarkan kata kunci",
    "search": "Cari",
    "reset": "Atur ulang",
    "create": "Tambah",
    "batchDelete": "Hapus pilihan",
    "loadFailed": "Gagal memuat. Silakan coba lagi.",
    "notFilled": "Belum diisi",
    "actions": "Tindakan",
    "view": "Lihat teks lengkap",
    "edit": "Edit",
    "delete": "Hapus",
    "details": "Detail pengetahuan",
    "missingTitle": "Konten lama tidak lengkap",
    "missingView": "Pertanyaan atau jawaban pada catatan ini belum diisi. Lengkapi sebelum menyimpan.",
    "missingForm": "Pertanyaan atau jawaban belum diisi. Lengkapi sebelum menyimpan.",
    "noDetails": "Tidak ada detail",
    "close": "Tutup",
    "enterQuestion": "Masukkan pertanyaan",
    "enterAnswer": "Masukkan jawaban",
    "answerPlaceholder": "Masukkan jawaban. Teks dapat terdiri dari beberapa baris.",
    "tagPlaceholder": "Masukkan tag lalu tekan Enter",
    "tagTip": "Tekan Enter untuk menambahkan tag. Koma dan spasi tidak memisahkan tag. Total panjang tag maksimal 512 karakter.",
    "cancel": "Batal",
    "save": "Simpan",
    "chooseHotel": "Pilih hotel terlebih dahulu",
    "empty": "Tidak ada data",
    "editTitle": "Edit pengetahuan",
    "createTitle": "Tambah pengetahuan",
    "tagRequired": "Tambahkan setidaknya satu tag",
    "tagText": "Tag harus berupa teks. Hapus lalu tambahkan kembali.",
    "tagBlank": "Tag tidak boleh kosong. Hapus lalu tambahkan kembali.",
    "tagsTooLong": "Tag terlalu panjang. Persingkat tag dan coba lagi.",
    "questionTooLong": "Pertanyaan tidak boleh melebihi 512 karakter",
    "answerTooLong": "Jawaban tidak boleh melebihi 5000 karakter",
    "invalidRecord": "Data catatan tidak valid. Buka kembali untuk mengedit.",
    "editSuccess": "Berhasil diperbarui",
    "createSuccess": "Berhasil ditambahkan",
    "deleteLimit": "Maksimal 100 catatan dapat dihapus sekaligus",
    "confirmBatch": "Hapus {count} catatan yang dipilih pada halaman ini? Penghapusan tidak dapat dibatalkan.",
    "confirmOne": "Hapus catatan ini? Penghapusan tidak dapat dibatalkan.",
    "deleteConfirm": "Konfirmasi penghapusan",
    "confirmDelete": "Konfirmasi hapus",
    "deleteSuccess": "Berhasil dihapus",
    "dataChanged": "Data telah berubah. Muat ulang daftar dan coba lagi."
  },
  // 本次 AI 用量同步独立追加，保留原有语言块。
  aiUsageSync: {
    "beta": "Beta",
    "title": "Statistik Penggunaan AI",
    "priceConfig": "Pengaturan Harga Tipe Kamar",
    "dateRange": "Rentang Tanggal",
    "startDate": "Tanggal Mulai",
    "endDate": "Tanggal Akhir",
    "scene": "Jenis Notifikasi",
    "all": "Semua",
    "callStatus": "Status Panggilan",
    "callStatusLabel": "Informasi status panggilan",
    "running": "Sedang Berjalan",
    "success": "Berhasil",
    "failed": "Gagal",
    "tokenStatus": "Data Penggunaan",
    "tokenStatusLabel": "Informasi data penggunaan",
    "known": "Tersedia",
    "unknownUsage": "Tidak Tersedia",
    "query": "Cari",
    "reset": "Atur Ulang",
    "categoryError": "Gagal memuat jenis notifikasi",
    "retry": "Muat Ulang",
    "chooseHotel": "Pilih hotel terlebih dahulu",
    "dailyUsage": "Penggunaan AI Harian",
    "noCallsFiltered": "Tidak ada panggilan sesuai filter.",
    "statisticsError": "Gagal memuat statistik penggunaan",
    "loadingTrend": "Memuat tren…",
    "details": "Detail Panggilan",
    "detailsError": "Gagal memuat detail panggilan",
    "loading": "Memuat…",
    "noCalls": "Tidak ada catatan panggilan",
    "waiting": "Menunggu pencarian",
    "callTime": "Waktu Panggilan",
    "usage": "Penggunaan AI",
    "requestInfo": "Informasi Permintaan",
    "requestId": "ID Permintaan: ",
    "requestDetails": "Detail Permintaan",
    "totalUsage": "Total Penggunaan AI",
    "callCount": "Jumlah Panggilan",
    "successCount": "Panggilan Berhasil",
    "unknownCount": "Panggilan dengan Penggunaan Tidak Diketahui",
    "today": "Hari Ini",
    "last7": "7 Hari Terakhir",
    "last30": "30 Hari Terakhir",
    "thisMonth": "Bulan Ini",
    "pending": "Menunggu Statistik",
    "unknown": "Tidak Diketahui",
    "usageLabel": "Penggunaan: ",
    "callCountLabel": "Panggilan: ",
    "unknownCountLabel": "Panggilan dengan penggunaan tidak diketahui: ",
    "missingUsage": "Sebagian panggilan tidak memiliki data penggunaan",
    "usageAxis": "Penggunaan",
    "description": "Penggunaan mencakup panggilan AI yang tercatat untuk hotel saat ini, tidak termasuk obrolan tanpa hotel. Tanggal menggunakan waktu Beijing.",
    "callStatusHelp": "Sedang berjalan, berhasil, dan gagal adalah status panggilan platform. Berhasil tidak berarti notifikasi telah dibuat.",
    "usageHelp": "Tersedia: penggunaan diketahui, termasuk nol. Tidak tersedia: panggilan tercatat tetapi penggunaan tidak diketahui dan tidak dihitung dalam total, terlepas dari berhasil atau gagal.",
    "invalidDates": "Pilih rentang tanggal yang valid. Tanggal mulai tidak boleh setelah tanggal akhir dan keduanya tidak boleh melebihi hari ini menurut waktu Beijing."
  },
  navbar: {
    searchHotel: 'Cari nama hotel',
    nightAudit: 'Audit malam',
    nightAuditWarning: 'Hotel sedang menjalankan audit malam, silakan coba lagi nanti',
    groupBooking: 'Reservasi grup',
    orderBox: 'Kotak Pesanan',
  },
  common: {
    logo: 'Logo',
    bundleSale: 'Penjualan Paket',
    splitTax: 'Pemisahan Pajak',
    taxIncluded: 'Termasuk Pajak',
    taxExcluded: 'Tidak Termasuk Pajak',
    businessFeeUnit: 'Satuan Biaya',
    fixedAmount: 'Jumlah Tetap',
    percentage: 'Persentase',
    pleaseEnter: 'Silakan masukkan',
    confirmCheckInOutTime: 'Anda telah memesan kamar dengan tanggal check-in {checkIn} dan check-out {checkOut}. Silakan konfirmasi tanggal menginap.',
    tax: 'Pajak',
    expenseWithTax: 'Pengeluaran (Termasuk Pajak)',
    totalProductPrice: 'Total Harga Produk',
    expenseWithoutTax: 'Pengeluaran (Tidak Termasuk Pajak)',
    roomFeeWithoutTax: 'Biaya Kamar (Tidak Termasuk Pajak)',
    salesAmountWithoutTax: 'Jumlah Penjualan (Tidak Termasuk Pajak)',
    taxIncludedPrice: 'Harga termasuk pajak',
    title: 'Sistem Manajemen Hotel EaseHUB',
    billingCycleType: 'Jenis siklus penagihan',
    weeklySettlement: 'Penyelesaian mingguan',
    monthlySettlement: 'Penyelesaian bulanan',
    accountReceivablePayment: 'Pembayaran AR',
    noResults: 'Tidak ditemukan informasi hotel terkait',
    shiftHandover: 'Serah terima shift',
    salesClerk: 'Petugas penjualan',
    currentShift: 'Shift saat ini',
    requestFailed: 'Permintaan gagal',
    confirmModify: 'Konfirmasi perubahan',
    operationSuccess: 'Operasi berhasil!',
    individualBooking: 'Reservasi individu',
    longBooking: 'Reservasi jangka panjang',
    cashPay: 'Bayar tunai',
    cashPayment: 'Pembayaran tunai',
    doorCard: 'Kartu kamar',
    more: 'Lainnya',
    success: 'Berhasil',
    close: 'Tutup',
    loadingEllipsis: 'Memuat...',
    cancel: 'Batal',
    printReport: 'Cetak laporan',
    printTime: 'Waktu cetak',
    businessDay: 'Hari operasional',
    operationDate: 'Tanggal operasi',
    subject: 'Akun',
    amount: 'Jumlah',
    save: 'Simpan',
    yuan: '',
    confirm: 'Konfirmasi',
    nextStep: 'Langkah berikutnya',
    all: 'Semua',
    immediateQuery: 'Cari sekarang',
    action: 'Aksi',
    pleaseSelect: 'Silakan pilih',
    pleaseInput: 'Silakan masukkan',
    inputYuan: 'Silakan masukkan ',
    yes: 'Ya',
    no: 'Tidak',
    remark: 'Catatan',
    delete: 'Hapus',
    oneHour: 'Satu jam',
    twoHours: 'Dua jam',
    threeHours: 'Tiga jam',
    fourHours: 'Empat jam',
    fiveHours: 'Lima jam',
    sixHours: 'Enam jam',
    sevenHours: 'Tujuh jam',
    eightHours: 'Delapan jam',
    saveSuccess: 'Berhasil disimpan',
    notice: 'Pemberitahuan',
    status: 'Status',
    cancelled: 'Dibatalkan',
    booked: 'Dipesan',
    hardLoading: 'Sedang memuat...',
    startDate: 'Tanggal mulai',
    endDate: 'Tanggal selesai',
    Deadline: 'Batas waktu',
    name2: 'Nama',
    roomNumber: 'Nomor kamar',
    checkInDate3: 'Tanggal check-in',
    checkOutDate3: 'Tanggal check-out',
    unitPrice3: 'Harga satuan',
    quantity: 'Jumlah',
    addBook: 'Tambah buku akun',
    bookName: 'Nama buku akun',
    accountOfConsumption: 'Akun konsumsi',
    details3: 'Detail',
    id: 'ID',
    commodityDetail: 'Detail produk',
    externalDocumentNumber: 'Nomor dokumen eksternal',
    accountOfPayment2: 'Akun pembayaran',
    strikeABalance: 'Penyesuaian akun',
    pleaseFillInRemarks2: 'Silakan isi catatan',
    search: 'Cari',
    nationality: 'Kewarganegaraan',
    sex: 'Jenis kelamin',
    male: 'Laki-laki',
    female: 'Perempuan',
    nation: 'Suku',
    contactInformation2: 'Informasi kontak',
    dateOfBirth: 'Tanggal lahir',
    documentType: 'Jenis dokumen',
    address2: 'Alamat',
    documentNumber: 'Nomor dokumen',
    validityOfVisa: 'Masa berlaku visa',
    visaType: 'Jenis visa',
    visaNumber: 'Nomor visa',
    pleaseEnterYourIdNumber: 'Silakan masukkan nomor dokumen',
    pleaseEnterTheCorrectIdNumber4: 'Silakan masukkan nomor dokumen yang benar',
    pleaseFillInYourName2: 'Silakan isi nama',
    pleaseSelectDocumentType: 'Silakan pilih jenis dokumen',
    dontWorryAboutGoldMembers2: 'Anggota Gold Qingzhu',
    goEasyOnThePlatinumMembers2: 'Anggota Platinum Qingzhu',
    lightOnDiamondMembers2: 'Anggota Diamond Qingzhu',
    unregisteredMember: 'Anggota belum terdaftar',
    ok2: 'OK',
    issuingAuthority: 'Otoritas penerbit',
    idPhoto: 'Foto KTP',
    qingzhuGroup: 'Grup Qingzhu',
    mobilePhoneNumber: 'Nomor ponsel',
    view: 'Lihat',
    activated: 'Diaktifkan',
    nonmember: 'Non-anggota',
    coupon: 'Kupon',
    ranking5: 'Peringkat',
    hotelName4: 'Nama hotel',
    isNotSet: 'Belum diatur',
    yu: 'Sisa',
    noVacancy: 'Kamar penuh',
    consumption: 'Konsumsi',
    refund: 'Pengembalian dana',
    iGotIt2: 'Saya mengerti',
    startANightTrial: 'Mulai audit malam',
    operator: 'Operator',
    handledBy: 'Ditangani oleh',
    to: 'Sampai',
    currentBusinessDay: 'Hari operasional saat ini',
    ok: 'OK',
    morningShift2: 'Shift pagi',
    middleShift2: 'Shift siang',
    nightShift2: 'Shift malam',
    pleaseEnterYourName: 'Silakan masukkan nama',
    selectAll: 'Pilih semua',
    pleaseEnterContent: 'Silakan masukkan konten',
    serialNumber: 'Nomor urut',
    address: 'Alamat',
    signatureOfAuthorizer: 'Tanda tangan pemberi persetujuan',
    signature3: 'Tanda tangan',
    roomType: 'Tipe kamar',
    dayRate: 'Harga kamar harian',
    checkInTime: 'Waktu check-in',
    checkOutTime: 'Waktu check-out',
    settlementAmount: 'Jumlah penyelesaian',
    hotelAddress: 'Alamat hotel',
    selectDate: 'Pilih tanggal',
    selectionTime: 'Pilih waktu',
    cancelCard: 'Batalkan kartu',
    thisCardIsEmptyPleaseMakeABusinessCardFirst:
      'Kartu ini kosong, silakan buat kartu terlebih dahulu',
    logoutSuccessful: 'Berhasil dibatalkan',
    cardCancellationFailure: 'Gagal membatalkan kartu',
    contactSupport: 'Silakan hubungi dukungan teknis untuk memeriksa layanan perangkat keras',
    submit: 'Kirim',
    contactPerson6: 'Kontak',
    contactNumber2: 'Nomor kontak',
    merchant3: 'Pedagang',
    Submitsuccessfully: 'Berhasil dikirim',
    smallProgram: 'Mini program',
    technicalSupport: 'Dukungan teknis',
    roomBillCheck: 'Pemeriksaan tagihan kamar',
    financialAssistant: 'Asisten keuangan',
    settlementCycle: 'Siklus penyelesaian',
    refundSuccessful: 'Pengembalian dana berhasil',
    beingRefunded: 'Sedang dikembalikan',
    refundFailure: 'Pengembalian dana gagal',
    channel: 'Saluran',
    cloakroom: 'Tutup kamar',
    infiniteQuantity: 'Jumlah tak terbatas',
    compute: 'Hitung',
    dateOfSale: 'Tanggal penjualan',
    originalPrice: 'Harga asli',
    pleaseEnterTheOriginalPrice: 'Silakan masukkan harga asli',
    member: 'Anggota',
    salesAmount: 'Jumlah penjualan',
    amountOfConsumption: 'Jumlah konsumsi',
    protocolUnit: 'Unit perjanjian',
    subjectDesc: 'Deskripsi akun',
    qzOrderNo: 'Nomor pesanan Qingzhu',
    checkInType: 'Jenis check-in',
    checkInOutDate: 'Tanggal check-in / check-out',
    channelOrderNo: 'Nomor pesanan saluran',
    pleaseEnterTheCorrectPhoneNumber3: 'Silakan masukkan nomor ponsel yang benar',
    logs: 'Log',
    walkIn: 'Tamu walk-in',
    businessCardPrintingSuccess: 'Pembuatan kartu berhasil',
    exportSuccessfully2: 'Ekspor berhasil',
    exportFailure: 'Ekspor gagal',
    other: 'Lainnya',
    toBeProcessed: 'Menunggu diproses',
    completed: 'Selesai',
    commonProduct: 'Produk umum',
    freeRoomProducts: 'Produk kamar gratis',
    makeACard: 'Buat kartu',
    day: 'Hari',
    points2: 'Poin',
    sunday: 'Minggu',
    monday: 'Senin',
    tuesday: 'Selasa',
    wednesday: 'Rabu',
    thursday: 'Kamis',
    friday: 'Jumat',
    saturday: 'Sabtu',
    lose: 'Gagal',
    since: 'Mulai',
    amountTotal: 'Total',
    total: 'Jumlah keseluruhan',
    tradeName: 'Nama produk',
    itemType: 'Jenis barang',
    orderStatus: 'Status pesanan',
    orderNumber: 'Nomor pesanan',
    anonymousUser: 'Pengguna anonim',
    commentTime: 'Waktu komentar',
    merchantReply: 'Balasan merchant',
    recoveryTime: 'Waktu balasan',
    recover: 'Balas',
    pleaseWriteAResponseOfAtLeast10Words: 'Harap isi balasan minimal 10 kata',
    replyTextMinimum10Words: 'Teks balasan minimal 10 kata',
    negativeComment: 'Ulasan negatif',
    cancel2: 'Batal',
    commentTemplateManagement: 'Manajemen template komentar',
    modifiedSuccessfully: 'Berhasil diubah',
    hygiene: 'Kebersihan',
    service: 'Layanan',
    facility: 'Fasilitas',
    position: 'Lokasi',
    appeal: 'Banding',
    successfullyDeleted: 'Berhasil dihapus',
    replySuccessfully2: 'Berhasil membalas',
    theMobilePhoneNumberFormatIsIncorrect5: 'Format nomor ponsel tidak benar',
    none4: 'Tidak ada',
    thisFunctionHasNotBeenOpenedIfYouNeedToOpenPleaseClickOpen:
      'Fungsi ini belum diaktifkan, silakan klik aktifkan jika diperlukan',
    noCommentsYet: 'Belum ada komentar',
    picture: 'Gambar',
    guestName: 'Nama tamu',
    handle: 'Tangani',
    edit: 'Ubah',
    type: 'Tipe',
    salesman: 'Sales',
    successfulOperation: 'Operasi berhasil',
    pleaseEnterTheCompanyName2: 'Silakan masukkan nama perusahaan',
    customerType: 'Jenis pelanggan',
    effective: 'Aktif',
    inVain: 'Tidak aktif',
    valid: 'Aktif',
    forbidden: 'Dinonaktifkan',
    enable: 'Aktifkan',
    companyName2: 'Nama perusahaan',
    favorable2: 'Diskon',
    day2: 'Hari',
    telephone: 'Telepon',
    pleaseEnterThePhoneNumber: 'Silakan masukkan nomor telepon',
    mailbox: 'Email',
    accountName: 'Nama akun',
    startTime: 'Waktu mulai',
    endTime: 'Waktu selesai',
    beingSubmitted: 'Sedang dikirim',
    pleaseSelectGender: 'Silakan pilih jenis kelamin',
    confirmDeletion: 'Konfirmasi penghapusan',
    letMeThinkItOver: 'Biarkan saya pikirkan lagi',
    theSizeOfTheUploadedPictureCannotExceed: 'Ukuran gambar yang diunggah tidak boleh melebihi',
    identificationCard2: 'KTP',
    editor: 'Editor',
    topLine: 'Aktif',
    downline: 'Nonaktif',
    validity: 'Masa berlaku',
    fullDayRoom: 'Kamar harian',
    hourlyRoom: 'Kamar per jam',
    append3: 'Tambah',
    immediatelyReduce3: 'Potongan langsung',
    activityName2: 'Nama aktivitas',
    sort: 'Kategori',
    on: 'Aktif',
    amountOfGift2: 'Jumlah hadiah',
    pleaseFillIn2: 'Silakan isi',
    pleaseSelectADate: 'Silakan pilih tanggal',
    roomFeeConsumption: 'Konsumsi biaya kamar',
    selectFile: 'Pilih file',
    uploadFailure: 'Unggah gagal',
    uploadSuccessfully: 'Unggah berhasil',
    print: 'Cetak',
    dateRange: 'Rentang tanggal',
    reupload: 'Unggah ulang',
    printBill: 'Cetak tagihan',
    cardNumber: 'Nomor kartu',
    paymentMethod: 'Metode pembayaran',
    payMethod: 'Cara pembayaran',
    balance: 'Saldo',
    membershipCardNumber: 'Nomor kartu anggota',
    birthday: 'Tanggal lahir',
    tradingHours: 'Waktu transaksi',
    enterAMaximumOf50Characters: 'Maksimal 50 karakter',
    membersMobileNumber: 'Nomor ponsel anggota',
    time: 'Waktu',
    modifyInformation: 'Ubah informasi',
    lengthOfStay: 'Jumlah hari menginap',
    roomListNumber: 'Nomor bill kamar',
    roomTypeName: 'Nama tipe kamar',
    settleAccounts: 'Check-out',
    accountNumber: 'Akun pencatatan',
    paymentRecord: 'Catatan pembayaran',
    paymentAmount: 'Jumlah pembayaran',
    paymentVerificationCode: 'Kode verifikasi pembayaran',
    enterInAnAccount: 'Catat ke akun',
    pleaseSelectACollectionSet: 'Silakan pilih set piutang',
    pleaseSelectTheAccountNumber: 'Silakan pilih akun pencatatan',
    pleaseSelectAPaymentMethod: 'Silakan pilih metode pembayaran',
    vipSignature: 'Tanda tangan VIP',
    amountNotWrittenOff3: 'Jumlah belum diverifikasi',
    availableCredit3: 'Limit tersedia',
    maximumAmount4: 'Limit maksimum',
    whetherItIsValidOrNot: 'Apakah valid',
    enabledSuccessfully: 'Berhasil diaktifkan',
    disableSuccessfully: 'Berhasil dinonaktifkan',
    roomNumberName: 'Nomor kamar - Nama',
    payment2: 'Pembayaran',
    operatingTime: 'Waktu operasi',
    classes: 'Shift',
    transfer: 'Transfer',
    accountOutstanding2: 'Belum ditutup',
    accountClosed: 'Sudah ditutup',
    rolledOut: 'Sudah ditransfer keluar',
    haveStruckOff: 'Sudah disesuaikan',
    noRoomChargeIsGenerated: 'Tidak menghasilkan biaya kamar',
    date3: 'Tanggal',
    itemName4: 'Nama item',
    pleaseEnterRemarks2: 'Silakan masukkan catatan',
    entryAndDepartureTime: 'Waktu masuk & keluar',
    roomRate: 'Tarif kamar',
    preAuthorizationAmount: 'Jumlah pra-otorisasi',
    room: 'Kamar',
    settlement: 'Penyelesaian',
    pleaseSelectMemberInformation: 'Silakan pilih informasi anggota',
    pleaseFillInThePaymentVerificationCode: 'Silakan isi kode verifikasi pembayaran',
    accountNumber3: 'Nomor akun',
    successfulEntry: 'Pencatatan berhasil',
    externalOrderNumber: 'Nomor pesanan eksternal',
    transferTo: 'Transfer masuk',
    beAuthorized: 'Sudah diotorisasi',
    haveAlreadySettled: 'Sudah diselesaikan',
    authorizationMode: 'Metode otorisasi',
    authorizedAmount: 'Jumlah otorisasi',
    authorizationTime: 'Waktu otorisasi',
    productType: 'Jenis produk',
    pleaseEnterTheChannelNumber: 'Silakan masukkan nomor saluran',
    derive: 'Ekspor',
    unwritten: 'Belum diverifikasi',
    cancelled3: 'Sudah diverifikasi',
    lehuiScanTheCode: 'Lehui - Scan kode',
    amountOnAccount3: 'Jumlah piutang',
    billingTime5: 'Waktu piutang',
    nameOfGuest3: 'Nama tamu menginap',
    roomNumber3: 'Nomor kamar',
    people: 'Orang',
    nameOfExpenseItem: 'Nama item biaya',
    viewDetails: 'Lihat detail',
    bankOfDeposit: 'Bank pembuka',
    bankCardNumber4: 'Nomor kartu bank',
    toBeConfirmed2: 'Menunggu konfirmasi',
    rejected: 'Ditolak',
    adjustmentAmount: 'Jumlah penyesuaian',
    meituan: 'Meituan',
    totalOrderAmount: 'Total jumlah pesanan',
    lightSettlementWithMerchants: 'Penyelesaian Qingzhu dengan merchant',
    membershipDistribution: 'Bagi hasil anggota',
    crossStoreRebate: 'Komisi lintas toko',
    avoidCommissionSubsidies: 'Subsidi komisi Qingzhu',
    membershipIncentiveSettlement: 'Penyelesaian insentif anggota',
    theUnitedStatesGroupDirectlyConnected: 'Meituan direct connect',
    flyingPigsConnectDirectly: 'Fliggy direct connect',
    fullNameOfTheBank4: 'Nama lengkap bank',
    accountBankAbbreviation4: 'Singkatan bank',
    theLocationOfTheBank4: 'Lokasi bank',
    pleaseEnterYourFullBankName2: 'Silakan masukkan nama lengkap bank',
    pleaseSelectBankAbbreviation2: 'Silakan pilih singkatan bank',
    pleaseSelectYourBankLocation2: 'Silakan pilih lokasi bank',
    pleaseEnterYourBankCardNumber2: 'Silakan masukkan nomor kartu bank',
    modificationTime2: 'Waktu perubahan',
    bankExample: 'Contoh: ICBC Cabang XX',
    companyNameNote: 'Catatan: jika rekening perusahaan, isi nama perusahaan',
    causeOfFailure: 'Penyebab kegagalan',
    pleaseEnterYourPhoneNumber: 'Silakan masukkan nomor ponsel',
    downloadStatement: 'Unduh laporan',
    operationLog: 'Log operasi',
    ctripDirectConnection: 'Ctrip direct connect',
    directConnectionInTheSameDirection: 'Tongcheng direct connect',
    flyingPig: 'Fliggy',
    ctrip: 'Ctrip',
    roomNight: 'Malam kamar',
    pictureUpload: 'Unggah gambar',
    aSinglePictureMustNotBeLargerThan: 'Ukuran satu gambar tidak boleh melebihi',
    checkInRoomType2: 'Tipe kamar check-in',
    checkInPerson: 'Tamu check-in',
    hotelSellingPrice: 'Harga jual hotel',
    effectiveDate3: 'Tanggal berlaku',
    viewExamples: 'Lihat contoh',
    underReview: 'Dalam peninjauan',
    billingType: 'Jenis penagihan',
    invoiceTitle2: 'Judul faktur',
    pleaseEnterTheInvoiceTitle2: 'Silakan masukkan judul faktur',
    invoiceHasBeenIssued: 'Faktur telah diterbitkan',
    haveBeenCancelled: 'Telah dibatalkan',
    paymentStatus: 'Status pembayaran',
    preferentialPrice: 'Harga diskon',
    gateRate: 'Harga publik',
    availableRoom: 'Kamar tersedia',
    orderableNumber: 'Jumlah dapat dipesan',
    numberOfRoomsReserved: 'Jumlah kamar dipesan',
    breakfast: 'Sarapan',
    copyOf: 'Porsi',
    dailyRate: 'Tarif harian',
    typeOfTouristSource3: 'Jenis sumber tamu',
    namephoneNumbermembershipNumber: 'Nama / Nomor ponsel / Nomor anggota',
    selectTimePoint5: 'Pilih titik waktu',
    externalChannel3: 'Saluran eksternal',
    retentionTime3: 'Waktu penahanan',
    contactName2: 'Nama kontak',
    numberOfDays: 'Jumlah hari',
    pleaseSelectAProtocolUnit3: 'Silakan pilih unit perjanjian',
    pleaseEnterTheNameOfTheExternalChannel2: 'Silakan isi nama saluran eksternal',
    pleaseFillInTheMembershipInformation3: 'Silakan isi informasi anggota',
    pleaseFillInTheReservationName2: 'Silakan isi nama pemesan',
    pleaseFillInTheReservationNumber2: 'Silakan isi nomor ponsel pemesan',
    theAmountCanOnlyBeEnteredInNumbers2: 'Jumlah hanya boleh diisi dengan angka',
    noMemberInformationFound: 'Tidak ditemukan informasi anggota terkait',
    noProtocolUnitIsQueried2: 'Tidak ditemukan informasi unit perjanjian',
    bulkRepricing: 'Ubah harga massal',
    totalRoomRate6: 'Total tarif kamar',
    trialCalculationOfHousePrice3: 'Simulasi harga kamar',
    free: 'Gratis',
    between: 'Kamar',
    upgradeRoomType: 'Upgrade tipe kamar',
    printOrNot: 'Cetak atau tidak',
    predepartureTime2: 'Waktu perkiraan keberangkatan',
    rooms: 'Jumlah kamar',
    averageHousePrice: 'Harga kamar rata-rata',
    arrivalTime: 'Waktu perkiraan kedatangan',
    creationTime: 'Waktu pembuatan',
    advancedSearch: 'Pencarian lanjutan',
    simpleSearch: 'Pencarian sederhana',
    price: 'Harga',
    orderTaking: 'Terima pesanan',
    sellingPrice: 'Harga jual',
    floorPrice: 'Harga dasar',
    channelName2: 'Nama saluran',
    bookingSuccessful2: 'Reservasi berhasil',
    checkedIn2: 'Sudah check-in',
    cancelSuccessfully2: 'Pembatalan berhasil',
    sorting: 'Pengurutan',
    invoiceNumber2: 'Nomor faktur',
    taxIdentificationNumber: 'Nomor identifikasi pajak',
    emailAddress: 'Alamat email',
    eTicket: 'Faktur elektronik khusus',
    eTicket2: 'Faktur elektronik umum',
    paperTicket: 'Faktur kertas khusus',
    paperTicket2: 'Faktur kertas umum',
    void: 'Dibatalkan',
    teamType: 'Jenis tim',
    teamName: 'Nama tim',
    markUpAmount: 'Jumlah markup',
    productName: 'Nama produk',
    lengthOfStay2: 'Durasi menginap',
    hours: 'Jam',
    checkIn: 'Check-in',
    changeRooms: 'Ganti kamar',
    rowHouse: 'Penempatan kamar',
    printCheckInSlip: 'Cetak slip check-in',
    proceedWith: 'Lanjutkan',
    rowHouseSuccess2: 'Penempatan kamar berhasil',
    toCheckIn: 'Menunggu check-in',
    checkedOut: 'Sudah check-out',
    onAccount: 'Ditangguhkan',
    basicInformation: 'Informasi dasar',
    prepayment: 'Pembayaran di muka',
    originalHouseType: 'Tipe kamar awal',
    seeMore: 'Lihat lebih banyak',
    thisRoomSupportsSmartDoorLocks: 'Kamar ini mendukung kunci pintu pintar',
    listingStatus: 'Status kamar',
    checkin: 'Masuk',
    preionization2: 'Pra-keberangkatan',
    weekTitle: 'Minggu',
    thePriceActuallyPaidByTheGuest: 'Harga yang dibayar tamu',
    late3: 'Malam',
    late4: 'Hari',
    nonCancellable2: 'Tidak dapat dibatalkan',
    one: 'Satu',
    two: 'Dua',
    three: 'Tiga',
    four: 'Empat',
    five: 'Lima',
    six: 'Enam',
    lightweightDistribution: 'Distribusi Qingzhu',
    liveAndTravelLightly: 'Qingzhu Bisnis & Perjalanan',
    jingdongDirectLink: 'JD direct connect',
    baiduMapDirectConnection: 'Baidu Map direct connect',
    tiktokDirectConnection: 'TikTok direct connect',
    ctripSingleStore: 'Ctrip toko tunggal',
    agoda: 'Agoda',
    meituanHomestay: 'Meituan Homestay',
    tujiaHomestay: 'Tujia Homestay',
    booking: 'Booking',
    expedia: 'Expedia',
    preCancelable: 'Dapat dibatalkan sebelum',
    partialWriteOff: 'Penghapusan sebagian',
    tookEffect: 'Telah berlaku',
    loseEffectiveness: 'Tidak berlaku',
    joinAHouse3: 'Gabung Kamar',
    bookingInformation: 'Informasi reservasi',
    pleaseSelectARoom3: 'Silakan pilih kamar',
    houseInformation: 'Informasi kamar terhubung',
    thereIsNoRowHouse: 'Belum ditempatkan kamar',
    reasonsForChangingRooms3: 'Alasan ganti kamar',
    numberOfRooms7: 'Total kamar',
    typeOfOperation3: 'Jenis operasi',
    exchangeAndUpgradeReport2: 'Laporan ganti & upgrade kamar',
    noDataAvailable2: 'Tidak ada data',
    pleaseSelectABusinessDayRange2: 'Silakan pilih rentang hari operasional',
    exportReport: 'Ekspor laporan',
    accountName3: 'Nama akun',
    aMaximumOf31DaysCanBeQueried: 'Rentang waktu maksimal 31 hari',
    naturalDay2: 'Hari kalender',
    otherConsumption3: 'Konsumsi lainnya',
    aggregateConsumption3: 'Total konsumsi',
    aggregateConsumptionTaxIncluded: 'Total Konsumsi (Termasuk Pajak)',
    materialType: 'Jenis material',
    materialName: 'Nama material',
    storageTypeSell: 'Penjualan',
    materialCode: 'Kode material',
    materialUnit: 'Satuan',
    inStorageNum: 'Jumlah masuk',
    outStorageNum: 'Jumlah keluar',
    selectTime: 'Silakan pilih waktu',
    floor: 'Lantai',
    lumpSumPayment3: 'Pembayaran total',
    ifTheRateIsGreaterThanHalfDayTheRateIsLessThanFullDay:
      'Jika lebih dari tarif setengah hari dan kurang dari tarif satu hari penuh, dihitung satu hari penuh',
    businessDate: 'Tanggal operasional',
    calculationFormula: 'Rumus perhitungan',
    manualRoomFeeCalculationHalfDayRoomFee05BedNightFullDayRoomFee1BedNight:
      'Perhitungan manual biaya kamar: setengah hari = 0,5 malam, satu hari penuh = 1 malam',
    halfDayRoomFeeTheAmountChargedIsLessThanOrEqualToHalfTheRoomRate:
      'Biaya setengah hari: jumlah tambahan ≤ setengah tarif kamar',
    fullDayRoomFeeTheAmountChargedIsGreaterThanOrEqualToTheRoomRateAndTheAmountExceedsTheRoomRateBy2TimesRecord2BedNightsAndSoOn:
      'Biaya satu hari penuh: jumlah tambahan ≥ tarif kamar; jika melebihi 2× tarif kamar, dihitung 2 malam, dan seterusnya',
    rentedBedNightsExcludeFreeRoomsAndSelfUsedRoomNights:
      'Jumlah malam terjual: tidak termasuk kamar gratis dan kamar digunakan sendiri',
    subtotal: 'Subtotal',
    totalOccupancy3: 'Total kamar',
    lettingRate: 'Tingkat hunian',
    inResidenceDate: 'Tanggal menginap',
    bookingDate: 'Tanggal reservasi',
    exposureNumber2: 'Jumlah paparan',
    numberOfVisitors3: 'Jumlah pengunjung',
    onlineChannel3: 'Saluran online',
    reasonForDeactivation: 'Alasan penonaktifan',
    downTime: 'Waktu penonaktifan',
    enterAMaximumOf20Characters: 'Maksimal 20 karakter',
    checkInInformation: 'Informasi check-in',
    numberOfRooms6: 'Jumlah kamar',
    totalPrice: 'Total harga',
    paymentInformation2: 'Informasi pembayaran',
    pleaseSelectAProduct: 'Silakan pilih produk',
    viewOrderDetails: 'Lihat detail pesanan',
    automaticallyJumpToOrderDetails: 'Otomatis menuju detail pesanan',
    addHoming3: 'Tambah Sekamar',
    getVerificationCode: 'Dapatkan kode verifikasi',
    pleaseSelectTheNumberOfRoomsFirst: 'Silakan pilih jumlah kamar terlebih dahulu',
    theNumberOfReservedRoomsCannotBeGreaterThanTheNumberOfAvailableRooms:
      'Jumlah kamar yang dipesan tidak boleh melebihi jumlah yang tersedia',
    pleaseEnterAmount: 'Silakan masukkan jumlah',
    makeAReservation: 'Buat reservasi',
    increaseRoomType: 'Tambah tipe kamar',
    deleteRoomType: 'Hapus tipe kamar',
    store: 'Toko',
    meituanDirectNew: 'Meituan direct (baru)',
    outOfService: 'Tidak aktif',
    smokeFreeOrNot: 'Bebas rokok atau tidak',
    roomOrientation: 'Arah kamar',
    windowCondition: 'Kondisi jendela',
    windowed: 'Dengan jendela',
    windowless: 'Tanpa jendela',
    innerFenestra: 'Jendela dalam',
    roomCharacteristics: 'Karakteristik kamar',
    airAndClean: 'Bersih',
    airViscus: 'Kotor',
    dendrojing: 'Bersih dihuni',
    astriction: 'Kotor dihuni',
    continuousStaySpecial: 'Promo menginap berkelanjutan',
    orderEarlyAndReduceMore: 'Pesan lebih awal, diskon lebih besar',
    discountValue: 'Diskon',
    select: 'Pilih',
    becameInvalid: 'Menjadi tidak berlaku',
    dateOfOperation: 'Tanggal operasi',
    promotionalAllocation: 'Konfigurasi promosi',
    promotionManagement: 'Manajemen promosi',
    operationContent2: 'Konten operasi',
    turnOnAutomaticDeferral: 'Aktifkan perpanjangan harga otomatis',
    productSetup: 'Pengaturan produk',
    thePriceShallNotBeLessThan20YuanAndShallNotBeHigherThan99998Yuan:
      'Harga tidak boleh kurang dari 20  dan tidak boleh lebih dari 99998000 ',
    iKnow: 'Saya mengerti',
    dataSpecification: 'Penjelasan data',
    settings: 'Pengaturan',
    restrictSales: 'Batasi penjualan',
    pleaseEnterPrice: 'Silakan masukkan harga',
    modificationFailure: 'Perubahan gagal',
    deletionFailure: 'Penghapusan gagal',
    product: 'Produk',
    pleaseSelectChannel: 'Silakan pilih saluran',
    standardProduct: 'Produk standar',
    bindingSuccessful: 'Pengikatan berhasil',
    lobby: 'Lobi',
    inventoryQuantity: 'Jumlah inventaris',
    uploadPictures: 'Unggah gambar',
    currentlyLimitedTo10Images: 'Saat ini dibatasi 10 gambar',
    pictureSizeMustBeLargerThan: 'Ukuran gambar harus lebih besar dari',
    warn3: 'Peringatan',
    theInputContentOfTheCurrentPageDoesNotMeetTheSpecificationsPleaseCheck:
      'Konten input pada halaman saat ini tidak memenuhi spesifikasi, silakan periksa',
    layer: 'Lapisan',
    untie: 'Lepas ikatan',
    cipher5: 'Kata sandi',
    pleaseEnterYourAccountNumber: 'Silakan masukkan akun',
    pleaseEnterPassword4: 'Silakan masukkan kata sandi',
    obtainTheSmsVerificationCode: 'Dapatkan kode verifikasi SMS',
    disposition: 'Konfigurasi',
    passwordType: 'Jenis kata sandi',
    setANewPassword: 'Atur kata sandi baru',
    pleaseEnterYourNewPassword: 'Silakan masukkan kata sandi baru',
    confirmPassword: 'Konfirmasi kata sandi',
    pleaseEnterYourPasswordAgain: 'Silakan masukkan kata sandi sekali lagi',
    electronicPriceBoard: 'Papan harga elektronik',
    operationInstruction: 'Petunjuk operasi',
    cardholder: 'Pemegang kartu',
    contact: 'Kontak',
    pleaseEnterTheCardholderName: 'Silakan masukkan nama pemegang kartu',
    cardholderNameIsRequired: 'Nama pemegang kartu wajib diisi',
    theCardholderNameMustBe2To5CharactersLong:
      'Nama pemegang kartu harus terdiri dari 2 hingga 5 karakter',
    remarksRequired: 'Catatan wajib diisi',
    selectCardType: 'Pilih jenis kartu',
    windowType2: 'Tipe jendela',
    suspensionOfSale: 'Penjualan dihentikan',
    enterMaterialName: 'Masukkan nama material',
    modifyTarget: 'Ubah target',
    theRecommendedTargetValueIsEstimatedBasedOnTheChangeTrendOfTheDataInTheSamePeriodLastYearAndTheActualDataOfLastMonth:
      'Nilai target yang disarankan diperkirakan berdasarkan tren perubahan data pada periode yang sama tahun lalu serta data aktual bulan lalu',
    dayUnit: '{day} hari',
    checkInOperator: 'Petugas Check-in',
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'],
    week: {
      mon: 'Senin',
      tue: 'Selasa',
      wed: 'Rabu',
      thu: 'Kamis',
      fri: 'Jumat',
      sat: 'Sabtu',
      sun: 'Minggu',
    },
  },
  language: {
    zh: '中文',
    en: 'EN',
    zhHk: '繁体',
    th: 'ไทย',
    id: 'Indonesian',
    es: 'Español',
    vi: 'Tiếng Việt',
  },
  activitySign: {
    eventDate: 'Tanggal acara',
    alreadyRegistered: 'Sudah terdaftar',
    signUpActivity: 'Acara yang dapat didaftarkan',
    noRegistrationIsAvailable: 'Tidak ada acara yang dapat didaftarkan',
    registeredActivity: 'Acara yang telah didaftarkan',
    thereAreNoRegisteredActivities: 'Belum ada acara terdaftar',
    thereAreNoCanceledEvents: 'Belum ada acara yang dibatalkan',
    signUp: 'Daftar',
  },
  componentsCostprint8cmprint: {
    dateOfConsumption: 'Tanggal konsumsi',
  },
  componentsCostprinta4template: {
    totalConsumption: 'Total konsumsi',
    dateOfConsumption: 'Tanggal konsumsi',
    feeName: 'Nama biaya',
  },
  componentsCounter: {
    theGoodsAreOnlyInStock: 'Stok produk tersisa',
    thereIsNotEnoughStockOfThisCommodity: 'Stok produk tidak mencukupi',
  },
  componentsNowpayaccounthandle: {
    modifyTheBookSuccessfully: 'Berhasil mengubah buku akun',
    bookModification: 'Ubah buku akun',
    pleaseEnterABookName: 'Silakan masukkan nama buku akun',
    pleaseSelectTheConsumerCategory: 'Silakan pilih kategori konsumsi',
    newAccountSuccessfully: 'Berhasil menambahkan buku akun baru',
  },
  componentsRecorddetail: {
    memberInfo: 'Nama anggota / Nomor kartu',
  },
  componentsRushbalance: {
    successfulWriteOff: 'Penyesuaian akun berhasil',
  },
  componentsShoppinggoods: {
    onlyAvailable: 'Hanya tampilkan yang tersedia',
    commodityCategory: 'Kategori produk',
    pleaseEnterTheProductName: 'Silakan masukkan nama produk',
    noDataIsQueried: 'Tidak ada data ditemukan',
    name3: 'Nama',
    purchaseQuantity: 'Jumlah pembelian',
    vendibility: 'Dapat dijual',
    allGoods: 'Semua produk',
  },
  componentsAddroomer: {
    addLabel: 'Tambah Label',
    noCustomerProfile: 'Profil pelanggan tidak tersedia untuk tamu ini',
    guestSaveFailedRetry: 'Gagal menyimpan tamu. Silakan coba lagi',
    changeOccupancy: 'Ubah penghuni',
    increaseOccupancy: 'Tambah penghuni',
    validityPeriod: 'Masa berlaku dokumen',
    startDate: 'Tanggal mulai',
    addGuest: 'Tambah tamu',
    atLeastOneGuest: 'Minimal satu tamu harus dipertahankan',
    guest: 'Tamu',
    enterGuestName: 'Masukkan nama {name}',
    enterValidPhone: 'Masukkan nomor ponsel {name} yang valid',
    selectDocumentType: 'Pilih jenis dokumen {name}',
    enterDocumentNumber: 'Masukkan nomor dokumen {name}',
  },
  componentsAnnouncement: {
    noticeBoard: 'Papan pengumuman',
  },
  componentsIdentifyMembers: {
    memberInformation: 'Informasi anggota',
    pleaseFillInTheGuestMobilePhoneNumberQuickIdentificationInformation:
      'Silakan isi nomor ponsel tamu untuk mengidentifikasi informasi dengan cepat',
    guestsCanUpgradeToAHigherLevelMembership:
      'Tamu dapat meningkatkan keanggotaan ke level yang lebih tinggi',
    l: 'Naik',
    unnamed: 'Belum terverifikasi',
    inRealName: 'Sudah terverifikasi',
    points: 'Poin',
    memberRightsAndInterests: 'Hak dan manfaat anggota',
    patron: 'Tamu',
    unfold: 'Perluas',
    unactivated: 'Belum diaktifkan',
    membershipSalesCopy: 'Teks penjualan keanggotaan',
    bookingDiscount: 'Diskon pemesanan kamar',
    costPerformance: 'Nilai manfaat pembelian kartu',
    memberPoints: 'Poin anggota',
    lateCheckOut: 'Check-out terlambat',
    copywritingType: 'Jenis teks promosi',
    afterTheGuestAuthenticatesThemselvesInThelightStayHotelReservationMiniProgramTheyCanReceiveA18YuanFreeBirthdayGiftCouponOrParticipateInExclusiveOffers:
      'Setelah tamu melakukan verifikasi identitas di mini program “LightStay Hotel Reservation”, mereka dapat menerima kupon ulang tahun gratis senilai 18 tanpa syarat atau berpartisipasi dalam penawaran eksklusif',
    afterTheGuestLogsInForTheFirstTimeInThelightStayHotelReservationMiniProgramTheyCanActivateTheirMembershipAndEnjoyExclusiveMemberBenefits:
      'Saat tamu pertama kali login ke mini program “LightStay Hotel Reservation”, keanggotaan akan diaktifkan dan mereka dapat menikmati manfaat eksklusif anggota',
    lightStayMemberLevelNonMember: 'Level anggota LightStay: Non-anggota',
    lightStayMembershipLevel: 'Level keanggotaan LightStay',
  },
  componentsSellcard: {
    employeeLastWeeksCardSalesList: 'Peringkat penjualan kartu karyawan minggu lalu',
    dragLeftAndRightToViewTheTable: 'Geser ke kiri dan kanan untuk melihat tabel',
    hotelLastWeeksCardSalesList: 'Peringkat penjualan kartu hotel minggu lalu',
    cardSalesRanking: 'Peringkat penjualan kartu',
    employee2: 'Karyawan',
    numberOfCardsSold: 'Jumlah kartu terjual',
    amountOfCommission: 'Jumlah komisi',
  },
  detailcomponentsOnecarddialog: {
    waitingGuestToSwipeCard: 'Menunggu tamu menggesek kartu',
    paymentInProcess: 'Pembayaran sedang diproses',
    guestPaymentSuccess: 'Pembayaran tamu berhasil',
    guestPaymentFailedPleaseInitiatePaymentAgain:
      'Pembayaran tamu gagal, silakan mulai penagihan ulang',
  },
  customerPSearch: {
    singleStoreMembershipLevel: 'Level keanggotaan satu toko',
    enterYourNamePhoneNumberAndCardNumber:
      'Masukkan nama, nomor ponsel, dan nomor kartu untuk pencarian',
  },
  customerPTable: {
    topUp: 'Isi ulang',
    gift: 'Hadiah',
    viewMembers2: 'Lihat anggota',
    modifyMembership2: 'Ubah keanggotaan',
    storedValueDeduction: 'Pengurangan saldo',
    integralChange2: 'Perubahan poin',
    integralQuery2: 'Pencarian poin',
    storedValueQuery2: 'Pencarian saldo',
    rechargeAllAccumulatedRechargeAmounts: 'Isi ulang: total akumulasi pengisian',
    giftAllAccumulatedGiftAmounts: 'Hadiah: total akumulasi hadiah',
    consumptionAllAccumulatedConsumptionAmounts: 'Konsumsi: total akumulasi konsumsi',
    refundAllAccumulatedRefundAmounts: 'Pengembalian dana: total akumulasi pengembalian',
    distributionSettings: 'Pengaturan distribusi',
  },
  componentsNightaudit: {
    theCurrentBusinessDayIs: 'Hari operasional saat ini adalah',
    startTheNightTrial: 'Mulai audit malam',
    theNightTrialIsInProgressAndCannotBeClosed:
      'Audit malam sedang berlangsung dan tidak dapat ditutup',
    immediateFeedback: 'Umpan balik langsung',
    nightAuditCompleted: 'Audit malam selesai',
    nightTrialInProgress: 'Audit malam berlangsung',
    nightTrialNewsNotice2: 'Pemberitahuan audit malam',
    nightAuditFailedPleaseHandleAccordingToThePromptAndPerformTheNightAuditAgainIfYouEncounterAnyProblemsPleaseContactTechnicalSupport:
      'Audit malam gagal, silakan tangani sesuai petunjuk lalu jalankan kembali audit malam. Jika mengalami masalah, silakan hubungi dukungan teknis',
  },
  componentsNightauditGrayEnv: {
    nightTrialNewsNotice2: 'Pemberitahuan audit malam',
    procedure: 'Prosedur',
    mistake: 'Kesalahan',
    carryOut: 'Jalankan',
    nightAuditFailureToEncounterProblemsCanBeInTheMorningAfter8OclockAsSoonAsPossibleToContactTechnicalSupportToHelpSolve:
      'Jika audit malam gagal dan terjadi masalah, silakan hubungi dukungan teknis sesegera mungkin setelah pukul 08.00 pagi untuk membantu penyelesaian',
    whenAnErrorOccursTheNightAuditStopsPleaseConfirmItCarefully:
      'Saat terjadi kesalahan, audit malam akan berhenti. Silakan konfirmasi dengan cermat',
  },
  componentsOpenPageLayout: {
    backToHomePage: 'Kembali ke beranda',
  },
  componentsShiftchoose: {
    pleaseSelectFlightSchedule: 'Silakan pilih shift',
    hello: ', halo!',
  },
  baseBasemultipleselect: {
    thisOptionWasNotFound: 'Opsi ini tidak ditemukan',
  },
  printsettingHalfprint: {
    test: 'Tes',
    print: 'Cetak',
    trisection: 'Tiga bagian',
    printInThirds: 'Cetak tiga bagian',
    printInHalf: 'Cetak dua bagian',
  },
  printsettingPrint: {
    print: 'Cetak',
  },
  printsettingSmallprint: {
    feeName: 'Nama biaya',
    totalConsumption: 'Total konsumsi',
  },
  hardwareIdcardbtn: {
    readIdentityCard: 'Baca kartu identitas',
  },
  hardwareReaddoorcard: {
    pleasePlaceYourKeyCardOnTheCardReader: 'Silakan letakkan kartu pintu pada pembaca kartu',
    effectiveTime: 'Waktu berlaku',
    failureTime: 'Waktu kedaluwarsa',
    readCard: 'Baca kartu',
    failedToObtainTheLockInformationProcedure: 'Gagal mendapatkan informasi kunci pintu',
    thisCardIsNotAGuestCardPleaseReBusinessCardPrinting:
      'Kartu ini bukan kartu tamu, silakan cetak ulang kartu',
    wheatDoorLockPlugInReadCard: 'Plugin kunci pintu Wheat membaca kartu',
    the: '',
    wheatDoorLockPlugInCancellationCard: 'Plugin kunci pintu Wheat pembatalan kartu',
    cardReadingFailure: 'Gagal membaca kartu',
  },
  componentsFeedback: {
    selectAttachment: 'Pilih lampiran',
    viewFeedbackLog: 'Lihat riwayat umpan balik',
    commitFailure: 'Gagal mengirim',
    problemFeedback3: 'Umpan balik masalah',
    pleaseEnterTheContactName4: 'Silakan masukkan nama kontak',
    pleaseEnterAContactNumber3: 'Silakan masukkan nomor kontak',
    uploadAttachment2: 'Unggah lampiran',
    pleaseEnterADetailedDescriptionOfTheProblem2: 'Silakan masukkan deskripsi masalah secara rinci',
    theUploadedFilesCannotExceed: 'File yang diunggah tidak boleh melebihi',
    aMaximumOfFiveFilesCanBeUploaded2: 'Maksimal 5 file dapat diunggah',
    aMaximumOfFiveFilesCanBeUploadedTheSizeOfEachFileCannotExceed20Mb:
      'Maksimal 5 file dapat diunggah, ukuran tiap file tidak boleh melebihi 20MB, format yang didukung',
    pleaseExplainTheProblemAndEnterTheQqNumberToFacilitateContact:
      'Silakan jelaskan masalah dan masukkan nomor QQ agar mudah dihubungi',
  },
  componentsFeedjump: {
    lightWinTreasureSmallProgram: 'Mini program LightWin Treasure',
    scanCodeUsingASmallProgram: 'Pindai kode untuk menggunakan mini program',
    realTimeControlOfRoomStatus: 'Kontrol status kamar secara real-time',
    onlineOneClickPriceAdjustment: 'Penyesuaian harga online satu klik',
    memberDevelopmentTools: 'Alat pengembangan anggota',
    moreFeaturesComingOnline: 'Lebih banyak fitur segera hadir',
    hotelOperationCarefulAssistant: 'Operasional hotel · asisten yang peduli',
  },
  componentsGethelp: {
    getHelp: 'Dapatkan bantuan',
  },
  componentsGoappshop: {
    applicationMarket: 'Pasar aplikasi',
  },
  componentsJointrain: {
    attendTraining: 'Ikuti pelatihan',
  },
  componentsLeftcontent: {
    hotelOperationsManager: 'Manajer operasional hotel',
    cityOperationsManager: 'Manajer operasional kota',
    customerServiceHotline: 'Hotline layanan pelanggan',
  },
  componentsTrain: {
    trainingCoursesAreInFullSwing: 'Kursus pelatihan sedang berlangsung',
    getDetailedTrainingNoticesAndMaterials: 'Dapatkan pemberitahuan dan materi pelatihan lengkap',
    followThelightStaySystemServicePublicAccount: 'Ikuti akun resmi “Layanan Sistem LightStay”',
    basicCourseIntroductorySeries: 'Kursus dasar: seri pengantar',
    mondayAndWednesday1430Start: 'Setiap Senin & Rabu mulai pukul 14:30',
    advancedCourseComplexScenesCommonQuestionsRecentNewFeatures:
      'Kursus lanjutan: skenario kompleks + pertanyaan umum + fitur terbaru',
    friday1430Start: 'Setiap Jumat mulai pukul 14:30',
  },
  merchantPCtxTab: {
    oldFinancialReconciliationSystem: 'Sistem rekonsiliasi keuangan lama',
    lightCommissionSubsidyHasBeenMovedToMemberIncentivePleaseGoToMemberIncentiveToConfirmTheBill:
      'Subsidi komisi LightStay telah dipindahkan ke insentif anggota, silakan ke menu insentif anggota untuk konfirmasi tagihan',
  },
  merchantPCtxTab1: {
    oldFinancialReconciliationSystem: 'Sistem rekonsiliasi keuangan lama',
    lightCommissionSubsidyHasBeenMovedToMemberIncentivePleaseGoToMemberIncentiveToConfirmTheBill:
      'Subsidi komisi LightStay telah dipindahkan ke insentif anggota, silakan ke menu insentif anggota untuk konfirmasi tagihan',
  },
  merchantPSearchqu: {
    enterHotelName: 'Masukkan nama hotel',
  },
  payIndex: {
    toBePaid: 'Menunggu pembayaran',
    pleaseScanQrCodeToCompletePayment: 'Silakan pindai kode QR untuk menyelesaikan pembayaran',
    canBeClosedAfter: 'dapat ditutup setelah',
    paymentSuccess: 'Pembayaran berhasil',
    automaticShutdownInSeconds: 'detik kemudian ditutup otomatis',
    automaticPageRefresh: 'Penyegaran halaman otomatis',
    duringThePayment: 'Sedang membayar',
    paymentAnomaly: 'Pembayaran tidak normal',
    ifThePaymentIsAbnormalContactTechnicalSupport:
      'Jika pembayaran tidak normal, silakan hubungi dukungan teknis',
    paymentFailure: 'Pembayaran gagal',
    payOff: 'Pembayaran ditutup',
    waitForTheUserToScanTheCode: 'Menunggu pengguna memindai kode',
    currentStatusOfLehuiPayment: 'Status pembayaran Lehui saat ini',
    theGunScannedTheCodeSuccessfully: 'Pemindai berhasil memindai kode',
    theUserHasPaidSuccessfully: 'Pengguna telah berhasil membayar',
    ifTheUserDoesNotPayItCanBeReRecordedInTheFinancePage:
      'Jika pengguna tidak membayar, dapat dicatat ulang di halaman keuangan',
  },
  sellCalctable: {
    maximumPromotion: 'Promosi maksimum',
    nonMemberSellingPricebrestimatedSettlementPrice:
      'Harga jual non-anggota<br>/perkiraan harga penyelesaian',
    ordinaryMemberSellingPricebrestimatedSettlementPrice:
      'Harga jual anggota biasa<br>/perkiraan harga penyelesaian',
    goldMemberSellingPricebrestimatedSettlementPrice:
      'Harga jual anggota emas<br>/perkiraan harga penyelesaian',
    platinumMemberSellingPricebrestimatedSettlementPrice:
      'Harga jual anggota platinum<br>/perkiraan harga penyelesaian',
    diamondMemberSellingPricebrestimatedSettlementPrice:
      'Harga jual anggota berlian<br>/perkiraan harga penyelesaian',
  },
  sellPTableTdNew: {
    noData: 'Tidak ada data',
  },
  sellPricecalc: {
    channelSellingPriceCalculator: 'Kalkulator harga jual saluran',
    selectRoomType: 'Pilih tipe kamar',
    pleaseSelectRoomType: 'Silakan pilih tipe kamar',
    selectProduct: 'Pilih produk',
    pleaseSelectAProductName: 'Silakan pilih nama produk',
    selectSaleDate: 'Pilih tanggal penjualan',
    distributionChannel: 'Saluran distribusi',
    pleaseSelectTheDistributionChannelNamenotRequired:
      'Silakan pilih nama saluran distribusi (opsional)',
    canNotExceed: 'Tidak boleh melebihi',
    pleaseSelectASaleDate: 'Silakan pilih tanggal penjualan',
    figure: 'Angka',
  },
  filtersIndex: {
    all: 'Semua',
    sinceThe: 'Sejak',
    free: 'Gratis',
    group: 'Grup',
    association: 'Asosiasi',
    theClock: 'Per jam',
    long: 'Jangka panjang',
    inapplicability: 'Tidak berlaku',
    haveProcessed: 'Sudah diproses',
    notProcessed: 'Belum diproses',
    averageSalesRate: 'Harga jual rata-rata',
    consumptionNight: 'Malam konsumsi',
    averageHousePriceOfConsumption: 'Harga kamar rata-rata konsumsi',
    onlinePermeability: 'Tingkat penetrasi online',
    cancelNight: 'Malam dibatalkan',
    rejectionNight: 'Malam ditolak',
    channelProvision: 'Disediakan oleh saluran',
    theHotelProvides: 'Disediakan oleh hotel',
  },
  jsonBookertypeoptions: {
    singleStoreMember: 'Anggota toko tunggal',
    lightLivingMember: 'Anggota LightStay',
  },
  layoutIndex: {
    collapseMenuBar: 'Lipat bilah menu',
  },
  componentsNavbar: {
    shiftManagement: 'Manajemen pergantian shift',
    helpCenter: 'Pusat bantuan',
    logout: 'Keluar',
    reportTitle: 'Laporan ringkasan serah terima shift',
    headers: {
      income: 'Pendapatan',
      expend: 'Pengeluaran',
      total: 'Total jumlah',
    },
  },
  componentsSidemessage: {
    orderNotice: 'Pemberitahuan pesanan',
    orderMessageReceivedNotification: 'Notifikasi pesan pesanan diterima',
    youDoNotHaveOrderManagementPermission: 'Anda belum memiliki izin manajemen pesanan',
    ignore: 'Abaikan',
    order: 'Pesan pesanan',
    noData: 'Tidak ada pesan baru',
    system: 'Pesan sistem',
    settlement: 'Pesan penyelesaian',
    dynamic: 'Pesan dinamis',
    serviceManagement: 'Manajemen tiket layanan',
    roomService: 'Layanan kamar',
    itemBorrow: 'Peminjaman barang',
    extendStay: 'Layanan perpanjangan menginap',
    manualEntry: 'Entri manual',
    confirmOrder: 'Konfirmasi pesanan',
    viewOrder: 'Lihat pesanan',
    youDoNotHaveAccessToEbkOrderManagement: 'Anda belum memiliki akses manajemen pesanan EBK',
    youReceive: 'Anda menerima',
    aNewMessage: 'pesan baru',
    have: 'memiliki',
    orderMessage: 'pesan pesanan',
    aNewSystemMessage: 'pesan sistem baru',
    aNewSettlementMessage: 'pesan penyelesaian baru',
  },
  componentsSoundnotice: {
    playOut: 'Pemutaran selesai',
    theVoicePromptsThatAMessageIsReceived: 'Notifikasi suara saat pesan diterima',
  },
  nightcheckNightStart: {
    nightTrialSequence: 'Urutan audit malam',
    nightAuditInstructions2: 'Petunjuk audit malam',
  },
  nightcheckNightTip: {
    theHotelHasNotBeenAuditedAtNightInOrderToAvoidAffectingTheHotelsRevenueDataPleaseStartTheNightAuditAsSoonAsPossible:
      'Hotel belum menjalankan audit malam. Untuk menghindari dampak pada data pendapatan hotel, silakan mulai audit malam sesegera mungkin',
    nightAuditInstructions2: 'Petunjuk audit malam',
    beforeTheNightAuditPleaseBeSureToCheckWhetherTheHotelsAccountingDataIsCorrectInAdvanceToAvoidAffectingTheHotelsRevenue:
      'Sebelum audit malam, pastikan untuk memeriksa terlebih dahulu apakah data akuntansi hotel sudah benar agar tidak memengaruhi pendapatan hotel',
    pleaseConfirmThatAllCheckInAndCheckOutOrdersForTheCurrentBusinessDayHaveBeenProcessed:
      'Pastikan semua pesanan check-in dan check-out pada hari operasional saat ini telah diproses',
    youHaveSetUpANightAuditToAutomaticallyCancelTheStoreOrdersThatHaveNotArrived:
      'Anda telah mengatur audit malam untuk otomatis membatalkan pesanan toko yang belum tiba',
    preArrivalAutoCheckIn: 'Anda telah mengatur check-in otomatis untuk pesanan pra-kedatangan saat audit malam',
    preArrivalAutoNoshow: 'Anda telah mengatur penandaan no-show otomatis untuk pesanan pra-kedatangan saat audit malam',
    preDepartureAutoCheckOut: 'Anda telah mengatur check-out otomatis untuk pesanan pra-keberangkatan saat audit malam',
    preDepartureAutoExtendStay: 'Anda telah mengatur perpanjangan menginap otomatis untuk pesanan pra-keberangkatan saat audit malam',
    theEarliestTimeForManualNightAuditIs: 'Waktu paling awal untuk audit malam manual adalah',
    nightAuditProcess: 'Proses audit malam',
    hotelBusinessDaysAreNowGreaterThanNaturalDays:
      'Hari operasional hotel saat ini telah melebihi hari kalender',
    nightAuditReminder: 'Pengingat audit malam',
    hotelBusinessDay: 'Hari operasional hotel',
    currentNaturalDay: 'Hari kalender saat ini',
    viewLogs: 'Lihat log',
    theNightTrialWasCompleted: 'Audit malam telah selesai',
    nightAuditStartTimeCanNotBeEarlierThan21OclockCanNotPerformNightAuditOperationOh:
      'Waktu mulai audit malam tidak boleh lebih awal dari pukul 21.00, tidak dapat menjalankan audit malam',
    thereIsAnOngoingNightTrialPleaseDoNotRepeatTheProcedure:
      'Audit malam sedang berlangsung, mohon jangan mengulangi proses',
  },
  nightcheckNightTipGrayEnv: {
    theCurrentBusinessDayOfTheHotelIsLongerThanTheNaturalDayOrTheNightAuditCanNotStartEarlierThan21OclockCanNotPerformTheNightAuditOperation:
      'Hari operasional hotel saat ini telah melebihi hari kalender, atau audit malam tidak dapat dimulai sebelum pukul 21.00 sehingga tidak dapat dijalankan',
    theNightTrialHasNotBeenCompletedPleaseExecuteTheNightTrialAsSoonAsPossible:
      'Audit malam belum selesai, silakan jalankan audit malam sesegera mungkin',
  },
  globalMethodsmixin: {
    hotelChangeAlert: 'Peringatan perubahan hotel',
    theHotelIsCurrentlyFrom: 'Hotel saat ini dari',
    switchTo: 'Beralih ke',
  },
  regularIndex: {
    pleaseEnterTheCorrectEmailAddress: 'Silakan masukkan alamat email yang benar',
    pleaseEnterTheCorrectIdNumber: 'Silakan masukkan nomor KTP yang benar',
    pleaseEnterTheCorrectIdNumber2: 'Silakan masukkan nomor dokumen yang benar',
  },
  sidebarLogo: {
    helpCenter2: 'Pusat bantuan',
  },
  modulesMember: {
    drench: 'LightStay',
  },
  modulesUser: {
    client: 'Pelanggan',
    membershipManagement: 'Manajemen keanggotaan',
    singleStoreMemberManagement: 'Manajemen anggota toko tunggal',
    storeValueManagement: 'Manajemen saldo tersimpan toko tunggal',
    singleStorePointsSetting: 'Pengaturan poin toko tunggal',
    storeValueReport: 'Laporan saldo tersimpan toko tunggal',
    failedToObtainOperationInformationProcedure: 'Gagal mendapatkan informasi operasional',
    billReconciliation: 'Rekonsiliasi tagihan',
    paymentRecord: 'Catatan pembayaran',
    expenseStatement: 'Laporan biaya',
  },
  utilsAddroute: {
    initializesTheReceivableFinancialMenu: 'Inisialisasi menu keuangan piutang',
  },
  utilsDoorcard: {
    initializationFailure: 'Inisialisasi gagal',
    noKeyCardReaderPlugInFound: 'Plugin pembaca kartu tidak ditemukan',
    cardReadingError: 'Kesalahan pembacaan kartu',
    plugIn: 'Plugin',
    cardReadingResult: 'Hasil pembacaan kartu',
    cardReadingFailure: 'Gagal membaca kartu',
    businessCardWriteData: 'Penulisan data kartu',
    businessCardPrintingResult: 'Hasil pembuatan kartu',
    businessCardFailure: 'Pembuatan kartu gagal',
    logoutStatusCode: 'Kode status pembatalan',
    logoutFailure: 'Pembatalan gagal',
  },
  utilsDoorcardmaitian: {
    noKeyCardReaderPlugInFound: 'Plugin pembaca kartu tidak ditemukan',
    cancelTheCardSuccessfully: 'Pembatalan kartu berhasil',
    readTheCardSuccessfully: 'Pembacaan kartu berhasil',
  },
  utilsEnum: {
    roomInNeedOfRepair: 'Kamar perlu perbaikan',
    guestRequest: 'Permintaan tamu',
    hotelRowRoomDemand: 'Kebutuhan penempatan kamar hotel',
    inProcess: 'Sedang diproses',
    alreadyEnded: 'Sudah berakhir',
    storeOrderPreArrivalHasNotBeenChecked:
      'Pemeriksaan pesanan toko pra-kedatangan belum dilakukan',
    leaveTheRoomForInspectionToday: 'Pemeriksaan kamar pra-keberangkatan hari ini',
    generateRoomChargesInTheRoom: 'Menghasilkan biaya kamar untuk kamar yang dihuni',
    cleanRoomToDirtyRoom: 'Kamar bersih menjadi kotor',
    switchingDay: 'Pergantian hari operasional',
    preArrivalNoShowRoomListPending: 'Pra-kedatangan tidak datang, daftar kamar menunggu check-in',
    preSeparationIsNotSeparated: 'Pra-keberangkatan belum berangkat',
    allRoomChargesAreGeneratedAndRecordedInTheAccount:
      'Semua biaya kamar untuk kamar yang dihuni telah dihasilkan dan dicatat',
    roomChange: 'Perubahan status kamar',
    generateCureReport: 'Hasilkan laporan final',
    shopHourRoom: 'Kamar per jam toko',
    onlineHourRoom: 'Kamar per jam online',
    presaleFullDayRoomProduct: 'Produk pra-jual kamar sehari penuh',
    presaleClockRoomProduct: 'Produk pra-jual kamar per jam',
  },
  utilsFreego: {
    theCardReaderIsNotConnectedToTheComputer: 'Pembaca kartu tidak terhubung ke komputer',
    checkValueError: 'Kesalahan nilai verifikasi',
    passwordError: 'Kata sandi salah',
    readCard: 'Baca kartu',
    cardReaderCommunicationIsNormal: 'Komunikasi pembaca kartu normal',
    businessCardPrintingSoftwareIsNotOpened: 'Perangkat lunak pembuatan kartu tidak dibuka',
    theReaderIsNotConnectedOrTheSoftwareIsNotOpen:
      'Pembaca kartu tidak terhubung atau perangkat lunak tidak dibuka',
    sorryYourBrowserDoesNotSupportCardReaderPleaseUseChrome:
      'Maaf, browser Anda tidak mendukung fungsi pembaca kartu. Silakan gunakan browser Chrome',
  },
  utilsIdcard: {
    idCardReaderIsConnectedToScanYourIdCardConnectTheIdCardScannerToYourComputerAndRefreshThePage:
      'Pembaca KTP terhubung. Untuk memindai KTP, hubungkan pemindai ke komputer dan segarkan halaman',
    toScanDocumentsInstallTheIdCardReaderControl:
      'Untuk memindai dokumen, silakan instal kontrol pembaca KTP',
    abnormalReadingIdCardPleaseRefreshAndTryAgain:
      'Pembacaan KTP tidak normal, silakan segarkan dan coba lagi',
    noIdInformationIsReadPleaseCheckWhetherTheIdCardIsPlacedOrPlacedInTheCorrectPosition:
      'Informasi dokumen tidak terbaca, silakan periksa apakah KTP telah diletakkan dengan benar',
  },
  utilsIndex: {
    justNow: 'Baru saja',
    aMinuteAgo: 'menit yang lalu',
    hoursAgo: 'jam yang lalu',
    month: 'Bulan',
    when: 'Jam',
    connectionSuccessful: 'Koneksi berhasil',
    theGlobalConnectionIsClosed: 'Koneksi global telah ditutup',
    yourBrowserDoesNotSupportIt: 'Browser Anda tidak mendukung',
  },
  utilsLinktopage: {
    contactTheAdministratorToEnableIt: 'Silakan hubungi administrator untuk mengaktifkan',
    noCorrespondingLedgerFound: 'Tidak ditemukan buku akun yang sesuai',
    accountReceivable: 'Piutang',
    administrativeAuthority: 'Hak administratif',
  },
  utilsRequest: {
    doNotRepeatRequests: 'Mohon jangan mengulangi permintaan',
    noFlightFoundPleaseSelectAgain: 'Tidak ditemukan jadwal, silakan pilih kembali',
    systemErrorPleaseContactTechnicalSupport: 'Kesalahan sistem, silakan hubungi dukungan teknis',
    networkException: 'Gangguan jaringan',
    requestTimedOutPleaseRefreshThePage: 'Permintaan waktu habis, silakan segarkan halaman',
    requestTimeout: 'Permintaan waktu habis',
    requestFailed: 'Permintaan gagal',
  },
  utilsSharestorage: {
    putInTheInitialMarker: 'Tambahkan penanda awal',
  },
  appdetailIndex: {
    specification: 'Spesifikasi',
    contactBusinessManager: 'Hubungi manajer bisnis',
    buyNow: 'Beli sekarang',
    applicationIntroduction: 'Pengenalan aplikasi',
    workingHours: 'Jam kerja',
    pleaseSelectProductSpecifications: 'Silakan pilih spesifikasi produk',
  },
  applistIndex: {
    fullApplication: 'Semua aplikasi',
    haveOpened: 'Sudah dibuka',
    haveNotOpened: 'Belum dibuka',
    inService: 'Sedang aktif',
    contactBusinessManager: 'Hubungi manajer bisnis',
    workingHours: 'Jam kerja',
    openImmediately: 'Buka sekarang',
    immediateRenewal: 'Perpanjang sekarang',
    expiredDays: 'Kedaluwarsa {days} hari',
    daysLeftToExpire: 'Tersisa {days} hari hingga kedaluwarsa',
  },
  createorderIndex: {
    goToPay: 'Pergi membayar',
    remaining: 'Sisa',
    orderProduct2: 'Produk pesanan',
    purchaser2: 'Pembeli',
    specification: 'Spesifikasi',
    successfulCustomsOrder2: 'Penutupan pesanan berhasil',
  },
  createorderPay: {
    amountPaid: 'Jumlah dibayar',
    paymentCountdown: 'Hitung mundur pembayaran',
    qrCodeHasExpired: 'Kode QR telah kedaluwarsa',
    updateNow: 'Perbarui sekarang',
    payment3: 'Pembayaran',
    scanQRCode: 'Silakan gunakan WeChat/Alipay untuk memindai kode QR dan membayar',
  },
  orderlistIndex: {
    orderDate: 'Tanggal pemesanan',
    product: 'Produk',
    toBePaid: 'Menunggu pembayaran',
    paymentSuccess: 'Pembayaran berhasil',
    paymentFailure: 'Pembayaran gagal',
    refunded: 'Telah dikembalikan',
    partialRefund: 'Pengembalian sebagian',
    goToPay: 'Pergi membayar',
    orderTime: 'Waktu pemesanan',
    orderProduct2: 'Produk pesanan',
    orderSpecification: 'Spesifikasi pesanan',
    refundAmount: 'Jumlah pengembalian',
    orderEffectiveTime: 'Waktu efektif pesanan',
    purchaser2: 'Pembeli',
    orderOperation: 'Operasi pesanan',
    successfulCustomsOrder2: 'Penutupan pesanan berhasil',
  },
  commentChannelComment: {
    modifyReply: 'Ubah balasan',
    setAsTemplate: 'Tetapkan sebagai template',
    selectRecommendedTemplate: 'Pilih template rekomendasi',
    inputReplyContentNoMoreThan10WordsAndNoMoreThan500Words:
      'Masukkan isi balasan, jumlah kata minimal 10 dan maksimal 500',
    theMaximumResponseTextIs500Characters: 'Teks balasan maksimal 500 karakter',
    areYouSureYouWantToDeleteReplies: 'Apakah Anda yakin ingin menghapus balasan?',
  },
  commentCommentTempManage: {
    newTemplate: 'Buat template baru',
    goodReputation: 'Ulasan positif',
    delete2: 'Hapus',
    templateName: 'Nama template',
    replyClassification: 'Kategori balasan',
    replyContent2: 'Isi balasan',
    pleaseEnterAtLeast10Characters: 'Silakan masukkan minimal 10 karakter',
    keyword: 'Kata kunci',
    pleaseEnterTheKeywordsThatYouWantToMatchTheCommentsSeparatedByCommas:
      'Silakan masukkan kata kunci untuk mencocokkan komentar, pisahkan dengan koma',
    pleaseEnterATemplateName: 'Silakan masukkan nama template',
    theValueCanContainNoMoreThan15Characters: 'Panjang maksimal 15 karakter',
    pleaseSelectAReplyCategory: 'Silakan pilih kategori balasan',
    pleaseEnterTheReplyContent: 'Silakan masukkan isi balasan',
    '10To500CharactersInLength': 'Panjang 10 hingga 500 karakter',
    theValueContainsAMaximumOf50Characters: 'Panjang maksimal 50 karakter',
    definitiveDeletion: 'Hapus secara permanen',
    deletingATemplateSucceeded: 'Template berhasil dihapus',
    creatingATemplateSucceeded: 'Template berhasil dibuat',
  },
  commentComment: {
    reasonForNotPassing: 'Alasan tidak lolos',
    setAsTemplate: 'Tetapkan sebagai template',
    replyAgain: 'Balas kembali',
    reappeal: 'Ajukan banding ulang',
    inComplaint: 'Dalam proses banding',
    typeOfAppeal: 'Jenis banding',
    statementOfAppeal: 'Penjelasan banding',
    selectRecommendedTemplate: 'Pilih template rekomendasi',
    inputTheReplyContentTheNumberOfWordsMoreThan10And300Words:
      'Masukkan isi balasan, jumlah kata minimal 10 dan maksimal 300',
    theMaximumResponseTextIs500Characters: 'Teks balasan maksimal 500 karakter',
    areYouSureYouWantToDeleteReplies: 'Apakah Anda yakin ingin menghapus balasan?',
  },
  commentComplain: {
    onceYourComplaintHasBeenReviewedTheCommentWillBeAutomaticallyDeleted:
      'Setelah banding Anda disetujui, sistem akan otomatis menghapus komentar tersebut',
    youCanUploadUpToFivePictures: 'Maksimal dapat mengunggah lima gambar',
    launchAComplaint: 'Ajukan banding',
    typeOfAppeal: 'Jenis banding',
    statementOfAppeal: 'Penjelasan banding',
    uploadCredentials: 'Unggah bukti',
    pleaseFillInTheContact: 'Silakan isi kontak',
    pleaseEnterTheCorrectName: 'Silakan masukkan nama yang benar',
    pleaseSelectTheAppealType: 'Silakan pilih jenis banding',
    theCauseOfTheComplaintMustBeAtLeast10Words: 'Alasan banding minimal 10 kata',
    theMaximumCauseOfAppealIs300Words: 'Alasan banding maksimal 300 kata',
    underAppeal: 'Sedang mengajukan banding',
    addAppealSuccess: 'Banding berhasil diajukan',
  },
  commentIndex: {
    totalEvaluation: 'Semua ulasan',
    waitForReply: 'Menunggu balasan',
    appealed: 'Sudah dibanting',
    allRoomTypes: 'Semua tipe kamar',
    noReplyYet: 'Belum dibalas',
    toBeReviewed: 'Menunggu peninjauan',
    notPass: 'Tidak lolos',
    alreadyPassed: 'Sudah lolos',
  },
  commentMain: {
    deleteReplySucceeded: 'Balasan berhasil dihapus',
    modifiedReplySucceeded: 'Balasan berhasil diubah',
  },
  commentPreview: {
    viewPicture: 'Lihat gambar',
  },
  commentReplyList: {
    replyDate: 'Tanggal balasan',
    commentChannel: 'Saluran komentar',
    review2: 'Ulasan',
    replyContent2: 'Isi balasan',
    commentReply: 'Balasan komentar',
    modifyReply: 'Ubah balasan',
    deleteReply: 'Hapus balasan',
    meituanReview: 'Ulasan Meituan',
    ctripReview: 'Ulasan Ctrip',
    whereToComment: 'Ulasan Qunar',
    sameTripReview: 'Ulasan Tongcheng',
    dianpingReviews: 'Ulasan Dianping',
    flyingPigReview: 'Ulasan Fliggy',
    parallelComment: 'Ulasan Tongcheng',
  },
  commentScore: {
    renewal: 'Perbarui',
    guestImpression: 'Kesan tamu',
    overallGuestRating: 'Penilaian keseluruhan tamu',
  },
  complainDetail: {
    issueDetails: 'Detail masalah',
    processingDetails: 'Detail penanganan',
    serviceProblem: 'Masalah layanan',
    healthProblem: 'Masalah kebersihan',
    processor: 'Penangani',
    processingTime: 'Waktu penanganan',
    communicationSituation: 'Situasi komunikasi',
  },
  complainHandle: {
    successfulProcessing: 'Penanganan berhasil',
    problemHandling: 'Penanganan masalah',
    roomInformation: 'Informasi kamar',
    guestInformation: 'Informasi tamu',
    communicationSituation: 'Situasi komunikasi',
    enterAMaximumOf300Characters: 'Maksimal 300 karakter',
    pleaseEnterTheProcessingResult: 'Silakan masukkan hasil penanganan',
  },
  complainIndex: {
    submissionDate: 'Tanggal pengajuan',
    processed: 'Sudah ditangani',
    submissionTime: 'Waktu pengajuan',
    feedbackProblem: 'Masalah umpan balik',
    untreated: 'Belum ditangani',
    viewTheResults: 'Lihat hasil',
  },
  ebkComment: {
    inputTheReplyContentTheNumberOfWordsMoreThan10And300Words:
      'Masukkan isi balasan, jumlah kata minimal 10 dan maksimal 300',
    theMaximumResponseTextIs300Characters: 'Teks balasan maksimal 300 karakter',
    modifiedReplySucceeded: 'Balasan berhasil diubah',
  },
  ebkGrade: {
    guestImpression: 'Kesan tamu',
  },
  ebkIndex: {
    totalEvaluation: 'Semua ulasan',
    waitForReply: 'Menunggu balasan',
  },
  customerCompany: {
    new: 'Tambah',
    whetherToAllowHangingAccounts2: 'Apakah mengizinkan piutang',
    loginListHidesRates: 'Sembunyikan harga kamar pada daftar login',
    confirmAction: 'Apakah yakin ingin {action} pelanggan perusahaan “{name}”?',
  },
  customerDialog: {
    whetherToAllowHangingAccounts2: 'Apakah mengizinkan piutang',
    theRegistrationFormHidesTheRoomRate: 'Sembunyikan harga kamar pada formulir pendaftaran',
    addACorporateClient: 'Tambah pelanggan perusahaan',
    changeCorporateAccount: 'Ubah pelanggan perusahaan',
    companyInformation: 'Informasi perusahaan',
    forShort: 'Singkatan',
    pleaseEnterCompanyAbbreviation: 'Silakan masukkan singkatan perusahaan',
    code: 'Kode',
    pleaseEnterTheCode: 'Silakan masukkan kode',
    legalPerson: 'Penanggung jawab hukum',
    pleaseEnterTheLegalPersonName: 'Silakan masukkan nama penanggung jawab hukum',
    fax: 'Faks',
    pleaseEnterTheFaxNumber: 'Silakan masukkan nomor faks',
    city: 'Kota',
    postcode: 'Kode pos',
    pleaseEnterPostalCode: 'Silakan masukkan kode pos',
    pleaseEnterDiscountRatio: 'Silakan masukkan rasio diskon',
    enterAMaximumOf100Characters: 'Maksimal 100 karakter',
    contactInformation: 'Informasi kontak',
    pleaseEnterTheContactNumber: 'Silakan masukkan nomor kontak',
    pleaseEnterEmail: 'Silakan masukkan email',
    setUp: 'Pengaturan piutang',
    pleaseEnterYourAccountName: 'Silakan masukkan nama akun',
    accountType: 'Jenis akun',
    maximumAmount: 'Batas maksimum',
    pleaseEnterDiscount: 'Silakan masukkan diskon',
    pleaseEnterAnIntegerBetween0And100: 'Silakan masukkan bilangan bulat antara 0–100',
    pleaseEnterTheCorrect11DigitMobileNumber: 'Silakan masukkan nomor ponsel 11 digit yang benar',
    pleaseEnterName: 'Silakan masukkan nama',
    pleaseEnterTheContactName3: 'Silakan masukkan nama kontak',
    creditAccount: 'Akun kredit',
    theCreditLimitCannotBeExceeded: 'Batas kredit tidak boleh melebihi',
    enterRange: 'Silakan masukkan angka dalam rentang 1–365',
  },
  customerIndex: {
    protocolUnitToBeDeveloped: 'Unit perjanjian, menunggu pengembangan',
  },
  heavenlyEyeCallThePolice: {
    alarmEvent: 'Peristiwa alarm',
    shootingTime: 'Waktu pengambilan gambar',
    theFollowingGuestsHaveNotBeenAddedToTheWhiteListSelectTheGuestsThatMatchThePhoto:
      'Tamu berikut belum ditambahkan ke daftar putih, pilih tamu yang sesuai dengan foto',
    stranger: 'Orang asing',
    whiteAdded: 'Ditambahkan ke daftar putih',
    ignored: 'Diabaikan',
    whitelist: 'Tambahkan ke daftar putih',
    environmentalPhotograph: 'Foto lingkungan',
    facePhoto: 'Foto wajah',
    pleaseSelectUser: 'Silakan pilih pengguna',
  },
  heavenlyEyeWhiteList: {
    personnelType: 'Jenis personel',
    addStaff: 'Tambah staf',
    pleaseEnterTheRoomNumber: 'Silakan masukkan nomor kamar',
    employee2: 'Karyawan',
    dweller: 'Penghuni',
    avatar: 'Avatar',
    photograph: 'Foto',
    pleaseSelectEnterName: 'Silakan pilih atau masukkan nama',
    pleaseCompleteTheFormBeforeSubmitting: 'Silakan lengkapi formulir sebelum mengirim',
    inputLabelDuplication: 'Label input duplikat',
    pleaseEnterTheLabelContent: 'Silakan masukkan isi label',
    doNotEnterLabelsInMoreThan10Words: 'Label tidak boleh lebih dari 10 kata',
    whetherToDeleteTheWhitelist: 'Apakah Anda yakin ingin menghapus daftar putih karyawan ini',
    uploadImageFormat: 'Gambar yang diunggah hanya boleh berformat JPG atau PNG!',
  },
  hicList: {
    dateOfPresentation: 'Tanggal pengajuan',
    dataExport: 'Ekspor data',
    bookingChannel: 'Saluran pemesanan',
    bodyTemperature: 'Suhu tubuh',
    healthStatus: 'Status kesehatan',
    theHealthInformationCollectionReportIsSuccessfullyExportedProcedure:
      'Laporan pengumpulan informasi kesehatan berhasil diekspor',
    failedToExportTheHealthInformationCollectionReportProcedure:
      'Gagal mengekspor laporan pengumpulan informasi kesehatan',
  },
  hicQrCode: {
    downloadPicture: 'Unduh gambar',
  },
  marketActivity: {
    couponType: 'Jenis kupon',
    couponName: 'Nama kupon',
    beOffline: 'Dinonaktifkan',
    terminated: 'Dihentikan',
    full: 'Minimum',
    reduction: 'Potongan',
    fromTheDateOfReceipt: 'Sejak tanggal penerimaan kupon',
    withinDays: 'hari berlaku',
    thisParameterIsValidWithinAFixedPeriod: 'Berlaku dalam periode waktu tetap',
    restrictedRoomNight: 'Batasan malam kamar',
    unlimited: 'Tidak terbatas',
    oneNight: 'Satu malam',
    discountType: 'Jenis diskon',
    validForTimePeriod: 'Berlaku dalam periode waktu',
    instructionsForUse: 'Petunjuk penggunaan',
    selectionOfParticipatingGoods: 'Pilih produk yang berpartisipasi',
    allGoods: 'Semua produk',
    platform: 'Platform',
    theNameOfTheCouponWillBeDisplayedToTheUserPleaseFillItInCarefully:
      'Nama kupon akan ditampilkan kepada pengguna, harap diisi dengan cermat',
    denomination: 'Nominal',
    fillInTheCouponAmountdiscountAmount: 'Isi nominal kupon (jumlah diskon)',
    pleaseSelectTheYearMonthAndDay2: 'Silakan pilih tahun, bulan, dan hari',
    instructionsWillBeDisplayedToTheUserPleaseFillInCarefully:
      'Petunjuk penggunaan akan ditampilkan kepada pengguna, harap diisi dengan cermat',
    viewActivity: 'Lihat aktivitas',
    maxOut: 'Potongan minimum',
    availableForBooking1Room1NightOnly: 'Hanya berlaku untuk pemesanan 1 kamar 1 malam',
    events: 'Aktivitas',
    orderNeedsToBeFull: 'Pesanan harus mencapai',
    issued: 'Telah diterbitkan',
    haveBeenUsed: 'Telah digunakan',
    expired2: 'Kedaluwarsa',
    editCoupon: 'Edit kupon',
    addCoupon: 'Tambah kupon',
    pleaseSelectTheOfferType: 'Silakan pilih jenis penawaran',
    pleaseEnterExpiryDate2: 'Silakan masukkan masa berlaku',
    pleaseSelectExpirationDate: 'Silakan pilih masa berlaku',
    pleaseEnterTheCouponName2: 'Silakan masukkan nama kupon',
    amountCanOnlyBeEnteredInPositiveIntegersPleaseReEnter:
      'Jumlah hanya boleh berupa bilangan bulat positif, silakan masukkan ulang',
    successfulActivation: 'Aktivasi berhasil',
    deactivated: 'Aktivasi dibatalkan',
    pleaseConfirmWhetherYouWantToTerminate: 'Silakan konfirmasi apakah Anda ingin menghentikan',
    terminationSuccess: 'Penghentian berhasil',
    cancelledTermination: 'Penghentian dibatalkan',
    pleaseEnterTheValidityPeriod: 'Silakan masukkan periode berlaku',
    createACoupon: 'Buat kupon',
    unedited: 'Edit dibatalkan',
    discountTemplate: 'Potongan langsung { money }',
    fullReductionTemplate: 'Potongan minimum { minAmount }',
    validityDaysTemplate: 'Berlaku dalam { day } hari sejak tanggal penerimaan kupon',
    activationConfirmation:
      'Setelah kupon diaktifkan, tidak dapat diubah lagi. Apakah Anda yakin ingin mengaktifkannya?',
    importValidationWarning:
      'Sebagian validasi hotel impor mengalami pengecualian, apakah ingin melanjutkan?',
  },
  marketActivitydata: {
    classificationSpecification: 'Penjelasan klasifikasi',
    data: 'Data',
    marketingRevenue: 'Pendapatan pemasaran',
    marketingExpenses: 'Biaya pemasaran',
    numberOfContacts: 'Jumlah jangkauan',
    numberOfVisitors: 'Jumlah pengunjung',
    numberOfTransactions: 'Jumlah transaksi',
    revenueDescription: 'Pendapatan yang dihasilkan dari pengguna yang terjangkau dalam 30 hari ',
    costDescription: 'Biaya pemasaran yang dikeluarkan dalam 30 hari ',
    reachCountDescription:
      'Jumlah pengguna yang terjangkau oleh aktivitas pemasaran dalam 30 hari (orang)',
    visitCountDescription:
      'Jumlah pengguna yang mengunjungi hotel ini setelah terjangkau dalam 30 hari (orang)',
    orderCountDescription:
      'Jumlah pengguna yang melakukan pemesanan setelah terjangkau dalam 30 hari (orang)',
  },
  marketCrowddata: {
    subdivide: 'Segmentasi',
    classificationSpecification: 'Penjelasan klasifikasi',
    numberOfPeople: 'Jumlah orang',
    membersWhoHaveStayedAtThisStore: 'Anggota yang pernah menginap di hotel ini',
    allMembers: 'Semua anggota',
    usersWhoHaveStayedInThisStoreInThePast1Year:
      'Pengguna yang menginap di hotel ini dalam 1 tahun terakhir',
    lowFrequencyMember: 'Anggota frekuensi rendah',
    usersWhoHaveStayedInTheLast1YearButHaveNotStayedInTheLast3Months:
      'Menginap dalam 1 tahun terakhir tetapi tidak menginap dalam 3 bulan terakhir',
    loyalUser: 'Pengguna loyal',
    usersWhoHaveStayedAtLeast3TimesInTheLast1Year:
      'Pengguna yang menginap lebih dari 3 kali dalam 1 tahun terakhir',
    lostUsers: 'Pengguna hilang',
    usersWhoHaveStayedInThePast2YearsAndHaveNotStayedInThePast1Year:
      'Menginap dalam 2 tahun terakhir namun tidak menginap dalam 1 tahun terakhir',
    interestedMember: 'Anggota berminat',
    interestedUserGroupsOfThisStore: 'Kelompok pengguna berminat di hotel ini',
    inThePast7DaysTheUserHasEnteredTheHomepageOfTheMiniProgramOfTheHotelAndHasNotPlacedAnOrder:
      'Dalam 7 hari terakhir, pengguna mengunjungi beranda mini program hotel ini tetapi tidak melakukan pemesanan',
    localInterestUserGroups: 'Kelompok pengguna berminat lokal',
    inThePast7DaysIHaveSearchedTheCityAndHotelWhereTheHotelIsLocated:
      'Dalam 7 hari terakhir, pengguna mencari kota dan hotel tempat hotel ini berada',
    orEnteredOtherHotelsInTheCityButDidNotPlaceAnOrder:
      'Atau mengunjungi hotel lain di kota ini namun tidak melakukan pemesanan',
    intraCityUserGroup: 'Kelompok pengguna dalam kota',
    usersWhoHaveStayedInTheCityInTheLast30DaysAreNotUsersOfThisStore:
      'Pengguna yang menginap di kota ini dalam 30 hari terakhir namun bukan pengguna hotel ini',
    createActivity: 'Buat aktivitas',
    lowFrequencyUser: 'Pengguna frekuensi rendah',
    marketingSuggestion:
      'Saran: segera buat aktivitas pemasaran untuk mempertahankan pengguna dan meningkatkan pemesanan!',
  },
  marketDatakb: {
    crowdDataBulletinBoard: 'Papan data audiens',
    activityDataKanban: 'Kanban data aktivitas',
  },
  marketDistribution: {
    releaseTime: 'Waktu distribusi',
    events: 'Aktivitas',
    releaseMode: 'Metode distribusi',
    smsSending: 'Pengiriman SMS',
    publicAccount: 'Akun publik',
    stopSmsPlatformPush: 'Penghentian push platform SMS LightStay',
    stopThePublicAccountPush: 'Penghentian push akun publik LightStay',
    iHaveReadAndAgree: 'Saya telah membaca dan menyetujui',
    precisionMarketingRules: 'Aturan pemasaran presisi',
    pleaseReadAndAgree: 'Silakan baca dan setujui',
    warmReminder: 'Pengingat hangat',
    issue: 'Terbitkan',
    couponName: 'Nama kupon',
    pleaseEnterTheCouponName2: 'Silakan masukkan nama kupon',
    sendingCrowd: 'Target pengiriman',
    pleaseSelectTheSender: 'Silakan pilih target pengiriman',
    quantityIssued: 'Jumlah diterbitkan',
    pleaseFillInTheNumberOfIssuedCards: 'Silakan isi jumlah kupon yang diterbitkan',
    sendingMode: 'Metode pengiriman',
    notificationTemplate: 'Template notifikasi',
    pleaseSelectANotificationTemplate: 'Silakan pilih template notifikasi',
    projectedCost: 'Perkiraan biaya',
    allUsers: 'Semua pengguna',
    interestedUsersOfThisStore: 'Pengguna berminat hotel ini',
    lostUsers: 'Pengguna hilang',
    loyalUser: 'Pengguna loyal',
    lowFrequencyUser: 'Pengguna frekuensi rendah',
    interestedUsersInTheSameCity: 'Pengguna berminat di kota yang sama',
    localUser: 'Pengguna lokal',
    unactivated: 'Belum diaktifkan',
    terminated: 'Dihentikan',
    voucherInformation: 'Informasi kupon',
    issuer: 'Penerbit',
    pleaseEnterTheReleaseQuantity: 'Silakan masukkan jumlah penerbitan',
    couponIssuedSuccessfully: 'Kupon berhasil diterbitkan',
    pleaseEnterCoupon: 'Silakan masukkan kupon',
    sendBatch: 'Batch pengiriman',
    pleaseEnterTheCorrectCoupon: 'Silakan masukkan kupon yang benar',
    perPersonUnit: 'lembar/orang',
    rule1:
      '1. Pembuatan aktivitas pemasaran tidak disarankan terlalu sering. LightStay memiliki mekanisme anti-kelelahan di sisi pengguna; dalam periode tertentu pengguna hanya dapat menerima jumlah terbatas push pemasaran/SMS.',
    rule2:
      '2. Untuk mencegah hotel terlalu sering menggunakan push pemasaran/SMS yang dapat mengganggu pengguna dan menurunkan citra merek hotel, fitur ini membatasi tiap saluran push sehingga pengguna hanya menerima 1 kali push dalam 7 hari.',
    rule3:
      '3. Push pemasaran/SMS tidak menjamin seluruhnya berhasil dikirim; hasil jangkauan aktual yang berlaku.',
    rule4:
      '4. Push pemasaran/SMS yang gagal dikirim akan dikembalikan biayanya, dan catatan pengiriman harus mencantumkan status berhasil atau gagal.',
  },
  marketRules: {
    rulesRulesRules: 'Aturan',
  },
  memberActivityManage: {
    longTerm: 'Jangka panjang',
    customInterval: 'Interval kustom',
    activeTime: 'Waktu aktivitas',
    addActivity: 'Tambah aktivitas',
    editingActivity: 'Edit aktivitas',
    editGear: 'Edit tingkatan',
    addGear: 'Tambah tingkatan',
    unlimited: 'Tidak terbatas',
    rechargeAmount2: 'Jumlah isi ulang',
    enabledState: 'Status aktif',
    activeState: 'Status aktivitas',
    pleaseEditTheAddedGears: 'Silakan edit tingkatan yang telah ditambahkan',
  },
  memberIntegralSetting: {
    integralRatioSetting: 'Pengaturan rasio poin',
    points: 'Poin',
    automaticCumulativePointSetting: 'Pengaturan akumulasi poin otomatis',
    storedValueConsumption: 'Konsumsi saldo tersimpan',
    nonCumulativeIntegral: 'Tidak mengakumulasi poin',
    pleaseFillInThePointsRatioSetting: 'Silakan isi pengaturan rasio poin',
    pleaseSelectTheAutomaticAccumulationPointSetting:
      'Silakan pilih pengaturan akumulasi poin otomatis',
    roomAndStoredConsumption: 'Konsumsi biaya kamar + saldo tersimpan',
    integralRatioLimit: 'Rasio poin hanya boleh berada dalam rentang 0.01 hingga 1000',
  },
  memberMemberManage: {
    pleaseArrangeMemberInformationAccordingToTheRequirementsInTheTemplate:
      'Silakan susun informasi anggota sesuai dengan persyaratan dalam template',
    downloadTemplate: 'Unduh template',
    freeCommissionPolicyTips: 'Tips kebijakan bebas komisi',
    downloadFailureData: 'Unduh data gagal',
    normal: 'Normal',
    registrationTime: 'Waktu pendaftaran',
    entryTime: 'Waktu input',
    augment: 'Tambah',
    decrease: 'Kurangi',
    singleStoreStoredValueBillPrinting: 'Pencetakan tagihan saldo tersimpan toko tunggal',
    theAmountOfMemberStoredValueIsOnlyAvailableInThisStoreAndIsNotAvailableInOtherStores:
      'Jumlah saldo tersimpan anggota hanya dapat digunakan di toko ini dan tidak berlaku di toko lain',
    currentMembersHaveUnusedBalancesOrPointsPleaseConfirmWhetherToDisable:
      'Anggota saat ini memiliki saldo atau poin yang belum digunakan, harap konfirmasi apakah akan menonaktifkan',
    lightLivingMember: 'Anggota LightStay',
    startOfEntryDate: 'Tanggal input mulai',
    dateOfEntry: 'Tanggal input akhir',
    membershipIntroduction: 'Impor anggota',
    memberExport: 'Ekspor anggota',
    newMember: 'Tambah anggota',
    viewGrade: 'Lihat level',
    viewMembers2: 'Lihat anggota',
    storedValueQuery2: 'Pencarian saldo tersimpan',
    transactionType: 'Jenis transaksi',
    registered: 'Terdaftar',
    unregistered: 'Belum terdaftar',
    theAmountOfThisStoredValue: 'Jumlah isi saldo kali ini',
    storedValueActivity: 'Aktivitas isi saldo',
    eventGiftAmount: 'Jumlah hadiah aktivitas',
    currentStoredValueBalance: 'Saldo tersimpan saat ini',
    storageTime: 'Waktu isi saldo',
    currentBalance: 'Saldo saat ini',
    topUpTheTotalAmount: 'Total jumlah isi ulang',
    totalGiftAmount: 'Total jumlah hadiah',
    totalPayment: 'Total pembayaran',
    totalRefundAmount: 'Total jumlah pengembalian',
    singleStoreMembershipLevel: 'Level anggota toko tunggal',
    storePoints: 'Poin toko tunggal',
    storedValueAccumulation: 'Akumulasi saldo tersimpan',
    incorrectEmailFormat: 'Format email tidak benar',
    membershipLevel: 'Level keanggotaan',
    occupation: 'Pekerjaan',
    pleaseEnterOccupation: 'Silakan masukkan pekerjaan',
    salespersonName: 'Nama sales',
    salespersonId: 'ID sales',
    pleaseEnterSalespersonId: 'Silakan masukkan ID sales',
    pleaseEnterTheSalespersonsName: 'Silakan masukkan nama sales',
    pleaseSelectTheYearMonthAndDay2: 'Silakan pilih tahun, bulan, dan hari',
    detailedAddress: 'Alamat lengkap',
    lv: 'Level',
    gradeName: 'Nama level',
    variableIntegral: 'Perubahan poin',
    pointBalance: 'Saldo poin',
    transactionAmount: 'Jumlah transaksi',
    changeType: 'Jenis perubahan',
    changeOfAmount: 'Jumlah perubahan',
    pleaseEnterAnInteger: 'Silakan masukkan bilangan bulat',
    topUpActivity: 'Aktivitas isi ulang',
    pleaseSelectAnActivity: 'Silakan pilih aktivitas',
    activeGear: 'Tingkatan aktivitas',
    rechargeAmount2: 'Jumlah isi ulang',
    pleaseEnterTheRechargeAmount: 'Silakan masukkan jumlah isi ulang',
    amountReceivable: 'Jumlah yang harus diterima',
    printDocuments: 'Cetak dokumen',
    deductionAmount: 'Jumlah pengurangan',
    pleaseEnterTheAmountOfDeduction: 'Silakan masukkan jumlah pengurangan',
    increaseTheIntegral: 'Tambah poin',
    reduceIntegral: 'Kurangi poin',
    filling: 'Isi',
    send: 'Kirim',
    pleaseEnterTheCorrectIdNumber: 'Silakan masukkan nomor KTP yang benar',
    pleaseEnterTheCorrectIdNumber2: 'Silakan masukkan nomor dokumen yang benar',
    pleaseFillInTheIdNumber: 'Silakan isi nomor dokumen',
    operationFailure: 'Operasi gagal',
    youDoNotHaveAccessRightsPleaseContactLightLiveOperationsToAddPermissions:
      'Anda tidak memiliki hak akses, silakan hubungi operasional LightStay untuk menambahkan izin',
    currentLimitSelect1FilePleaseRemoveAndAdd:
      'Saat ini dibatasi memilih 1 file, silakan hapus lalu tambahkan kembali',
    memberDataIsExportedSuccessfullyProcedure: 'Data anggota berhasil diekspor',
    memberDataFailedToBeExportedProcedure: 'Gagal mengekspor data anggota',
    noDataAvailableAtThisTime: 'Saat ini tidak ada data',
    memberImportTemplateDownloadedSuccessfully: 'Template impor anggota berhasil diunduh',
    failedToDownloadTheMemberImportTemplate: 'Gagal mengunduh template impor anggota',
    modifyMembership2: 'Ubah anggota',
    addAMemberSuccessfully: 'Anggota berhasil ditambahkan',
    renewMemberSuccessfully: 'Anggota berhasil diperbarui',
    integralChange2: 'Perubahan poin',
    memberRecharge: 'Isi ulang anggota',
    deductionOfStoredValue: 'Pengurangan saldo tersimpan',
    scoreChangeSuccess: 'Perubahan poin berhasil',
    memberRechargeSuccessfully: 'Isi ulang anggota berhasil',
    theDeductionOfStoredValueIsSuccessful: 'Pengurangan saldo tersimpan berhasil',
    integralQuery2: 'Pencarian poin',
    pleaseEnterSalesman: 'Silakan masukkan sales',
    definitiveRemoval: 'Hapus secara permanen',
    derivedInformation: 'Informasi ekspor',
    memberDataExportInformation: 'Informasi ekspor data anggota.xlsx',
    memberImportTemplate: 'Template impor anggota.xlsx',
    totalMembers: 'Total {memberTotal} anggota',
    xlsFormatOnly: 'Hanya mendukung file format XLS',
    commissionRefundNotice:
      'Mulai 1 Februari 2021, anggota yang diimpor pertama kali melalui fitur “Impor Anggota” akan mendapatkan pengembalian penuh komisi setelah memesan dan menginap melalui mini program LightStay!',
    enabled: 'Diaktifkan',
    disabled: 'Dinonaktifkan',
    idTypeAndNumber: 'Jenis dokumen / Nomor dokumen',
    distributionSettings: 'Pengaturan distribusi',
    setAsAPromotionalUser: 'Tetapkan sebagai pengguna promosi',
  },
  memberMemberReport: {
    ordinaryMember: 'Anggota biasa',
    goldMember: 'Anggota emas',
    platinumMember: 'Anggota platinum',
    diamondMember: 'Anggota berlian',
    enterYourNamePhoneNumberAndIdNumber: 'Masukkan nama, nomor ponsel, dan nomor dokumen',
    membership: 'Status keanggotaan',
    activateStore: 'Aktifkan toko',
    ourStore: 'Toko ini',
    otherStores: 'Toko lain',
    sourceOfDevelopment: 'Sumber pengembangan',
    activationDate: 'Tanggal aktivasi',
    dateOfPurchase: 'Tanggal pembelian',
    purchaseTime: 'Waktu pembelian',
    memberNickname: 'Nama panggilan anggota',
    memberName: 'Nama anggota',
    membershipIdNumber: 'Nomor dokumen anggota',
    activationTime: 'Waktu aktivasi',
    currentLevelDevelopmentSource: 'Sumber pengembangan level saat ini',
    currentLevelPurchaseTime: 'Waktu pembelian level saat ini',
  },
  memberSaveReport: {
    downloadReport: 'Unduh laporan',
    totalAmountOfStoredValue: 'Total saldo tersimpan',
    totalGiftAmount: 'Total jumlah hadiah',
    totalConsumptionAmount: 'Total jumlah konsumsi',
    totalAmountOfRefund: 'Total jumlah pengembalian konsumsi',
    user: 'Pengguna',
    transactionType: 'Jenis transaksi',
    storedValue: 'Saldo tersimpan',
    consumptionRefund: 'Pengembalian konsumsi',
    membershipLevel: 'Level keanggotaan',
    storedValueAmount: 'Jumlah saldo tersimpan',
    amountOfRefund: 'Jumlah pengembalian',
    memberStoredValueReport: 'Laporan saldo tersimpan anggota.xlsx',
    theMemberStoredValueReportIsSuccessfullyExported:
      'Laporan saldo tersimpan anggota berhasil diekspor',
    failedToExportTheMemberStoredValueReport: 'Gagal mengekspor laporan saldo tersimpan anggota',
    searchPlaceholder: 'Ponsel / Dokumen / Nama / Nomor kartu',
  },
  clientClient: {
    guestTag: 'Label tamu',
    pleaseEnterYourContactInformation: 'Silakan masukkan informasi kontak',
    pleaseEnterYourNationality: 'Silakan masukkan kewarganegaraan',
    pleaseEnterNationality: 'Silakan masukkan etnis',
    pleaseEnterAddress: 'Silakan masukkan alamat',
    age: 'Usia',
    customerLabel: 'Label pelanggan',
    modifyGuestInformation: 'Ubah informasi tamu',
    inputLabelDuplication: 'Label input duplikat',
    pleaseEnterTheLabelContent: 'Silakan masukkan isi label',
    doNotEnterLabelsInMoreThan10Words: 'Label tidak boleh lebih dari 10 kata',
  },
  financeIndex: {
    pleaseCancelRenewFirst:
      'Silakan batalkan perpanjangan menginap terlebih dahulu sebelum melakukan check-out',
    addAnotherItem: 'Tambah item lain',
    checkInOrderNumber: 'Nomor pesanan check-in',
    adjustFinance: 'Penyesuaian keuangan',
    batchTransfer: 'Transfer massal',
    checkOut: 'Check-out piutang',
    pleaseEnterTheRoomNumber: 'Silakan masukkan nomor kamar',
    pleaseEnterRoomTypeName: 'Silakan masukkan nama tipe kamar',
    pleaseEnterChannel: 'Silakan masukkan saluran',
    pleaseEnterCheckInTime: 'Silakan masukkan waktu check-in',
    pleaseEnterYourDepartureTime: 'Silakan masukkan waktu check-out',
    pleaseEnterAccount: 'Silakan masukkan akun',
    entryTime2: 'Waktu pencatatan',
    pleaseEnterTheCreditDate: 'Silakan masukkan waktu pencatatan',
    consumptionAmountyuan: 'Jumlah konsumsi ',
    pleaseEnterTheAmountSpent: 'Silakan masukkan jumlah konsumsi',
    paymentAmountyuan: 'Jumlah pembayaran ',
    pleaseEnterThePaymentAmount: 'Silakan masukkan jumlah pembayaran',
    editBill: 'Edit tagihan',
    checkOut2: 'Check-out',
    cancelAccount: 'Batalkan Check-out',
    partialClosing: 'Check-out Sebagian',
    accountAdjustment: 'Penyesuaian akun',
    smallGoodsAreAccountedFor: 'Barang Kecil',
    pleaseSelectAPaymentHistory: 'Silakan pilih riwayat pembayaran',
    pleaseFillInTheAmountOfPayment: 'Silakan isi jumlah pembayaran',
    yourAccountInformationIsEmptyPleaseEnterTheAccountBeforePrinting:
      'Informasi akun kosong, silakan lakukan pencatatan sebelum mencetak',
    theRoomNumberCannotBeEmptyPleaseCheckWhetherThePagePathIsCorrect:
      'Nomor pesanan kamar tidak boleh kosong, silakan periksa apakah jalur halaman benar',
    smallwares: 'Barang kecil',
    creditOrdersDoNotSupportPartialCheckout: 'Pesanan kredit tidak mendukung penyelesaian sebagian',
    pleaseSelectTheOrderYouWantToCheckOut: 'Silakan pilih pesanan yang ingin diselesaikan',
    creditBookingIsNotSupportedPleaseCheckOutDirectly:
      'Pesanan kredit tidak mendukung piutang, silakan lakukan check-out langsung',
    pleaseSelectACover: 'Silakan pilih paket akun',
    unionpayScanCode: 'UnionPay - Pindai kode',
    checkOutSuccessfully: 'Check-out berhasil',
    securityDeposit: 'Deposit',
    warmReminder: 'Pengingat hangat',
    signOut: 'Keluar',
    cancelled: 'Dibatalkan',
    the: ' ',
    wheatDoorLockPlugInCancellationCard: 'Plugin kunci pintu Wheat - pembatalan kartu',
    whetherTheKeyCardHasBeenCancelled: 'Apakah kartu pintu telah dibatalkan',
    selectUnsettledAccountsWarning: 'Silakan pilih akun yang “belum diselesaikan”',
    feizhuRoomFeeValidation:
      'Jumlah biaya kamar Fliggy harus ≥ 0, biaya kamar saat ini: {roomRateFees}',
    feizhuNonRoomFeeValidation: 'Jumlah “biaya non-kamar” Fliggy harus ≥ 0, biaya saat ini: {fees}',
    pleaseSelectUnsettledAccounts: 'Silakan pilih akun yang belum diselesaikan',
    additionalChargeAmountEmpty: 'Jumlah biaya tambahan kosong, silakan ulangi operasi',
  },
  financeMangementOld: {
    accountType: 'Jenis akun',
    creditAccount: 'Akun kredit',
    prepaidAccount: 'Akun prabayar',
    settlementPeriod: 'Periode penyelesaian',
    maximumAmount: 'Batas maksimum',
    theMaximumMustBeGreaterThanZero: 'Batas maksimum harus lebih besar dari nol',
    theMaximumAmountCannotBeGreaterThan100Million: 'Batas maksimum tidak boleh lebih dari 100 juta',
    theStartTimeCannotBeEqualToTheEndTime: 'Waktu mulai tidak boleh sama dengan waktu berakhir',
    theStartTimeCannotBeLaterThanTheEndTime:
      'Waktu mulai tidak boleh lebih besar dari waktu berakhir',
    pleaseSelectAnEndTime: 'Silakan pilih waktu berakhir',
    theEndTimeCannotBeEqualToTheStartTime: 'Waktu berakhir tidak boleh sama dengan waktu mulai',
    theEndTimeCannotBeLaterThanTheStartTime:
      'Waktu berakhir tidak boleh lebih kecil dari waktu mulai',
    pleaseEnterTheBillingPeriod: 'Silakan masukkan periode penagihan',
    settlementPeriodCanOnlyBeEnteredInNumbers:
      'Periode penyelesaian hanya boleh diisi dengan angka',
    newAccount: 'Tambah akun',
    pleaseFillInTheAccountName: 'Silakan isi nama akun',
    pleaseFillInTheCompanyName: 'Silakan isi nama perusahaan',
    pleaseSelectAnAccountType: 'Silakan pilih jenis akun',
    pleaseSelectAChannelName: 'Silakan pilih nama saluran',
  },
  financeMangement: {
    creditAccount: 'Akun kredit',
    prepaidAccount: 'Akun prabayar',
    enableConfirmation:
      'Setelah diaktifkan, unit perjanjian ini akan mendukung piutang. Apakah ingin mengaktifkan?',
    disableConfirmation:
      'Setelah dinonaktifkan, unit perjanjian ini tidak lagi mendukung piutang. Apakah ingin menonaktifkan?',
  },
  foodRoomAccountFinance: {
    foodSource: 'Sumber Makanan',
    foodRoomAccountLabel: 'Akun Kamar Makanan',
    foodOrderNo: 'No. Pesanan Food',
    fmisAccountSerialNo: 'No. Seri Akun FMIS',
    chargedAmount: 'Jumlah Tagihan',
    notAllowedSplit: 'Akun kamar makanan tidak dapat dipecah',
    notAllowedRush: 'Akun kamar makanan tidak dapat dibatalkan',
    notAllowedTransfer: 'Akun kamar makanan tidak dapat ditransfer',
    notAllowedPartialSettlement: 'Akun kamar makanan tidak mendukung penyelesaian sebagian',
  },
  financeMixin: {
    onlinePaymentAccountsAreNotAllowedToOpen:
      'Akun pembayaran online tidak diizinkan untuk pemisahan akun',
    smallCommodityAccountsCanNotBeDismantled: 'Akun barang kecil tidak dapat dipisah',
    negativeDebtCannotBeBroken: 'Saldo negatif tidak dapat dipisah',
    accountsReceivableAreNotAllowedToBeDebunked: 'Akun piutang tidak diizinkan untuk pemisahan',
    debitsAreNotAllowedInThisAccount: 'Akun ini tidak diizinkan untuk pemisahan',
    onlinePaymentRefundAccountDoesNotAllowForChargebacks:
      'Akun pengembalian pembayaran online tidak diizinkan untuk penyesuaian',
    theAccountHasBeenRefundedAndCannotBeCharged:
      'Akun ini telah direfund dan tidak dapat disesuaikan',
    refundedAccountsCannotBeCharged: 'Akun yang telah direfund tidak dapat disesuaikan',
    thisAccountIsNotAllowedToBeCharged: 'Akun ini tidak diizinkan untuk penyesuaian',
    businessDayHasBeenSwitchedNoChargeIsAllowed:
      'Hari operasional telah berganti, penyesuaian tidak diizinkan',
    splitBill: 'Pisahkan tagihan',
    transfer: 'Transfer',
    offset: 'Penyesuaian',
    refund: 'Pengembalian deposit',
  },
  detailcomponentsAccountlisttable: {
    onAccount: 'Ditangguhkan',
  },
  detailcomponentsAddjudge: {
    theRoomChargeIsExcessive: 'Biaya kamar tambahan terlalu besar',
    chargeJudgment: 'Penilaian biaya tambahan',
    addOnOption: 'Opsi biaya tambahan',
    generatedRoomCharge: 'Biaya kamar dihasilkan',
    pleaseFillInTheAdditionalRoomCharge: 'Silakan isi biaya kamar tambahan',
    theAdditionalAmountCannotBe0: 'Jumlah biaya tambahan tidak boleh 0',
  },
  detailcomponentsAdjustaccounts: {
    reconciliationSuccess: 'Penyesuaian akun berhasil',
    accountAdjustment: 'Penyesuaian akun',
    accountOfReconciliation: 'Akun penyesuaian',
    incorrectTransferAmountFormatupToTwoDecimalPlaces:
      'Format jumlah penyesuaian tidak benar (maksimal dua angka desimal)',
    theTransferAmountCannotBe: 'Jumlah penyesuaian tidak boleh',
    theTransferAmountCannotBeGreaterThan100Million:
      'Jumlah penyesuaian tidak boleh lebih dari 100 juta',
  },
  detailcomponentsArsuitselect: {
    receivableSet: 'Paket piutang',
    creditOrderCheckoutTip: 'Pesanan credit stay harus dicatat sebagai piutang saat check-out',
    nonProtocolOrderArTip: 'Pesanan perusahaan non-kontrak tidak dapat dicatat sebagai piutang',
  },
  detailcomponentsBackout: {
    closedSuccessfully: 'Pembatalan penyelesaian berhasil',
    cancelAccount: 'Batalkan penyelesaian',
    confirmationRevocation: 'Konfirmasi pembatalan',
    pleaseSelectTheBillYouWantToCancel: 'Silakan pilih tagihan yang ingin dibatalkan',
  },
  detailcomponentsBorrow: {
    return: 'Kembalikan',
    itemBorrowingReminder: 'Pengingat peminjaman barang',
    borrowARoom: 'Pinjam kamar',
    quantityBorrowed: 'Jumlah dipinjam',
    returnQuantity: 'Jumlah dikembalikan',
    loanDate2: 'Tanggal peminjaman',
    returnOrNot: 'Dikembalikan atau tidak',
    whetherToReturnAll: 'Apakah dikembalikan semua',
    amountOfCompensation: 'Jumlah kompensasi',
    onlyNumbersGreaterThan0CanBeEntered: 'Hanya angka lebih besar dari 0 yang dapat dimasukkan',
    partOfTheReturnCanOnlyBeLessThanTheAmountBorrowed:
      'Pengembalian sebagian harus kurang dari jumlah yang dipinjam',
    returned: 'Sudah dikembalikan',
    noReturn: 'Belum dikembalikan',
    returnSuccessfully: 'Pengembalian berhasil',
  },
  detailcomponentsColorblock: {
    financialType: 'Jenis keuangan',
    accountingType: 'Jenis Akuntansi',
    orderForGoods: 'Pesanan',
  },
  detailcomponentsCommon: {
    unionpayScanCode: 'UnionPay - Pindai kode',
    insufficientMemberBalance:
      'Saldo anggota adalah {balance} , silakan pilih metode penerimaan lain',
  },
  detailcomponentsCreditsettletip: {
    creditSettleAlert:
      'Pengingat: pesanan Fliggy kredit, biaya kamar aktual {roomRate} , biaya non-kamar {nonRoomRate} . Harap verifikasi jumlah sebelum mengajukan check-out',
  },
  detailcomponentsDivideaccounts: {
    additionalDebits: 'Tambah pemisahan akun',
    totalAmount: 'Total jumlah',
    totalDebitsTaken: 'Total yang telah dipisah',
    totalUndismantledLoans: 'Total belum dipisah',
    successfulDismantling: 'Pemisahan akun berhasil',
    borrowMoney: 'Pemisahan akun',
    loanAmount: 'Jumlah pemisahan',
    upTo150Words: 'Maksimal 150 karakter',
    closedAccount: 'Sudah dipisah',
    tenAtMost: 'Maksimal sepuluh pemisahan',
    theAmountOfDebitsIsNotEqualToTheTotalAmount: 'Jumlah pemisahan tidak sama dengan total jumlah',
    theDebitAmountMustBeFilledInAndGreaterThan: 'Jumlah pemisahan wajib diisi dan lebih besar dari',
  },
  detailcomponentsEnteraccount: {
    cashCnyReceipt: 'Penerimaan tunai RMB',
    accountEntry: 'Akun pencatatan',
    amountRecorded: 'Jumlah dicatat',
    pleaseFillInTheAmountOfPayment: 'Silakan isi jumlah pencatatan',
    pleaseSelectAPaymentMethod: 'Silakan pilih metode pembayaran',
    entriesCannotBeEmpty: 'Akun pencatatan tidak boleh kosong',
    theAmountRecordedCannotBe: 'Jumlah pencatatan tidak boleh 0',
    pleaseFillInUnitPrice: 'Silakan isi harga satuan',
    unitPriceCannotBeZero: 'Harga satuan tidak boleh 0',
    pleaseFillInServings: 'Silakan isi jumlah porsi',
    servingsCannotBeZero: 'Jumlah porsi tidak boleh 0',
    pleaseSelectMealDate: 'Silakan pilih tanggal konsumsi',
    ArRefundCannotExceedBalance: 'Jumlah pengembalian AR tidak boleh melebihi saldo AR',
  },
  detailcomponentsExpandcolumn: {
    memberName: 'Nama anggota',
    receivableSet: 'Paket piutang',
    from: 'Dari',
    orderForGoods: 'Pesanan',
    rollOutTo: 'Transfer ke',
    refundedAmount: 'Telah direfund: {amount} ',
  },
  detailcomponentsHangaccounts: {
    checkOut: 'Check-out piutang',
    reasonForPayment: 'Alasan piutang',
  },
  detailcomponentsHourroomfeeconfirm: {
    roomRateConfirmation: 'Konfirmasi biaya kamar',
    roomRate2: 'Jumlah biaya kamar',
  },
  detailcomponentsPartsettle: {
    partialClosing: 'Check-out Sebagian',
    pleaseFillInTheAmountOfPayment: 'Silakan isi jumlah pembayaran',
    pleaseSelectAPaymentHistory: 'Silakan pilih riwayat pembayaran',
  },
  detailcomponentsPreauthcheck: {
    authorizedSettlement: 'Penyelesaian terotorisasi',
  },
  detailcomponentsPreauthtemplate: {
    cancelAuthorizationPleaseWait: 'Membatalkan otorisasi, harap tunggu',
    succeededInCancelingAuthorization: 'Pembatalan otorisasi berhasil',
    thereIsAnOutstandingPreAuthorizationRecordInTheRoom:
      'Masih terdapat catatan pra-otorisasi yang belum diselesaikan di kamar',
    confirmThatYouWantToCancelAuthorization: 'Konfirmasi untuk membatalkan otorisasi',
    roomPaymentRequired: 'Kamar memerlukan {action} sejumlah:',
    orderCanceledWarning: 'Pesanan telah dibatalkan, tidak dapat {action}',
    roomCheckedInWarning: 'Kamar telah check-in, tidak dapat {action}',
    roomCheckedOutWarning: 'Status kamar adalah “sudah check-out”, tidak dapat {action}',
  },
  detailcomponentsRefundtip: {
    refundReminder: 'Pengingat pengembalian dana',
    whenUsingAnOnlineRefundTheAmountWillBeRefundedToTheAccountFromWhichTheGuestPaid:
      'Saat menggunakan pengembalian online, jumlah akan dikembalikan ke akun pembayaran tamu',
    whenUsingAOneCardRefundSystem:
      'Saat menggunakan sistem refund kartu terpadu, jumlah akan dikembalikan ke akun pembayaran tamu',
  },
  detailcomponentsSmallwarecost: {
    smallwares: 'Barang kecil',
    smallGoodsEnteredTheAccountSuccessfully: 'Barang kecil berhasil dicatat',
    smallGoodsAreAccountedFor: 'Barang Kecil',
    payOrNot: 'Dibayar atau tidak',
    pleaseEnterTheExternalOrderNumber: 'Silakan masukkan nomor pesanan eksternal',
    pleaseSelectASmallItem: 'Silakan pilih barang kecil',
    insufficientMemberBalance:
      'Saldo anggota adalah {balance} , silakan pilih metode penerimaan lain',
  },
  detailcomponentsTransferaccounts: {
    transferMoney: 'Transfer',
    transferToAccount: 'Transfer ke akun',
    pleaseSelectValidTransferAccount: 'Silakan pilih akun tujuan transfer yang valid',
    transferSuccess: 'Transfer berhasil',
    batchTransferSuccess: 'Transfer massal berhasil',
  },
  mangementMember: {
    orderType: 'Jenis pesanan',
    receivableOrders: 'Pesanan piutang',
    totalAmountNotApproved: 'Total jumlah belum diverifikasi',
    approvedTotalAmount: 'Total jumlah sudah diverifikasi',
    amountAvailable: 'Jumlah tersedia',
    amountSpent: 'Jumlah digunakan',
    whetherToWriteOffAllTheReceivables: 'Apakah ingin menutup semua piutang',
    whetherToReverseWriteOffAllTheReceivables: 'Apakah ingin menutup invers semua piutang',
    cancelAfterVerification: 'Verifikasi & tutup',
    reverseWriteOff: 'Tutup invers',
    depositInAdvance: 'Deposit di muka',
    dateOfPosting: 'Tanggal piutang',
    pleaseEnterTheOrderNumber: 'Silakan masukkan nomor pesanan',
    completeWriteOff: 'Tutup seluruhnya',
    completeReverseWriteOff: 'Tutup seluruhnya invers',
    batchWriteOff: 'Tutup massal',
    batchReverseWriteOff: 'Tutup massal invers',
    records: 'Catatan',
    advanceCredit: 'Pencatatan prabayar',
    thePrepaidAmountMustBeGreaterThanZero: 'Jumlah prabayar harus lebih besar dari nol',
    theAmountInAdvanceCannotBeGreaterThan100Million:
      'Jumlah prabayar tidak boleh lebih dari 100 juta',
    checkTheDepartureDateUpToOneMonth: 'Tanggal check-out maksimal dapat dicari hingga satu bulan',
    noAccountPleaseCreateANewOne: 'Tidak ada paket akun, silakan buat baru',
    allWereSuccessfullyWrittenOff: 'Semua berhasil ditutup',
    allWriteOffsFailed: 'Semua penghapusan (write-off) gagal',
    noWriteOffIsAllowedOnTheDayReceivableIsGenerated:
      'Penghapusan tidak diizinkan pada hari piutang dibuat',
    pleaseSelectTheItemsYouWantToWriteOff: 'Silakan pilih item yang ingin dihapuskan',
    listOfAccountsReceivable3XLS: 'Daftar piutang.xls',
    prepaymentAmountRequired: 'Silakan isi jumlah prabayar',
    prepaymentAmountFormatError: 'Format jumlah prabayar tidak benar (maksimal dua angka desimal)',
  },
  mangementTablerow: {
    paidInAmount: 'Jumlah diterima',
  },
  mangementVerificatemodal: {
    successfulWriteOff: 'Penghapusan berhasil',
    cancelAfterVerification: 'Hapuskan',
    reverseWriteOff: 'Hapuskan invers',
    generationTime: 'Waktu pembuatan',
    amountWrittenOff2: 'Jumlah dihapuskan',
    pleaseFillInTheWriteOffAmount: 'Silakan isi jumlah penghapusan',
    theAmountToBeWrittenOffCannotBeGreaterThanTheAmountThatCanBeWrittenOff:
      'Jumlah penghapusan tidak boleh melebihi jumlah yang dapat dihapuskan',
  },
  mangementVerifyrecordsmodal: {
    records: 'Catatan',
    lot: 'Batch',
  },
  merchantChargeList: {
    accumulatedUncreditedNightsInArrearsDuringTheContractPeriod:
      'Akumulasi malam tertunggak yang belum dikreditkan selama periode kontrak',
    hideZeroAmounts: 'Sembunyikan jumlah 0',
  },
  merchantCheckBill: {
    confirmationCheck: 'Konfirmasi pemeriksaan',
    afterConfirmationSettlementWillBeMadeInAccordanceWithThisBill:
      'Setelah dikonfirmasi, penyelesaian akan dilakukan sesuai tagihan ini',
    appealChannel: 'Saluran banding',
    causeOfAppeal: 'Alasan banding',
    youCanEnterUpTo150Words: 'Maksimal dapat memasukkan 150 kata',
    accountName: 'Nama rekening',
    roomBillCheck: 'Pemeriksaan tagihan kamar',
    memberIncentiveCheck: 'Pemeriksaan insentif anggota',
    confirmed: 'Dikonfirmasi',
    reasonForAdjustment: 'Alasan penyesuaian',
    deductibleTarget: 'Target pengurangan',
    currentDeduction: 'Pengurangan periode ini',
    deductible: 'Telah dikurangkan',
    confirmationTime: 'Waktu konfirmasi',
    rejectionTime: 'Waktu penolakan',
    liveLightlyInTheDirectCamp: 'LightStay langsung',
    new: 'Tambah',
    appealSuccessfully: 'Banding berhasil',
    checkSuccessfully: 'Pemeriksaan berhasil',
    currDeductionDesc:
      '1. Pengurangan periode ini bernilai positif berarti LightStay mengurangi jumlah yang dibayarkan ke merchant; 2. Bernilai negatif berarti pengembalian ke merchant',
    qzMerchantSettleDesc:
      'Penyelesaian LightStay dengan merchant = total jumlah pesanan - pengurangan periode ini',
  },
  merchantInfoManage: {
    changeLetter: 'Surat perubahan',
    note: 'Catatan',
    paymentCanOnlyBeMadeAfterTheModificationOfTheReceivingAccountIsApprovedIfTheCurrentSettlementPaymentIsToBePaidThePaymentWillStillBeMadeAccordingToTheOriginalAccount:
      'Perubahan rekening penerima harus disetujui sebelum pembayaran dilakukan. Jika ada pembayaran yang menunggu, pembayaran tetap dilakukan ke rekening lama',
    groundsForRejection: 'Alasan penolakan',
    downloadTheAttachmentTemplate2: 'Unduh template lampiran',
    viewingModificationLogs2: 'Lihat log perubahan',
    thisSettlementInformationIsUsedForRoomFeeSettlementAndCanOnlyBeModifiedByTheHotelOwnerPleaseAddItWithCaution:
      'Informasi penyelesaian ini digunakan untuk penyelesaian biaya kamar dan hanya dapat diubah oleh pemilik hotel, harap tambahkan dengan hati-hati',
    thisAccountIsUsedForTheSettlementOfRoomChargesAndCanOnlyBeModifiedByTheHotelOwnerPleaseModifyItCarefullyUploadTheChangeLetterAndAffixTheOfficialSealAsRequired:
      'Rekening penerima ini digunakan untuk penyelesaian biaya kamar dan hanya dapat diubah oleh pemilik hotel. Harap ubah dengan hati-hati, unggah surat perubahan dan bubuhkan stempel resmi sesuai ketentuan',
    modifyLog2: 'Log perubahan',
    beforeModification3: 'Sebelum perubahan',
    receivablesAccountManagement2: 'Manajemen rekening penerimaan',
    bankAccountName4: 'Nama pemilik rekening bank',
    letterOfRequestForChange2: 'Surat permohonan perubahan',
    pleaseEnterYourBankName2: 'Silakan masukkan nama pemilik rekening bank',
    pleaseUploadTheRequestForChange2: 'Silakan unggah surat permohonan perubahan',
    afterModification2: 'Setelah perubahan',
    afterDownloadingTheApplicationChangeLetterYouNeedToPrintItOutSignAndSealItAndThenUploadThePictureOrPdfFile:
      'Setelah mengunduh surat permohonan perubahan, silakan cetak, tanda tangani, dan beri stempel resmi, lalu unggah dalam bentuk gambar atau file PDF',
    onlyJpgPngAndPdfFilesCanBeUploaded: 'Hanya file JPG, PNG, dan PDF yang didukung',
  },
  merchantMerchantHelper: {
    smallProgramSettlementRules: 'Masalah aturan penyelesaian mini program',
    settlementOfPaymentProblems: 'Masalah pembayaran penyelesaian',
    smallProgramSettlementRulesCommonProblems: 'Masalah umum aturan penyelesaian mini program',
    frequentlyAskedQuestionsAboutSettlementPayments:
      'Pertanyaan umum tentang pembayaran penyelesaian',
    q1SettlementCriteria: 'Q1: Tagihan seperti apa yang dapat diselesaikan?',
    a1SettlementCriteria:
      'Kriteria penyelesaian kami adalah status pesanan selesai dan tamu telah check-out',
    q2PmsCancellation: 'Q2: Apa yang harus dilakukan jika tagihan PMS dibatalkan?',
    a2PmsCancellation:
      'Jika PMS berstatus dibatalkan, standar penyelesaian kami adalah: setelah tamu meminta pembatalan dan dilakukan pengembalian dana, silakan hubungi tim layanan pelanggan untuk menjalankan proses refund',
    q1AuditTime: 'Q1: Kapan waktu audit penyelesaian?',
    a1AuditTime:
      'Sebelum hari Jumat setiap minggu, tagihan penyelesaian direct-connect minggu berikutnya akan diunggah ke sistem. Merchant hanya perlu mengonfirmasi tagihan pada Kamis berikutnya untuk menerima pembayaran',
    q2PaymentTime: 'Q2: Setelah merchant mengonfirmasi tagihan, kapan pembayaran dilakukan?',
    a2PaymentTime:
      'Merchant yang telah mengonfirmasi tagihan akan dibayarkan pada hari Kamis. Untuk pembayaran gagal sebelumnya, akan dibayarkan ulang pada Kamis–Jumat',
    q3CheckPayment: 'Q3: Bagaimana cara memeriksa apakah pembayaran telah dilakukan?',
    a3CheckPayment: 'Merchant dapat memeriksa status pembayaran pada halaman catatan pembayaran',
    q4RejectedStatement:
      'Q4: Apa yang harus dilakukan jika tagihan ditolak? Kapan pembayaran dilakukan?',
    a4RejectedStatement:
      'Untuk tagihan yang ditolak merchant, kantor pusat akan melakukan audit ulang. Jika penyesuaian selesai dan merchant mengonfirmasi sebelum Kamis, pembayaran akan dilakukan pada hari Kamis. Tagihan yang belum dikonfirmasi akan dibayarkan pada Kamis berikutnya',
  },
  merchantRemitRecord: {
    roomChargePaymentRecords: 'Catatan pembayaran biaya kamar',
    memberIncentiveRecord: 'Catatan insentif anggota',
    fundsToBeRemitted: 'Menunggu pembayaran',
    remitting: 'Sedang dibayarkan',
    remittedMoney: 'Sudah dibayarkan',
    paymentFailure2: 'Pembayaran gagal',
    collectionAccount: 'Rekening penerima',
    payee: 'Penerima',
    statusUpdateTime: 'Waktu pembaruan status',
    paymentTime: 'Waktu pembayaran',
    timeToInitiateAPayment: 'Waktu pengajuan pembayaran',
  },
  merchantSettleInfo: {
    pleaseScanTheQrCodeOfYourCloudAccountToBindYourBankCard:
      'Silakan pindai kode QR akun cloud Anda untuk mengikat kartu bank',
    bindBankCard: 'Ikat kartu bank',
    completeInformation: 'Informasi pribadi',
    bankAccountName4: 'Nama pemilik rekening bank',
    idNumber: 'Nomor KTP',
    pleaseEnterYourBankName2: 'Silakan masukkan nama pemilik rekening bank',
    pleaseEnterYourIdNumber2: 'Silakan masukkan nomor KTP',
    idNumberFormatIsIncorrectPleaseReEnter: 'Format nomor KTP salah, silakan masukkan ulang',
    phoneNumberFormatIsIncorrectPleaseReEnter: 'Format nomor ponsel salah, silakan masukkan ulang',
    pleaseUpload: 'Silakan unggah',
    internalUserHidden: 'Pengguna internal tidak ditampilkan',
    amountPendingPayment: 'Jumlah {amount}, akan dibayarkan kemudian',
  },
  billCheckBillDetails: {
    channelDetails: 'Detail saluran',
    whereToConnectDirectly: 'Qunar direct connect',
    drench: 'LightStay',
    cityWide: 'Dalam kota',
    whereToGo: 'Qunar',
    distribution: 'Distribusi',
    tradeCaravan: 'Perjalanan bisnis',
    statementOfAccount: 'Laporan rekonsiliasi',
    qzSettleFormula:
      'Penyelesaian LightStay dengan merchant = jumlah penyelesaian pesanan + refund yang ditanggung merchant + diskon yang ditanggung merchant + dana amal merchant',
    merchantDiscountNote:
      'Jika terjadi refund pada pesanan periode ini, jumlah diskon yang ditanggung merchant adalah 0',
  },
  billCheckBill: {
    turnDown: 'Tolak',
    ticketReceived: 'Faktur diterima',
    forThePublic: 'Perusahaan',
    forPrivacy: 'Pribadi',
    expenseDetail: 'Detail biaya',
    confirmationCheck: 'Konfirmasi pemeriksaan',
    afterConfirmationSettlementWillBeMadeInAccordanceWithThisBill:
      'Setelah dikonfirmasi, penyelesaian akan dilakukan sesuai tagihan ini',
    perfectInformation: 'Lengkapi informasi',
    causeOfAppeal: 'Alasan banding',
    youCanEnterUpTo150Words: 'Maksimal dapat memasukkan 150 kata',
    creditDetails: 'Detail pengurangan',
    roomNightCreditDetails: 'Detail pengurangan malam kamar',
    invoiceManagement: 'Manajemen faktur',
    sellersName: 'Nama penjual',
    invoiceNumber: 'Nomor faktur',
    invoiceDate: 'Tanggal faktur',
    invoiceAmount2: 'Jumlah faktur',
    electronicInvoiceOrNot: 'Faktur elektronik atau tidak',
    invoiceFile: 'File faktur',
    reasonForRejectingInvoice: 'Alasan penolakan faktur',
    theTotalAmountOfTheOrderIncludesTheAmountOfThePreviousBillAndTheMerchantSettlementAmountLessThan0:
      'Total jumlah pesanan telah mencakup jumlah penyelesaian LightStay dengan merchant pada tagihan sebelumnya yang bernilai kurang dari 0',
    quantityDueForTheCurrentPeriod: 'Jumlah yang harus dikurangkan periode ini',
    actualAmountOfDeductionForTheCurrentPeriod: 'Jumlah pengurangan aktual periode ini',
    amountDeductedForTheNightOfThePeriod: 'Jumlah pengurangan malam kamar periode ini',
    uncreditedQuantityForTheCurrentPeriod: 'Jumlah belum dikreditkan periode ini',
    pleaseEnter150WordsOrLess: 'Silakan masukkan maksimal 150 kata',
    pleaseEnterTheInvoiceHoldersInformation: 'Silakan masukkan informasi pemegang faktur',
    pleaseEnterTheInvoiceNumber: 'Silakan masukkan nomor faktur',
    pleaseEnterExpiryDate2: 'Silakan masukkan masa berlaku',
    pleaseSelectTheInvoiceType: 'Silakan pilih jenis faktur',
    pleaseSelectWhetherToEInvoice: 'Silakan pilih apakah faktur elektronik',
    pleaseUploadTheInvoicePhoto: 'Silakan unggah foto faktur',
    pleaseFillInTheAmount: 'Silakan isi jumlah',
    specialTicket: 'Faktur khusus',
    ordinaryTicket: 'Faktur biasa',
    expenseItem: 'Item biaya',
    amountIncurred: 'Jumlah terjadi',
    source: 'Sumber',
    instructions: 'Keterangan',
    confirmationTime: 'Waktu konfirmasi',
    groupReceiptStatus: 'Status penerimaan grup',
    rejectionTime: 'Waktu penolakan',
    whetherTheInvoiceHasBeenEntered: 'Apakah faktur telah dicatat',
    feeDetails: 'Detail biaya',
    fileUpload: 'Unggah file',
    uploadAMaximumOf5Images: 'Maksimal unggah 5 gambar',
    appealSuccessfully: 'Banding berhasil',
    checkSuccessfully: 'Pemeriksaan berhasil',
    theSizeOfTheUploadedCompressedPackageCannotExceed:
      'Ukuran paket terkompresi yang diunggah tidak boleh melebihi',
    onlyTheUploadFormatIsSupported: 'Format unggah yang didukung hanya',
    theCompressedPackageFileCannotBeLargerThan:
      'Ukuran file paket terkompresi tidak boleh lebih dari',
    amountOfDeductionForTheCurrentPeriod: 'Jumlah pengurangan periode ini',
    theMerchantNeedsToInvoiceTheAmount: 'Jumlah yang perlu difakturkan oleh merchant',
    billingDetails: 'Detail tagihan',
    currentAdrAmount: 'Jumlah ADR periode ini',
    settlementSystemUpgrade:
      'Untuk memenuhi persyaratan bank terkait penyelesaian dana, meningkatkan efisiensi penyelesaian, dan melengkapi informasi kualifikasi, grup melakukan peningkatan sistem penyelesaian dan memerlukan pelengkapan informasi yang diminta bank',
    confirmPreviousBills:
      'Harap konfirmasi tagihan periode sebelumnya terlebih dahulu, jika tidak maka tagihan periode baru tidak dapat ditampilkan',
    paperInvoiceInstructions:
      'Untuk faktur kertas, pengiriman harus dibayar pengirim. Kiriman dengan pembayaran di tempat akan ditolak. Penerima faktur: LightStay Distribusi Faktur Elektronik; Tel: 15901580289. Setelah faktur kertas diterima, LightStay akan melakukan pemeriksaan',
    uploadFormatRestrictions:
      'Catatan: Mendukung unggahan salah satu dari 5 format berikut: pdf, gambar, word, paket terkompresi, ofd. PDF dan OFD maksimal 5 file (masing-masing maksimal 3MB); gambar maksimal 5 file (masing-masing maksimal 3MB, format jpg/jpeg/png); word maksimal 1 file (maksimal 20MB); paket terkompresi maksimal 1 file (maksimal 20MB, format rar/zip/7z)',
    cumulativeUndeductedNights:
      'Akumulasi malam tertunggak yang belum dikurangkan selama periode kontrak (sebelum pengurangan periode ini)',
    invoiceDuplicate:
      'Nomor faktur duplikat, silakan periksa apakah nomor faktur sudah benar. Jika benar, harap jelaskan alasan penggunaan faktur yang sama di kolom catatan.',
    pdfSizeExceeded: 'Ukuran PDF yang diunggah tidak boleh melebihi 3MB!',
    ofdSizeExceeded: 'Ukuran OFD yang diunggah tidak boleh melebihi 3MB!',
    wordSizeExceeded: 'Ukuran Word yang diunggah tidak boleh melebihi 20MB!',
    singleFormatOnly: 'Hanya mendukung satu format!',
  },
  billCheckMemberDetails: {
    memberIncentiveDetails: 'Detail insentif anggota',
    memberIncentiveStatement: 'Laporan rekonsiliasi insentif anggota',
  },
  billDeductionDetails: {
    feeDetails: 'Detail biaya',
    statementDetailsSheet: 'Lembar detail rekonsiliasi',
  },
  billRemitRecord: {
    collectionAccount: 'Rekening penerima',
    payee: 'Penerima',
    statusUpdateTime: 'Waktu pembaruan status',
    timeToInitiateAPayment: 'Waktu pengajuan pembayaran',
    paymentTime: 'Waktu pembayaran',
  },
  billCheckDetails: {
    channelOrderDetails: 'Detail pesanan saluran',
    merchantRefunds: 'Pengembalian dana ditanggung merchant',
    merchantConcession: 'Diskon ditanggung merchant',
    channelOrderNumber: 'Nomor pesanan saluran',
    reasonForAdjustment3: 'Alasan penyesuaian',
    adjustmentType: 'Jenis penyesuaian',
    originalOrderPrice: 'Harga awal pesanan',
    memberDiscount: 'Diskon anggota',
    skimpingOnCommission: 'Komisi LightStay',
    payChannelCommission: 'Komisi saluran pembayaran',
    amountOfMerchantWelfare: 'Dana kesejahteraan merchant',
    refundNight: 'Malam pengembalian dana',
    totalRefundAmount: 'Total jumlah pengembalian dana',
    stayEasyAndRefundCommission: 'Komisi LightStay yang dikembalikan',
    subsidy: 'Subsidi',
    saleCardOrderNumber: 'Nomor pesanan penjualan kartu',
    membershipLevel: 'Level keanggotaan',
    dateOfRegistration: 'Tanggal pendaftaran',
    referrer: 'Pereferensi',
    amountPaid: 'Jumlah dibayar',
    merchantsShareTheAmount: 'Jumlah bagi hasil merchant',
    employeeShareAmount: 'Jumlah bagi hasil karyawan',
    shareAmount: 'Jumlah bagi hasil',
    rebateRatio: 'Rasio komisi',
    commissionRebate: 'Jumlah komisi',
    distributionSubchannel: 'Sub-saluran distribusi',
    channelCost: 'Harga awal saluran',
    lightSettlementWithMerchantsOrder: 'Penyelesaian LightStay dengan merchant (pesanan)',
    lightUndertakeDiscounts: 'Diskon ditanggung LightStay',
  },
  billDedetails: {
    currentAmountReceivable: 'Jumlah piutang periode ini',
    amountOfDeductionForTheCurrentPeriod: 'Jumlah potongan periode ini',
    remainingAmountOfDeduction: 'Sisa potongan',
    pleasureManagementFee: 'Biaya manajemen Yuexiang',
    brandManagementFee: 'Biaya manajemen merek',
    mastersCommission: 'Biaya kepala toko',
    otherExpenses: 'Biaya lainnya',
    openingDate: 'Tanggal pembukaan',
    preferentialPolicy: 'Kebijakan preferensi',
    managementFeeStartDate: 'Tanggal mulai biaya manajemen',
    thisPeriodOfBusinessSelfPromotion: 'Promosi mandiri merchant periode ini',
    enjoyCommissionRate: 'Tarif komisi Yuexiang',
    enjoyManagementFeeForThisPeriod: 'Biaya manajemen Yuexiang periode ini',
    currentAdjustmentExpense: 'Biaya penyesuaian periode ini',
    reasonsForAdjustingExpensesInTheCurrentPeriod: 'Alasan penyesuaian biaya periode ini',
    notPaidInThePreviousPeriod: 'Belum dibayar periode sebelumnya',
    currentReceivable: 'Piutang periode ini',
    currentPaid: 'Telah dibayar periode ini',
    balanceDue: 'Sisa yang harus dibayar',
    brandCommissionRate: 'Tarif komisi merek',
    currentBrandManagementFee: 'Biaya manajemen merek periode ini',
    monthlyRate: 'Standar biaya bulanan',
    currentObjective: 'Target periode ini',
    totalPmsRevenueForThePeriod: 'Total pendapatan PMS periode ini',
    totalPmsReceivableForThePeriod: 'Total piutang PMS periode ini',
  },
  chargeIndex: {
    expenseItem: 'Item biaya',
    totalAmountPayable: 'Total jumlah yang harus dibayar',
    cashPayable: 'Tunai yang harus dibayar',
    creditPayable: 'Potongan yang harus dibayar',
    deductionAdjustment: 'Penyesuaian potongan',
    deductible: 'Telah dipotong',
    residualCredit: 'Sisa potongan',
    managementFeeStartDate: 'Tanggal mulai biaya manajemen',
    currentObjective: 'Target periode ini',
    currentPeriodAdjustment: 'Penyesuaian periode ini',
    notPaidInThePreviousPeriod: 'Belum dibayar periode sebelumnya',
    currentReceivable: 'Piutang periode ini',
    currentPaid: 'Telah dibayar periode ini',
    balanceDue: 'Sisa yang harus dibayar',
  },
  commonIndex: {
    accountName: 'Nama rekening',
    collectionAccountType: 'Jenis rekening penerima',
    distributionRoomBillReconciliation: 'Rekonsiliasi tagihan kamar distribusi',
    memberIncentiveCheck: 'Pemeriksaan insentif anggota',
    directSellingRoomFeePaymentRecords: 'Catatan pembayaran biaya kamar penjualan langsung',
    distributeRoomChargePaymentRecords: 'Catatan pembayaran biaya kamar distribusi',
    memberIncentiveRecord: 'Catatan insentif anggota',
    confirmed: 'Dikonfirmasi',
    reasonForAdjustment: 'Alasan penyesuaian',
    settlementGrounds: 'Dasar penyelesaian',
    operationDetails: 'Detail operasi',
    merchantRefunds: 'Pengembalian dana ditanggung merchant',
    merchantConcession: 'Diskon ditanggung merchant',
    amountOfMerchantWelfare: 'Dana kesejahteraan merchant',
    americanOrder: 'Pesanan Meituan',
    flyingPigOrder: 'Pesanan Fliggy',
    lightLiveMiniProgramOrder: 'Pesanan mini program LightStay',
    memberShareAmount: 'Jumlah bagi hasil anggota',
    theAmountOfCrossStoreRefund: 'Jumlah komisi lintas toko',
    lightlyAdjustTheAmount: 'Jumlah penyesuaian LightStay',
    reasonForAdjustment3: 'Alasan penyesuaian',
    fundsToBeRemitted: 'Menunggu pembayaran',
    remitting: 'Sedang dibayarkan',
    remittedMoney: 'Telah dibayarkan',
    paymentFailure2: 'Pembayaran gagal',
    lightSettlementWithMerchantsOrder: 'Penyelesaian LightStay dengan merchant (pesanan)',
  },
  infoInfoManage: {
    note: 'Catatan',
    theApplicationChangeLetterNeedsToBePrintedOutAndSignedWithTheOfficialSealAfterDownloadingIfThePrintIs2PagesPleaseAffixTheSealAndUploadThePicture:
      'Surat permohonan perubahan harus dicetak, ditandatangani, dan dibubuhi stempel resmi setelah diunduh. Jika dicetak 2 halaman, harap bubuhkan stempel sambungan lalu unggah foto.',
    submitAndModifyTheAuditProcessOfTheReceivingAccountOnlyAfterTheAuditIsPassedCanThePaymentBeMadeTheRejectedAccountWillNotBeMade:
      'Pengajuan perubahan rekening penerima harus melalui proses audit. Pembayaran hanya dapat dilakukan setelah audit disetujui; rekening yang ditolak tidak akan dibayarkan.',
    beforeModification3: 'Sebelum perubahan',
    pleaseBePatientWhileTheInformationIsBeingReviewed: 'Informasi sedang ditinjau, mohon menunggu',
    groundsForRejection: 'Alasan penolakan',
    downloadTheAttachmentTemplate2: 'Unduh template lampiran',
    forPrivacy: 'Perorangan',
    forThePublic: 'Perusahaan',
    auditStatus: 'Status audit',
    viewingModificationLogs2: 'Lihat log perubahan',
    pleaseUploadYourBankCardInformationAsSoonAsPossibleToAvoidAffectingYourPaymentProgress:
      'Silakan unggah informasi kartu bank sesegera mungkin agar tidak memengaruhi proses pembayaran Anda',
    modifyLog2: 'Log perubahan',
    receivablesAccountManagement2: 'Manajemen rekening penerima',
    collectionAccountType: 'Jenis rekening penerima',
    pleaseSelectACollectionAccountType: 'Silakan pilih jenis rekening penerima',
    bankAccountName5: 'Nama pemilik rekening bank',
    recipientsCellPhoneNumber: 'Nomor ponsel penerima',
    pleaseEnterTheRecipientsMobilePhoneNumber: 'Silakan masukkan nomor ponsel penerima',
    payeeIdNumber: 'Nomor KTP penerima',
    pleaseEnterThePayeeIdNumber: 'Silakan masukkan nomor KTP penerima',
    payeeIdCardFront: 'KTP penerima (depan)',
    reverseOfPayeeIdCard: 'KTP penerima (belakang)',
    uploadContractAttachment: 'Unggah lampiran kontrak',
    letterOfRequestForChange2: 'Surat permohonan perubahan',
    pleaseEnterTheBankAccountName: 'Silakan masukkan nama pemilik rekening bank',
    pleaseEnterTheLegalPersonName: 'Silakan masukkan nama penanggung jawab hukum',
    legalPersonNameCanOnlyBeEnteredInChineseCharactersPleaseReEnter:
      'Nama penanggung jawab hukum hanya boleh diisi dengan huruf Tionghoa, silakan masukkan ulang',
    phoneNumberFormatIsIncorrectPleaseReEnter: 'Format nomor ponsel salah, silakan masukkan ulang',
    pleaseEnterYourIdNumber2: 'Silakan masukkan nomor KTP',
    idNumberFormatIsWrongCanOnlyEnterNumbersAndUppercaseLettersPleaseReEnter:
      'Format nomor KTP salah, hanya angka dan huruf kapital yang diperbolehkan, silakan masukkan ulang',
    pleaseEnterAUnifiedSocialCreditCode: 'Silakan masukkan Kode Kredit Sosial Terpadu',
    onlyNumbersAndLettersAreSupportedPleaseReEnter:
      'Hanya angka dan huruf yang didukung, silakan masukkan ulang',
    pleaseUploadTheRequestForChange2: 'Silakan unggah surat permohonan perubahan',
    frontOfIdentityCard: 'KTP (depan)',
    reverseOfIdCard: 'KTP (belakang)',
    businessLicense: 'Izin usaha',
    pleaseUploadTheContractAttachment: 'Silakan unggah lampiran kontrak',
    afterModification2: 'Setelah perubahan',
    corporateName: 'Nama penanggung jawab hukum',
    unifyTheSocialCreditCode: 'Kode Kredit Sosial Terpadu',
    legalPersonMobilePhoneNumber: 'Nomor ponsel penanggung jawab hukum',
    pleaseEnterTheFrenchPhoneNumber: 'Silakan masukkan nomor ponsel penanggung jawab hukum',
    legalPersonIdNumber: 'Nomor KTP penanggung jawab hukum',
    pleaseEnterTheCorporateIdNumber: 'Silakan masukkan nomor KTP penanggung jawab hukum',
    corporateIdentityCardFront: 'KTP penanggung jawab hukum (depan)',
    reverseOfCorporateIdentityCard: 'KTP penanggung jawab hukum (belakang)',
    pleaseUpload: 'Silakan unggah',
    fileUpload: 'Unggah file',
    uploadAMaximumOf2Images: 'Maksimal unggah 2 gambar',
    theSizeOfTheUploadedProfilePictureCannotExceed:
      'Ukuran gambar profil yang diunggah tidak boleh melebihi',
    uploadPictureFormatOnlySupported: 'Format gambar yang didukung hanya',
    onlyJpgJpegAndPngFilesCanBeUploaded: 'Hanya file JPG, JPEG, dan PNG yang didukung',
    onlyJpgJpegPngFilesCanBeUploadedPleaseUploadTheChangeLetterAsAPhoto:
      'Hanya file JPG, JPEG, dan PNG yang didukung. Harap unggah surat perubahan sebagai foto',
    pleaseWaitFileUploadIsNotComplete: 'Harap tunggu, unggahan file belum selesai',
    contractStampPageRequired: 'Halaman kontrak berstempel (wajib)',
    otherPagesOptional: 'Halaman lain (opsional, maksimal 2 gambar)',
    contractStampInstructions:
      '2) Halaman kontrak berstempel: harus memuat informasi rekening penerima pihak B dan dibubuhi stempel resmi; unggah halaman kontrak yang memenuhi persyaratan.',
    individualMobileNote: 'Catatan: jika usaha perorangan, isi dengan nomor ponsel pemilik',
    individualNameNote: 'Catatan: jika usaha perorangan, isi dengan nama pemilik',
    individualIdNote: 'Catatan: jika usaha perorangan, isi dengan nomor KTP pemilik',
    individualRegNumberNote: 'Catatan: jika usaha perorangan, isi dengan nomor registrasi',
    maxTwoImages: 'Maksimal 2 gambar',
    recipientLegalMobile: 'Nomor ponsel penerima/penanggung jawab hukum',
    recipientLegalIdNumber: 'Nomor KTP penerima/penanggung jawab hukum',
  },
  invoicingAddInvoicingApplication: {
    billingApplication: 'Permohonan penerbitan faktur',
    expenseType: 'Jenis biaya:',
    totalAmountApplied: 'Total jumlah pengajuan',
    theApplicationAmountIsIncorrect: 'Jumlah pengajuan tidak valid',
    status: 'Status:',
    causeOfRejection: 'Alasan penolakan:',
    billingInformation: 'Informasi penagihan:',
    pleaseEnterPhoneNumber: 'Silakan masukkan nomor telepon',
    dutyNumber: 'Nomor pajak',
    pleaseEnterYourTaxId: 'Silakan masukkan nomor pajak',
    pleaseEnterYourAccountBank: 'Silakan masukkan bank pembuka rekening',
    pleaseEnterTheAddress: 'Silakan masukkan alamat',
    openABankAccount: 'Nomor rekening bank',
    pleaseEnterYourBankAccountNumber: 'Silakan masukkan nomor rekening bank',
    pleaseEnterEmail: 'Silakan masukkan email',
    pickUpTelephone: 'Telepon penerima',
    pleaseEnterTheReceivingPhoneNumber: 'Silakan masukkan nomor telepon penerima',
    mailingAddress: 'Alamat pengiriman',
    pleaseEnterYourMailingAddress: 'Silakan masukkan alamat pengiriman',
    addressee: 'Penerima',
    pleaseEnterTheRecipient: 'Silakan masukkan penerima',
    repudiationPeriod: 'Periode penolakan:',
    claimPeriod: 'Periode pengajuan:',
    pleaseEnterTheAmountRequested: 'Silakan masukkan jumlah yang diajukan',
    theNumberCannotExceed15Digits: 'Jumlah angka tidak boleh melebihi 15 digit',
    pleaseEnterTheCorrectNumber: 'Silakan masukkan angka yang benar',
    paymentPeriod: 'Periode penagihan',
    availableAmount: 'Jumlah yang dapat ditagihkan',
    amountApplied2: 'Jumlah pengajuan',
    pleaseSelectTheBillingType5: 'Silakan pilih jenis penagihan',
    receipt: 'Tanda terima',
    pleaseEnterTitle: 'Silakan masukkan judul',
    theCurrentlySelectedFeeTypeDoesNotHaveBillingDataPleaseSelectAgain:
      'Jenis biaya yang dipilih saat ini tidak memiliki data penagihan, silakan pilih kembali',
    theTotalApplicationAmountNeedsToBeGreaterThan: 'Total jumlah pengajuan harus lebih besar dari',
    invoicingTypeAndFeeTypeDoNotCorrespondTheReceiptCanOnlyMatchTheDepositAndQualityDeposit:
      'Jenis faktur dan jenis biaya tidak sesuai; tanda terima hanya dapat digunakan untuk deposit dan deposit kualitas',
    thePageIsAutomaticallyClosed5SecondsAfterSubmission:
      'Pengajuan berhasil, halaman akan tertutup otomatis setelah 5 detik',
    generalInvoice: 'Faktur umum (faktur elektronik)',
    specialInvoice: 'Faktur khusus (faktur elektronik)',
  },
  invoicingInvoicingApplication: {
    applicationDate: 'Tanggal pengajuan',
    billingApplication: 'Pengajuan penagihan',
    expenseType: 'Jenis biaya',
    amountApplied2: 'Jumlah pengajuan',
    expressNumber: 'Nomor resi',
    alreadyRequested: 'Sudah diajukan',
  },
  preauthorizationIndex: {
    turn: 'Ubah',
    increaseAuthorization: 'Tambah otorisasi',
    authorizationFailure: 'Otorisasi gagal',
    settlementTime: 'Waktu penyelesaian',
    preAuthorizationDetailsLightWinTreasureHotelManagementSystem:
      'Detail pra-otorisasi - Sistem Manajemen Hotel LightWin Treasure',
    declined: 'Ditolak',
    flyingPigCreditDoesNotSupportPreAuthorization:
      'Fliggy Credit Stay saat ini belum mendukung pra-otorisasi',
    newAuthorization: 'Tambah otorisasi',
    cancelAuthorizationPleaseWait: 'Membatalkan otorisasi, mohon tunggu',
    succeededInCancelingAuthorization: 'Pembatalan otorisasi berhasil',
    pleaseWaitForTheSettlementAuthorization:
      'Sedang memproses otorisasi penyelesaian, mohon tunggu',
    confirmThatYouWantToCancelAuthorization: 'Konfirmasi untuk membatalkan otorisasi',
    orderStatusWarning: 'Status pesanan {status}, tidak dapat {action}',
    roomStatusWarning: 'Kamar telah check-in, tidak dapat {action}',
    roomCheckoutWarning: "Status kamar adalah 'sudah check-out', tidak dapat {action}",
  },
  componentsAuthsettle: {
    payment3: 'Pembayaran',
    paidInAmount: 'Jumlah diterima',
    settlementSuccess: 'Penyelesaian berhasil',
    authorizedSettlement: 'Penyelesaian terotorisasi',
    accountEntry: 'Akun pencatatan',
    pleaseFillInTheAuthorizedAmount: 'Silakan isi jumlah otorisasi',
    theActualAmountReceivedMustBeGreaterThan0: 'Jumlah diterima harus lebih besar dari 0',
    theActualAmountReceivedCannotBeGreaterThanTheAuthorizedAmount:
      'Jumlah diterima tidak boleh lebih besar dari jumlah otorisasi',
  },
  componentsBanklist: {
    bankOfChina: 'Bank of China',
    industrialAndCommercialBankOfChina: 'Industrial and Commercial Bank of China',
    industrialAndCommercialBankOfChina3: 'ICBC',
    agriculturalBankOfChina: 'Agricultural Bank of China',
    agriculturalBankOfChina3: 'ABC',
    chinaConstructionBank: 'China Construction Bank',
    chinaConstructionBank3: 'CCB',
    postalSavingsBankOfChina: 'Postal Savings Bank of China',
    postalSavingsBank: 'Postal Savings Bank',
    bankOfCommunications: 'Bank of Communications',
    chinaMerchantsBank: 'China Merchants Bank',
    shanghaiPudongDevelopmentBank: 'Shanghai Pudong Development Bank',
    shanghaiPudongDevelopmentBank3: 'SPDB',
    chinaCiticBank: 'China CITIC Bank',
    everbrightBank: 'China Everbright Bank',
    chinaMinshengBank: 'China Minsheng Bank',
    minshengBank: 'Minsheng Bank',
    guangdongDevelopmentBank: 'Guangdong Development Bank',
    guangfaBank: 'Guangfa Bank',
    pingAnBank: 'Ping An Bank',
    industrialBank: 'Industrial Bank',
    huaxiaBank: 'Huaxia Bank',
    bankOfShanghai: 'Bank of Shanghai',
    bankOfBeijing: 'Bank of Beijing',
    bohaiBank: 'Bohai Bank',
    zheshangBank: 'Zheshang Bank',
    huishangBank: 'Huishang Bank',
    hsbc: 'HSBC',
    hangSengBank: 'Hang Seng Bank',
    hengfengBank: 'Hengfeng Bank',
  },
  componentsExpandcolumn: {
    bankName: 'Nama bank',
    authorizationCode: 'Kode otorisasi',
    from: 'Dari',
    rollOutTo: 'Transfer ke',
  },
  componentsTransferaccounts: {
    transferMoney: 'Transfer',
    transferToAccount: 'Transfer ke akun',
    authorizationFailure: 'Otorisasi gagal',
  },
  componentsUpdateauthorization: {
    automaticSettlementAfterExpiration: 'Penyelesaian otomatis setelah masa berlaku berakhir',
    authorizationCode: 'Kode otorisasi',
    bankName: 'Nama bank',
    pleaseFillInTheAuthorizedAmount: 'Silakan isi jumlah otorisasi',
    newAuthorization: 'Tambah otorisasi',
    modifyAuthorization: 'Ubah otorisasi',
    renewal: 'Perbarui',
  },
  componentsCancelorder: {
    reminderThisOrderIsAnEbOrderPleaseVerifyTheOtaOrderStatusBeforeCancellation:
      'Pengingat: pesanan ini adalah pesanan EB, silakan verifikasi status pesanan OTA sebelum pembatalan',
    orderCancelledSuccessfully: 'Pesanan berhasil dibatalkan',
    cancelAnOrder2: 'Batalkan pesanan',
    cancellationReason: 'Alasan pembatalan',
    remarks5100Words: 'Catatan (5–100 karakter)',
    replyTextMinimum5Words: 'Teks balasan minimal 5 karakter',
    pleaseSelectACancellationReason: 'Silakan pilih alasan pembatalan',
    originalStayWillBeCancelled: 'Perpanjangan pesanan asli akan dibatalkan secara otomatis',
    cancellationRules: 'Aturan pembatalan',
    channelDescription: 'Deskripsi kanal',
    refundScore: 'Kembalikan poin',
    refundCoupon: 'Kembalikan kupon',
    orderMessage: 'Pesan pesanan',
    pleaseEnterOrderMessage: 'Silakan masukkan pesan pesanan',
    directCancelSuccessComment: 'Pesanan berhasil dibatalkan',
  },
  componentsEditcontactinfo: {
    modifyAContact: 'Ubah kontak',
    pleaseEnterThe11DigitPhoneNumber: 'Silakan masukkan nomor ponsel 11 digit',
  },
  componentsEditorder: {
    modifyTheOrder2: 'Ubah pesanan',
    selectDate1: 'Pilih tanggal 1',
    selectDate2: 'Pilih tanggal 2',
    contactNumber4: 'Nomor kontak',
    theRetentionTimeMustNotBeLessThanTheCurrentTime:
      'Waktu penahanan tidak boleh lebih awal dari waktu saat ini',
    theRetentionTimeShallNotBeLessThanTheEstimatedArrivalTime:
      'Waktu penahanan tidak boleh lebih awal dari perkiraan kedatangan',
    theRetentionTimeMustNotBeLongerThanThePreDepartureTime:
      'Waktu penahanan tidak boleh lebih lama dari perkiraan keberangkatan',
    doNotRepeatThisOperationWhileSubmittingChanges:
      'Sedang mengirim perubahan, mohon jangan mengulangi operasi',
    orderModificationSuccessful: 'Perubahan pesanan berhasil',
  },
  componentsEditOrderV2: {
    addedRoomsOverAvailability: 'Jumlah kamar yang ditambahkan tidak boleh melebihi ketersediaan',
    arrivalBeforeToday: 'Tanggal kedatangan pesanan kamar baru tidak boleh lebih awal dari hari ini',
    assignedRoom: 'Kamar ditetapkan {room}',
    availabilityLoading: 'Memuat ketersediaan tipe kamar ini. Silakan coba lagi nanti',
    availableCount: 'Tersedia: {count}',
    checkedInRoom: 'Sudah check-in {room}',
    checkedOutRoom: 'Sudah check-out {room}',
    chooseArrivalTime: 'Pilih waktu kedatangan',
    chooseDepartureTime: 'Pilih waktu keberangkatan',
    detailLoadFailed: 'Gagal memuat data perubahan pesanan versi baru',
    detailLoadRetry: 'Gagal memuat data perubahan pesanan versi baru. Silakan coba lagi',
    discountLabel: 'Diskon {discount}% dari tarif konter',
    invalidStay: 'Silakan pilih waktu kedatangan dan keberangkatan yang valid',
    keepOneRoom: 'Setidaknya satu pesanan kamar yang valid harus tersisa setelah perubahan',
    latestPriceFailed: 'Gagal memuat tarif terbaru. Sesuaikan tanggal menginap dan coba lagi',
    latestPriceLoading: 'Memuat tarif terbaru. Silakan kirim nanti',
    longStayAtLeastTenDays: 'Masa inap untuk reservasi jangka panjang minimal 10 hari',
    longStayAtMostOneYear: 'Masa inap untuk reservasi jangka panjang tidak boleh lebih dari satu tahun',
    longStayNoMorning: 'Kamar dini hari tidak diizinkan untuk reservasi jangka panjang',
    markedCancelled: 'Ditandai untuk dibatalkan',
    newRoomOrder: 'Pesanan kamar baru',
    newRoomPriceLoading: 'Memuat tanggal menginap dan tarif pesanan kamar baru. Silakan kirim nanti',
    noReducibleRoom: 'Tidak ada pesanan kamar sementara atau menunggu check-in yang dapat dikurangi untuk tipe ini',
    otherStatus: 'Status lainnya',
    phonePlaceholder: 'Masukkan nomor ponsel',
    productPriceFailed: 'Gagal memuat produk dan tarif hotel. Silakan coba lagi',
    roomNumberValue: 'Kamar {room}',
    roomOrderDetails: 'Detail',
    roomTypeInfo: 'Informasi tipe kamar',
    roomTypeNoProduct: 'Tidak ada produk hotel yang tersedia untuk tipe kamar ini',
    stayChangedClearRoom: 'Tanggal menginap berubah. Penetapan kamar sebelumnya dihapus; silakan tetapkan lagi',
    stayPriceRefreshFailed: 'Gagal memuat tarif setelah tanggal menginap berubah. Silakan coba lagi',
    stayProductPriceFailed: 'Gagal memuat produk dan tarif untuk masa inap yang dipilih. Silakan coba lagi',
    stayProductUnavailable: 'Tidak ada produk hotel yang tersedia untuk tipe kamar ini pada masa inap yang dipilih',
    storeProductMissing: 'Produk hotel tidak ditemukan',
    temporaryRoomOrder: 'Pesanan kamar sementara',
    unassignedSummary: '{count} kamar menunggu penetapan',
  },
  componentsEditroomorder: {
    modifyingTheAgreedUnitInformationWillRecalculateAllRoomRatesInTheOrder:
      'Mengubah informasi unit perjanjian akan menghitung ulang semua harga kamar dalam pesanan',
    modifyRoomList: 'Ubah daftar kamar',
  },
  componentsEditroomprice: {
    modifyTheHousePrice: 'Ubah harga kamar',
    theCurrentPriceCalendarCannotBeModified: 'Kalender harga saat ini tidak dapat diubah',
    updatePriceCalendarSuccessfully: 'Pembaruan kalender harga berhasil',
  },
  componentsLevelup: {
    payTheBill: 'Bayar',
    partUpgrade: 'Bagian peningkatan',
    confirmTheUpgrade: 'Konfirmasi peningkatan',
    currentRoomType: 'Tipe kamar saat ini',
    reselection: 'Pilih ulang',
    chargeOrNot: 'Dikenakan biaya atau tidak',
    currentTotalHousePrice: 'Total harga kamar saat ini',
    totalRateAfterUpgrade: 'Total harga setelah peningkatan',
    priceDifference: 'Selisih harga',
    upgradeCause: 'Alasan peningkatan',
    enterAMaximumOf150Words: 'Maksimal 150 karakter',
    pleaseChooseWhetherToCharge: 'Silakan pilih apakah dikenakan biaya',
    pleaseEnterTheUpgradeReason: 'Silakan isi alasan peningkatan',
    inTheCaseOfPaymentTheSpreadCannotBeLessThanOrEqualTo0:
      'Jika berbayar, selisih harga tidak boleh ≤ 0',
    reminderIfYouUpgradeTheRoomTypeBetweenTheNightAuditAnd0600PleaseManuallyHandleTheRoomRateDifference:
      'Pengingat: jika meningkatkan tipe kamar antara audit malam hingga pukul 06.00, harap tangani selisih harga kamar secara manual',
  },
  componentsSeeroomprice: {
    viewRoomRates: 'Lihat harga kamar',
  },
  componentsStay: {
    theCurrentRoomTypeIsSoldOutPleaseSelectAnotherDate:
      'Tipe kamar saat ini telah habis terjual, silakan pilih tanggal lain',
    existingRoomSingleChargeCheckOut: 'Check-out dengan piutang pada pesanan kamar saat ini',
    theAccountOfTheExistingHouseBillIsTransferredToTheNewHouseBill:
      'Akun pesanan kamar saat ini ditransfer ke pesanan kamar baru sebelum check-out',
    promptTheCurrentRoomIsALinkedRoomBillAfterExtendingTheStayYouNeedToManuallyAddTheNewRoomBillToTheLinkedRooms:
      'Pengingat: kamar saat ini merupakan pesanan kamar terhubung, setelah perpanjangan menginap Anda perlu menambahkan pesanan kamar baru ke kamar terhubung secara manual',
    nonStoreSingleCanNotSustain: 'Pesanan non-toko tidak mendukung perpanjangan',
    youCannotRenewYourStayUntilTheCheckOutDate:
      'Belum mencapai tanggal check-out, tidak dapat melakukan perpanjangan',
    extendStayadvance: 'Perpanjang / lebih awal',
    originalOrder2: 'Pesanan asli',
    continuationPrice: 'Harga perpanjangan',
    changeTheCheckOutTime: 'Ubah waktu check-out',
    selectDateTime: 'Pilih tanggal & waktu',
    continuationPriceRule: 'Aturan harga perpanjangan',
    swapOrder: 'Tukar pesanan',
    nameAndMobilePhoneNumberOfThePersonWhoMadeTheReservation: 'Nama dan nomor ponsel pemesan',
    subscriber: 'Pemesan',
    roomAccountProcessing: 'Pemrosesan akun kamar',
    pleaseSelectTheRenewalPriceRule: 'Silakan pilih aturan harga perpanjangan',
    checkOutTimeCannotBeLessThanTheCurrentTime:
      'Waktu check-out tidak boleh lebih awal dari waktu saat ini',
    theRenewalOfStayIsSuccessful: 'Perpanjangan menginap berhasil',
    pleaseSelectANewOrder: 'Silakan pilih pesanan baru',
    theRenewalOfTheOrderDoesNotSupportTheFlyingPigCreditOrder:
      'Perpanjangan dengan penggantian pesanan tidak mendukung pesanan Fliggy Credit Stay',
    extendStayadvanceSuccess: 'Perpanjangan / check-out lebih awal berhasil',
    roomNumber: 'No. Kamar',
    checkInPerson: 'Tamu',
    checkOutTime: 'Waktu Check-out',
    makeCard: 'Buat Kartu',
    booked: 'Bukukan',
    close: 'Tutup',
  },
  componentsTools: {
    pendingClosing: 'Menunggu pengajuan penutupan',
    closingSuccessful: 'Pengajuan penutupan berhasil',
    failedToApplyForClosing: 'Pengajuan penutupan gagal',
    firstNightRate: 'Tarif malam pertama',
    lateNightRate: 'Tarif malam terakhir',
    maximumHousePrice: 'Harga kamar maksimum',
    minimumRoomRate: 'Tarif kamar minimum',
  },
  ebkorderIndex: {
    priceDescription: 'Penjelasan harga',
    merchantPromotionTotalAmountBorneByTheMerchant:
      'Promosi merchant = total jumlah yang ditanggung merchant',
    totalSellingPriceTotalOrderAmountMerchantPromotion:
      'Total harga jual = total pesanan - promosi merchant',
    totalCommissionTotalSellingPriceCommissionRate:
      'Total komisi = total harga jual × tarif komisi',
    totalBasePriceTotalSellingPriceTotalCommission:
      'Total harga dasar = total harga jual - total komisi',
    userPaymentAmountActuallyPaidByTheUser:
      'Pembayaran pengguna = jumlah yang benar-benar dibayar pengguna',
    totalOrder: 'Total pesanan',
    totalSellingPrice: 'Total harga jual',
    userPayment: 'Pembayaran pengguna',
    totalCommission: 'Total komisi',
    totalFloorPrice: 'Total harga dasar',
    merchantPromotion: 'Promosi merchant',
    viewOrder: 'Lihat pesanan',
    orderTransferMethod: 'Metode pemindahan pesanan',
    removalOfOrder: 'Pemindahan pesanan',
    contactAndMobilePhoneNumber: 'Kontak & nomor ponsel',
    channelOrderStatus: 'Status pesanan saluran',
    orderStatus: 'Status pemindahan',
    channelOrderNumber: 'Nomor pesanan saluran',
    channelType: 'Tipe kamar saluran',
    expectedArrivalexpectedDeparture: 'Perkiraan tiba / berangkat',
    bookingType: 'Jenis reservasi',
    estimatedTimeOfArrival: 'Perkiraan waktu kedatangan',
    orderCreationTime: 'Waktu pembuatan pesanan',
    inBooking: 'Sedang dipesan',
    bookingFailed: 'Reservasi gagal',
    bookingException: 'Reservasi bermasalah',
    initialRejection: 'Penolakan awal',
    canceling: 'Sedang dibatalkan',
    otherStates: 'Status lainnya',
    movedOrder: 'Sudah dipindahkan',
    unmovedOrder: 'Belum dipindahkan',
    createTimeDesc: 'Waktu pembuatan menurun',
    createTimeAsc: 'Waktu pembuatan menaik',
    arriveTimeDesc: 'Waktu kedatangan menurun',
    arriveTimeAsc: 'Waktu kedatangan menaik',
    ebkOrderCheckMsg: 'Belum ada data, klik untuk menambahkan',
  },
  ebkorderUnbindtip: {
    youDoNotHaveAMeituanAccount: 'Anda belum mengikat akun Meituan',
    pleaseSetItInmoresystemSettingsebAccountAuthorization:
      'Silakan atur di [Lainnya] - [Pengaturan Sistem] - [Otorisasi Akun EB]',
    clickToGo: 'Klik untuk menuju',
  },
  orderBoxIndex: {
    title: 'Kotak Pesanan',
    businessType: 'Jenis Bisnis',
    processStatus: 'Status Proses',
    businessTypeCreateOrder: 'Buat Pesanan',
    businessTypeCancelOrder: 'Batalkan Pesanan',
    businessTypeCheckout: 'Check-out',
    businessTypeExtendStay: 'Perpanjang Menginap',
    statusPending: 'Menunggu',
    statusProcessing: 'Sedang Diproses',
    statusProcessed: 'Selesai Diproses',
    quickAccept: 'Terima Pesanan Cepat',
    confirmQuickAccept: 'Konfirmasi terima pesanan cepat untuk pesanan ini?',
  },
  invoiceInvoiceDetail: {
    personage: 'Pribadi',
    firm: 'Perusahaan',
    headerType: 'Jenis judul',
    invoiceAmount2: 'Jumlah faktur',
    pleaseEnterTheInvoiceAmount: 'Silakan masukkan jumlah faktur',
    pleaseEnterTheInvoiceNumber2: 'Silakan masukkan nomor faktur',
    invoiceGroup: 'Pengelompokan faktur',
    selectRoomList: 'Pilih daftar kamar',
    orderAmount: 'Jumlah pesanan',
    pleaseEnterTheInvoiceTitleToSearch: 'Masukkan judul faktur untuk mencari',
    pleaseEnterYourTaxIdentificationNumber: 'Masukkan nomor identifikasi pajak',
    unitAddress: 'Alamat perusahaan',
    pleaseEnterTheAddressOfTheUnit: 'Masukkan alamat perusahaan',
    telephoneNumber: 'Nomor telepon',
    bankOfDeposit2: 'Bank pembuka',
    pleaseEnterYourBank: 'Masukkan bank pembuka',
    bankAccount: 'Rekening bank',
    pleaseEnterYourBankAccount: 'Masukkan rekening bank',
    pleaseEnterYourEmailAddress: 'Masukkan alamat email',
    invoiceMailingAddress: 'Alamat pengiriman faktur',
    pleaseEnterTheInvoiceMailingAddress: 'Masukkan alamat pengiriman faktur',
    billingNote: 'Catatan penagihan',
    pleaseEnterYourBillingRemarks: 'Masukkan catatan penagihan',
    pleaseSelectTheBillingType5: 'Silakan pilih jenis penagihan',
    pleaseSelectAHeaderType: 'Silakan pilih jenis judul',
    fillInAtLeastOneEMailAndMailingAddress:
      'Isi setidaknya salah satu: email atau alamat pengiriman',
  },
  invoiceInvoiceList: {
    toBeInvoiced: 'Menunggu penagihan',
    pleaseEnterYourTaxIdentificationNumber: 'Masukkan nomor identifikasi pajak',
    pleaseEnterTheInvoiceNumber2: 'Masukkan nomor faktur',
    newInvoice: 'Tambah faktur',
    invoiceType: 'Jenis faktur',
    invoiceAmount: 'Jumlah faktur',
    billingTime: 'Waktu penagihan',
  },
  invoiceRoomInvoiceAssociationSearch: {
    roomListInvoiceList2: 'Daftar faktur kamar',
    namePhoneNumberRoomNumber: 'Nama tamu, nomor ponsel, nomor kamar',
  },
  invoiceRoomInvoiceList: {
    roomListInvoiceList2: 'Daftar faktur kamar',
    accumulatedInvoiceAmount: 'Akumulasi jumlah faktur',
    toBeInvoiced: 'Menunggu penagihan',
    newInvoice: 'Tambah faktur',
    invoiceType: 'Jenis faktur',
    invoiceAmount: 'Jumlah faktur',
    billingTime: 'Waktu penagihan',
  },
  orderListBaseinfo: {
    getThePhoneNumber: 'Dapatkan nomor ponsel',
    preSaleVoucherNumber: 'Nomor voucher prajual',
    contractNumber: 'Nomor kontrak',
    invoice: 'Faktur',
    promotionalActivity: 'Aktivitas promosi',
    estimatedSettlementAmount: 'Perkiraan jumlah penyelesaian',
    pack: 'Paket',
    selfServiceReservation: 'Reservasi mesin mandiri',
    theInvoiceForThisOrderIsProvidedByTheSalesChannelToTheGuest2:
      'Faktur pesanan ini disediakan oleh saluran penjualan kepada tamu',
    thisOrderIsInvoicedByYourHotelToTheGuest:
      'Faktur pesanan ini diterbitkan oleh hotel Anda kepada tamu',
    theAmountIsForReferenceOnlyTheSpecificSettlementAmountIsSubjectToTheBill:
      'Jumlah ini hanya sebagai referensi; jumlah penyelesaian final mengacu pada tagihan',
    systemRemark: 'Catatan sistem',
    sellerRemark: 'Catatan merchant',
  },
  orderListCheckIn: {
    handleSuccessfully: 'Proses berhasil',
    viewCheckInInformation: 'Lihat informasi check-in',
    handleAgain: 'Proses ulang',
    handlingFailure: 'Proses gagal',
    theNameCannotBeBlank2: 'Nama tidak boleh kosong',
    theIdTypeCannotBeEmpty: 'Jenis dokumen tidak boleh kosong',
    theIdNumberCannotBeEmpty: 'Nomor dokumen tidak boleh kosong',
    pleaseArrangeTheRoomFirst: 'Silakan atur kamar terlebih dahulu',
    checkInData: 'Data formulir check-in',
  },
  orderListDetail: {
    checkInStatus: 'Status check-in',
    total: 'Total',
    chargedToAccount: 'Ditangguhkan',
    natureTraffic: 'Lalu lintas alami',
    natureOrderTip: 'Pesanan ini berasal dari saluran reservasi penjualan langsung LightStay',
    preCheckInForm: 'Formulir pra check-in',
    continuationOrder: 'Pesanan perpanjangan',
    liveOnCredit: 'Credit Stay',
    preSaleVoucherReservationForm: 'Formulir reservasi voucher prajual',
    meituanEbOrder: 'Pesanan Meituan EB',
    ctripEbOrder: 'Pesanan Ctrip EB',
    flash: 'Flash',
    fullGuarantee: 'Jaminan penuh',
    roomListInformation: 'Informasi daftar kamar',
    automaticRowHouse: 'Penempatan kamar otomatis',
    bulkCheckIn: 'Check-in massal',
    unterracedHouse: 'Belum ditempatkan',
    upgrades: 'Upgrade',
    prefabricatedKeyCard: 'Kartu pintu pra-cetak',
    modifyTheOrder2: 'Ubah pesanan',
    cancelAnOrder2: 'Batalkan pesanan',
    rejectAnOrder: 'Tolak pesanan',
    pleaseArrangeTheRoomBeforePreformingTheKeyCard:
      'Silakan atur kamar terlebih dahulu sebelum membuat kartu pintu',
    theListingHasBeenCancelled: 'Daftar kamar ini telah dibatalkan',
    noRoomingAllowedAfterThePreDepartureTime:
      'Tidak diizinkan menempatkan kamar setelah waktu pra-keberangkatan',
    allListingsAreAlreadyFurnished: 'Semua daftar kamar telah ditempatkan',
    theAutomaticPlatoonSucceeded: 'Penempatan kamar otomatis berhasil',
    someRowhousesAreSuccessful: 'Sebagian penempatan kamar berhasil',
    smartCheckInBusinessHasNotOpenedTheFunction:
      'Fitur check-in cerdas belum diaktifkan untuk merchant ini',
    thisOrderIsARenewalOrderCheckInMayAffectTheOriginalRoomRenewal:
      'Pesanan ini adalah pesanan perpanjangan; check-in dapat memengaruhi perpanjangan kamar asli',
    thisOrderIsARenewalOrderWhichMayAffectTheContinuationOfTheOriginalRoom:
      'Pesanan ini adalah pesanan perpanjangan; melanjutkan dapat memengaruhi perpanjangan kamar asli',
    exceedDepartureDate: 'Telah melewati tanggal pra-keberangkatan, tidak dapat upgrade tipe kamar',
    theCurrentTimeHasExceededTheCheckOutTimeCannotUpgradeTheRoom:
      'Waktu saat ini telah melewati waktu check-out, tidak mendukung upgrade kamar',
    cancelingTheCurrentRowSucceededProcedure: 'Pembatalan penempatan kamar saat ini berhasil',
    orderAcceptedSuccessfully: 'Pesanan berhasil diterima',
    successfulRejection: 'Penolakan berhasil',
    thisActionWillCancelTheListingWhetherToContinue:
      'Tindakan ini akan membatalkan daftar kamar, lanjutkan?',
  },
  orderListGiftinfodetail: {
    packageName: 'Nama paket',
    packageValue: 'Nilai paket',
    wayOfGiving: 'Cara pemberian',
    dateOfPresentation2: 'Tanggal pemberian',
    packageDetails: 'Detail paket',
    oneDeliveryPerRoom: 'Satu kali per kamar',
    complimentaryOnceADayPerRoom: 'Gratis sekali per hari per kamar',
  },
  orderListOrderDetail: {
    orderDetails: 'Detail pesanan',
    finance3: 'Keuangan',
    preAuthorizationDetail: 'Detail pra-otorisasi',
  },
  orderListOrderList: {
    durationOfResidence: 'Durasi menginap',
    bookingTime: 'Waktu reservasi',
    preCheckInForm: 'Formulir pra check-in',
    housePig: 'House Pig',
    presaleTicket: 'Voucher prajual',
    nameMobilePhoneNumberOrderNumberChannelNumberQuery:
      'Pencarian berdasarkan nama, nomor ponsel, nomor pesanan, nomor pesanan saluran',
    multipleSearch: 'Pencarian multiple',
    selfServiceReservation: 'Reservasi mesin mandiri',
    rejectAnOrder: 'Tolak pesanan',
    individualTraveler: 'Tamu individu',
    team2: 'Tim',
    estimate: 'Perkiraan tiba',
    firstDayPrice: 'Harga hari pertama',
    areYouSureYouWantToTakeTheOrder: 'Apakah Anda yakin ingin menerima pesanan ini',
    orderAcceptedSuccessfully: 'Pesanan berhasil diterima',
    booked: 'Sudah dipesan',
    refused: 'Ditolak',
    extendStayCheckInImpact:
      'Pesanan ini adalah pesanan perpanjangan, proses check-in dapat memengaruhi perpanjangan kamar asli',
    exceededDepartureCannotUpgrade:
      'Telah melewati tanggal perkiraan keberangkatan pukul 06.00, tidak diizinkan upgrade tipe kamar',
    exceededCheckoutCannotUpgrade:
      'Waktu saat ini telah melewati waktu check-out, tidak mendukung upgrade kamar',
    exceededDepartureCannotArrangeRoom:
      'Melewati waktu perkiraan keberangkatan, tidak diizinkan mengatur kamar',
    preArrivalNotArrived: 'Pra-kedatangan tidak datang',
    noshow: 'No-show',
  },
  orderListNoShow: {
    title: 'No-show',
    noshowReason: 'Alasan no-show',
    remarkPlaceholder: 'Catatan (5-100 karakter)',
    remarkMinLength: 'Catatan minimal 5 karakter',
    pleaseSelectNoshowReason: 'Silakan pilih alasan no-show',
  },
  orderListPricedetail: {
    channelCost: 'Harga awal saluran',
    eventDiscount: 'Diskon aktivitas',
    guestActivityDiscount: 'Diskon aktivitas tamu',
    memberDiscount: 'Diskon anggota',
    guestMembershipDiscount: 'Diskon keanggotaan tamu',
    sameTripExclusiveOffer: 'Penawaran eksklusif Tongcheng',
    guestTongchengExclusiveDiscount: 'Diskon eksklusif Tongcheng untuk tamu',
    guestPurchasePrice: 'Harga pembelian tamu',
    activityDiscountAndHotelSellingPriceExplanationThereWillBeADifferenceBetweenTheGuestsOfThisChannelAndTheSettlementBillYouCanClickpricePromptToViewTheActualAmountPaidByTheGuests:
      'Penjelasan diskon aktivitas dan harga jual hotel: mungkin terdapat perbedaan antara tamu saluran ini dan tagihan penyelesaian; klik “petunjuk harga” untuk melihat jumlah yang benar-benar dibayar tamu',
    priceDetails: 'Detail harga',
    memberBenefits: 'Manfaat anggota',
    jointMemberBenefits: 'Manfaat anggota bersama',
  },
  orderListPromotiondetail: {
    eventDetails2: 'Detail aktivitas',
    preferentialRules: 'Aturan promo',
  },
  orderListPromotiondetailnew: {
    eventDetails2: 'Detail aktivitas',
    dateCondition: 'Kondisi tanggal',
    bookingConditions: 'Syarat pemesanan',
    preferentialRules: 'Aturan promo',
    participationDate: 'Tanggal partisipasi',
  },
  orderListRefuse: {
    areYouSureYouWantToDeclineThisOrder: 'Apakah Anda yakin ingin menolak pesanan ini',
    confirmationRejection: 'Konfirmasi penolakan',
    successfulRejection: 'Penolakan berhasil',
    theOrderWillBeClosedAtTheSameTime: 'Pesanan akan ditutup bersamaan setelah ditolak',
    overbookingSetup: 'Pengaturan overbooking',
  },
  orderListTip: {
    useWechatToScanThecheckInQrCodeAtTheFrontDeskToOpenTheOrderInquiryPage:
      'Gunakan WeChat untuk memindai “QR check-in” di front desk untuk membuka halaman pencarian pesanan',
    fillInTheBookingPersonsNameMobilePhoneNumberAndCheckInDateToCheckTheBookingForm:
      'Isi nama pemesan, nomor ponsel, dan tanggal check-in untuk mencari formulir pemesanan',
    selectTheBookingFormThatNeedsToBeCheckedInAndSelectTheRoomWhereYouWantToAddPeopleToFillInTheInformation:
      'Pilih formulir pemesanan yang perlu check-in, lalu pilih kamar untuk menambahkan tamu dan isi informasinya',
    atThisPointYouCanViewTheRoomAlertInThePreOrderDetailsAfterFillingInTheInformationOfAllTheGuestsClickThecheckInButtonToCheckInTheGuests:
      'Setelah mengisi informasi semua tamu, Anda dapat melihat peringatan kamar di detail pra-pesanan; klik tombol “Check-in” untuk memproses check-in',
    atThisPointYouCanSeeInTheListDetailsThatThePersonHasBeenAddedSuccessfully:
      'Pada tahap ini, Anda dapat melihat di detail daftar bahwa tamu telah berhasil ditambahkan',
    off: 'Tutup',
    theUserHasCompletedTheProcedure: 'Pengguna telah menyelesaikan proses',
    pleaseGuideTheGuestsTocheckInInTheFollowingWay:
      'Mohon pandu tamu untuk melakukan “check-in” dengan cara berikut',
    afterTheGuestsFillInAndSubmitThePageWillDisplaypleaseBringYourIdToTheFrontDeskForVerification:
      'Setelah tamu mengisi dan mengirimkan, halaman akan menampilkan “Silakan bawa identitas ke front desk untuk verifikasi”',
    pleaseGuideTheGuestsToAddAdditionalGuestsAsFollows:
      'Mohon pandu tamu untuk “menambahkan tamu tambahan” dengan cara berikut',
  },
  groupOrderAddroomer: {
    validityPeriod: 'Masa berlaku',
    addmodifyCheckInGuests: 'Tambah/Ubah tamu check-in',
    pleaseEnterAddress: 'Silakan masukkan alamat',
    startDate: 'Tanggal mulai',
    currentSubscript: 'Indeks saat ini',
  },
  groupOrderIndex: {
    bulkCheckIn: 'Check-in massal',
    automaticRowHouse: 'Penempatan kamar otomatis',
    checkInAddition: 'Tambah tamu check-in',
    pleaseSelectTheRoomYouWantToCheckIn: 'Silakan pilih kamar yang ingin di-check-in',
    theEmptyAndDirtyRoomYouSelectedIsConfirmedToCheckIn:
      'Kamar kosong namun kotor yang Anda pilih, apakah yakin ingin check-in',
    checkInSuccessful: 'Check-in berhasil',
    roomNoLongerAvailablePleaseChangeToAnotherRoomNumber:
      'Kamar sudah tidak tersedia, silakan ganti ke nomor kamar lain',
    theRoomIsOccupiedPleaseChangeToAnotherRoomNumber:
      'Kamar sedang ditempati, silakan ganti ke nomor kamar lain',
    pleaseArrangeTheRoomBeforeChoosing: 'Silakan atur kamar terlebih dahulu sebelum memilih',
    allListingsAreAlreadyFurnished: 'Semua daftar kamar sudah ditempatkan',
    theAutomaticPlatoonSucceeded: 'Penempatan kamar otomatis berhasil',
    pleaseListTheRoomFirstAndThenAddTheGuest:
      'Silakan atur kamar terlebih dahulu lalu tambahkan tamu',
    succeededInCancelingTheRowHouse: 'Pembatalan penempatan kamar berhasil',
  },
  presalecouponsPredetail: {
    ticketName: 'Nama voucher prajual',
    presaleTicket: 'Voucher prajual',
    saleOrderNumber: 'Nomor pesanan penjualan',
    purchaseTime: 'Waktu pembelian',
    advanceOrder: 'Pesanan reservasi',
    availableProduct: 'Produk yang tersedia',
    commodityContent: 'Konten produk',
    ruleInformation: 'Informasi aturan',
    availableTime: 'Waktu reservasi tersedia',
    checkInTime2: 'Waktu check-in tersedia',
    markUpRule: 'Aturan penambahan harga',
    cancellationRules: 'Aturan pembatalan reservasi',
    paymentInformation: 'Informasi pembayaran',
    crossedPrice: 'Harga coret',
    chineseFood: 'Masakan Tiongkok',
    dinner2: 'Makan malam',
    bookedBedtotalBedHours: 'Malam kamar yang dipesan / total malam kamar (jam)',
    raiseAPrice: 'Tambah harga',
    meituanDirectNew: 'Meituan koneksi langsung (baru)',
    officialWebsiteDirect: 'Situs resmi (direct)',
    ctripSingleStore: 'Ctrip toko tunggal',
    agoda: 'Agoda',
    meituanHomestay: 'Meituan Homestay',
    tujiaHomestay: 'Tujia Homestay',
    booking: 'Booking',
    expedia: 'Expedia',
  },
  presalecouponsPrelist: {
    dateOfPayment: 'Tanggal pembayaran',
    productId: 'ID produk',
    sellOrderNumber: 'Nomor pesanan penjualan',
    noAppointment: 'Belum reservasi',
    completeWriteOff: 'Hapuskan seluruhnya',
    completeReverseWriteOff: 'Tutup seluruhnya invers',
    refunded: 'Telah direfund',
    orderNumber2: 'Nomor pesanan',
    timeOfPayment: 'Waktu pembayaran',
    bookedBedtotalBedHours: 'Malam kamar yang dipesan / total malam kamar (jam)',
  },
  hardwareParking: {
    parkingLotManagement: 'Manajemen parkir',
    parkingLotDescription: 'Mendukung pengenalan plat nomor otomatis untuk masuk dan keluar',
    settings: 'Pengaturan',
    parkingLotConfig: 'Konfigurasi parkir',
    currentDevice: 'Perangkat saat ini',
    unboundDeviceTip: 'Hotel saat ini belum mengikat perangkat parkir',
    sidPlaceholder: 'Silakan masukkan SID',
    secretKeyPlaceholder: 'Silakan masukkan SecretKey',
    enableStatus: 'Status aktif',
    hotelNotBoundWarning: 'Hotel saat ini belum mengikat perangkat parkir',
    enterSidAndSecretKey: 'Silakan masukkan SID dan SecretKey',
    saveSuccess: 'Berhasil disimpan',
    saveFailed: 'Gagal menyimpan',
    configFailed: 'Konfigurasi gagal',
    parkingDeviceEnabled: 'Perangkat parkir telah diaktifkan',
    parkingDeviceDisabled: 'Perangkat parkir telah dinonaktifkan',
    fetchHardwareRelationFailed: 'Gagal mendapatkan relasi pengikatan perangkat keras',
    fetchConfigFailed: 'Gagal mendapatkan konfigurasi parkir',
  },
  roomOrderListVehicleDialog: {
    title: 'Nomor plat kendaraan',
    platePlaceholder: 'Silakan masukkan nomor plat kendaraan',
    add: 'Tambah',
    plateNo: 'Nomor plat kendaraan',
    enterPlateWarning: 'Silakan masukkan nomor plat kendaraan',
    enterPlateFormatWarning: 'Format plat nomor tidak benar',
    addSuccess: 'Berhasil ditambahkan',
    deleteConfirm: 'Apakah Anda yakin ingin menghapus nomor plat kendaraan ini?',
    deleteSuccess: 'Berhasil dihapus',
  },
  roomOrderListDetail: {
    vehiclePlateNo: 'Nomor plat kendaraan',
    saveFailed: 'Gagal menyimpan',
    cancelStay: 'Batalkan perpanjangan',
    enterRemarkContent: 'Silakan masukkan isi catatan',
    systemRemark: 'Catatan sistem',
    merchantRemark: 'Catatan merchant',
    originalStayOrder: 'Pesanan perpanjangan asli',
    newStayOrder: 'Pesanan perpanjangan baru',
    continued: 'Lanjut',
    downloadIdPhoto: 'Unduh foto identitas',
    uploadedToPolice: 'Telah diunggah ke sistem kepolisian',
    reuploadToPolice: 'Unggah ulang ke sistem kepolisian',
    cancelStaySuccess: 'Pembatalan perpanjangan berhasil',
    enterNumber: 'Silakan masukkan jumlah',
    liveOnCredit: 'Credit Stay',
    duration: 'Durasi',
    invoice: 'Faktur',
    roomInformation2: 'Informasi kamar',
    numberOfGuests: 'Jumlah tamu',
    doorLockCode: 'Kode kunci pintu',
    generatePassword: 'Buat kata sandi',
    resetPassword: 'Atur ulang kata sandi',
    passwordInvalidation: 'Nonaktifkan kata sandi',
    idNumber2: 'Nomor identitas',
    guestAddress: 'Alamat tamu',
    theInvoiceForThisOrderIsProvidedByTheSalesChannelToTheGuest2:
      'Faktur pesanan ini disediakan oleh saluran penjualan kepada tamu',
    thisOrderIsInvoicedByYourHotelToTheGuest:
      'Faktur pesanan ini diterbitkan oleh hotel Anda kepada tamu',
    originalOrder2: 'Pesanan asli',
    swapOrder: 'Tukar pesanan',
    faceCollection: 'Pengambilan wajah',
    invoice2: 'Terbitkan faktur',
    sendPassword: 'Kirim kata sandi',
    upgradeTheRoom: 'Upgrade kamar',
    extendStayadvance: 'Perpanjang / lebih awal',
    transferToFullDayRoom: 'Ubah Harian',
    decamping: 'Kurangi tamu sekamar',
    increaseCohabitation: 'Tambah Sekamar',
    checkInSlip4: 'Formulir check-in',
    reinstatement: 'Pulihkan check-in',
    renewalOrder2: 'Pesanan perpanjangan',
    roomChangeConfirmationForm3: 'Formulir konfirmasi pindah kamar',
    conferenceCorps: 'Grup konferensi',
    tourParty: 'Rombongan tur',
    confirmNeedToResumeCheckIn: 'Konfirmasi perlu memulihkan check-in',
    operationReminder: 'Pengingat operasi',
    reinstatedCheckInSuccessful: 'Pemulihan check-in berhasil',
    fullDayRoomTransfersAreNotSupportedForOnlineOrders:
      'Pesanan online tidak mendukung perubahan ke kamar harian penuh',
    whetherToCancelTheRowRoomAndTransferToTheFullDay:
      'Apakah ingin membatalkan penempatan kamar dan mengubah ke kamar harian penuh',
    areYouSureYouWantToChangeToAFullDayRoom:
      'Apakah Anda yakin ingin mengubah ke kamar harian penuh',
    checkOutTimeWillBeChangedTo2:
      'Setelah diubah ke kamar harian penuh, waktu check-out akan menjadi',
    theRoomIsIn: 'Kamar berada di',
    existingRowHouse: 'Sudah ditempatkan',
    conversionToFullDayRoomSuccessful: 'Berhasil diubah ke kamar harian penuh',
    flyingPigCreditLiveOrdersDoNotSupportJointHousing2:
      'Pesanan Fliggy Credit Stay tidak mendukung kamar gabungan',
    generatePassword2: 'Sedang membuat kata sandi',
    passwordGeneratedSuccessfully: 'Pembuatan kata sandi berhasil',
    areYouSureYouWantToResetYourCurrentPassword:
      'Apakah Anda yakin ingin mengatur ulang kata sandi saat ini',
    resetPassword2: 'Sedang mengatur ulang kata sandi',
    resetPasswordSuccessfully: 'Pengaturan ulang kata sandi berhasil',
    areYouSureYouWantToInvalidateYourCurrentPassword:
      'Apakah Anda yakin ingin menonaktifkan kata sandi saat ini',
    thePasswordIsInvalid: 'Sedang menonaktifkan kata sandi',
    thePasswordIsInvalidProcedure: 'Penonaktifan kata sandi berhasil',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomCannotBeChanged2:
      'Waktu saat ini telah melewati waktu check-out, kamar tidak dapat diubah',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomUpgradeIsNotSupported2:
      'Waktu saat ini telah melewati waktu check-out, upgrade kamar tidak didukung',
    theCurrentTimeHasPassed600CheckInDateTheRoomUpgradeIsNotSupported2:
      'Waktu saat ini telah melewati pukul 06.00 pada tanggal check-out, upgrade kamar tidak didukung',
    theGuestHasAppliedForOnlineRenewalAndMayNotBeAbleToRenewTheOrder:
      'Tamu telah mengajukan perpanjangan online, melanjutkan proses mungkin tidak dapat mengganti pesanan perpanjangan',
    flyingPigCreditOrdersCanNotBeSustained2:
      'Pesanan Fliggy Credit Stay tidak mendukung perpanjangan',
    itHasPassedTheCheckOutDateAndCannotBeExtended2:
      'Telah melewati tanggal check-out, tidak dapat diperpanjang',
    successfulRoomExchange2: 'Pindah kamar berhasil',
    upgradedRoomTypeData: 'Data tipe kamar yang di-upgrade',
    theOtherRoomsInTheOrderHaveCheckedOutAndThecustomerTypeCannotBeModified:
      'Kamar lain dalam pesanan telah check-out, tipe sumber tamu tidak dapat diubah',
    theGuestHasAppliedForOnlineRenewalAndConfirmedTheNeedToContinueChangingRooms:
      'Tamu telah mengajukan perpanjangan online, konfirmasi untuk melanjutkan perubahan kamar?',
  },
  roomOrderListGroupRoomDetail: {
    contactNumber4: 'Nomor kontak',
    aTotalOf: 'Total',
    occupancyStatus: 'Status hunian',
    onAccount2: 'Ditangguhkan',
    rollOut: 'Transfer keluar',
    setAsMaster: 'Tetapkan sebagai pesanan utama',
    rescission: 'Lepas kamar terhubung',
    teamRegistrationSheet: 'Formulir pendaftaran tim',
    numberOfRooms: 'Jumlah kamar',
    confirmToCancelTheHouseRelationship: 'Konfirmasi untuk melepaskan hubungan kamar',
    successfullyDisconnectingTheHouse: 'Berhasil melepaskan kamar terhubung',
    rollOutSuccess: 'Transfer keluar berhasil',
    setTheMasterOrderToSucceed: 'Berhasil menetapkan sebagai pesanan utama',
  },
  roomOrderListMinusroomer: {
    residentGuest: 'Tamu yang menginap',
    reduceRoommateSuccess: 'Berhasil mengurangi tamu sekamar',
    decamping: 'Kurangi tamu sekamar',
    pleaseSelectTheNumberOfPeopleYouWantToReduce: 'Silakan pilih jumlah tamu yang ingin dikurangi',
    keepAtLeastOneOccupantInTheRoom: 'Harus menyisakan setidaknya satu tamu di kamar',
  },
  roomOrderListRelativeRoom: {
    roomOrder: 'Pesanan Kamar',
    reservationOrder: 'Reservasi',
    pendingCheckIn: 'Menunggu Check-in',
    pleaseSelectARoomOrder: 'Silakan pilih pesanan kamar',
    linkRoomNumber: 'Nomor kamar terhubung',
    inTheRoom: 'Kamar dihuni',
    residentialTeam: 'Tim yang menginap',
    flyingPigCreditDoesNotSupportHousing: 'Fliggy Credit Stay tidak mendukung kamar terhubung',
    directChannelsDoNotSupportTheEstablishmentOfJointHousesAndTeamsWithStoreChannels:
      'Saluran direct connect tidak mendukung pembentukan kamar terhubung dan tim dengan saluran toko',
    guestsNameMobilePhoneNumberAndRoomNumber: 'Nama tamu, nomor ponsel, nomor kamar',
    teamNameBookingPersonNameMobilePhoneNumber: 'Nama tim, nama pemesan, nomor ponsel',
    pleaseSelectATeam: 'Silakan pilih tim',
    joinTheTeamSuccessfully: 'Berhasil bergabung ke tim',
    joinTheRoomSuccessfully: 'Berhasil bergabung ke kamar',
  },
  roomOrderListRollin: {
    flyingPigCreditDoesNotSupportHousing: 'Fliggy Credit Stay tidak mendukung kamar terhubung',
    directChannelsDoNotSupportTheEstablishmentOfJointHousesAndTeamsWithStoreChannels:
      'Saluran direct connect tidak mendukung pembentukan kamar terhubung dan tim dengan saluran toko',
    transferIn: 'Transfer masuk ke kamar terhubung',
    namePhoneNumberRoomNumber2: 'Nama tamu, nomor ponsel, nomor kamar',
    succeededInJoiningTheHouse: 'Berhasil bergabung ke kamar terhubung',
  },
  roomOrderListRoomOrderDetail: {
    twinRooms: 'Kamar terhubung',
    roomList: 'Daftar kamar',
    noRoomListingInformationAvailable: 'Belum ada informasi daftar kamar',
    manage: 'Kelola',
    fullState: 'Semua status',
    finance3: 'Keuangan',
    preAuthorizationDetail: 'Detail pra-otorisasi',
    houseDetails: 'Detail kamar terhubung',
    listingDetails: 'Detail daftar kamar',
    thereAreNoOccupants: 'Belum ada tamu',
  },
  roomOrderListRoomOrderList: {
    durationOfResidence: 'Durasi menginap',
    bookingTime: 'Waktu reservasi',
    room2: 'Kamar',
    doNotGift: 'Tidak diberikan',
    nameMobilePhoneNumberOrderNumberChannelNumberQuery:
      'Pencarian nama, nomor ponsel, nomor pesanan, nomor pesanan saluran',
    multipleSearch: 'Pencarian multiple',
    bonusPoints: 'Poin bonus',
    subscriber: 'Pemesan',
    subscriberNumber: 'Telepon pemesan',
    areYouSureYouWantToGiveAwayPoints: 'Apakah Anda yakin ingin memberikan poin',
    rewardPointsSuccessfully: 'Poin berhasil diberikan',
    guestphone: 'Tamu/Telepon',
    actualCheckoutTime: 'Waktu check-out aktual',
  },
  faceFacedialog: {
    faceCollection: 'Pengambilan wajah',
    faceCollectionSuccess: 'Pengambilan wajah berhasil',
    faceCollectionFailure: 'Pengambilan wajah gagal',
    takeAPicture: 'Ambil foto',
    upload: 'Unggah',
    upCross: 'Sedang mengunggah',
    uploadingPhotosPleaseCloseLater: 'Sedang mengunggah foto, silakan tutup nanti',
    pleaseTakeAPictureFirst: 'Silakan ambil foto terlebih dahulu',
    collectionSuccess: 'Pengambilan berhasil',
    collectionFailedPleaseTryAgain: 'Pengambilan gagal, silakan coba lagi!',
  },
  printtemplateChangeroom: {
    theOriginal: 'Asal',
    changeDate: 'Tanggal pindah kamar',
    roomRateUpgrade: 'Upgrade harga kamar:',
    roomRate: 'Harga kamar:',
  },
  printtemplateChangeroomprintsmall: {
    changeDate: 'Tanggal pindah kamar',
    checkOutTime: 'Waktu check-out',
    theOriginal: 'Asal',
  },
  printtemplateGroupordertableprint: {
    position: 'Posisi',
  },
  printtemplateStayinprint: {
    confidentiality: 'Rahasia',
  },
  printtemplateStaymore: {
    departureDate: 'Tanggal rencana keluar',
    newDepartureDate: 'Tanggal rencana keluar baru',
  },
  printtemplateStaymoreprint: {
    departureDate: 'Tanggal rencana keluar',
    newDepartureDate: 'Tanggal rencana keluar baru',
  },
  noticeOrdernotice: {
    messageCenter: 'Pusat pesan',
    orderInformation: 'Informasi pesanan',
    dynamic: 'Pesan dinamis',
    settlement: 'Pesan penyelesaian',
    system: 'Pesan sistem',
    noData: 'Belum ada pesan baru',
    dynamicInformation: 'Informasi dinamis',
    systemInformation: 'Informasi sistem',
    nightTrialFailTitle: 'Audit malam gagal',
    nightTrialFailContent: 'Audit malam gagal, harap segera ditangani.',
  },
  noticeServicemanage: {
    serviceManagement: 'Manajemen tiket layanan',
    roomService: 'Layanan kamar',
    itemBorrow: 'Peminjaman barang',
    extendStay: 'Layanan perpanjangan',
  },
  operatelogLog: {
    nightAuditLog: 'Log audit malam',
    downloadLog: 'Unduh log',
    downloadSuccessfully: 'Unduhan berhasil',
  },
  operatelogNightauditlog: {
    nightTrialMethod: 'Metode audit malam',
    nightTrialResult: 'Hasil audit malam',
    manualNightAudit: 'Audit malam manual',
    automaticNightAudit: 'Audit malam otomatis',
    nightAuditFailure: 'Audit malam gagal',
    successfulNightAudit: 'Audit malam berhasil',
    nightTrialDate: 'Tanggal audit malam',
    nightAuditRecord: 'Catatan audit malam',
  },
  operatelogWorkingday: {
    variableMode: 'Metode perubahan',
  },
  financeAccountsreceivableaging: {
    bookName: 'Nama buku akun',
    totalAmountReceivable: 'Total piutang',
    amountPayable030Days: 'Piutang (0–30 hari)',
    amountPayable3160Days: 'Piutang (31–60 hari)',
    amountPayable6190Days: 'Piutang (61–90 hari)',
    amountToBeCollected91DaysOrMore: 'Piutang (≥91 hari)',
    typeOfExchange: 'Jenis pindah kamar',
    originalRoomNumber: 'Nomor kamar asal',
    existingRoomNumber: 'Nomor kamar saat ini',
    currentHouseType: 'Tipe kamar saat ini',
    roomChangeTime: 'Waktu pindah kamar',
    changeRoomsAfterCheckIn: 'Pindah kamar setelah check-in',
    originalRoomRate: 'Harga kamar asal',
    spotRate: 'Harga kamar saat ini',
  },
  financeAdjustmentCash: {
    financialStatement: 'Arus keuangan',
    occurrenceTime: 'Waktu kejadian',
    reconciliationStatement: 'Laporan penyesuaian akun',
  },
  financeAr: {
    channelReconciliationReport: 'Laporan rekonsiliasi saluran',
    writeOffStatus: 'Status penghapusan',
    amountOnCredit: 'Jumlah piutang',
    estimatedSettlementPrice: 'Perkiraan harga penyelesaian',
    unapprovedAmount: 'Jumlah belum diverifikasi',
    guestInvoiceRequirement: 'Kebutuhan faktur tamu',
    roomNumbername: 'Nomor kamar/Nama',
  },
  financeBreakfastStatistic: {
    flatBreakfast: 'Sarapan termasuk kamar',
    advancePurchase: 'Beli sarapan',
    availableBreakfasts: 'Jumlah sarapan tersedia',
    verifiedBreakfasts: 'Sarapan terverifikasi',
    breakfastAmount: 'Jumlah sarapan',
    breakfastStatisticsReport: 'Laporan statistik sarapan',
    breakfastStatisticsReportxls: 'Laporan statistik sarapan.xls',
  },
  financeChannelConsume: {
    typeOfCompany: 'Jenis perusahaan',
    roomNights: 'Jumlah malam kamar',
  },
  financeCheckout: {
    checkOutBusinessDay: 'Hari operasional check-out',
    helpOneself: 'Pemakaian internal',
    team2: 'Tim',
    checkOutStatement: 'Laporan check-out',
  },
  financeCreatedCompanyAccountOfAge: {
    scale: 'Proporsi',
    aged180DaysOrMore: 'Umur piutang ≥180 hari',
    agingStatementOfCreditCompany: 'Laporan umur piutang perusahaan kredit',
    accountAge030Days: 'Umur piutang 0–30 hari',
    accountAge3160Days: 'Umur piutang 31–60 hari',
    accountAge6190Days: 'Umur piutang 61–90 hari',
    accountAge91180Days: 'Umur piutang 91–180 hari',
  },
  financeDemandAccount: {
    collectTheRoomChargeInAdvance: 'Penagihan biaya kamar di muka',
    estimatedArrears: 'Perkiraan tunggakan',
    collectionStatement: 'Laporan penagihan',
  },
  financeHangAccount: {
    accountStatus: 'Status akun',
    businessDayOfHangingAccount: 'Hari operasional piutang',
    hangTheAccountOperator: 'Operator piutang',
    currentBalance: 'Saldo saat ini',
    closingTime: 'Waktu penutupan',
    noteOfHangingAccount: 'Catatan piutang',
    temporaryDebitStatement: 'Laporan piutang sementara',
    membercompany: 'Anggota/Perusahaan',
  },
  financeInventoryInOut: {
    inOutDate: 'Tanggal keluar-masuk gudang',
    storageType: 'Metode keluar-masuk gudang',
    storageTypeOut: 'Keluar gudang',
    fileName: 'Laporan keluar-masuk gudang',
    columns: {
      inStoragePrice: 'Jumlah masuk gudang',
      outStoragePrice: 'Jumlah keluar gudang',
    },
  },
  financeHousekeeping: {
    cleaningDate: 'Tanggal pembersihan',
    cleanType: 'Jenis pembersihan',
    cleaner: 'Petugas kebersihan',
    status: 'Status tiket',
    dailyCleaningAndLinen: 'Pembersihan harian + ganti linen',
    dailyCleaning: 'Pembersihan harian',
    dispatchTime: 'Waktu penugasan',
    cleanTime: 'Waktu pembersihan',
    checkRoomTime: 'Waktu inspeksi kamar',
    recleaningReason: 'Alasan pembersihan ulang',
    checkerName: 'Supervisor inspeksi',
    statuses: {
      toBeCleared: 'Menunggu dibersihkan',
      finishCleaning: 'Pembersihan selesai',
      noCleaning: 'Tidak perlu dibersihkan',
      cancelOrder: 'Batalkan penugasan',
      unauditedRoom: 'Menunggu inspeksi',
      wardRoundRejection: 'Inspeksi ditolak',
    },
  },
  settingHousekeeping: {
    cleaners: 'Petugas kebersihan',
    selectCleaners: 'Silakan pilih petugas kebersihan',
    onDutyConfig: 'Pengaturan jam kerja petugas kebersihan',
    roomAssign: 'Penugasan kamar',
    assignMode: {
      free: 'Penugasan bebas',
      byFloor: 'Berdasarkan lantai',
      byRoom: 'Berdasarkan kamar',
    },
    viewAssign: 'Lihat penugasan',
    cleanerPrefix: 'Kebersihan:',
    autoDispatchConfig: 'Pengaturan penugasan otomatis pembersihan kamar',
    autoDispatch: {
      off: 'Matikan penugasan otomatis',
      on: 'Aktifkan penugasan otomatis',
    },
    autoDispatchRoomType: 'Jenis kamar penugasan otomatis',
    leaveRoom: 'Kamar check-out',
    stayRoom: 'Kamar dihuni',
    dispatchRule: 'Aturan penugasan kebersihan',
    rules: {
      byTotal: 'Distribusi rata berdasarkan total tiket per orang',
      byPending: 'Distribusi rata berdasarkan tiket tertunda per orang',
    },
    leaveCleanType: 'Jenis pembersihan otomatis kamar check-out',
    stayCleanType: 'Jenis pembersihan otomatis kamar dihuni',
    dispatchTimeForStay: 'Waktu penugasan kamar dihuni',
    afterCleanCheck: 'Perlu inspeksi setelah pembersihan',
    needCheck: {
      no: 'Tidak perlu',
      yes: 'Perlu',
    },
    dialog: {
      assignRelation: 'Relasi penugasan',
      selectFloor: 'Silakan pilih lantai',
    },
    messages: {
      selectCleaners: 'Silakan pilih petugas kebersihan',
      dutyTimeInvalid:
        'Waktu selesai jam kerja petugas kebersihan tidak boleh lebih awal dari waktu mulai',
    },
  },
  financeBreakfastDetails: {
    mealDate: 'Tanggal makan',
    includeWaitingForCheckIn: 'Sertakan kamar menunggu check-in',
    title: 'Laporan detail sarapan',
    columns: {
      guestNum: 'Jumlah tamu',
      roomContainsBreakfastNum: 'Kamar termasuk sarapan',
      buyBreakfastNum: 'Beli sarapan',
      useBreakfastNum: 'Jumlah digunakan',
    },
  },
  breakfastVerification: {
    checkedInRoomList: 'Daftar kamar yang sedang ditempati',
    roomNo: 'No. kamar',
    breakfastCount: 'Jumlah sarapan',
    verified: 'Terverifikasi',
    buyBreakfast: 'Beli sarapan',
    verificationRecord: 'Catatan verifikasi',
    verificationTime: 'Waktu verifikasi',
    cardReading: 'Membaca kartu',
    swipeCardVerification: 'Gesek kartu untuk verifikasi',
    breakfastVerification: 'Verifikasi sarapan',
    pendingBreakfast: 'Sarapan menunggu verifikasi',
    verificationCount: 'Jumlah verifikasi',
    confirmVerification: 'Konfirmasi',
    noRoomRead: 'Informasi kamar tidak terbaca',
    cardReadFailed: 'Gagal membaca kartu. Periksa kartu kamar atau pembaca kartu.',
    noPendingBreakfast: 'Kamar ini tidak memiliki sarapan yang menunggu verifikasi',
    verificationCountPositive: 'Jumlah verifikasi harus lebih besar dari 0',
    verificationCountExceedsPending: 'Jumlah verifikasi tidak boleh melebihi sarapan yang menunggu',
    verificationSuccess: 'Verifikasi berhasil',
  },
  buyBreakfastDialog: {
    title: 'Beli sarapan',
    entryAccount: 'Akun posting',
    count: 'Jumlah',
    totalAmount: 'Total jumlah',
    payVerificationCode: 'Kode verifikasi pembayaran',
    positiveMoney: 'Masukkan jumlah lebih besar dari 0, maksimal 2 desimal',
    positiveInteger: 'Masukkan bilangan bulat lebih besar dari 0',
    priceRequired: 'Masukkan harga satuan',
    countRequired: 'Masukkan jumlah',
    roomOrderNoMissing: 'Nomor pesanan kamar tidak ditemukan. Sarapan tidak dapat dibeli.',
    selectAccountSet: 'Pilih set akun',
    onlinePaymentFailed: 'Pembayaran online gagal',
    paymentIncomplete: 'Pembayaran belum selesai. Posting sarapan tidak dibuat.',
    buySuccess: 'Sarapan berhasil dibeli',
  },
  financeBreakfastVerificateDetail: {
    title: 'Laporan detail verifikasi sarapan',
  },
  readDoorCardRoom: {
    lockNotConfigured: 'Kunci pintu belum dikonfigurasi atau belum diaktifkan',
    getLockInfoFailed: 'Gagal mendapatkan informasi kunci pintu',
    readCardTimeout: 'Waktu membaca kartu habis. Periksa pembaca kartu.',
    emptyCard: 'Kartu ini kosong. Buat kartu terlebih dahulu.',
    notGuestCard: 'Kartu ini bukan kartu tamu. Buat ulang kartu.',
    readCardServiceFailed: 'Gagal membaca kartu. Hubungi dukungan untuk memeriksa layanan perangkat keras.',
    readCardFailed: 'Gagal membaca kartu. Periksa kartu kamar atau pembaca kartu.',
    noRoomInfo: 'Informasi kamar tidak terbaca',
    unsupportedLockReadMode: 'Mode pembacaan kartu kunci saat ini tidak didukung',
  },
  financePreauth: {
    authorizationStatus: 'Status otorisasi',
    authorizationDate: 'Tanggal otorisasi',
    settlementDate: 'Tanggal penyelesaian',
    expirationDate: 'Tanggal kedaluwarsa',
    preAuthorizationStatement: 'Laporan pra-otorisasi',
    settlementTime: 'Waktu penyelesaian',
  },
  financeRedeemDetail: {
    dateType: 'Jenis tanggal',
    writeOffDate: 'Tanggal penghapusan',
    dateOfPosting: 'Tanggal piutang',
    dateOfEntry2: 'Tanggal pencatatan',
    bookType: 'Jenis buku akun',
    businessDayOfHangingAccount: 'Hari operasional piutang',
    hangTheAccountOperator: 'Operator piutang',
    theRoomNumberIsCharged: 'Nomor kamar piutang',
    writeOffTheAmountCredited: 'Jumlah penghapusan dicatat',
    writeOffTheEntryTime: 'Waktu pencatatan penghapusan',
    writeOffTheAccountOperator: 'Operator pencatatan penghapusan',
    amountWrittenOff2: 'Jumlah dihapuskan',
    writeOffTime: 'Waktu penghapusan',
    writeOffTheOperator: 'Operator penghapusan',
    channelWriteOffDetailReport: 'Laporan detail penghapusan per saluran',
  },
  financeRushCash: {
    financialStatement: 'Arus keuangan',
    occurrenceTime: 'Waktu kejadian',
    debitStatement: 'Laporan penyesuaian',
  },
  financeSellRank: {
    agreementUnitConsumptionRankingTable: 'Tabel peringkat konsumsi unit perjanjian',
  },
  financeTodayGuestBalance: {
    roomFee3: 'Biaya kamar',
    balanceSheetForGuestsInResidence: 'Laporan saldo tamu yang menginap',
  },
  financeTransferCash: {
    turnOutOfRoom: 'Transfer keluar kamar',
    bookkeepingTime: 'Waktu pembukuan',
    turnIntoARoom: 'Transfer masuk kamar',
    transferTime: 'Waktu transfer',
    transferStatement: 'Laporan transfer',
  },
  financeZeroRoomFee: {
    zeroRoomRateReport: 'Laporan tarif kamar nol',
  },
  incomeBaseprice: {
    totalRevenue: 'Total pendapatan',
    roomNight: 'Total malam kamar',
    storeRevenue: 'Pendapatan properti',
    interstoreNight: 'Malam kamar properti',
    directRevenuebasePrice: 'Pendapatan direct connect (harga dasar)',
    straightInternight: 'Malam direct connect',
    miniProgramRevenuebasePrice: 'Pendapatan mini program (harga dasar)',
    smallProgramNight: 'Malam mini program',
    xinmeituanDirectRevenuebasePrice: 'Pendapatan Meituan direct baru (harga dasar)',
    newUnitedStatesGroupStraightInternight: 'Malam Meituan direct baru',
    ctripDirectRevenuebasePrice: 'Pendapatan Ctrip direct (harga dasar)',
    ctripDirectConnectionBetweenNight: 'Malam Ctrip direct',
    directRevenuebasePrice2: 'Pendapatan Tongcheng direct (harga dasar)',
    theSameJourneyDirectlyConnectedToTheNight: 'Malam Tongcheng direct',
    qunarDirectRevenuebasePrice: 'Pendapatan Qunar direct (harga dasar)',
    whereToGoStraightToTheNight: 'Malam Qunar direct',
    tiktokDirectRevenuebasePrice: 'Pendapatan TikTok direct (harga dasar)',
    tiktokStraightBetweenNight: 'Malam TikTok direct',
    flyingPigDirectRevenuebasePrice: 'Pendapatan Fliggy direct (harga dasar)',
    flyingPigsStraightInternight: 'Malam Fliggy direct',
    baiduMapRevenuebasePrice: 'Pendapatan Baidu Map (harga dasar)',
    baiduMapNight: 'Malam Baidu Map',
    jingdongDirectRevenuebasePrice: 'Pendapatan JD direct (harga dasar)',
    jingdongDirectConnectionBetweenNight: 'Malam JD direct',
    lightResidentialAndCommercialTravelRevenuebasePrice:
      'Pendapatan LightStay bisnis & perjalanan (harga dasar)',
    lightStayBusinessNights: 'Malam LightStay bisnis',
    lightHomeDistributionRevenuebasePrice: 'Pendapatan distribusi LightStay (harga dasar)',
    lightNightInTheDistributionRoom: 'Malam distribusi LightStay',
    storeAdr: 'ADR properti',
    usGroupEbRevenue: 'Pendapatan Meituan EB',
    usGroupEbNight: 'Malam Meituan EB',
    meituanEbadr: 'ADR Meituan EB',
    ctripEbRevenue: 'Pendapatan Ctrip EB',
    ctripEbNight: 'Malam Ctrip EB',
    ctripEbadr: 'ADR Ctrip EB',
    flyingPigEbRevenue: 'Pendapatan Fliggy EB',
    flyingPigEbNight: 'Malam Fliggy EB',
    ebadrTheFlyingPig: 'ADR Fliggy EB',
    douyinGroupPurchaseEbRevenue: 'Pendapatan TikTok Group Purchase EB',
    douyinGroupPurchaseEbNight: 'Malam TikTok Group Purchase EB',
    douyinGroupPurchaseEbadr: 'ADR TikTok Group Purchase EB',
    directAdrbasePrice: 'ADR direct connect (harga dasar)',
    miniProgramAdrbasePrice: 'ADR mini program (harga dasar)',
    newMeituanDirectAdrbasePrice: 'ADR Meituan direct baru (harga dasar)',
    directRouteAdrbasePrice: 'ADR Ctrip direct (harga dasar)',
    sameRouteDirectAdrbasePrice: 'ADR Tongcheng direct (harga dasar)',
    whereToDirectAdrbasePrice: 'ADR Qunar direct (harga dasar)',
    tiktokDirectAdrbasePrice: 'ADR TikTok direct (harga dasar)',
    flyingPigDirectAdrbasePrice: 'ADR Fliggy direct (harga dasar)',
    baiduMapAdrbasePrice: 'ADR Baidu Map (harga dasar)',
    jingdongDirectLinkAdrbasePrice: 'ADR JD Direct (harga dasar)',
    lightResidentialAndBusinessAdrbasePrice: 'ADR LightStay Bisnis & Perjalanan (harga dasar)',
    lightLiveDistributionAdrbasePrice: 'ADR Distribusi LightStay (harga dasar)',
  },
  incomeExpense: {
    consumptionAccountStatisticsReport: 'Laporan statistik akun konsumsi',
    accountId: 'ID akun',
    roomNumbername: 'Nomor kamar/Nama',
  },
  incomeGuestSourceDetail: {
    selfUseRoom: 'Kamar Penggunaan Internal',
    roomNightDataIsBasedOnTheQueriedBusinessDayStatistics:
      'Data malam kamar dihitung berdasarkan hari operasional yang dipilih',
    calculationMode: 'Metode perhitungan',
    guestCheckInDetailsReport: 'Laporan detail check-in sumber tamu',
    freeRoom: 'Kamar gratis',
    teamRoom: 'Kamar tim',
    singleRoom: 'Kamar kontrak jangka panjang',
    roomRate2: 'Jumlah biaya kamar',
  },
  incomeHandleover: {
    shiftSummaryStatisticsReport: 'Laporan statistik ringkasan serah terima',
    income: 'Pendapatan',
    disburse: 'Pengeluaran',
    totalAmount: 'Jumlah total',
    shiftSummaryReport: 'Laporan ringkasan serah terima',
  },
  incomeManageSingle: {
    category: 'Kategori',
    today: 'Hari ini',
    accumulatedThisMonth: 'Akumulasi bulan ini',
    lastMonthCumulative: 'Akumulasi periode yang sama bulan lalu',
    monthlyGrowthRate: 'Tingkat pertumbuhan bulanan',
    currentYearAccumulation: 'Akumulasi tahun ini',
    accumulatedInTheSamePeriodOfLastYear: 'Akumulasi periode yang sama tahun lalu',
    annualGrowthRate: 'Tingkat pertumbuhan tahunan',
    operatingStatementsingleDay: 'Laporan operasional (harian)',
    operatingStatementOneDayxlsx: 'Laporan operasional harian.xlsx',
    orderSourceBedNightsIncludeFreeRoomsAndSelfUsedRoomNights:
      'Malam kamar sumber pesanan: termasuk kamar gratis dan kamar penggunaan internal',
    rentalRateexcludingSelfUsedRoomsAndFreeRoomsRentedBedNightsexcludingSelfUsedRoomsAndFreeRoomsTotalNumberOfRooms:
      'Tingkat hunian (tanpa kamar internal & gratis) = malam kamar disewakan (tanpa kamar internal & gratis) / total kamar',
    totalRoomFeeIncomeincludingCommissionExcludingFreeRoomsAndSelfUsedRooms:
      'Total pendapatan biaya kamar (termasuk komisi), tidak termasuk kamar gratis & internal',
    youHaveNotOpenedThecustomerCheckInDetailsReportViewingPermission:
      'Anda belum memiliki izin untuk melihat laporan “Detail check-in sumber tamu”',
    averageRoomRate:
      'Harga kamar rata-rata (tanpa kamar internal & gratis) = total pendapatan biaya kamar / malam kamar disewakan (tanpa kamar internal & gratis)',
    revparFormula: 'RevPAR = total pendapatan biaya kamar / total kamar',
    totalRevenueFormula:
      'Total pendapatan operasional = total pendapatan biaya kamar + seluruh pendapatan lainnya (termasuk komisi, tidak termasuk isi ulang anggota)',
  },
  incomeManageTotal: {
    generalLedger: 'Buku besar',
    totalAverageRoomRateyuan: 'Rata-rata harga kamar keseluruhan ',
    rentalTotalRoomNightroom: 'Total malam kamar disewakan',
    fullDayRoomNightroom: 'Malam kamar harian penuh',
    longBagRoomNightroom: 'Malam kamar kontrak jangka panjang',
    hourRoomNightroom: 'Malam kamar per jam',
    teamRoomNightroom: 'Malam kamar tim',
    freeRoomNightroom: 'Malam kamar gratis',
    privateRoomNightroom: 'Malam kamar penggunaan internal',
    totalRoomRateyuan: 'Total biaya kamar ',
    smallCommoditiesyuan: 'Barang kecil ',
    mealFeeyuan: 'Biaya makan ',
    serviceChargeyuan: 'Biaya layanan ',
    membershipFeermb: 'Biaya keanggotaan ',
    otherExpensesyuan: 'Biaya lainnya ',
    totalRevenue: 'Total pendapatan operasional ',
    totalRevenueWithTax: 'Total Pendapatan (Termasuk Pajak)',
    roomNightsroom: 'Jumlah malam kamar',
    averageRoomRateyuan: 'Harga kamar rata-rata ',
    totalRoomRateyuan2: 'Total biaya kamar ',
    operatingStatementcumulative: 'Laporan operasional (kumulatif)',
    theQueryTimeRangeCannotBeLongerThanOneYear:
      'Rentang waktu pencarian tidak boleh lebih dari satu tahun',
    totalOccupancyRate: 'Tingkat hunian total (%)',
    fullDayOccupancyRate: 'Tingkat hunian kamar harian penuh (%)',
    hourlyOccupancyRate: 'Tingkat hunian kamar per jam (%)',
    lettingRate: 'Tingkat hunian (%)',
    internightRatio: 'Proporsi malam kamar (%)',
    totalRevpar: 'Total REVPAR ',
    cumulativeOperatingStatementxls: 'Laporan operasional kumulatif.xls',
    rentalRateexcludingSelfUsedRoomsAndFreeRoomsRentedBedNightsexcludingSelfUsedRoomsAndFreeRoomsTotalNumberOfRooms:
      'Tingkat hunian (tanpa kamar internal & gratis) = malam kamar disewakan (tanpa kamar internal & gratis) / total kamar',
    totalRoomFeeIncomeincludingCommissionExcludingFreeRoomsAndSelfUsedRooms:
      'Total pendapatan biaya kamar (termasuk komisi), tidak termasuk kamar gratis & internal',
    averageRoomRate:
      'Harga kamar rata-rata (tanpa kamar internal & gratis) = total pendapatan biaya kamar / malam kamar disewakan (tanpa kamar internal & gratis)',
    totalRevenueFormula:
      'Total pendapatan operasional = total pendapatan biaya kamar + seluruh pendapatan lainnya (termasuk komisi, tidak termasuk isi ulang anggota)',
  },
  incomeOperatingIncome: {
    yesterdaysBalance: 'Saldo kemarin',
    todaysBalance: 'Saldo hari ini',
    statisticalStatementOfBusinessIncome: 'Laporan statistik pendapatan operasional',
    totalconsumptionTotalPaymentTotal: 'Total = total konsumsi - total pembayaran',
    yesterdaysBalancetheHotelsCumulativeConsumptionTotalFromThePreviousBusinessDayMinusPaymentTotal:
      'Saldo kemarin = total konsumsi kumulatif hotel hingga hari operasional sebelumnya - total pembayaran',
    todaysBalancetotalyesterdaysBalance: 'Saldo hari ini = total + saldo kemarin',
  },
  incomeBusinessIncomeDetail: {
    reportTitle: 'Laporan rincian pendapatan operasional',
    consumeTotal: 'Total konsumsi',
    settleTotal: 'Total penerimaan',
    roomFee: 'Biaya kamar',
    mealFee: 'Biaya makan',
    goodsFee: 'Barang kecil',
    serviceFee: 'Biaya layanan',
    memberFee: 'Biaya keanggotaan',
    otherConsume: 'Konsumsi lainnya',
    dailyBalance: 'Saldo harian',
    orderNo: 'No. Pesanan',
    roomOrderNo: 'No. Pesanan Kamar',
    roomNo: 'No. Kamar',
    guestName: 'Nama tamu',
    noData: 'Tidak ada data',
  },
  incomeOverduty: {
    category: 'Kategori',
    firstLevelSubject: 'Akun tingkat pertama',
    description: 'Deskripsi',
    shiftStatisticsReport: 'Laporan statistik serah terima',
  },
  incomePayExpense: {
    cashPaymentStatement3: 'Laporan detail konsumsi pembayaran tunai',
    abstract: 'Ringkasan',
  },
  incomePayment: {
    paymentAccountStatisticsReport: 'Laporan statistik akun pembayaran',
    submitted: 'Telah diajukan',
    earlyMorningWatch: 'Shift dini hari',
    roomNumberName: 'Nomor kamar - Nama',
    dateRangeCannotExceedThreeMonths: 'Rentang tanggal pencarian tidak boleh melebihi 3 bulan',
  },
  incomeRoomTypeReport: {
    totalRoomRate: 'Total biaya kamar',
    numberOfOutages: 'Jumlah tidak tersedia',
    numberOfNightsForRent: 'Jumlah malam kamar disewakan',
    roomTypeReport: 'Laporan tipe kamar',
    theEndTimeOfTheBusinessDayCannotExceedTheCurrentTime:
      'Waktu akhir hari operasional tidak boleh melebihi waktu saat ini',
    theSelectionPeriodCannotBeLongerThan31Days: 'Periode pilihan tidak boleh lebih dari 31 hari',
  },
  incomeSellercount: {
    roomNightDataIsBasedOnTheQueriedBusinessDayStatistics:
      'Data malam kamar dihitung berdasarkan hari operasional yang dipilih',
    calculationMode: 'Metode perhitungan',
    salesPerformanceStatement: 'Laporan kinerja penjualan',
    roomFee3: 'Biaya kamar',
  },
  incomeSmallwaredetail: {
    detailedSalesReportOfSmallGoods: 'Laporan detail penjualan barang kecil',
  },
  incomeSmallwaresummary: {
    summaryReportOfSmallCommoditySales: 'Laporan ringkasan penjualan barang kecil',
    averageUnitPrice: 'Harga satuan rata-rata',
  },
  kanbanIndex: {
    yesterday: 'Kemarin',
    last7Days: '7 hari terakhir',
    lastWeek: 'Minggu lalu',
    last30Days: '30 hari terakhir',
    lastMonth: 'Bulan lalu',
    managementProfile: 'Profil operasional',
    flowConversion: 'Konversi trafik',
    serviceIndicator: 'Indikator layanan',
    competitiveCircleAnalysis: 'Analisis lingkar persaingan',
    writeAReport: 'Tulis laporan',
    theTimeDimensionIsConsistentWithTheScreeningDateAndTheBookingAmountIsCalculatedAccordingToTheActualAmountPaidByTheGuest:
      'Dimensi waktu konsisten dengan tanggal penyaringan, dan jumlah pemesanan dihitung berdasarkan pembayaran aktual tamu',
    operationPersonnelManagementOverviewSuggestions2: 'Saran ringkasan operasional staf',
    theTimeDimensionIsConsistentWithTheScreeningDateAndContainsTheDataSummaryOfAllPlatformsOfMeituanCtripAndFeizhu:
      'Dimensi waktu konsisten dengan tanggal penyaringan dan mencakup ringkasan data semua platform Meituan, Ctrip, dan Fliggy',
    operationPersonnelFlowConversionSuggestions2: 'Saran konversi trafik staf operasional',
    theTimeDimensionIsTheEndDateAndTheDayBeforeTheStartDateOfTheCurrentSelectedDateIncludingTheDataSummaryOfAllPlatformsOfMeituanCtripAndFeizhu:
      'Dimensi waktu adalah tanggal akhir dari rentang yang dipilih dan hari sebelum tanggal mulai, mencakup ringkasan data semua platform Meituan, Ctrip, dan Fliggy',
    operationPersonnelServiceIndicatorsSuggestions2: 'Saran indikator layanan staf operasional',
    theTimeDimensionIsConsistentWithTheScreeningDateAndContainsTheDataSummaryOfAllPlatformsOfMeituanAndCtrip:
      'Dimensi waktu konsisten dengan tanggal penyaringan dan mencakup ringkasan data semua platform Meituan dan Ctrip',
    operationalPersonnelCompetitionCircleAnalysisAndSuggestions2:
      'Saran analisis lingkar persaingan staf operasional',
    amountOfExposure: 'Jumlah eksposur',
    pageView: 'Jumlah tampilan',
    orderQuantity: 'Jumlah pesanan',
    myExposureCount: 'Jumlah eksposur saya',
    numberOfPeopleExposedInThePreviousIssue: 'Jumlah eksposur periode sebelumnya',
    myExposureConversionRate2: 'Tingkat konversi eksposur saya',
    previousExposureConversionRate2: 'Tingkat konversi eksposur periode sebelumnya',
    myNumberOfViewers: 'Jumlah pengunjung saya',
    numberOfVisitorsInTheLastIssue: 'Jumlah pengunjung periode sebelumnya',
    myConversionRate2: 'Tingkat konversi saya',
    conversionRateOfLastPeriodTransaction2: 'Tingkat konversi transaksi periode sebelumnya',
    paymentOrderNumber: 'Jumlah pesanan berbayar',
    myPaymentOrderNumber: 'Jumlah pesanan berbayar saya',
    previousPaymentOrderNumber: 'Jumlah pesanan berbayar periode sebelumnya',
  },
  kanbanReportManage: {
    reportTitle: 'Judul laporan',
    reportWriter: 'Penulis laporan',
    reportDate: 'Tanggal laporan',
    reportNumber: 'Nomor laporan',
    draft: 'Draf',
    haveReleased: 'Telah dipublikasikan',
    reportTime: 'Waktu laporan',
    exportDaily: 'Ekspor laporan harian',
  },
  kanbanSeeKanban: {
    dataBoard: 'Papan data',
    managementProfile: 'Profil operasional',
    operationPersonnelManagementOverviewSuggestions2: 'Saran ringkasan operasional staf',
    flowConversion: 'Konversi trafik',
    operationPersonnelFlowConversionSuggestions2: 'Saran konversi trafik staf operasional',
    serviceIndicator: 'Indikator layanan',
    operationPersonnelServiceIndicatorsSuggestions2: 'Saran indikator layanan staf operasional',
    competitiveCircleAnalysis: 'Analisis lingkar persaingan',
    operationalPersonnelCompetitionCircleAnalysisAndSuggestions2:
      'Saran analisis lingkar persaingan staf operasional',
    theProportionOfSalesAmount: 'Proporsi jumlah penjualan',
    salesRoomNightProportion: 'Proporsi malam kamar penjualan',
    noProposal: 'Belum ada saran',
  },
  componentsDataReport: {
    compose: 'Tulis',
    dataReport: 'Laporan data',
    reportType: 'Jenis laporan',
    pleaseSelectAReportType: 'Silakan pilih jenis laporan',
    dailyOperationReport: 'Laporan operasional harian',
    weeklyOperationsReport: 'Laporan operasional mingguan',
    monthlyOperatingReport: 'Laporan operasional bulanan',
    runCustomReports: 'Laporan operasional kustom',
    reportTitle: 'Judul laporan',
    analysisDate: 'Tanggal analisis',
    businessDataAnalysisDimension: 'Dimensi analisis data operasional',
    businessAnalysisAndSuggestion: 'Analisis dan saran operasional',
    trafficAnalysisSuggestion: 'Saran analisis trafik',
    serviceIndicatorSuggestion: 'Saran indikator layanan',
    competitiveCircleAnalysisSuggestion: 'Saran analisis lingkar persaingan',
    previewReport: 'Pratinjau laporan',
    saveReport: 'Simpan laporan',
    saveReleaseReport: 'Simpan & publikasikan laporan',
    pleaseEnterTheTitleOfTheReport: 'Silakan masukkan judul laporan',
    pleaseEnterBusinessAnalysisSuggestions: 'Silakan masukkan saran analisis operasional',
    pleaseEnterTrafficAnalysisSuggestions: 'Silakan masukkan saran analisis trafik',
    pleaseEnterTheServiceIndicatorSuggestion: 'Silakan masukkan saran indikator layanan',
    pleaseEnterTheCompetitionCircleAnalysisSuggestion:
      'Silakan masukkan saran analisis lingkar persaingan',
  },
  componentsFlowLine: {
    myExposureConversionRate2: 'Tingkat konversi eksposur saya',
    previousExposureConversionRate2: 'Tingkat konversi eksposur periode sebelumnya',
    myConversionRate2: 'Tingkat konversi transaksi saya',
    conversionRateOfLastPeriodTransaction2: 'Tingkat konversi transaksi periode sebelumnya',
    exposureToViewConversionRate: 'Tingkat konversi dari eksposur ke tampilan',
    browseToTheConversionRateOfTheTransaction: 'Tingkat konversi dari tampilan ke transaksi',
  },
  componentsRatioPieChart: {
    directConnection3: 'Koneksi langsung',
  },
  competeCChannelData: {
    lostOrders: 'Jumlah pesanan hilang',
    single: 'Pesanan',
    numberOfLostNights: 'Jumlah malam kamar hilang',
    lossAmount: 'Jumlah kerugian',
    distanceFromMe: 'Jarak dari saya',
    mark: 'Penilaian',
    startingPrice: 'Harga mulai',
    theProportionOfLostOrders: 'Proporsi pesanan hilang',
    drainType: 'Tipe kamar yang hilang',
    orderConversionRate: 'Tingkat konversi pemesanan',
    viewTheProportionOfUsers: 'Proporsi pengguna yang melihat',
    finalPurchaseRatio: 'Rasio pembelian akhir',
  },
  flowFChart: {
    browseToTheConversionRateOfTheTransaction: 'Tingkat konversi dari tampilan ke transaksi',
    exposureToViewConversionRate: 'Tingkat konversi dari eksposur ke tampilan',
  },
  flowFTable: {
    myHotel: 'Hotel saya',
    monthOnMonth: 'Perbandingan bulan ke bulan',
    onlinePaymentSingular: 'Jumlah pesanan pembayaran online',
    single: 'Pesanan',
  },
  flowFlowTable: {
    payForOrderQuantity: 'Jumlah pesanan berbayar',
    exposureConversionRate: 'Tingkat konversi eksposur',
    transactionConversionRate: 'Tingkat konversi transaksi',
  },
  reportManageLog: {
    dataReportOperationLogs: 'Log operasi laporan data',
    logNumber: 'Nomor log',
    operationName: 'Nama operasi',
  },
  serveindexServeAnnularChart: {
    scoreDistributionGraph: 'Grafik distribusi penilaian',
    article: 'Item',
    numberOfCommentsWithChart: 'Jumlah ulasan dengan gambar',
    newBadReviewsThisPeriod: 'Item  Jumlah ulasan buruk baru periode ini: {num} item',
    unrepliedBadReviews: '  Jumlah ulasan buruk yang belum dibalas: {num} item',
  },
  serveindexServeRadarChart: {
    radarMap: 'Diagram radar',
  },
  serveindexServelist: {
    basicScore: 'Skor dasar',
    awardPoints: 'Poin penghargaan',
    penaltyPoint: 'Poin penalti',
  },
  situationSChannelTable: {
    salesNight: 'Malam kamar terjual',
    averageSalesRate: 'Harga rata-rata penjualan kamar',
    consumptionNight: 'Malam kamar konsumsi',
    averageHousePriceOfConsumption: 'Harga kamar rata-rata konsumsi',
    cancelNight: 'Malam kamar dibatalkan',
    cancellationRate: 'Tingkat pembatalan',
    noSingleRoomNights: 'Malam kamar pesanan ditolak',
    rejectRate: 'Tingkat penolakan',
    onlinePermeability: 'Tingkat penetrasi online',
    channelOnlineStatus: 'Status online saluran',
    lightHoldTheDirectConnection: 'LightStay koneksi langsung',
  },
  situationSGrid: {
    onAYearOnYearBasis: 'Perbandingan tahun ke tahun',
    chainRatio: 'Perbandingan periode sebelumnya',
    cancellationRate: 'Tingkat pembatalan',
    rejectRate: 'Tingkat penolakan',
    theBookingAmountIncludesCancelledAndRejectedOrders:
      'Jumlah pemesanan termasuk pesanan dibatalkan dan ditolak',
    reservationAmountCancelAndRejectOrders: 'Jumlah pemesanan tanpa pesanan dibatalkan dan ditolak',
    accessSource: 'Sumber akses',
    onlineChannelConsumptionBedNightstotalAvailableInventory:
      'Malam kamar konsumsi saluran online / total inventori tersedia',
    advanceBookingBedNightstotalSalesBedNights:
      'Malam kamar pemesanan awal / total malam kamar terjual',
    cancelBedNightssalesBedNights: 'Malam kamar dibatalkan / malam kamar terjual',
    rejectBedNightssalesBedNights: 'Malam kamar ditolak / malam kamar terjual',
  },
  situationSalePieChart: {
    salesRoomNightProportion: 'Proporsi malam kamar terjual',
    theProportionOfSalesAmount: 'Proporsi jumlah penjualan',
  },
  orderDiscontinuedrooms: {
    operationalDowntime: 'Waktu nonaktif operasional',
    disableStartEndTime: 'Waktu mulai & berakhir nonaktif',
    releaseTime2: 'Waktu pengaktifan kembali',
    inactiveRoomReport: 'Laporan kamar nonaktif',
    deactivationOperator: 'Operator penonaktifan',
    releaseOperator: 'Operator pengaktifan kembali',
    normalExchange: 'Pindah kamar normal',
    freeUpgrade: 'Upgrade gratis',
    chargeEscalation: 'Upgrade berbayar',
  },
  orderGuest: {
    reportType2: 'Jenis laporan',
    sameDayCheckIn: 'Check-in hari yang sama',
    sameDayCheckOut: 'Check-out hari yang sama',
    dailyArrivalsAndDepartures: 'Kedatangan & keberangkatan harian',
    contractCompany: 'Perusahaan perjanjian',
    firstDayRate: 'Harga kamar hari pertama',
    nation2: 'Negara',
    roomListRemarks: 'Catatan daftar kamar',
    guestStatement: 'Laporan tamu menginap',
  },
  orderRoomChange: {
    unterracedHouse: 'Belum ditempatkan',
    typeOfExchange: 'Jenis pindah kamar',
    normalExchange: 'Pindah kamar normal',
    freeUpgrade: 'Upgrade gratis',
    chargeEscalation: 'Upgrade berbayar',
    originalRoomNumber: 'Nomor kamar asal',
    existingRoomNumber: 'Nomor kamar saat ini',
    currentHouseType: 'Tipe kamar saat ini',
    roomChangeTime: 'Waktu pindah kamar',
    changeRoomsAfterCheckIn: 'Pindah kamar setelah check-in',
    originalRoomRate: 'Harga kamar asal',
    spotRate: 'Harga kamar saat ini',
  },
  checkInIndex: {
    viewListingDetails: 'Lihat detail daftar kamar',
    message: 'Informasi',
    individualStepIntoSuccess: 'Check-in tamu individu berhasil',
    automaticallyRedirectsToListingDetails: 'Dialihkan otomatis ke detail daftar kamar',
    successfulCodeScanning: 'Pemindaian kode berhasil',
    thereIsNoCorrespondingProductForTheCurrentRoomType:
      'Tidak ada produk yang sesuai untuk tipe kamar saat ini',
    memberBalanceIs: 'Saldo anggota adalah',
    pleaseSelectAnotherRecipient: 'Rupiah, silakan pilih penerima pembayaran lain',
  },
  checkInNewindex: {
    committedParameter: 'Parameter yang dikirim',
    individualStepIntoSuccess: 'Check-in tamu individu berhasil',
  },
  checkInRoomerItem: {
    moreInformation: 'Informasi lebih lanjut',
    number: 'Nomor',
  },
  componentsBookertypesearch: {
    pleaseEnterTheMemberInformationYouWantToQuery:
      'Silakan masukkan informasi anggota yang ingin dicari',
    enterTheInformationAboutTheProtocolUnitToBeQueried:
      'Silakan masukkan informasi unit perjanjian yang ingin dicari',
  },
  componentsDepositsection: {
    selectPaymentMethod: 'Pilih metode pembayaran',
  },
  componentsOpenpagetemplate: {
    conditionOfTheHouse2: 'Status kamar',
  },
  componentsProductsection: {
    noProductAvailableOnBookingDateForThisRoomType:
      'Tidak ada produk untuk tipe kamar ini pada tanggal pemesanan',
  },
  componentsRoomerItem: {
    moreInformation: 'Informasi lebih lanjut',
    genderBirthday: 'Jenis kelamin - tanggal lahir',
    nationalityNationality: 'Kewarganegaraan - etnis',
    pleaseEnterTheFullAddress2: 'Silakan masukkan alamat lengkap',
    validityPeriod: 'Masa berlaku',
  },
  utilsLehuimixin: {
    viewListingDetails: 'Lihat detail daftar kamar',
    automaticallyRedirectsToListingDetails: 'Dialihkan otomatis ke detail daftar kamar',
    successfulCodeScanning: 'Pemindaian kode berhasil',
    callbackRoute: 'Rute callback',
    checkInSuccessful: 'Check-in berhasil',
    listingDetails: 'Detail daftar kamar',
    orderDetails: 'Detail pesanan',
  },
  utilsUtils: {
    noProductAvailableOnBookingDateForThisRoomType:
      'Tidak ada produk untuk tipe kamar ini pada tanggal pemesanan',
    thisRoomTypeIsSoldOutWithinTheBookingDate:
      'Tipe kamar ini telah habis terjual pada tanggal pemesanan',
    noPriceIsSetForThisRoomTypeDuringTheBookingDate:
      'Tidak ada harga yang ditetapkan untuk tipe kamar ini pada tanggal pemesanan',
    memberBalanceIsInsufficientPleaseChooseAnotherPaymentMethod:
      'Saldo anggota tidak mencukupi, silakan pilih metode pembayaran lain',
  },
  componentsAuthcode: {
    laterOn: 'Nanti',
    verificationCodeSentSuccessfullyPleaseNoteThatCheck:
      'Kode verifikasi berhasil dikirim, silakan periksa',
  },
  componentsBookingcommonmixin: {
    reset: 'Atur ulang',
  },
  componentsBookingmixin: {
    nineHours: 'Sembilan jam',
    tenHours: 'Sepuluh jam',
    elevenHours: 'Sebelas jam',
    twelveHours: 'Dua belas jam',
    hourStore: 'Jam - Properti',
    noRoomTypesAvailable: 'Tidak ada tipe kamar yang dapat dipesan',
    houseList: 'Daftar penempatan kamar',
    totalPrice: 'Total harga',
  },
  componentsLimitinput: {
    insufficientStock: 'Stok tidak mencukupi',
  },
  componentsMembersearch: {
    memberInformationDoesNotExistOrHasBeenDisabled:
      'Informasi anggota tidak ada atau telah dinonaktifkan',
    pleaseEnterTheMemberInformationYouWantToQuery3:
      'Silakan masukkan informasi anggota yang ingin dicari',
    memberBalanceIsInsufficientPleaseChooseAnotherPaymentMethod:
      'Saldo anggota tidak mencukupi, silakan pilih metode pembayaran lain',
    theMembersMobilePhoneNumberIsIncorrectAndTheStoredValuePaymentCannotBeUsed:
      'Nomor ponsel anggota tidak benar, pembayaran saldo tersimpan tidak dapat digunakan',
    memberNamephoneNumbermembershipNumber: 'Nama anggota / nomor ponsel / nomor kartu',
  },
  componentsPaytip: {
    memberPaymentFailure: 'Pembayaran anggota gagal',
    pleaseReEnterTheAccount: 'Silakan masukkan ulang pencatatan',
  },
  futureIndex: {
    roomTypeSummary: 'Ringkasan tipe kamar',
    roomDetail: 'Detail kamar',
  },
  futureSummary: {
    soldNumberavailableNumberoverSoldNumberdisabledNumber:
      'Terjual / Tersedia (oversold) / Dinonaktifkan',
    totalNumberOfRoomsPhysicalTotalNumberOfRooms: 'Total kamar: jumlah fisik kamar hotel',
    availableNumberTotalNumberOfRoomsSoldNumberDisabledNumberFullDayRoomOverSoldNumber:
      'Tersedia: total kamar - terjual - dinonaktifkan + oversold kamar harian penuh',
    disabledNumberNumberOfDisabledRoomsInTheHotel: 'Dinonaktifkan: jumlah kamar yang dinonaktifkan',
    soldNumberRoomsBookedOnTheDayRoomsCurrentlyOccupiedOnTheDayWithoutTodaysDepartureAndClockRoom:
      'Terjual: kamar dipesan hari ini + kamar dihuni hari ini (tidak termasuk hari ini check-out & kamar per jam)',
  },
  groupbookingIndex: {
    pleaseEnterTeamName: 'Silakan isi nama tim',
    memberBalanceNotEnough: 'Saldo anggota {balance}, silakan pilih metode penerimaan lain',
    bookingRoomCannotBeZero: 'Jumlah kamar yang dipesan tidak boleh 0',
    roomTypeStockNotEnough: 'Stok tipe kamar tidak mencukupi',
    pleaseEnterContractNo: 'Silakan masukkan nomor kontrak',
    remarkPlaceholder: 'Maksimal 150 karakter',
    discountPricePlaceholder: 'Silakan masukkan harga diskon',
    leftRoomsTip: 'Masih ada {count} kamar belum ditempatkan',
    searchMemberPlaceholder: 'Nama / nomor ponsel / nomor anggota',
    groupBooking: 'Reservasi grup',
    contractNumber: 'Nomor kontrak',
    teamBookingSuccessful: 'Reservasi grup berhasil',
  },
  longbookingIndex: {
    singleRoom: 'Kamar kontrak jangka panjang',
  },
  longbookingProductionlist: {
    houseList: 'Daftar penempatan kamar',
    inAddition: 'Masih ada',
  },
  onlinedataIndex: {
    chainRatio: 'Perbandingan periode sebelumnya',
    onAYearOnYearBasis: 'Perbandingan tahun ke tahun',
    theDirectConnectionChannelHasNotBeenOpenedInOrderToPreventTheLossOfOrdersPleaseContactTheOperationManagerAsSoonAsPossibleToOpenTheDirectConnectionChannel:
      'Saluran direct connect belum dibuka; untuk mencegah kehilangan pesanan, silakan hubungi manajer operasional LightStay',
    relevance: 'Keterkaitan',
    onlineRevenue: 'Pendapatan online',
    onlineNight: 'Malam kamar online',
    channelProportion: 'Proporsi saluran',
    channelOnlineStatus: 'Status online saluran',
    directConnection3: 'Direct connect',
    temporarilyWithoutAuthority: 'Tidak ada akses',
    totalOnlineRevenue: 'Total pendapatan online',
    onlineTotalNight: 'Total malam kamar online',
    online: 'Online',
    thisEbAccountIsNotBoundPleaseBindEbAccountInEbAccountManagement:
      'Akun EB belum terikat, silakan ikat di Manajemen Akun EB',
  },
  realTimeIndex: {
    allBuildings: 'Semua gedung',
    allFloors: 'Semua lantai',
    depositShort: 'Dep',
    roomRateShort: 'Tar',
    totalShort: 'Tot',
    preAuthShort: 'Pre',
    balanceShort: 'Sisa',
    powerOff: 'Mati',
    powerOn: 'Nyala',
    new2: 'Baru',
    al: 'Terkait',
    openChannelsForDirectConnection: 'Buka direct connect',
    createRoomType: 'Buat tipe kamar',
    createARoom: 'Buat kamar',
    renewalOrder2: 'Pesanan perpanjangan',
    roomChangeConfirmationForm3: 'Formulir konfirmasi pindah kamar',
    checkInSlip4: 'Formulir check-in',
    whenExtendingYourStayTheRoomPriceDisplayedIsForTheFirstDayOfTheExtendedStayWhenCheckingOutEarlyOrChangingTheExpectedDepartureTimeThePriceDisplayedIsForTheLastNight2:
      'Saat perpanjangan, harga yang ditampilkan adalah harga hari pertama; saat check-out lebih awal atau mengubah waktu pra-keberangkatan, yang ditampilkan adalah harga malam terakhir',
    friendlyReminderPleaseMakeSureToDoubleCheckAllTheDetailsAndThenSignForConfirmationAfterChangingRoomsRememberToTakeYourPersonalBelongingsFromTheOriginalRoom3:
      'Pengingat: mohon periksa kembali sebelum menandatangani; setelah pindah kamar jangan lupa membawa barang pribadi',
    continuationRoomsShowTheFirstDayPrice2:
      'Harga kamar perpanjangan menampilkan harga hari pertama',
    friendlyReminderPleaseDoubleCheckAllTheDetailsAndSignForConfirmationDontForgetToTakeYourPersonalBelongings3:
      'Pengingat: mohon periksa kembali dan tanda tangani; jangan lupa membawa barang pribadi',
    liveLightlyInTheDirectCamp: 'LightStay direct',
    whereToConnectDirectly: 'Qunar direct',
    baiduMap: 'Baidu Map',
    jingdong: 'JD',
    flyingPigCreditLiveOrdersDoNotSupportJointHousing2:
      'Pesanan Fliggy Credit Stay tidak mendukung kamar terhubung',
    flyingPigCreditOrdersCanNotBeSustained2:
      'Pesanan Fliggy Credit Stay tidak mendukung perpanjangan',
    itHasPassedTheCheckOutDateAndCannotBeExtended2:
      'Telah melewati tanggal check-out, tidak dapat diperpanjang',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomUpgradeIsNotSupported2:
      'Waktu saat ini telah melewati waktu check-out, upgrade kamar tidak didukung',
    theCurrentTimeHasPassed600CheckInDateTheRoomUpgradeIsNotSupported2:
      'Waktu saat ini telah melewati pukul 06.00 pada tanggal check-out, upgrade kamar tidak didukung',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomCannotBeChanged2:
      'Waktu saat ini telah melewati waktu check-out, kamar tidak dapat diubah',
    successfulRoomExchange2: 'Pindah kamar berhasil',
    successfulDisposal: 'Berhasil ditandai kotor',
    cleanAndSuccessful: 'Berhasil ditandai bersih',
    deactivateSuccessfully: 'Berhasil mengaktifkan kembali',
    temporaryPassword: 'Kata sandi sementara',
    thisPasswordIsValidFor30MinutesAndExpiresImmediatelyAfterUse:
      'Kata sandi ini berlaku 30 menit dan langsung kedaluwarsa setelah digunakan',
    quickSearch: 'Cari cepat nomor kamar atau nama',
    batchModify: 'Ubah Status Kamar',
    ignore: 'Abaikan',
    goAndOperate: 'Pergi & operasikan',
    bookingInfo: 'Info Pemesanan Menunggu Kedatangan',
    orderNo: 'No. Pesanan',
    channelName: 'Nama Saluran',
    bookerName: 'Nama Pemesan',
    arrivalTime: 'Waktu Kedatangan',
    roomRate: 'Tarif Kamar',
  },
  realTimeServicemsg: {
    dateOfService: 'Tanggal layanan',
    applicationTime2: 'Waktu pengajuan',
    serviceType: 'Jenis layanan',
    serviceTime: 'Waktu layanan',
    serviceSuccess: 'Layanan berhasil',
    serviceFailure: 'Layanan gagal',
    serviceCompletion: 'Layanan selesai',
    theRoomRequestHasBeenServiced: 'Permintaan kamar telah diselesaikan',
  },
  componentsCommon: {
    roomBalance: 'Saldo kamar',
    depositWithPreAuth: 'Deposit (termasuk pra-otorisasi)',
    madeCardCount: 'Jumlah kartu dibuat',
    stayOver: 'Perpanjang',
    checkOut4: 'Check-out',
    temporaryPassword: 'Kata sandi sementara',
    sendPassword: 'Kirim kata sandi',
    muck: 'Tandai kotor',
    setAside: 'Tandai bersih',
    deactivate: 'Aktifkan kembali',
    faceEast: 'Menghadap timur',
    faceWest: 'Menghadap barat',
    faceSouth: 'Menghadap selatan',
    faceNorth: 'Menghadap utara',
    decorativeFalseWindow: 'Jendela dekoratif palsu',
    stayAwayFromElevators: 'Jauh dari lift',
    nearTheStairs: 'Dekat tangga',
    closeToTheRoad: 'Dekat jalan',
    windowWall: 'Dinding luar jendela',
    bedTypeDescription: 'Deskripsi tipe tempat tidur',
    guestControl: 'Kontrol tamu',
    latestCheckIn: 'Menginap Terakhir',
    noHistoricalCheckInInfo: 'Tidak ada informasi riwayat menginap untuk kamar ini',
    temporaryMakeCard: 'Buat kartu sementara',
  },
  componentsEmpty: {
    searchNull: 'Hasil pencarian kosong',
  },
  componentsGrouphandle: {
    batchModify: 'Ubah Status Kamar',
    pleaseSelectAnActiveArea: 'Silakan pilih area aktif',
    selectStartDate: 'Pilih tanggal mulai',
    selectEndDate: 'Pilih tanggal akhir',
    emptyCleanToEmptyDirty: 'Kosong bersih → kosong kotor',
    emptyDirtyToEmptyClean: 'Kosong kotor → kosong bersih',
    stayCleanAndTurnDirty: 'Huni bersih → huni kotor',
    stayDirtyAndTurnClean: 'Huni kotor → huni bersih',
    batchOutage: 'Nonaktifkan massal',
    batchDeactivation: 'Aktifkan kembali massal',
    pleaseEnterTheStartTime: 'Silakan masukkan waktu mulai',
    pleaseEnterTheEndTime: 'Silakan masukkan waktu akhir',
    pleaseSelectTheRoomForBatchOperation: 'Silakan pilih kamar untuk operasi massal',
    batchOperationSuccessful: 'Operasi massal berhasil',
    whetherToConfirmTheDeactivationBatchDeactivationIncludesrowRooms:
      'Konfirmasi penonaktifan? Penonaktifan massal mencakup kamar yang sudah ditempatkan',
  },
  componentsHourcheckinconfirm: {
    checkInTimeConfirmation: 'Konfirmasi waktu check-in',
    continuousHousing: 'Lanjutkan penempatan',
    theArrivalTimeHasBeenExceededPleaseConfirmTheGuestCheckInTime:
      'Telah melewati waktu kedatangan perkiraan, mohon konfirmasi waktu check-in tamu',
    itHasBeenOccupiedPleaseManuallyArrangeTheRoomAfterFurtherProcessing:
      'Kamar sudah ditempati; lanjutkan proses dan atur kamar secara manual',
  },
  componentsOperationlog: {
    operationRecord: 'Catatan operasi',
  },
  componentsStopservice: {
    successfulDeactivation: 'Penonaktifan berhasil',
    selectStartDate: 'Pilih tanggal mulai',
    selectEndDate: 'Pilih tanggal akhir',
    noteAtLeast3Words: 'Catatan minimal 3 karakter',
    startMustAfterNow: 'Tanggal mulai harus lebih besar atau sama dengan tanggal saat ini',
    endMustAfterStart: 'Tanggal selesai harus lebih besar dari tanggal mulai',
  },
  serviceHandle: {
    accept: 'Terima',
    turnDown2: 'Tolak',
    serviceProcessing: 'Pemrosesan layanan',
    whetherToProcess: 'Apakah akan diproses',
    reasonForRefusal: 'Alasan penolakan',
    pleaseEnterTheReasonForTheRejection: 'Silakan masukkan alasan penolakan',
    accepted: 'Telah diterima',
    denialOfService: 'Layanan ditolak',
  },
  sankebookingArrangeroom: {
    noRoomAvailablePleaseConfirmAndTryAgain:
      'Tidak ada kamar yang dapat diatur, silakan konfirmasi dan coba lagi',
    upgradeNumberOfRooms: 'Jumlah kamar yang di-upgrade',
    pleaseEnterRoomChangeRemarks: 'Silakan masukkan catatan pindah kamar',
    conditionOfTheHouse2: 'Status kamar',
    pleaseSelectTheRoomYouWantToUpgrade: 'Silakan pilih kamar yang ingin di-upgrade',
    thereAreCurrentlyNoRoomTypesAvailableForUpgrade:
      'Saat ini tidak ada tipe kamar yang tersedia untuk upgrade',
    theNumberOfRowRoomsCannotBeGreaterThanTheNumberOfReservedRooms:
      'Jumlah kamar yang diatur tidak boleh melebihi jumlah kamar yang dipesan',
    thisRoomTypeIsNotOnline: 'Tipe kamar ini belum online',
    hourProductPleaseSelectAnotherRoomType: 'Produk per jam, silakan pilih tipe kamar lain',
    thisRoomType: 'Tipe kamar ini',
    productsAreSoldOutPleaseChooseAnotherRoomType:
      'Produk per jam telah habis terjual, silakan pilih tipe kamar lain',
    noPriceIsSetForTheHourProductPleaseSelectAnotherRoomType:
      'Produk per jam belum memiliki harga, silakan pilih tipe kamar lain',
    yourUpgradedRoomTypeIsAllThatIsLeft: 'Tipe kamar hasil upgrade yang tersisa hanya',
    pleaseChangeToAnotherRoomTypeOrReduceTheNumberOfRoomUpgrades:
      'kamar, silakan ganti ke tipe kamar lain atau kurangi jumlah kamar yang di-upgrade',
  },
  sankebookingIndex: {
    channelOrderRoomType: 'Tipe kamar pesanan saluran',
    operationPrompt: 'Petunjuk operasi',
    furtherBooking: 'Lanjutkan pemesanan',
    thisOrderHasAlreadyBeenBookedPleaseDoNotRepeat:
      'Pesanan ini sudah diproses, mohon jangan mengulang',
    floorPriceModel: 'Mode harga dasar',
    sellingPriceModel: 'Mode harga jual',
    theNumberOfReservedRoomsCannotBe: 'Jumlah kamar yang dipesan tidak boleh',
    reservationNumber: 'Jumlah reservasi',
    inAddition: 'Masih ada',
    useEbInformation: 'Gunakan informasi EB',
    useEbOrderInformation: 'Gunakan informasi pesanan EB',
    theNumberOfBookingRoomsIsInconsistentWithTheNumberOfChannelOrdersWhetherToContinueBooking:
      'Jumlah kamar yang dipesan tidak konsisten dengan jumlah pesanan saluran, lanjutkan pemesanan?',
    thisOrderCannotBeBooked: 'Pesanan ini tidak dapat diproses untuk pemesanan',
  },
  activityData: {
    dailySpecial: 'Promo harian',
    keepPricesLow: 'Pertahankan harga rendah',
    motivateUsersToBuyMore: 'Dorong pengguna untuk membeli lebih banyak',
    earlyRush: 'Tarik pemesanan lebih awal',
  },
  componentsActivitydetail: {
    discount: 'Diskon',
    promotionInfo:
      'Setelah pendaftaran aktivitas berhasil dikirim, aktivitas akan langsung berlaku. Selama aktivitas berlangsung, hotel dapat mengubah atau keluar, namun pesanan yang telah selesai tetap mengikuti aturan yang ada. Harga asli kamar yang ikut aktivitas tidak boleh lebih tinggi dari saluran lain, jika tidak maka mungkin tidak akan ditampilkan.',
    offerDetails:
      'Harga sebelum promo untuk kamar yang ikut aktivitas tidak boleh lebih tinggi dari saluran lain agar mendapatkan lebih banyak eksposur. Disarankan kamar dengan harga terendah ikut aktivitas untuk mendapatkan lebih banyak trafik.',
    backToActivityList: 'Kembali ke daftar aktivitas',
    quantitySold: 'Jumlah terjual',
    sellLowEachNight: 'Harga rendah per malam',
    pleaseSelectAnEventProduct: 'Silakan pilih produk yang akan mengikuti aktivitas',
    noRoomTypeInformationAvailable: 'Tidak ada informasi tipe kamar',
    productsHaveBeenSelectedForTheEvent: 'Produk yang mengikuti aktivitas telah dipilih',
    selectOffer: 'Pilih penawaran',
    iHaveReadAndAgree: 'Saya telah membaca dan menyetujui',
    activityRelatedClause: 'Ketentuan terkait aktivitas',
    selectedOffer: 'Penawaran terpilih',
    signUpNow: 'Daftar sekarang',
    activeTime: 'Waktu aktivitas',
    activityProfile: 'Ringkasan aktivitas',
    activityRequirement: 'Persyaratan aktivitas',
    preferentialDetails: 'Detail penawaran',
    specialSpecification: 'Keterangan khusus',
    entryAndExitRules: 'Aturan berlaku & keluar',
    costAttribution: 'Atribusi biaya',
    midAutumnFestival: 'Festival Pertengahan Musim Gugur',
    specialProduct: 'Produk khusus',
    areYouSureYouWantToCommitYourChanges: 'Apakah Anda yakin ingin mengirim perubahan?',
    pleaseSelectTheRoomTypeToParticipateInTheEvent: 'Silakan pilih tipe kamar yang ikut aktivitas',
    pleaseSelectDiscount: 'Silakan pilih diskon',
    pleaseReadAndAgreeToTheTermsOfTheEvent: 'Silakan baca dan setujui ketentuan aktivitas',
    successfulRegistration: 'Pendaftaran berhasil',
  },
  componentsSelfactivitylist: {
    expired: 'Telah kedaluwarsa',
    copyPromotion: 'Salin promosi',
    promotionType: 'Jenis promosi',
    marginOfPreference: 'Besaran diskon',
    eventDate: 'Tanggal aktivitas',
    beOffline: 'Telah offline',
    merchantsPushThemselvesOffline: 'Promosi merchant dihentikan',
    offlineSuccess: 'Berhasil dihentikan',
    areYouSureYouWantToDeleteTheActivity: 'Apakah Anda yakin ingin menghapus aktivitas ini?',
  },
  componentsActivitycontent: {
    activityRequirement: 'Persyaratan aktivitas',
    quantitySold: 'Jumlah terjual',
    signUpNow: 'Daftar sekarang',
    cancelRegistration: 'Batalkan pendaftaran',
    reEnroll: 'Daftar ulang',
    areYouSureYouWantToCancelYourRegistration: 'Apakah Anda yakin ingin membatalkan pendaftaran?',
  },
  componentsSelfactivitylog: {
    inquire: 'Cari',
    back: 'Kembali',
  },
  componentsDialog: {
    rule: 'Aturan',
    new: 'Baru',
    content: 'Konten',
    activityRelatedClause: 'Ketentuan terkait aktivitas',
  },
  componentsSelfactivitydetail: {
    discountInfo:
      'Mengaktifkan perpanjangan otomatis akan otomatis memperpanjang promosi 30 hari sebelum tanggal berakhir dengan membuat promosi baru. Jika sisa waktu kurang dari 30 hari, sistem akan otomatis memperpanjang hingga 30 hari.',
    chooseToParticipateInPromotionalProducts: 'Pilih produk yang ikut promosi',
    noRoomTypeInformationAvailable: 'Tidak ada informasi tipe kamar',
    selectedProductsForPromotion: 'Produk terpilih untuk promosi',
    selectTheChannelWhereThePromotionIsEffective: 'Pilih saluran tempat promosi berlaku',
    allChannels: 'Semua saluran',
    designatedChannel: 'Saluran tertentu',
    noEffectiveChannelInformationIsAvailable: 'Tidak ada informasi saluran yang berlaku',
    youHaveSelectedTheChannelWhereThePromotionTakesEffect:
      'Anda telah memilih saluran tempat promosi berlaku',
    activeConfiguration: 'Konfigurasi aktivitas',
    setForAtLeast2Days: 'Atur minimal 2 hari',
    setThisParameterForAtLeast1Day: 'Atur minimal 1 hari',
    discount: 'Diskon',
    theDiscountValueIsSetToAtLeast95Off: 'Nilai diskon minimal 95%',
    theMinimumAmountOfImmediateReductionIsSetAt5: 'Potongan langsung minimal 5 ',
    immediateReductionPromotionIsNotEffectiveForCtrip:
      'Promosi potongan langsung tidak berlaku untuk Ctrip',
    thePromotionIsValidOnlyOnCtrip: 'Promosi ini hanya berlaku di Ctrip',
    thePromotionIsOnlyEffectiveOnCtripAndTongcheng:
      'Promosi ini hanya berlaku di Ctrip dan Tongcheng',
    link: 'Menginap berurutan',
    advanceBooking: 'Reservasi lebih awal',
    preferentialMode: 'Metode diskon',
    firstStayDiscount: 'Diskon menginap pertama',
    automaticExtension: 'Perpanjangan otomatis',
    saleTime: 'Waktu cuci gudang',
    theFollowingDay: 'Hari berikutnya',
    theIntervalShallNotBeLessThan30Days: 'Interval waktu tidak boleh kurang dari 30 hari',
    areYouSureYouWantToCommitYourChanges: 'Apakah Anda yakin ingin mengirim perubahan?',
    pleaseSelectTheRoomTypeToParticipateInTheEvent: 'Silakan pilih tipe kamar yang ikut aktivitas',
    pleaseSelectAnEventCheckInDate: 'Silakan pilih tanggal check-in aktivitas',
    pleaseFillInTheDiscountAmount: 'Silakan isi jumlah diskon',
    atLeast95OffUpTo30Off: 'Diskon minimal 95% hingga maksimal 30%',
    theDiscountAmountIsAtLeast5AndUpTo500: 'Jumlah diskon minimal 5  dan maksimal 500 ',
    pleaseFillInTheNumberOfConsecutiveDays: 'Silakan isi jumlah hari menginap berurutan',
    theNumberOfConsecutiveDaysMustBeGreaterThanOrEqualTo1DayAndLessThanOrEqualTo10Days:
      'Jumlah hari menginap berurutan harus antara 1 hingga 10 hari',
    pleaseFillInTheAdvanceBookingDays: 'Silakan isi jumlah hari reservasi lebih awal',
    pleaseFillInTheSaleTime: 'Silakan isi waktu cuci gudang',
    congratulationsOnYourPromotionCreation: 'Selamat, promosi berhasil dibuat',
    congratulationsOnYourSuccessfulCopyPromotion: 'Selamat, promosi berhasil disalin',
    back: 'Kembali',
  },
  componentsSelfactivitytemp: {
    createNow: 'Buat sekarang',
  },
  productOversaleSetting: {
    timePeriod: 'Periode waktu',
    numberSold: 'Jumlah terjual',
    oversold: 'Boleh oversell',
    oversoldQuantity: 'Jumlah oversell',
    oversoldCannotBeGreaterThanTheRemainingPhysicalRoomCapacityOfTheHotelOnThatDay:
      'Jumlah oversell tidak boleh melebihi sisa kapasitas fisik kamar hotel pada hari tersebut',
    oversoldStockIsActivatedWhenTheActualPhysicalStockOfTheRoomTypeIsSoldOutForTheDay:
      'Stok oversell akan aktif ketika stok fisik kamar pada hari tersebut telah habis',
    pleaseOpenTheAutomaticOverbookingSettingInMoreSystemSettingsBasicSettingsDirectConnectionOrderToAvoidAutomaticRejectionOfOverbookingOrderTimeout:
      'Silakan aktifkan pengaturan penerimaan otomatis saat oversell di Lainnya > Pengaturan Sistem > Pengaturan Dasar > Pesanan Direct Connect untuk menghindari penolakan otomatis pesanan oversell karena timeout',
    timeSelectionIsOutOfRange: 'Pemilihan waktu di luar rentang',
    configurationSuccessful: 'Konfigurasi berhasil',
    theSetOverbookingQuantityMustBeGreaterThanOrEqualTo:
      'Jumlah oversell yang ditetapkan harus lebih besar atau sama dengan',
  },
  productDelayprice: {
    holidayFactorRange:
      'Rentang koefisien hari libur: desimal 1–5, maksimal satu angka di belakang koma.',
    holidayPricingRule:
      'Setelah koefisien hari libur ditetapkan, harga hari libur nasional Tiongkok akan menjadi kelipatan dari harga hari biasa. Contoh: koefisien 2 dan harga hari biasa 100 , maka harga hari libur menjadi 200 .',
    holidayFactor:
      'Harga hari libur nasional Tiongkok akan menjadi kelipatan dari harga hari biasa',
    priceCopy: 'Salin harga 2 bulan',
    open: 'Aktif',
    deferredProduct: 'Produk penundaan harga',
    allDayRoomProducts: 'Produk kamar harian penuh',
    deferralOnlyAppliesToProductsWithFullDayOccupancyType:
      'Penundaan harga hanya berlaku untuk produk dengan tipe kamar harian penuh',
    priceExtensionTime: 'Durasi penundaan harga',
    holidayCoefficient: 'Koefisien hari libur',
    statutoryHolidayPricesAreWeekdays: 'Harga hari libur nasional adalah',
    times: 'kali',
    automaticDeferralDescription: 'Penjelasan penundaan otomatis',
    theSystemCopiesThePriceOfTheMostRecentWeekToAFutureDateWithoutAPriceAndDatesThatAlreadyHaveAPriceWillNotBeOverwrittenByTheSystem:
      'Sistem menyalin harga satu minggu terakhir ke tanggal mendatang yang belum memiliki harga; tanggal yang sudah memiliki harga tidak akan ditimpa',
    thePriceSourceOfTheAutomaticPriceExtensionIsThePriceOfTheWeekBeforeTheAutomaticPriceExtensionDateInCaseOfHolidaysItIsSkippedAndThePriceOfThePreviousWeekIsTaken:
      'Sumber harga penundaan otomatis adalah harga satu minggu sebelum tanggal penundaan; jika bertepatan hari libur, akan dilewati dan menggunakan harga minggu sebelumnya',
    turnOffAutomaticDeferral: 'Matikan penundaan otomatis',
  },
  productManageSetting: {
    advanceSale: 'Pra-penjualan',
    needChannelConnection:
      'Produk ini memerlukan koneksi saluran untuk dibuat. Apakah Anda ingin mengaktifkan koneksi saluran?',
    confirmChangeProductType:
      'Mengubah tipe produk akan mengosongkan saluran publikasi dan semua aturan produk. Apakah Anda yakin?',
    limitSale: 'Batas penjualan (kamar)',
    checkInDay: 'Hari check-in',
    beforeCheckIn: 'Sebelum check-in',
    atLatest: 'Paling lambat',
    theHourlyIncreaseCannotBeGreaterThanThePrice:
      'Biaya tambahan per jam tidak boleh lebih besar dari harga',
    physicalRoomType: 'Tipe kamar fisik',
    earliestCheckInTime: 'Waktu check-in paling awal',
    latestCheckOutTime: 'Waktu check-out paling akhir',
    howLongNoAdditionalRoomChargeminutes: 'Durasi perpanjangan tanpa biaya tambahan (menit)',
    howLongIsTheFullDayRoomChargehours: 'Durasi dikenakan tarif kamar harian penuh (jam)',
    cancelRule: 'Aturan pembatalan',
    paymentPolicy: 'Kebijakan pembayaran',
    validForOnlineSalesOnly: 'Hanya berlaku untuk penjualan online',
    releaseChannel: 'Saluran publikasi',
    productRegulation: 'Aturan produk',
    effectiveChannel: 'Saluran yang berlaku',
    priceyuan: 'Harga ',
    inputPrice: 'Masukkan harga',
    extraChargePerHourrmb: 'Biaya tambahan per 1 jam ',
    forSaleOnly: 'Batas penjualan (kamar)',
    inputSpace: 'Masukkan jumlah kamar',
    enjoyHotelStayLight: 'LightStay Hotel Enjoy',
    pleaseEnterTheNumberOfRooms: 'Silakan masukkan jumlah kamar',
    additionalRule: 'Aturan tambahan',
    found: 'Buat',
    containing: 'Termasuk',
    pleaseEnterTheNumberOfRestrictedRooms: 'Silakan masukkan jumlah kamar yang dibatasi',
    nonDeletable: 'Tidak dapat dihapus',
    early: 'Awal',
    withoutBreakfast: 'Tanpa sarapan',
    liveLightAndEnjoy: 'LightStay Preferred',
    confirmToDeleteThisRule: 'Apakah Anda yakin ingin menghapus aturan ini',
    areYouSureToKeepItForSale: 'Apakah Anda yakin ingin menyimpan untuk dijual',
    areYouSureToCreateASale: 'Apakah Anda yakin ingin membuat penjualan',
    areYouSureYouWantToLeave: 'Apakah Anda yakin ingin keluar',
  },
  productPriceCalendar: {
    is: 'Apakah',
    confirmDeleteWarning:
      'Silakan pastikan apakah produk ini masih memiliki pesanan kamar yang belum check-out agar tidak memengaruhi perpanjangan. Jika yakin menghapus, klik tombol “Konfirmasi hapus” di bawah',
    totalAvailableRooms: 'Total kamar tersedia 10 kamar / (termasuk kuota oversell 3 kamar)',
    limitZeroFull:
      'Jika batas penjualan = 0, status menjadi penuh; setelah kamar ditutup tidak akan dijual di kanal online.',
    openRoomAvailable:
      'Saat kamar dibuka dan masih ada sisa, kamar dapat dijual online; setelah ditutup tidak akan dijual online',
    allProducts3: 'Semua produk',
    onlineProduct2: 'Produk online',
    offLineProduct2: 'Produk offline',
    theReckoner: 'Kalkulator',
    preSaleFullDayRoom: 'Pra-penjualan kamar harian penuh',
    presaleHourRoom: 'Pra-penjualan kamar per jam',
    viewIsNotSupported: 'Tampilan belum didukung',
    channelPricesCannotBeSet: 'Harga saluran tidak dapat diatur',
    smallProgramChannelPriceCanBeAdjustedToUpdate:
      'Harga saluran mini program dapat disesuaikan untuk pembaruan',
    switchRoom: 'Buka/Tutup kamar',
    limitedSalesNumber: 'Batas penjualan',
    unlimitedSale: 'Penjualan tanpa batas',
    packUpAllProducts: 'Lipat semua produk',
    expandAllProducts: 'Perluas semua produk',
    modifyProductPrice: 'Ubah harga produk',
    extraChargeForMoreThan1Hour: 'Biaya tambahan jika lebih dari 1 jam',
    enjoyHotelStayLight: 'LightStay Hotel Enjoy',
    pleaseEnterLimitedNumber: 'Silakan masukkan jumlah batas penjualan',
    maintenancePrice: 'Pemeliharaan harga',
    priceNotMaintained: 'Harga belum dipelihara',
    amendTheSalesRestrictionRules: 'Ubah aturan batas penjualan',
    confirmOrNot: 'Apakah dikonfirmasi',
    areYouSureYouWantToContinue: 'Apakah Anda yakin ingin melanjutkan perubahan',
    theCurrentRateExceedsTheThresholdSetByTheHotel5:
      'Harga saat ini melebihi ambang batas yang ditetapkan hotel',
    definiteModification: 'Konfirmasi perubahan',
  },
  productPriceCalendarNew: {
    open: 'Buka kamar',
    iss: 'Apakah',
    remainingContractReservedRooms: 'Sisa kamar kontrak yang dicadangkan',
    roomsCannotBeLower: 'kamar, jumlah kamar cadangan tidak boleh lebih rendah dari nilai ini',
    confirmDeleteWarning:
      'Silakan pastikan apakah produk ini masih memiliki pesanan kamar yang belum check-out agar tidak memengaruhi perpanjangan. Jika yakin menghapus, klik tombol “Konfirmasi hapus” di bawah',
    Thenumberofremainingcontractreservedroomsforthisproduct:
      'Jumlah kamar kontrak tersisa untuk produk ini tidak nol; permohonan penutupan kamar telah diajukan, silakan menunggu persetujuan.',
    cannotCloseRoom:
      'Jumlah kamar kontrak tersisa untuk produk ini tidak nol, kamar tidak dapat ditutup. Silakan hubungi manajer saluran.',
    confirmModification: 'Konfirmasi perubahan',
    EBDeepOperationFailed: 'Operasi EB tingkat lanjut gagal',
    syncCurrentPageEBData: 'Sinkronkan data EB halaman ini',
    previousTwoWeeks: 'Dua minggu sebelumnya',
    nextTwoWeeks: 'Dua minggu berikutnya',
    batchChangeInventory: 'Ubah inventori massal',
    theReckoner: 'Kalkulator',
    preSaleFullDayRoom: 'Pra-penjualan kamar harian penuh',
    presaleHourRoom: 'Pra-penjualan kamar per jam',
    underRevision: 'Sedang diubah',
    viewIsNotSupported: 'Tampilan belum didukung',
    dataSynchronizationIsUnderwayPleaseQueryTheDataAgainAfter1Minute:
      'Sinkronisasi data sedang berlangsung, silakan periksa kembali setelah 1 menit',
    lightLiveDistributionChannelPriceCannotBeSet:
      'Harga saluran distribusi LightStay tidak dapat diatur',
    smallProgramChannelPriceCanBeAdjustedToUpdate:
      'Harga saluran mini program dapat disesuaikan untuk pembaruan',
    switchRoomSetup: 'Pengaturan buka/tutup kamar',
    notModify: 'Tidak diubah',
    roomSetting: 'Pengaturan jumlah kamar',
    unlimitedSale: 'Penjualan tanpa batas',
    reserveRoomSetup: 'Pengaturan kamar cadangan',
    pleaseSelectRoomType: 'Silakan pilih tipe kamar',
    pleaseSelectCheckInType: 'Silakan pilih tipe check-in',
    notShowPreSaleProduct: 'Jangan tampilkan produk pra-penjualan',
    showPreSaleProduct: 'Tampilkan produk pra-penjualan',
    notShowEbProduct: 'Jangan tampilkan produk EB',
    showEbProduct: 'Tampilkan produk EB',
    allCheckInTypes: 'Semua tipe check-in',
    holiday: 'Hari libur',
    packItAllUp: 'Lipat semua',
    expandAll: 'Perluas semua',
    extraChargeForMoreThan1Hour: 'Biaya tambahan jika lebih dari 1 jam',
    theNumberOfReservedRoomsCanBeIncreasedAtMostNotMoreThanTheCurrentInventoryAtLeastNotLessThanTheNumberOfRemainingContractedReservedRooms:
      'Jumlah kamar cadangan dapat ditambah, maksimal tidak boleh melebihi inventori saat ini dan minimal tidak boleh lebih kecil dari sisa kamar kontrak',
    offLineProduct2: 'Produk offline',
    onlineProduct2: 'Produk online',
    allProducts3: 'Semua produk',
    showFloor: 'Tampilkan harga dasar',
    theReservePriceIsNotDisplayed: 'Harga dasar tidak ditampilkan',
    directChannel4: 'Saluran direct',
    goWhereTheDirectConnection: 'Qunar direct',
    unboundChannel: 'Saluran belum terikat',
    synchronizationFailure: 'Sinkronisasi gagal',
    theStartDateOfTheLastTwoWeeksCannotBeLessThanTheCurrentDate:
      'Tanggal mulai dua minggu sebelumnya tidak boleh lebih kecil dari tanggal hari ini',
    pleaseSelectTheCurrentStartEndDate: 'Silakan pilih tanggal mulai dan akhir saat ini',
    pleaseEnterTheNumberOfReservedRooms: 'Silakan masukkan jumlah kamar cadangan',
    pleaseEnterLimitedNumber: 'Silakan masukkan jumlah batas penjualan',
    maintenancePrice: 'Pemeliharaan harga',
    priceNotMaintained: 'Harga belum dipelihara',
    modifyProductPrice: 'Ubah harga produk',
    modifyProductInventory: 'Ubah inventori produk',
    confirmOrNot: 'Apakah dikonfirmasi',
    theCurrentRateExceedsTheThresholdSetByTheHotel5:
      'Harga saat ini melebihi ambang batas yang ditetapkan hotel',
    areYouSureYouWantToContinue: 'Apakah Anda yakin ingin melanjutkan perubahan',
    definiteModification: 'Konfirmasi perubahan',
    ebChannel: 'Saluran EB',
    ebMeituan: 'EB Meituan',
    ebCtrip: 'EB Ctrip',
    ebFeizhu: 'EB Fliggy',
  },
  productPriceAudit: {
    allRejectedSuccessfully: 'Semua penolakan berhasil',
    pass: 'Lolos',
    turnDown: 'Tolak',
    revisedPrice: 'Harga setelah perubahan',
    rangeOfVariation: 'Rentang perubahan harga',
    priceChanger: 'Pengubah harga',
    auditor: 'Pemeriksa',
    auditTime: 'Waktu audit',
    toBeReviewed: 'Menunggu audit',
    passTheExamination: 'Audit disetujui',
    expired: 'Kedaluwarsa',
    successfulAudit: 'Audit berhasil',
  },
  pcncomponentDataexplain: {
    totalAvailableRooms: 'Total kamar tersedia 10 kamar / (termasuk kuota oversell 3 kamar)',
    ebPriceSoldRemaining: 'Harga kamar (harga jual EB) / jumlah terjual / sisa kamar',
    ebPriceSoldCloseStatus: 'Harga kamar (harga jual EB) / jumlah terjual / status tutup kamar',
    ebBasePriceReservedUnlimited:
      'Harga dasar EB / sisa kamar cadangan (termasuk kontrak & cadangan sementara) / penjualan tanpa batas',
    hourRoomProductsShowHourRoomIdentification:
      'Produk kamar per jam menampilkan label kamar per jam',
    whenTheProductPriceIsChangedOrTheHousingStatusIsNotImmediatelyEffectiveInTheAuditTheIdentificationInTheAuditIsDisplayedAndTheIdentificationInTheAuditIsHiddenAfterTheAuditPassesTheModificationAndBecomesEffective:
      'Saat harga produk atau status kamar diubah dan belum langsung berlaku karena audit, akan ditampilkan label “dalam audit”; setelah audit disetujui dan perubahan berlaku, label akan disembunyikan',
    underRevision: 'Sedang diubah',
    thePriceOrInventoryHasDataThatIsBeingModifiedTheIdentifierIsDisplayedWhenTheModificationResultIsNotObtainedTheIdentifierIsHiddenOnlyAfterSuccessOrFailure:
      'Jika harga atau inventori sedang diubah dan hasil belum diperoleh, label akan ditampilkan; label hanya disembunyikan setelah berhasil atau gagal',
    ifTheProductFailsToChangeThePriceOrChangeTheRoomStatusTheFailureIdentifierWillBeDisplayedAndTheIdentifierWillBeHiddenOnlyAfterTheNextOperationSucceedsInChangingThePriceOrChangingTheRoomStatus:
      'Jika perubahan harga atau status kamar gagal, label gagal akan ditampilkan; label hanya disembunyikan setelah operasi berikutnya berhasil',
    theProductFailsToBeObtainedContactTheOperationManagerToCheckWhetherTheProductHasBeenChanged:
      'Gagal mendapatkan produk, silakan hubungi manajer operasional untuk memastikan apakah produk telah berubah',
    statusDeclaration: 'Penjelasan status',
    whenTheLimitedNumberOfSalesIs0TheRoomIsFullAndItCannotBeSoldAfterClosingTheRoomOnlyTheRelevantRoomWillStopSellingInTheUnlimitedNumberState:
      'Jika batas penjualan = 0, kamar dianggap penuh; setelah kamar ditutup tidak dapat dijual. Pada mode tanpa batas, hanya penutupan kamar yang menghentikan penjualan',
    ctripEbPrepaidProductsShowThePrepaidLogo: 'Produk EB prabayar Ctrip menampilkan ikon prabayar',
    ctripEbCashProductsShowTheCashLogo: 'Produk EB bayar di tempat Ctrip menampilkan ikon tunai',
  },
  pcncomponentBatchUpdateStock: {
    cannotCloseRoomTip: 'Produk EB tidak dapat ditutup jika sisa kamar cadangan tidak nol',
    roomSettingTip:
      'Penyesuaian jumlah kamar adalah batas penjualan untuk semua produk di bawah tipe kamar. Inventori produk direct dan EB mengambil nilai minimum dari batas penjualan dan inventori fisik',
    infiniteQuantityTip:
      'Tanpa batas sesuai dengan EB Meituan tanpa batas, Fliggy tanpa batas, Ctrip freesale; direct channel juga tanpa batas',
    notModify: 'Tidak diubah',
    roomSetting: 'Pengaturan jumlah kamar',
    restrictedSalesIncrease: 'Tambah batas penjualan',
    restrictedSalesReduction: 'Kurangi batas penjualan',
    directlyConnectedProductsOnlySupportToModifyTheSwitchingRoomStatusDoNotSupportToModifyTheInventory:
      'Produk direct hanya mendukung perubahan status buka/tutup kamar, tidak mendukung perubahan inventori',
    batchChangeInventory: 'Ubah inventori massal',
    productSelection: 'Pemilihan produk',
    whetherToDisplayPreSaleProducts: 'Apakah menampilkan produk pra-penjualan',
    channelSelection: 'Pemilihan saluran',
    paymentType: 'Jenis pembayaran',
    selectionWeek2: 'Pilih hari',
    switchRoomSetup: 'Pengaturan buka/tutup kamar',
    open: 'Buka kamar',
    someProductsFailedToModifyTheFollowingAreFailedProductsPleaseGetTheLatestPriceInventoryAndModifyAgain2:
      'Sebagian produk gagal diubah; berikut produk yang gagal. Silakan ambil harga & inventori terbaru lalu coba lagi',
    pleaseSelectADateRange2: 'Silakan pilih rentang tanggal',
    pleaseSelectAWeek2: 'Silakan pilih hari',
    pleaseEnterTheNumberOfRestrictedRooms: 'Silakan masukkan jumlah kamar yang dibatasi',
    pleaseEnterTheNumberOfRestrictedAdditionalRooms:
      'Silakan masukkan jumlah kamar tambahan yang dibatasi',
    pleaseEnterTheNumberOfRestrictedReducedRooms:
      'Silakan masukkan jumlah kamar yang dikurangi batasnya',
  },
  pcncomponentPriceunified: {
    weekend: 'Akhir pekan',
    officialWebsiteDirect: 'Situs resmi (direct)',
    dateCannotRepeat: 'Tanggal tidak boleh berulang',
    displayNextPage: 'Tampilkan halaman berikutnya',
    priceCannotBeLessThan20: 'Harga jual tidak boleh ≤ 20',
    lowSellingPriceTip:
      'Harga jual produk berikut terlalu rendah, silakan konfirmasi apakah ingin melanjutkan perubahan',
    priceExceedsThresholdTip:
      'Perubahan harga ini melebihi batas yang ditetapkan, silakan hubungi manajer toko untuk audit perubahan harga',
    selectProduct: 'Pilih produk',
    weekdays: 'Hari kerja',
    noDifference: 'Tidak dibedakan',
    distinguish: 'Dibedakan',
    bulkAdjustment: 'Penyesuaian massal',
    increase: 'Tambah',
    reduce: 'Kurangi',
    weekdayWeekend: 'Hari kerja / akhir pekan',
    someProductsFailedToModifyTheFollowingAreFailedProductsPleaseGetTheLatestPriceInventoryAndModifyAgain2:
      'Sebagian produk gagal diubah; berikut produk yang gagal. Silakan ambil harga dan inventori terbaru lalu ubah kembali',
    weekendPrice: 'Harga akhir pekan',
    repricingDate: 'Tanggal perubahan harga',
    effectiveWeek: 'Minggu efektif',
    maxFiveDates: 'Maksimal memilih 5 tanggal',
    priceChangeModeTip:
      'Mode perubahan harga dapat memilih ubah harga jual + komisi atau harga dasar. Pada mode harga jual + komisi, hanya produk Ctrip yang mendukung perubahan komisi dan dapat dinaikkan; mode harga dasar hanya produk Ctrip yang dapat diubah',
    sellPriceCommission: 'Harga jual + komisi',
    ebChannel: 'Saluran EB',
    ebMeituan: 'EB Meituan',
    ebCtrip: 'EB Ctrip',
    ebFeizhu: 'EB Fliggy',
    splitPricing: 'Ubah harga terpisah',
    uniformPriceChange: 'Ubah harga seragam',
    productSelection: 'Pemilihan produk',
    paymentType: 'Jenis pembayaran',
    selectionWeek2: 'Pilih hari',
    thePreviousStepReselectTheProduct: 'Langkah sebelumnya: pilih ulang produk',
    methodOfRepricing: 'Metode perubahan harga',
    separatePriceChangesCanSetThePriceOfEachProductAndUnifiedPriceChangesCanBeAddedAndReducedInBatches:
      'Perubahan terpisah dapat mengatur harga tiap produk, sedangkan perubahan seragam dapat menambah atau mengurangi harga secara massal',
    priceModel: 'Model harga',
    priceBeforeModification: 'Harga sebelum perubahan',
    extraChargeAfterOneHour: 'Biaya tambahan setelah 1 jam',
    commission: 'Komisi',
    directChannel4: 'Saluran direct',
    goWhereTheDirectConnection: 'Qunar direct',
    value: 'Nilai',
  },
  pcncomponentTable: {
    passTheVerification: 'Verifikasi berhasil',
    verificationFail: 'Verifikasi gagal',
  },
  pcncomponentLog: {
    revisedPrice3: 'Harga setelah perubahan',
    pleaseEnterTheRevisedPrice: 'Silakan masukkan harga setelah perubahan',
    pleaseSelectAStandardProduct: 'Silakan pilih produk standar',
    straight: 'Direct',
  },
  giftPro: {
    bindUnbind: 'Ikat / Lepas ikatan',
    giftValueInfo: 'Nilai paket hadiah hanya untuk ditampilkan, tidak menimbulkan biaya nyata',
    thePackageCanOnlyBeConfiguredWithAllDayRoomProducts:
      'Paket hadiah hanya dapat dikonfigurasi untuk produk kamar harian penuh',
    eachProductCanBeConfiguredWithOnlyOnePackage:
      'Setiap produk hanya dapat dikonfigurasi dengan satu paket',
    theGiftPackageIsOnlyValidForMeituanDirectConnectionProducts:
      'Paket hadiah hanya berlaku untuk produk Meituan direct',
    packageDescription: 'Deskripsi paket',
    allProducts2: 'Semua produk',
    modifiedGiftPack: 'Ubah paket hadiah',
    packageName: 'Nama paket',
    giftPackageGiving: 'Metode pemberian paket',
    packageType: 'Jenis paket',
    packageStatus: 'Status paket',
    activeProduct: 'Produk yang berlaku',
    createPackage: 'Buat paket',
    packageValue: 'Nilai paket',
    packageEffectiveDate: 'Tanggal berlaku paket',
    upperLimit1500: 'Batas atas 1500',
    upperLimit: 'Batas atas',
    packageDetails: 'Detail paket',
    maximum80Characters: 'Maksimal 80 karakter',
    wayOfGiving: 'Cara pemberian',
    thePackageValueCannotBeEmpty: 'Nilai paket tidak boleh kosong',
    oneDeliveryPerRoom: 'Satu kali per kamar',
    complimentaryOnceADayPerRoom: 'Gratis satu kali per hari per kamar',
    pleaseEnterThePackageName: 'Silakan masukkan nama paket',
    pleaseSelectTheGiftMethod: 'Silakan pilih metode pemberian',
    pleaseSelectAPackageType: 'Silakan pilih jenis paket',
    pleaseSelectPackageDetails: 'Silakan pilih detail paket',
    pleaseSelectAnEffectiveProduct: 'Silakan pilih produk yang berlaku',
    pleaseSelectAnEffectiveDate: 'Silakan pilih tanggal berlaku',
    whetherToDropTheGiftPackage: 'Apakah akan menonaktifkan paket hadiah',
    giftBagOffLine: 'Paket hadiah dinonaktifkan',
    offlineSuccess: 'Berhasil dinonaktifkan',
    offlineFailure: 'Gagal dinonaktifkan',
    methodOfCancellation: 'Metode pembatalan',
    createdSuccessfully: 'Berhasil dibuat',
    creationFailure: 'Gagal membuat',
  },
  giftLog: {
    packageOperationLog: 'Log operasi paket hadiah',
  },
  pullnewMember: {
    memberInformationEntry: 'Input informasi anggota',
    areRequiredFieldsOtherFieldsAreNotRequired: 'adalah wajib, kolom lainnya tidak wajib',
    idNumber: 'Nomor identitas',
    inputResult: 'Hasil input',
    recordSuccessfully: 'Berhasil dicatat',
    entryFailure: 'Gagal dicatat',
    memberSale: 'Promo anggota',
    enter: 'Input',
    passport: 'Paspor',
    pleaseEnterTheIdNumber: 'Silakan masukkan nomor identitas',
    theNameFormatIsIncorrect: 'Format nama tidak benar',
    theMobilePhoneNumberCannotBeEmpty: 'Nomor ponsel tidak boleh kosong',
    theMobilePhoneNumberFormatIsIncorrect: 'Format nomor ponsel tidak benar',
    theFormatOfTheIdCardNumberIsIncorrect: 'Format nomor KTP tidak benar',
    memberInformationEnteredSuccessfully: 'Informasi anggota berhasil dimasukkan',
  },
  pullnewNewlist: {
    promoter: 'Promotor',
    pullTime: 'Waktu akuisisi',
    pleaseEnterYourPromoterName: 'Silakan masukkan nama promotor',
    memberNickname: 'Nama panggilan anggota',
    pulsingType: 'Jenis akuisisi',
  },
  pullnewQrcode: {
    aboutHalfA4: 'Sekitar setengah kertas A4',
    sizeLarge: 'Besar',
    sizeSmall: 'Kecil',
    sizeMedium: 'Sedang',
    lShapedStand: 'Stand bentuk L',
    paperSize: 'Ukuran kertas',
    downloadPicture: 'Unduh gambar',
    memberPullNewCodeGenerationPleaseWait: 'Kode akuisisi anggota sedang dibuat, mohon tunggu',
    memberPoster: 'Poster anggota',
    frontDeskStaff: 'Staf front desk',
    foreground: 'Front desk',
    commonArea: 'Area publik',
    corridor: 'Koridor',
    elevator: 'Lift',
    displayStand: 'Rak display',
  },
  tiktokpresalecouponDetail: {
    name: 'Nama',
    totalGoodsPrice: 'Total harga produk (harga coret)',
    uploadImageTips:
      'Unggah 1–5 gambar, ukuran maksimal 5M; resolusi disarankan 375×280px; rasio 4:3',
    unavailableCheckInDates: 'Tanggal tidak tersedia untuk check-in:',
    otherInStoreOffers: 'Dapat menikmati promo lain di toko (detail hubungi merchant)',
    createACoupon: 'Buat kupon prajual',
    support: 'Didukung',
    nonsupport: 'Tidak didukung',
    putUp: 'Menginap',
    bindAvailableProducts: 'Ikat produk yang tersedia',
    bindAtLeastOneProduct: 'Harus mengikat minimal satu produk',
    meal: 'Makanan',
    addMeal: 'Tambah makanan',
    courteousReception: 'Layanan tambahan',
    addItem: 'Tambah item',
    unlimitedInventory: 'Inventori tidak terbatas',
    stockLimit: 'Batas inventori',
    whenAutomaticExtensionIsEnabledTheProductWillBeAutomaticallyExtendedFor30DaysAfterTheExpirationDate:
      'Saat perpanjangan otomatis diaktifkan, masa penjualan produk akan otomatis diperpanjang 30 hari setelah tanggal berakhir',
    namedDate: 'Tanggal tertentu',
    specifiedDays: 'Jumlah hari tertentu',
    fromTheDateOfPurchase: 'Sejak tanggal pembelian',
    availableWithinDays: 'Berlaku dalam (hari)',
    unavailableWeek: 'Hari tidak tersedia',
    unavailableHolidays: 'Hari libur tidak tersedia',
    unavailableDate: 'Tanggal tidak tersedia',
    subjectToAMarkup: 'Perlu biaya tambahan',
    noMarkup: 'Tanpa biaya tambahan',
    allStores: 'Semua properti',
    addMarkupRules: 'Tambah aturan biaya tambahan',
    limitOnePurchasePerOrder: 'Satu per pesanan',
    purchaseLimitPerPerson: 'Batas pembelian per orang',
    maximumPurchasePerPerson: 'Maksimal pembelian per orang',
    zhang: 'Lembar',
    noAdvanceReservationRequired: 'Tidak perlu reservasi terlebih dahulu',
    advanceReservationRequired: 'Perlu reservasi terlebih dahulu',
    aheadOfSchedule: 'Lebih awal',
    dailyReservation: 'Hari reservasi',
    beforeCheckIn: 'Sebelum check-in',
    cannotBeCombinedWithOtherInStoreOffers: 'Tidak dapat digabungkan dengan promo toko lainnya',
    theMealTypeCannotBeEmpty: 'Jenis makanan tidak boleh kosong',
    theNameOfTheOfferCannotBeEmpty: 'Nama layanan tambahan tidak boleh kosong',
    ticketName: 'Nama kupon prajual',
    pleaseEnterTicketNamemaximum24Words:
      'Silakan masukkan nama kupon prajual (maksimal 60 karakter)',
    fractionalAppointment: 'Reservasi bertahap',
    commodityContent: 'Konten produk',
    lunch: 'Makan siang',
    automaticExtension: 'Perpanjangan otomatis',
    availabilityDate: 'Tanggal tersedia untuk check-in',
    markUpPolicy: 'Kebijakan biaya tambahan',
    additionalChargesApply: 'Item berbiaya tambahan',
    purchaseRestrictionRule: 'Aturan pembatasan pembelian',
    reservationRule: 'Aturan reservasi',
    upload110PicturesImageSize5mOrLessRecommendedResolution375280pxImageRatio:
      'Unggah 1–10 gambar, ukuran maksimal 5M; resolusi disarankan 375×280px; rasio gambar',
    preSaleTicketHeadChart: 'Gambar header kupon prajual',
    longMapOfAdvanceTickets: 'Gambar panjang kupon prajual',
    reservationValidity: 'Masa berlaku reservasi',
    markupStore: 'Properti dengan biaya tambahan',
    markupSession: 'Periode biaya tambahan',
    unit: 'Satuan',
    pleaseEnterTheUnit: 'Silakan masukkan satuan',
    priceyuan: 'Harga ',
    cancellationRules: 'Aturan pembatalan reservasi',
    rulesOfUse: 'Aturan penggunaan',
    otherDescriptiveInformation: 'Informasi penjelasan lainnya',
    pleaseEnterAdditionalExplanatoryInformation: 'Silakan masukkan informasi penjelasan tambahan',
    found: 'Buat',
    picturePreview: 'Pratinjau gambar',
    theNameOfTheVoucherCannotBeEmpty: 'Nama voucher prajual tidak boleh kosong',
    theNameOfTheVoucherCannotExceed24Characters:
      'Nama voucher prajual tidak boleh melebihi 60 karakter',
    pleaseSelectASaleDate: 'Silakan pilih tanggal penjualan',
    pleaseSelectTheReservationValidityPeriod: 'Silakan pilih masa berlaku reservasi',
    pleaseSelectTheHeaderDiagram: 'Silakan pilih gambar header',
    pleaseSelectALongMap: 'Silakan pilih gambar panjang',
    thePurchaseLimitPerPersonCanOnlyBeANumber: 'Batas pembelian per orang harus berupa angka',
    pleaseFillInTheLengthOfStay: 'Silakan isi durasi menginap',
    mealPriceMustBeGreaterThan: 'Harga makanan harus lebih besar dari',
    theCourtesyPriceMustBeGreaterThan: 'Harga layanan tambahan harus lebih besar dari',
    theTotalPriceOfTheGoodsCannotBeEmpty: 'Total harga produk tidak boleh kosong',
    theTotalPriceOfTheGoodsMustBeGreaterThan: 'Total harga produk harus lebih besar dari',
    pleaseFillInTheActualPricePaidByTheGuest: 'Silakan isi harga yang benar-benar dibayar tamu',
    theActualPricePaidMustBeGreaterThan: 'Harga yang dibayar tamu harus lebih besar dari',
    theActualPricePaidByTheGuestCannotBeGreaterThanTheTotalPriceOfTheProduct:
      'Harga yang dibayar tamu tidak boleh lebih besar dari total harga produk',
    youCanOnlyUploadPictureFiles: 'Hanya dapat mengunggah file gambar',
    pleaseUploadAtLeast1HeaderImage: 'Silakan unggah minimal 1 gambar header',
    pleaseUploadAtLeast1LongPicture: 'Silakan unggah minimal 1 gambar panjang',
    pleaseEnterTheMaximumPurchasePerPerson: 'Silakan masukkan jumlah maksimum pembelian per orang',
    pleaseFillInTheDailyLimit: 'Silakan isi batas harian',
    confirmTheDateToDeleteThis: 'Konfirmasi penghapusan tanggal ini',
    confirmToDeleteThisProduct: 'Konfirmasi hapus produk ini',
    confirmToDeleteThisMeal: 'Konfirmasi hapus makanan ini',
    removeMarkupRules: 'Hapus aturan biaya tambahan',
    confirmToRemoveThisMarkupPolicy: 'Konfirmasi hapus kebijakan biaya tambahan ini',
    newMarkupRules: 'Tambah aturan biaya tambahan',
    confirmToDeleteThisOffer: 'Konfirmasi hapus layanan tambahan ini',
    addProjectData: 'Tambah data proyek',
    popUpsAreClosed: 'Popup telah ditutup',
    beSureToRemoveThisRestriction: 'Apakah yakin ingin menghapus pembatasan ini',
    imageUploadFailed: 'Unggah gambar gagal',
  },
  tiktokpresalecouponList: {
    deleteConfirm: 'Setelah dihapus, produk tidak dapat dipulihkan. Yakin ingin menghapus?',
    shelveConfirm: 'Setelah diturunkan, produk tidak dapat dijual. Yakin ingin menurunkan?',
    unrestrictedInventory: 'Inventori tidak dibatasi',
    theRemovalHasBeenCancelled: 'Penurunan dibatalkan',
    productId: 'ID produk',
    product: 'Produk',
    createACoupon: 'Buat voucher prajual',
    listing: 'Naikkan',
    delist: 'Turunkan',
    auditFailure: 'Audit gagal',
    soldInventory: 'Inventori terjual',
    modifiedPricePool: 'Ubah kumpulan harga',
    copy: 'Salin',
    exportListOfPreSaleTickets: 'Ekspor daftar voucher prajual',
    itemDeletion: 'Penghapusan produk',
    goodsOffTheProductionLine: 'Produk diturunkan',
    removedSuccessfully: 'Berhasil diturunkan',
  },
  assemblyAddpriceruledialog: {
    allStores: 'Semua properti',
    byDate: 'Berdasarkan tanggal',
    byHoliday: 'Berdasarkan hari libur',
    addMarkupRules: 'Tambah aturan biaya tambahan',
    markupStore: 'Properti dengan biaya tambahan',
    markUpPeriod: 'Periode biaya tambahan',
    pleaseEnterTheAmountOfTheIncrease: 'Silakan masukkan jumlah biaya tambahan',
    theIncreaseMustBeGreaterThan: 'Biaya tambahan harus lebih besar dari',
    pleaseSelectTheIncreasePeriod: 'Silakan pilih periode biaya tambahan',
    pleaseSelectAFestival: 'Silakan pilih hari libur',
    pleaseSelectTheWeekOfIncrease: 'Silakan pilih hari kenaikan harga',
  },
  assemblyAddmeals: {
    addMeal: 'Tambah makanan',
    typeOfMeal: 'Jenis makanan',
    pleaseSelectTheTypeOfMeal: 'Silakan pilih jenis makanan',
    lunch: 'Makan siang',
    dinner: 'Makan malam',
    copies: 'Porsi',
    pleaseEnterTheNumberOfCopies: 'Silakan masukkan jumlah porsi',
    theNumberOfCopiesMustBeGreaterThan: 'Jumlah porsi harus lebih besar dari',
  },
  settingHardware: {
    hardwareManagementToBeDeveloped: 'Manajemen perangkat keras, dalam pengembangan',
  },
  settingMessage: {
    messageManagementToBeDeveloped: 'Manajemen pesan, dalam pengembangan',
  },
  baseinfotabBase: {
    orientation: 'Lokasi',
    china: 'Tiongkok',
    province: 'Provinsi',
    hotelRating: 'Peringkat hotel',
    detailedAddress: 'Alamat lengkap',
    city: 'Kota',
    hotelPrice: 'Harga hotel',
    hotelReceptionCellPhone: 'Ponsel resepsionis hotel',
    hotelFrontDesk: 'Telepon meja depan hotel',
    areaCode: 'Kode area',
    landlineNumber: 'Nomor telepon tetap',
    extensionNumber: 'Nomor ekstensi',
    serviceStatus: 'Status layanan',
    ctripHotelStars: 'Peringkat hotel Ctrip',
    noStarLevel: 'Tanpa bintang',
    starLevel: '{num} Bintang',
    whetherToSellItOnTheInternet: 'Apakah dijual secara online',
    currency: 'Mata uang',
    longitude: 'Garis bujur',
    latitude: 'Garis lintang',
    baiduLatitudeAndLongitude: 'Lintang & bujur Baidu',
    pleaseEnterTheCorrectPhoneNumberWithAMaximumOf11Digits:
      'Silakan masukkan nomor ponsel yang benar, maksimal 11 digit',
    theLengthIs78Characters: 'Panjang 7–8 karakter',
    theLengthIs34Characters: 'Panjang 3–4 karakter',
    pleaseEnterAnInteger: 'Silakan masukkan bilangan bulat',
    pleaseEnterTheHotelName: 'Silakan masukkan nama hotel',
    lengthOf250ChineseCharacters: 'Panjang 2–50 karakter',
    theValueContains34Digits: 'Panjang 3–4 digit',
    theValueContains78Characters: 'Panjang 7–8 digit',
    pleaseEnterTheValue: 'Silakan masukkan nilai',
    pleaseSelectAProvince: 'Silakan pilih provinsi',
    pleaseSelectCity: 'Silakan pilih kota',
    pleaseSelectACounty: 'Silakan pilih distrik/kabupaten',
    pleaseEnterTheFullAddress2: 'Silakan masukkan alamat lengkap',
    theDetailedAddressDoesNotExceed50ChineseCharacters:
      'Alamat lengkap tidak boleh melebihi 50 karakter',
    pleaseSelectHotelClass: 'Silakan pilih kelas hotel',
    pleaseSelectACtripHotelStar: 'Silakan pilih peringkat hotel Ctrip',
    selectWhetherTheExternalNetworkIsVisible:
      'Silakan pilih apakah ditampilkan di jaringan eksternal',
    pleaseSelectHotelServiceStatus: 'Silakan pilih status layanan hotel',
    economical: 'Ekonomis',
    quasi1Star: 'Semi 1 bintang',
    true1Star: '1 bintang',
    quasi2Star: 'Semi 2 bintang',
    true2Star: '2 bintang',
    quasi3Star: 'Semi 3 bintang',
    true3Star: '3 bintang',
    quasi4Star: 'Semi 4 bintang',
    true4Star: '4 bintang',
    quasi5Star: 'Semi 5 bintang',
    true5Star: '5 bintang',
    inOperation: 'Beroperasi',
    suspendBusiness: 'Operasional ditangguhkan',
    tencentMapLatitudeAndLongitudeCanNotBeEmpty: 'Lintang dan bujur Tencent Map tidak boleh kosong',
    theNameAndAddressOfTheHotelAreUnderReview: 'Nama dan alamat hotel sedang dalam peninjauan',
    districtcounty: 'Distrik/Kabupaten',
    tencentamapLatitudeAndLongitude: 'Lintang & bujur Tencent/Amap',
    pleaseEnterTheCorrectPhoneNumberAndTheMaximumIs11Digits:
      'Silakan masukkan nomor ponsel yang benar, maksimal 11 digit',
  },
  baseinfotabFull: {
    hotelTimezone: 'Zona waktu hotel',
    fixedRoomNumber: 'Apakah jumlah kamar tetap',
    businessCircle: 'Kawasan bisnis',
    hotelBuildingHeight: 'Tinggi gedung hotel',
    subordinateBusinessCircle: 'Sub kawasan bisnis',
    totalNumberOfRooms: 'Jumlah total kamar',
    hotelOpeningHours: 'Waktu pembukaan hotel',
    pleaseSelectADate5: 'Silakan pilih tahun & bulan',
    affiliatedGroup: 'Grup afiliasi',
    hotelRenovationTime: 'Waktu renovasi hotel',
    affiliatedBrand: 'Merek afiliasi',
    hotelTypeupToThree: 'Jenis hotel (maksimal 3)',
    hotelThemeupToThreeCanBeSelected: 'Tema hotel (maksimal 3)',
    settlementMethod: 'Metode penyelesaian',
    hotelProfile: 'Profil hotel',
    hotelTransportationLocation: 'Lokasi & akses transportasi',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan3Digits:
      'Masukkan angka ≥ 0 dan maksimal 3 digit',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan2Digits:
      'Masukkan angka ≥ 0 dan maksimal 2 digit',
    pleaseEnterADescriptionOfTheHotelWithAMaximumLengthOf800Characters:
      'Masukkan profil hotel, maksimal 800 karakter',
    pleaseEnterTheHotelTransportationLocation: 'Silakan masukkan lokasi & akses transportasi hotel',
    pleaseEnterTheHotelTransportationLocationInAMaximumOf800Characters:
      'Masukkan lokasi & akses transportasi hotel, maksimal 800 karakter',
    pleaseEnterTheTotalNumberOfRooms: 'Silakan masukkan jumlah total kamar',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan3Digits2:
      'Masukkan angka ≥ 0 dan maksimal 3 digit',
    pleaseSelectYourBrand: 'Silakan pilih merek afiliasi',
    pleaseEnterTheHotelBuildingHeight: 'Silakan masukkan tinggi gedung hotel',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan2Digits2:
      'Masukkan angka ≥ 0 dan maksimal 2 digit',
    pleaseEnterHotelRenovationTime: 'Silakan masukkan waktu renovasi hotel',
    pleaseEnterHotelOpeningHours: 'Silakan masukkan waktu pembukaan hotel',
    pleaseEnterTheCheckoutSupportCardType:
      'Silakan masukkan jenis kartu yang didukung saat check-out',
    pleaseSelectHotelType: 'Silakan pilih jenis hotel',
    pleaseSelectAHotelTheme: 'Silakan pilih tema hotel',
    bizumi: 'Bizumi',
    theBusinessCircleIsUnderReview: 'Kawasan bisnis sedang dalam peninjauan',
    includesButNotLimitedToHotelAddressHotelFacilitiesHotelServicesProvidedHotelFeaturesAndAdvantages:
      'Termasuk namun tidak terbatas pada: alamat hotel, fasilitas, layanan, fitur dan keunggulan hotel',
    includesButNotLimitedToTrafficFacilitiesNearTheHotelSuchAsDistanceFromTheBusStation100MetersDistanceFromTheHighSpeedTrainStation25Km:
      'Termasuk namun tidak terbatas pada: fasilitas transportasi di sekitar hotel, misalnya jarak 100 m dari halte bus, 2,5 km dari stasiun kereta cepat',
  },
  baseinfotabInfo: {
    commission2: 'Pajak & biaya',
    bookingInstructions: 'Petunjuk pemesanan',
    variousFaults: 'Berbagai gangguan',
    earliestCheckInTime: 'Waktu check-in paling awal',
    latestDepartureTime: 'Waktu check-out paling akhir',
    hourRoomEarliestCheckInTime: 'Waktu check-in paling awal kamar per jam',
    hourRoomLatestCheckOutTime: 'Waktu check-out paling akhir kamar per jam',
    aMaximumOf30Characters: 'Maksimal 30 karakter',
    taxTitle: 'Nama pajak/biaya',
    chargingStandard: 'Standar penagihan',
    reservationNotes: 'Catatan pemesanan',
    chineseDescription: 'Deskripsi bahasa Mandarin',
    pleaseEnterYourEarliestCheckInTime: 'Silakan masukkan waktu check-in paling awal',
    pleaseEnterTheLatestDepartureTime: 'Silakan masukkan waktu check-out paling akhir',
    pleaseEnterTheEarliestCheckInTimeForTheHourRoom:
      'Silakan masukkan waktu check-in paling awal untuk kamar per jam',
    pleaseEnterTheLatestCheckOutTimeForTheHourRoom:
      'Silakan masukkan waktu check-out paling akhir untuk kamar per jam',
    pleaseSelectTheBookingInstructions: 'Silakan pilih petunjuk pemesanan',
    noMoreThan10ChineseCharactersInLength: 'Panjang tidak melebihi 10 karakter',
    theLengthCannotExceed20Characters: 'Panjang tidak melebihi 20 karakter',
    noMoreThan20ChineseCharactersInLength: 'Panjang tidak melebihi 20 karakter',
    noMoreThan30ChineseCharactersInLength: 'Panjang tidak melebihi 30 karakter',
    theLengthCannotExceed60Characters: 'Panjang tidak melebihi 60 karakter',
    cutOffTheWaterSupply: 'Pemadaman air',
    powerFailure: 'Pemadaman listrik',
    elevatorFailure: 'Kerusakan lift',
    cantUseBankCard: 'Tidak dapat menggunakan kartu bank',
    networkFault: 'Gangguan jaringan',
    pleaseEnterTheStartTimeAndEndTime: 'Silakan masukkan waktu mulai dan waktu akhir',
    theStartTimeMustBeYoungerThanTheEndTime: 'Waktu mulai harus lebih awal dari waktu akhir',
  },
  baseinfotabServer: {
    squareMeter: 'Meter persegi',
    parkingLot: 'Area parkir',
    elevator2: 'Lift',
    pleaseEnterArea: 'Silakan masukkan luas',
    internetAccessInPublicAreas: 'Akses internet di area publik',
    hotelFacilities: 'Fasilitas hotel',
    otherFacilities: 'Fasilitas lainnya',
    hotelService: 'Layanan hotel',
    otherServices: 'Layanan lainnya',
    fallow: 'Rekreasi',
    otherLeisure: 'Rekreasi lainnya',
    pleaseEnterAMaximumOf10DigitsInEnglish: 'Silakan masukkan maksimal 10 karakter (huruf/angka)',
    pleaseSelectParking: 'Silakan pilih area parkir',
    pleaseSelectTheHall: 'Silakan pilih lobi',
    pleaseEnterTheHallArea: 'Silakan masukkan luas lobi',
    pleaseSelectElevator: 'Silakan pilih lift',
    pleaseSelectPublicAreasToAccessTheInternet: 'Silakan pilih area publik dengan akses internet',
    pleaseSelectHotelFacilities: 'Silakan pilih fasilitas hotel',
    pleaseSelectHotelServices: 'Silakan pilih layanan hotel',
    pleaseSelectLeisure: 'Silakan pilih fasilitas rekreasi',
    oneToFiveStars: 'Semi 1–5 bintang',
    true15Stars: 'Bintang 1–5',
    walkUp: 'Tanpa lift',
    thereIsAnElevator: 'Dengan lift',
    lobbyless: 'Tanpa lobi',
    haveALobby: 'Dengan lobi',
    noInternetAccess: 'Tidak ada akses internet',
    freeParking: 'Parkir gratis',
    noParking: 'Tanpa parkir',
    parkingLotAvailable: 'Tersedia parkir',
    paidParking: 'Parkir berbayar',
    charge: 'Berbayar',
  },
  borrowBorrowrecord: {
    loanDate2: 'Tanggal peminjaman',
    newBorrowing: 'Tambah peminjaman',
    return: 'Pengembalian',
    cannotBeGreaterThanTheAvailableAmount: 'Tidak boleh melebihi jumlah tersedia',
    enterItemNameAndRoomNumber: 'Masukkan nama barang dan nomor kamar',
    unitPriceOfGoods2: 'Harga satuan barang',
    quantityBorrowed: 'Jumlah dipinjam',
    borrowARoom: 'Kamar peminjaman',
    dateOfReturn: 'Tanggal pengembalian',
    returnQuantity: 'Jumlah dikembalikan',
    borrowedState: 'Status peminjaman',
    amountOfCompensation: 'Jumlah kompensasi',
    serviceSuccess: 'Layanan berhasil',
    serviceFailure: 'Layanan gagal',
    reasonForRefusal: 'Alasan penolakan',
    enterAMaximumOf30Characters: 'Maksimal 30 karakter',
    returnOrNot: 'Dikembalikan atau tidak',
    hasItBeenReturned: 'Sudah dikembalikan',
    onlyNumbersGreaterThan0CanBeEntered: 'Hanya angka lebih besar dari 0 yang diperbolehkan',
    theAmountReturnedCannotBeGreaterThanOrEqualToTheAmountBorrowed:
      'Jumlah pengembalian tidak boleh lebih besar atau sama dengan jumlah dipinjam',
    upTo20Characters: 'Maksimal 20 karakter',
    pleaseEnterTheReturnQuantity: 'Silakan masukkan jumlah pengembalian',
    onLoan: 'Sedang dipinjam',
    theRoomRequestHasBeenServiced: 'Permintaan kamar telah diselesaikan',
    serviceCompletion: 'Layanan selesai',
    returned: 'Telah dikembalikan',
    noReturn: 'Belum dikembalikan',
    enterAMaximumOf9Characters: 'Maksimal 9 karakter',
    chooseToBorrowRoom: 'Pilih kamar peminjaman',
  },
  borrowBorrowset: {
    newItem: 'Tambah barang',
    usable: 'Dapat digunakan',
    notAvailable: 'Tidak tersedia',
    alreadyRemoved: 'Telah dihapus',
    enterItemName: 'Masukkan nama barang',
    unitPriceOfGoods2: 'Harga satuan barang',
    inventory: 'Inventori',
    amountBorrowed: 'Jumlah dipinjam',
    loanableQuantity: 'Jumlah dapat dipinjam',
    theNameCannotExceed9CharactersPleaseEnterANewName:
      'Nama tidak boleh lebih dari 9 karakter, silakan masukkan ulang',
    priceCannotBeLessThan0PleaseReEnter: 'Harga tidak boleh kurang dari 0, silakan masukkan ulang',
    priceCannotBeGreaterThan9999PleaseReEnter:
      'Harga tidak boleh lebih dari 9999, silakan masukkan ulang',
    theInventoryCannotBeLessThan0PleaseReEnter:
      'Inventori tidak boleh kurang dari 0, silakan masukkan ulang',
    inventoryCannotBeLessThanTheBorrowedAmountPleaseReEnter:
      'Inventori tidak boleh kurang dari jumlah dipinjam, silakan masukkan ulang',
    areYouSureYouWantToDeleteThisItem: 'Apakah Anda yakin ingin menghapus barang ini',
    areYouSureYouWantToDisableThisItem: 'Apakah Anda yakin ingin menonaktifkan barang ini',
    thisItemHasNotBeenReturnedConfirmToDelete:
      'Masih ada barang yang belum dikembalikan, konfirmasi hapus?',
  },
  businessCardIndex: {
    pleaseUploadPictures: 'Silakan unggah gambar',
    pleaseEnterRoomType: 'Silakan masukkan tipe kamar',
    uploadBackground: 'Unggah latar belakang',
    saveOperation: 'Simpan',
    uploadProfilePicture: 'Unggah foto profil',
    pleaseEnterAValidNumber: 'Silakan masukkan angka yang valid',
    businessCardType: 'Jenis kartu nama',
    currentPriceOfRoomType: 'Harga saat ini tipe kamar',
    roomTypeOriginalPrice: 'Harga awal tipe kamar',
    backgroundImage: 'Gambar latar',
    avatar: 'Avatar',
    hotelRecommendation: 'Rekomendasi hotel',
    roomTypeRecommendation: 'Rekomendasi tipe kamar',
    theNameCannotBeBlank2: 'Nama tidak boleh kosong',
    thePhoneNumberCannotBeEmpty: 'Nomor ponsel tidak boleh kosong',
    pleaseEnterAValidPhoneNumber: 'Silakan masukkan nomor ponsel yang valid',
    roomTypeNameCannotBeEmpty: 'Nama tipe kamar tidak boleh kosong',
    theCurrentPriceOfTheRoomTypeCannotBeEmpty: 'Harga saat ini tipe kamar tidak boleh kosong',
    roomTypeOriginalPriceCannotBeEmpty: 'Harga awal tipe kamar tidak boleh kosong',
    pleaseUploadTheBackgroundImage: 'Silakan unggah gambar latar',
    pleaseUploadPhoto: 'Silakan unggah foto',
    areYouSureYouWantToLeaveTheCurrentPage: 'Apakah Anda yakin ingin meninggalkan halaman ini',
    pleaseSelectImageUpload: 'Silakan pilih unggahan gambar',
    theCurrentPriceOfTheRoomTypeShallNotBeLessThan:
      'Harga saat ini tipe kamar tidak boleh kurang dari',
    roomTypeOriginalPriceMustNotBeLessThan: 'Harga awal tipe kamar tidak boleh kurang dari',
  },
  businessCardUploadavatar: {
    selectPicture: 'Pilih gambar',
    uploadProfilePicture: 'Unggah foto profil',
    pleaseSelectImageUpload: 'Silakan pilih unggahan gambar',
    onlyJpgAndPngImagesAreSupportedAndTheSizeOfTheImageDoesNotExceed5m:
      'Hanya mendukung gambar JPG/PNG dengan ukuran tidak melebihi 5 MB',
  },
  ctnhotelHotelserver: {
    applicationTime2: 'Waktu pengajuan',
    toDealWith: 'Proses',
    pleaseRenewYourStayOnTheDayOfDeparture: 'Silakan perpanjang masa menginap pada hari check-out',
    applicant: 'Pemohon',
    originalExpectedArrivalDate: 'Tanggal perkiraan kedatangan awal',
    originalDepartureDate: 'Tanggal perkiraan keberangkatan awal',
    applicationType: 'Jenis pengajuan',
    renewTheNewOrderNumber: 'Nomor pesanan baru perpanjangan',
    renewalDate: 'Tanggal perpanjangan',
  },
  ebaccountLogin: {
    accountLogin: 'Login akun',
    gotTheMessage: 'Pesan telah diterima',
  },
  ebaccountSetting: {
    accountBinding: 'Pengikatan akun',
    goToMaintain: 'Kelola',
    priceModel: 'Model harga',
    automaticOrder: 'Pemindahan pesanan otomatis',
    comingSoon: 'Segera hadir',
    hourlyRoomOrder: 'Terima pesanan kamar per jam',
    orderCancellation: 'Pembatalan pesanan',
    bound: 'Terikat',
    roomTypeSetting: 'Pengaturan tipe kamar',
    goToSettings: 'Buka pengaturan',
    lastStep: 'Langkah sebelumnya',
    correlationState: 'Status keterkaitan',
    bindAccount: 'Ikat akun',
    synchronizationTime: 'Waktu sinkronisasi',
    onSale: 'Dijual',
    associated: 'Terkait',
    uncorrelated: 'Tidak terkait',
    bind: 'Ikat',
    noDataIsQueried: 'Tidak ada data',
    whetherToUnbindTheAccount: 'Apakah akan melepas ikatan akun',
    pleaseEnterTheCommissionRate: 'Silakan masukkan tingkat komisi',
    channelSetting: 'Pengaturan saluran',
    floorPriceModel: 'Model harga dasar',
    sellingPriceModel: 'Model harga jual',
    viewSettings: 'Lihat pengaturan',
    orderSetup: 'Pengaturan pesanan',
    pleaseSelectAPriceModel: 'Silakan pilih model harga',
    pleaseSelectHourRoomPickUp: 'Silakan pilih pengaturan penerimaan kamar per jam',
    dataSynchronization: 'Sinkronisasi data',
    ctripRoomType: 'Tipe kamar Ctrip',
    usGroupRoomType: 'Tipe kamar Meituan',
    lightWinTreasureRoomTypeName: 'Nama tipe kamar LightWin Treasure',
    commissionRate: 'Tingkat komisi',
    pleaseEnterTheSmsVerificationCode: 'Silakan masukkan kode verifikasi SMS',
    pleaseEnterTheContentInThePicture: 'Silakan masukkan teks pada gambar',
    groggery: 'Hotel',
    ctripProductName: 'Nama produk Ctrip',
    meituanProductName: 'Nama produk Meituan',
    ctripProducts: 'Produk Ctrip',
    meituanProducts: 'Produk Meituan',
    lightWinTreasureProductName: 'Nama produk LightWin Treasure',
    commissionRateIsGreaterThanOrEqualTo0AndLessThan100: 'Tingkat komisi harus ≥ 0 dan < 100',
    commissionRatesAreNumericalAndReservedForTwoDecimalPlaces:
      'Tingkat komisi harus berupa angka dengan dua angka desimal',
    pleaseSelectTheHourlyOrderSetting: 'Silakan pilih pengaturan pemindahan pesanan kamar per jam',
    automaticCancellation: 'Pembatalan otomatis',
    manualCancellation: 'Pembatalan manual',
    automaticConfirmation: 'Konfirmasi otomatis',
    manualValidation: 'Konfirmasi manual',
    meituancom: 'Meituan',
    ctrip: 'Ctrip Travel',
    pleaseEnterTheImageVerificationCode: 'Silakan masukkan kode verifikasi gambar',
    pleaseSelectHotel: 'Silakan pilih hotel',
    theDataSynchronizationIsSuccessfulQueryTheDataAgain10MinutesLater:
      'Sinkronisasi data berhasil, silakan periksa kembali setelah 10 menit',
    unbind: 'Lepas ikatan',
    whetherToUnbindTheProduct: 'Apakah ingin melepas ikatan produk ini',
    pleaseSelectTheProductName: 'Silakan pilih nama produk LightWin Treasure',
    unbindSuccessfully: 'Berhasil melepas ikatan',
    whetherToUnbindTheBindingRelationshipOfTheHouseType:
      'Apakah ingin melepas ikatan tipe kamar ini',
    pleaseSelectLightWinTreasureRoomTypeName: 'Silakan pilih nama tipe kamar LightWin Treasure',
    feizhu: 'Fliggy',
    notYetUnlocked: 'Belum diaktifkan',
    pleaseBindTheAccountFirst: 'Silakan ikat akun terlebih dahulu',
    areYouSureYouWantToUnbindTheAccount: 'Apakah Anda yakin ingin melepas ikatan akun',
    notYetBound: 'Belum terikat',
    pleaseConfirmTheHotelYouWantToBindTo: 'Silakan konfirmasi hotel yang ingin diikat',
    ctripEbAccount: 'Akun EB Ctrip',
    meituanEbAccount: 'Akun EB Meituan',
    pleaseContactYourHotelOperationsManagerToSetUpACtripHotelid:
      'Silakan hubungi manajer operasional hotel untuk mengatur HotelID Ctrip',
    useEbOrderInformation: 'Gunakan informasi pesanan EB',
    pleaseSelectEbOrderCancellation: 'Silakan pilih pengaturan pembatalan pesanan EB',
    meituanEbRoomType: 'Tipe kamar EB Meituan',
    lightWinTreasureRoomTypeId: 'ID tipe kamar LightWin Treasure',
    lightWinTreasureProductId: 'ID produk LightWin Treasure',
    pleaseSelectTheEbOrderCancellationSettings: 'Silakan pilih pengaturan pembatalan pesanan EB',
    whenYouAutomaticallyMoveTheOrderIfYouDoNotSetTheRoomTypeYouWillMoveTheOrderManually:
      'Saat pemindahan pesanan otomatis, jika tipe kamar tidak disetel maka pesanan akan dipindahkan secara manual',
    whenYouManuallyMoveTheOrderYouWillBeGivenPriorityToMatchTheRoomTypeSetSavingTheTimeOfMovingTheOrder:
      'Saat pemindahan manual, sistem akan memprioritaskan pencocokan tipe kamar yang telah disetel untuk menghemat waktu',
    thisEbOrderSetupCompletedPleaseProceedAsSoonAsPossible:
      'Pengaturan pesanan EB selesai, silakan segera lanjutkan',
    reminderIfYouNeedToSetOrAddARoomTypePleaseContactYourOperationalManager:
      'Pengingat: jika perlu mengatur atau menambah tipe kamar, silakan hubungi manajer operasional Anda',
    orderSetupCompletedPleaseProceedAsSoonAsPossible:
      'Pengaturan pesanan selesai, silakan segera lanjutkan',
    yourctripTravelEbkAccountisNotBoundAndYouWillNotBeAbleTo:
      'Akun EBK “Ctrip Travel” Anda belum terikat sehingga tidak dapat melakukan',
    associationToAvoidAffectingEbMovingOrdersPleaseBindAsSoonAsPossible:
      'asosiasi. Untuk menghindari dampak pada pemindahan pesanan EB, silakan segera ikat',
    yourctripTravelEbkAccounthasExpiredAndYouWillNotBeAbleTo:
      'Akun EBK “Ctrip Travel” Anda telah kedaluwarsa sehingga tidak dapat melakukan',
    associationToAvoidAffectingEbMovingOrdersPleaseunbindAndReBindAfterThe:
      'asosiasi. Untuk menghindari dampak pada pemindahan pesanan EB, silakan lepaskan ikatan lalu ikat ulang',
    yourmeituanEbkAccountisNotBoundAndYouWillNotBeAbleTo:
      'Akun EBK “Meituan” Anda belum terikat sehingga tidak dapat melakukan',
    automaticallyCreditedToArAccount: 'Otomatis dikreditkan ke akun AR',
    noticeOfMovingOrderEb: 'Setelah pemindahan pesanan berhasil, EB otomatis menerima pesanan',
    checkInSuccessNoticeEb: 'Notifikasi check-in',
    meituanMovingOrderDeductsPublicGoods: 'Pemindahan pesanan Meituan memotong dana publik',
    meituanMovingOrderServiceRate: 'Tarif Biaya Layanan Operasional Meituan %',
    yourctripTravelEbkAccounthasExpired:
      'Akun EB Ctrip Travel Anda telah kedaluwarsa, silakan klik “Kelola” untuk mengatur ulang akun EB',
    yourmeituanEbkAccounthasExpired:
      'Akun EB Meituan Anda telah kedaluwarsa, silakan klik “Kelola” untuk mengatur ulang akun EB',
  },
  ebmanagementIndex: {
    accountBinding: 'Pengikatan akun',
    commissionRate: 'Tingkat komisi',
    theAccountIsBoundSuccessfullyAndTheInDepthOperationIsStartedSimultaneously:
      'Akun berhasil diikat dan operasi lanjutan diaktifkan secara bersamaan',
    whetherToUnbindTheAccount: 'Apakah perlu melepas ikatan akun',
    pleaseEnterTheCommissionRate: 'Silakan masukkan tingkat komisi',
    theTimeDimensionIsConsistentWithTheScreeningDateAndTheBookingAmountIsCalculatedAccordingToTheActualAmountPaidByTheGuest:
      'Dimensi waktu konsisten dengan tanggal penyaringan; jumlah pemesanan dihitung berdasarkan pembayaran aktual tamu',
    pleaseEnterTheSmsVerificationCode: 'Silakan masukkan kode verifikasi SMS',
    pleaseEnterTheContentInThePicture: 'Silakan masukkan teks pada gambar',
    groggery: 'Hotel',
    commissionRateIsGreaterThanOrEqualTo0AndLessThan100: 'Tingkat komisi harus ≥ 0 dan < 100',
    commissionRatesAreNumericalAndReservedForTwoDecimalPlaces:
      'Tingkat komisi harus berupa angka dengan dua angka desimal',
    pleaseSelectHotel: 'Silakan pilih hotel',
    pleaseEnterTheImageVerificationCode: 'Silakan masukkan kode verifikasi gambar',
    accountUntying: 'Lepas ikatan akun',
    unbindSuccessfully: 'Berhasil melepas ikatan',
    pleaseConfirmTheHotelYouWantToBindTo: 'Silakan konfirmasi hotel yang ingin diikat',
    noEbAccountHasBeenBound: 'Belum ada akun EB yang terikat',
    ebAccountLogin: 'Login Akun EB',
  },
  hardwareBluetoothlock: {
    smartDoorLock: 'Kunci pintu pintar',
    configurationFailure: 'Konfigurasi gagal',
    thisFunctionSpecificallyRefersToTheConnectionOfSmartDoorLocksSuchAsPasswordAndBluetoothWhichCanBeOpenedByUsingPasswordAndBluetoothThroughSmallProgramsAndAppsToImproveTheCustomersCheckInExperience:
      'Fungsi ini khusus untuk integrasi kunci pintar seperti kata sandi dan Bluetooth; dapat membuka pintu melalui mini program dan aplikasi menggunakan kata sandi/Bluetooth untuk meningkatkan pengalaman check-in tamu',
  },
  hardwareChoseroom: {
    selectARoom2: 'Pilih kamar',
  },
  hardwareCreatepassworddialog: {
    createPassword: 'Buat kata sandi',
    selectType: 'Pilih jenis',
    pleaseEnterAgain: 'Silakan masukkan kembali',
    validUntil: 'Berlaku hingga',
    pleaseEnterA6DigitPassword: 'Silakan masukkan kata sandi 6 digit',
    passwordIsDifferentPleaseReEnter: 'Kata sandi tidak sama, silakan masukkan kembali',
    oneTimePassword: 'Kata sandi sekali pakai',
    timePeriodCipher: 'Kata sandi periode waktu',
    offlinePassword: 'Kata sandi offline',
    longAgingOfflinePassword: 'Kata sandi offline jangka panjang',
  },
  hardwareEditpassworddialog: {
    oneTimePassword: 'Kata sandi sekali pakai',
    timePeriodCipher: 'Kata sandi periode waktu',
    offlinePasswordForALongTime: 'Kata sandi offline jangka panjang',
    offlinePassword: 'Kata sandi offline',
    recover2: 'Pulihkan',
    currentPassword: 'Kata sandi saat ini',
    pleaseEnterAgain: 'Silakan masukkan kembali',
    validUntil: 'Berlaku hingga',
    pleaseEnterA6DigitPassword: 'Silakan masukkan kata sandi 6 digit',
    passwordIsDifferentPleaseReEnter: 'Kata sandi tidak sama, silakan masukkan kembali',
    longAgingOfflinePassword: 'Kata sandi offline jangka panjang',
  },
  hardwareHousepricecard: {
    memberRightsShowStoreActivitiesShow: 'Tampilan hak anggota dan aktivitas toko',
    openThePriceBoard: 'Buka papan harga kamar',
    downloadRateBoard: 'Unduh papan harga kamar',
    failedToConfigureElectronicPriceBoard: 'Gagal mengonfigurasi papan harga elektronik',
  },
  hardwareIdcard: {
    whenTheIdCardTypeIsIdCardTheIdCardInformationCanBeReadByTheIdCardReaderAndAutomaticallyFilledIntoTheTextBox:
      'Jika jenis dokumen adalah KTP, informasi dapat dibaca oleh pembaca kartu dan diisi otomatis ke kolom',
    idCardReader: 'Pembaca kartu identitas',
    failedToConfigureTheIdCardReader: 'Gagal mengonfigurasi pembaca kartu identitas',
  },
  hardwareLock: {
    doorLockType: 'Jenis kunci pintu',
    selectiveLock: 'Pilih kunci',
    areYouSureYouWantToDeleteTheDoorLockConfigurationForThisRoom:
      'Apakah Anda yakin ingin menghapus konfigurasi kunci pintu untuk kamar ini',
    pleaseEnterRoomNumberAndEquipmentModel: 'Silakan masukkan nomor kamar dan model perangkat',
    doorLockCardPrintingRecord: 'Catatan pencetakan kartu kunci',
    roomDoorLockConfiguration2: 'Konfigurasi kunci pintu kamar',
    passwordSetting2: 'Pengaturan kata sandi',
    deviceType: 'Jenis perangkat',
    equipmentBrand: 'Merek perangkat',
    equipmentType: 'Model perangkat',
    versionNumber: 'Nomor versi',
    roomLockNumber: 'Nomor kunci kamar',
    doorLock: 'Kunci pintu',
    doorLockPower: 'Daya baterai kunci',
    editDoorLockConfiguration: 'Edit konfigurasi kunci pintu',
    selectDevice: 'Pilih perangkat',
    setTheDoorLock: 'Atur kunci pintu',
    setTheRoomLockNumber: 'Atur nomor kunci kamar',
    pleaseEnterDoorLock: 'Silakan masukkan kunci pintu',
    settingNmsParameters: 'Atur parameter NMS',
    pleaseEnterNetworkManagementParameters: 'Silakan masukkan parameter manajemen jaringan',
    traditionalDoorLock: 'Kunci pintu tradisional',
    smartDoorLock: 'Kunci pintu pintar',
    pleaseEnterTheLockId: 'Silakan masukkan ID kunci',
    pleaseEnterLockmac: 'Silakan masukkan lockMac',
    batchDelete: 'Hapus massal',
    confirmBatchDeleteText:
      'Apakah Anda yakin ingin menghapus massal konfigurasi kunci kamar yang dipilih?',
    pleaseSelectRecordsToDelete: 'Silakan pilih data yang ingin dihapus',
    batchDeleteSuccess: 'Hapus massal berhasil',
    batchDeleteFail: 'Hapus massal gagal',
  },
  hardwareLockpassword: {
    createPassword: 'Buat kata sandi',
    comeIntoForce: 'Berlaku',
    activationCode: 'Kode aktivasi',
    applicableRoom: 'Kamar yang berlaku',
    expirationDate3: 'Tanggal kedaluwarsa',
    theDoorLockThatSupportsThePasswordIsNotEnabled:
      'Kunci pintu yang mendukung kata sandi belum diaktifkan',
    passwordSetting: 'Pengaturan kata sandi',
    invalidate: 'Nonaktifkan',
    restore: 'Pulihkan',
    confirmInvalidatePassword: 'Apakah Anda yakin ingin menonaktifkan kata sandi saat ini?',
  },
  hardwareLockroom: {
    importTemplateFileName: 'Template impor kunci pintu.xlsx',
    downloadSuccess: 'Unduhan template impor kunci pintu berhasil',
    downloadFail: 'Unduhan template impor kunci pintu gagal',
    importDialogTitle: 'Impor massal kunci pintu',
    roomDoorLockConfiguration: 'Konfigurasi kunci pintu kamar',
    customRule: 'Aturan kustom',
    rule: 'Aturan',
    deviceType: 'Jenis perangkat',
    selectDevice: 'Pilih perangkat',
    empty: 'Kosong',
    selectLock: 'Pilih kunci',
    deviceBrand: 'Merek perangkat',
    deviceModel: 'Model perangkat',
    version: 'Versi',
    configurationInfo: 'Informasi konfigurasi',
    selectRoom: 'Pilih kamar',
    lockDeviceId: 'ID perangkat kunci',
    remainingPower: 'Sisa daya',
    remoteOpenDoorType: 'Metode buka pintu jarak jauh',
    gatewayOpen: 'Buka melalui gateway',
    bluetoothOpen: 'Buka melalui Bluetooth',
    rule1: 'Nomor kunci = nomor kamar',
    rule2Prefix: 'Nomor kunci =',
    rule3Prefix: 'Nomor kunci =',
    trimRoomNumber: 'Hapus digit awal nomor kamar',
    import: 'Impor',
    clickUpload: 'Klik untuk unggah',
    imported: 'Telah diimpor',
    rulePrefix: 'Aturan:',
    generateLockId: 'Hasilkan nomor kunci',
    lockIdLabel: 'ID kunci',
    roomLockNumberLabel: 'Nomor kunci kamar',
    enterRoomLockNumber: 'Masukkan nomor kunci kamar',
    enterLockId: 'Masukkan ID kunci',
    gatewayParams: 'Parameter gateway',
    enterGatewayParams: 'Masukkan parameter gateway',
    enterLockMac: 'Silakan masukkan lockMac',
    getFreeGoLock: 'Dapatkan kunci FreeGo',
  },
  hardwareNfclock: {
    thisFunctionRefersToTheDockingOfCarmenLockWhichCanImproveTheEfficiencyOfCheckInByMakingTheGuestsRoomCardThroughLightWinTreasure:
      'Fungsi ini khusus untuk integrasi kunci Carmen; kartu kamar tamu dapat dibuat melalui LightWin Treasure untuk meningkatkan efisiensi check-in',
    traditionalDoorLock: 'Kunci pintu tradisional',
    doorLockInformationConfiguration2: 'Konfigurasi informasi kunci pintu',
    functionCardManagement2: 'Manajemen kartu fungsi',
    failedToConfigureATraditionalDoorLock: 'Gagal mengonfigurasi kunci pintu tradisional',
  },
  hardwarePricecard: {
    full: 'Penuh',
    serviceHotline: 'Hotline layanan',
    downloadRateBoard: 'Unduh papan harga kamar',
  },
  hardwareSelfdevicedialog: {
    selfServiceMachinePaymentConfiguration: 'Konfigurasi pembayaran mesin swalayan',
    depositAllocationCollection: 'Konfigurasi penarikan deposit',
    orderRetentionTimeConfiguration: 'Konfigurasi waktu penahanan pesanan',
    whetherTheUnpaidOrderIsCancelledImmediately:
      'Apakah pesanan yang belum dibayar dibatalkan segera',
    minutes: 'Menit',
    checkOutArrangement: 'Pengaturan check-out',
    checkOutAccountingConfiguration: 'Konfigurasi akuntansi check-out',
    temporaryCheckOut: 'Check-out dengan pembukuan sementara',
    checkOut2: 'Check-out',
    autoAddRoomFeeConfig: 'Konfigurasi tambah biaya kamar otomatis',
    whetherToEnableAutoAddRoomFee: 'Apakah mengaktifkan tambah biaya kamar otomatis',
    occupancyConfiguration: 'Konfigurasi check-in',
    whetherToSupportHourRoomWithoutReservation: 'Apakah mendukung kamar per jam tanpa reservasi',
    supportForTimePeriodsWithoutReservation:
      'Rentang waktu yang mendukung kamar per jam tanpa reservasi',
    theSelfServiceMachineIsSuccessfullyConfigured: 'Konfigurasi mesin swalayan berhasil',
    selfServiceMachineConfiguration2: 'Konfigurasi mesin swalayan',
    pleaseFillInTheDepositConfiguration: 'Silakan isi konfigurasi deposit',
    pleaseSelectTheTimePeriodWhenTheHourRoomIsNotBooked:
      'Silakan pilih rentang waktu kamar per jam tanpa reservasi',
  },
  hardwareSelfservice: {
    selfServiceMachine: 'Mesin swalayan',
    selfServiceMachineConfiguration2: 'Konfigurasi mesin swalayan',
    failedToConfigureTheSelfServiceMachine: 'Gagal mengonfigurasi mesin swalayan',
    thereIsNoSelfServiceMachineInTheHotel: 'Hotel belum mengonfigurasi mesin swalayan',
    thisSwitchIsToOpenTheSelfServiceMachineAndPmsSystemInterfaceSwitchIfTheHotelNeedsToConnectToTheSelfServiceCheckInMachineYouNeedToTurnOnTheSwitch:
      'Sakelar ini untuk membuka antarmuka antara mesin swalayan dan sistem PMS; jika hotel perlu terhubung ke mesin check-in mandiri, aktifkan sakelar ini',
  },
  "hardwareSetWitness": {
    "title": "Perangkat Pengลnal Wajah",
    "desc": "Pengลnal wajah, check-in mandiri",
    "setting": "Pengaturan",
    "configSuccess": "Konfigurasi pengลnal wajah berhasil diaktifkan",
    "configClose": "Konfigurasi pengลnal wajah berhasil dinonaktifkan",
    "configFailed": "Konfigurasi gagal"
  },
  "hardwareWitness": {
    "deviceSnSetting": "Pengaturan Kode Perangkat",
    "deviceSn": "SN Perangkat",
    "addSn": "Tambah SN Baru",
    "enterSn": "Silakan masukkan SN",
    "addSnBtn": "+ Tambah SN",
    "saveSuccess": "Berhasil disimpan",
    "deleteSuccess": "Berhasil dihapus",
    "snRepeatError": "SN tidak boleh duplikat",
    "deleteConfirmMsg": "Apakah Anda yakin ingin menghapus SN perangkat ini?",
    "deleteConfirmTitle": "Peringatan"
  },


  hardwareSethouserpricecard: {
    transversePlate: 'Horizontal',
    verticalVersion: 'Vertikal',
    addPictureUpload: 'Tambah unggahan gambar',
    show: 'Tampilkan',
    doNotShow: 'Jangan tampilkan',
    format: 'Tata letak',
    storePicture: 'Gambar properti',
    pleaseEnterADescription: 'Silakan masukkan deskripsi',
    hourRoomRates: 'Harga kamar per jam',
    pleaseSelectTheNumberOfHours: 'Silakan pilih jumlah jam',
    whetherToDisplayMemberPrices: 'Apakah menampilkan harga anggota',
    roomReservationPhone: 'Telepon reservasi',
    pleaseEnterTheReservationNumber: 'Silakan masukkan nomor reservasi',
    bookingGuide: 'Panduan pemesanan',
    pleaseEnterThePreOrderGuideCopy: 'Silakan masukkan teks panduan pemesanan',
    hotelAnnouncement: 'Pengumuman hotel',
    pleaseEnterTheHotelBulletin: 'Silakan masukkan pengumuman hotel',
    uploadedPictures: 'Gambar yang diunggah',
    storePicturesMustBeUploaded: 'Gambar properti wajib diunggah',
    onlyJpgjepgpngFormatIsSupported: 'Hanya mendukung format jpg/jpeg/png!',
  },
  functionalcardAuthorizationcard: {
    authorizationCardBeforeReportingTheLoss: 'Kartu otorisasi sebelum dilaporkan hilang',
    authorizationCard: 'Kartu otorisasi',
    generallyOnlyOneAuthorizationCardNeedsToBeBrushedOnTheLockAndTheLockWillMakedidiTwiceToIndicateAuthorizationSuccess:
      "Biasanya cukup menggesek satu kartu otorisasi pada kunci; bunyi 'bip bip' dua kali menandakan otorisasi berhasil",
    whenTheRoomNumberOrTimeInformationOnTheLockIsLostTheRoomNumberSettingCardOrTheClockSettingCardCanBeUsedToSetTheLockOrTheAuthorizationCardCanBeBrushedThreeTimesAndTheRoomGuestCardCanBeUsedToOpenTheLock:
      'Jika nomor kamar atau informasi waktu pada kunci hilang, gunakan kartu set nomor kamar atau kartu set waktu; atau gesek kartu otorisasi 3 kali, lalu kartu tamu kamar dapat digunakan untuk membuka kunci',
  },
  functionalcardExtendssetting: {
    after: 'Setelah',
    inMinutes: 'Dalam menit',
    findRoomNumber: 'Cari nomor kamar',
    timeDeviation: 'Deviasi waktu',
    roomNumberRequired: 'Nomor kamar wajib diisi',
    whenTheRoomNumberOrTimeInformationOnTheLockIsLostTheRoomNumberSettingCardOrTheClockSettingCardCanBeUsedToSetTheLockOrTheAuthorizationCardCanBeBrushedThreeTimesAndTheRoomGuestCardCanBeUsedToOpenTheLock:
      'Jika nomor kamar atau informasi waktu pada kunci hilang, gunakan kartu set nomor kamar atau kartu set waktu; atau gesek kartu otorisasi 3 kali, lalu kartu tamu kamar dapat digunakan untuk membuka kunci',
    generallyOnlyOneAuthorizationCardNeedsToBeBrushedOnTheLockAndTheLockWillMakedidiTwiceToIndicateAuthorizationSuccess:
      "Biasanya cukup menggesek satu kartu otorisasi pada kunci; bunyi 'bip bip' dua kali menandakan otorisasi berhasil",
  },
  functionalcardIndex: {
    selectiveClassification: 'Pilih kategori',
    functionCardManagement2: 'Manajemen kartu fungsi',
    authorizationCard: 'Kartu otorisasi',
    extendedSettingsClass: 'Kelas pengaturan lanjutan',
    openCategory: 'Kategori buka pintu',
    specificFunctionClass: 'Kategori fungsi khusus',
    businessCardFailure: 'Pembuatan kartu gagal',
  },
  functionalcardOpendoor: {
    beforeTheLossWasReported: 'Sebelum dilaporkan hilang',
    publicDoorsCanBeOpened: 'Dapat membuka pintu umum',
    canOpenTheLock: 'Dapat membuka kunci ganda',
    availablePeriod: 'Periode tersedia',
    startTimeRequired: 'Waktu mulai wajib diisi',
    theEndTimeIsRequired: 'Waktu akhir wajib diisi',
    floorFill: 'Lantai wajib diisi',
    theFloorMustConsistOf4PureDigits: 'Lantai harus terdiri dari 4 digit angka',
    layerControlCardUsedToOpenAllLocksInASpecificLayerOfABuilding:
      'Kartu kontrol lantai: digunakan untuk membuka semua kunci pada lantai tertentu di suatu gedung',
    totalCardCanOpenAllLocksInThisSystem:
      'Kartu master: dapat membuka semua kunci dalam sistem ini',
  },
  functionalcardParticularfeature: {
    checkOutCardBeforeTheLossWasReported: 'Kartu check-out sebelum dilaporkan hilang',
    theMissingCardNumber: 'Nomor kartu yang hilang',
    pleaseEnterTheCardNumberToFind: 'Silakan masukkan nomor kartu untuk mencari',
    theLostCardNumberIsRequired: 'Nomor kartu yang hilang wajib diisi',
    lostCardIfACardIsLostItCanBeReportedEnterTheNumberOfTheLostCardMakeALostCardAndBrushItOnceOnTheDoorThatCanOpenTheLostCard:
      'Kartu kehilangan: jika kartu hilang, laporkan kehilangan; pilih nomor kartu yang hilang, buat kartu kehilangan, lalu gesek sekali pada kunci yang dapat dibuka oleh kartu tersebut',
    checkOutCardUsedByTheWaiterGenerallyTheWaiterHasTwoCardsOneIsTheLayerControlCardUsedToOpenTheDoorAndTheOtherIsTheCheckOutCardWhenTheGuestNotifiesTheCheckOutTheWaiterChecksTheRoomAndTheCheckOutCardIsBrushedOnceOnTheDoorThatCanOpenTheCheckOutCardThePreviousGuestCardCannotBeOpenedAndDoesNotAffectTheNewGuestCard:
      'Kartu check-out: digunakan oleh petugas; umumnya petugas memiliki dua kartu—kartu kontrol lantai untuk membuka pintu dan kartu check-out. Setelah tamu check-out dan kamar diperiksa, kartu check-out digesek sekali sehingga kartu tamu sebelumnya tidak lagi dapat membuka pintu tanpa memengaruhi kartu tamu baru',
  },
  sdkinitIndex: {
    theLockInformationIsInitializedSuccessfullyProcedure: 'Inisialisasi informasi kunci berhasil',
    afterEnteringTheCardManagement: 'Setelah masuk ke manajemen kartu',
    performTheInitialConfigurationOfDoorLockInformationFirst:
      'Silakan lakukan konfigurasi awal informasi kunci terlebih dahulu',
    hardwareDeviceType: 'Jenis perangkat keras',
    hardwareBrand: 'Merek perangkat keras',
    configurationInformation: 'Informasi konfigurasi',
    thisParameterIsMandatory: 'Informasi konfigurasi wajib diisi',
    initialConfiguration: 'Konfigurasi awal',
    doorLockInformationConfiguration2: 'Konfigurasi informasi kunci pintu',
    theDoorLockInformationIsConfiguredSuccessfully: 'Konfigurasi informasi kunci pintu berhasil',
    configurationFailure: 'Konfigurasi gagal',
  },
  hotelBaseInfo: {
    basicInformation3: 'Informasi dasar',
    detailedInformation: 'Informasi detail',
    hotelFacilitiesAndServices: 'Fasilitas dan layanan hotel',
    hotelPoliciesAndNotices: 'Kebijakan dan pemberitahuan hotel',
  },
  hotelFloor: {
    floorInformationToBeDeveloped: 'Informasi lantai, dalam pengembangan',
  },
  hotelPicture: {
    acquiesce: 'Default',
    theLatestTime: 'Terbaru',
    theFarthestTime: 'Terlama',
    batchDeletion: 'Hapus massal',
    undelete: 'Batalkan penghapusan',
    cover: 'Sampul',
    firstMap: 'Gambar utama',
    setAsHotelCover: 'Tetapkan sebagai sampul hotel',
    noPictureInformationIsAvailable: 'Tidak ada informasi gambar',
    submit2: 'Kirim',
    photoEditor: 'Editor foto',
    setAsTheFirstPictureOfTheRoomType: 'Tetapkan sebagai gambar utama tipe kamar',
    recentRevision: 'Perubahan terbaru',
    appearance: 'Tampilan luar',
    guestRoom: 'Kamar tamu',
    publicFacilities: 'Fasilitas umum',
    catering: 'Katering',
    surroundingEnvironment: 'Lingkungan sekitar',
    theCoverImageAndFirstImageCannotBeDeletedDirectly:
      'Gambar sampul dan gambar utama tidak dapat dihapus langsung',
    areYouSureToDeleteThePicture: 'Apakah Anda yakin ingin menghapus gambar',
    operate: 'Operasi',
    pleaseSelectAtLeastOnePicture: 'Silakan pilih minimal satu gambar',
    pleaseSelectCategory: 'Silakan pilih kategori',
    pleaseUploadThePictureSuccessfullyBeforeSubmitting:
      'Silakan unggah gambar dengan sukses sebelum mengirim',
    imagesCannotBeUploadedInBatchEditingMode:
      'Tidak dapat mengunggah gambar dalam mode edit massal',
    pleaseUploadThePictureSuccessfullyBeforeSubmitting: 'Silakan unggah gambar dengan sukses sebelum mengirim',
    imagesCannotBeUploadedInBatchEditingMode: 'Tidak dapat mengunggah gambar dalam mode edit massal',
    logoOnlyOne: 'Hanya satu gambar Logo yang dapat diunggah',
    logoSizeLimit: 'Ukuran gambar Logo tidak boleh melebihi 500KB',
    logoRatioError: 'Logo harus berupa gambar persegi dengan rasio 1:1. Ukuran saat ini: {width}×{height}',
  },
  assemblyModifyinventoryprice: {
    unlimitedInventory: 'Inventori tanpa batas',
    stockLimit: 'Batas inventori',
    modifiedPricePool: 'Ubah kumpulan harga',
    soldInventory: 'Inventori terjual',
  },
  hotelPreview: {
    viewPicture: 'Lihat gambar',
  },
  hotelRoomType: {
    batchImportRoomType: 'Impor tipe kamar massal',
    importTemplateFileName: 'Template impor tipe kamar.xlsx',
    downloadSuccess: 'Unduhan template impor tipe kamar berhasil',
    downloadFail: 'Unduhan template impor tipe kamar gagal',
    newHousingType: 'Buat tipe kamar',
    partialWindow: 'Jendela sebagian',
    skylight: 'Jendela atap',
    closedWindow: 'Jendela tertutup',
    bayWindow: 'Jendela menjorok',
    hotelCode: 'Kode hotel',
    roomTypeCode: 'Kode tipe kamar',
    externalRoomTypeCode2: 'Kode tipe kamar eksternal',
    whetherToSellOnline: 'Apakah dijual online',
    bedType2: 'Tipe tempat tidur',
  },
  hotelRoom: {
    newRoom: 'Buat kamar',
    pleaseArrangeTheRoomInformationAccordingToTheRequirementsInTheTemplate:
      'Silakan susun informasi kamar sesuai persyaratan pada template',
    downloadTemplate: 'Unduh template',
    downloadFailureData: 'Unduh data gagal',
    batchImport: 'Impor massal',
    floor2: 'Lantai',
    building: 'Gedung',
    housingType: 'Tipe kamar',
    faceEast: 'Menghadap timur',
    faceWest: 'Menghadap barat',
    faceSouth: 'Menghadap selatan',
    faceNorth: 'Menghadap utara',
    stayAwayFromElevators: 'Jauh dari lift',
    nearTheStairs: 'Dekat tangga',
    closeToTheRoad: 'Dekat jalan',
    windowWall: 'Dinding luar jendela',
    decorativeFalseWindow: 'Jendela dekoratif palsu',
    theRoomNumberCannotBeEmpty: 'Nomor kamar tidak boleh kosong',
    theFloorOnWhichTheRoomIsLocatedCannotBeEmpty: 'Lantai tempat kamar berada tidak boleh kosong',
    theRoomTypeCannotBeEmpty: 'Tipe kamar tidak boleh kosong',
    editSuccessfully: 'Berhasil diedit',
    newSuccess: 'Berhasil ditambahkan',
    theHouseTypeAndNameCannotBeEmptyTheFloorWhereTheHouseResidesCannotBeEmpty:
      'Tipe kamar dan nama tidak boleh kosong, lantai tempat kamar berada tidak boleh kosong',
    currentLimitSelect1FilePleaseRemoveAndAdd:
      'Saat ini hanya dapat memilih 1 file, silakan hapus lalu tambahkan kembali',
    definitiveRemoval: 'Konfirmasi hapus',
    abnormalDataInformationTemplate: 'Template informasi data abnormal',
    xlsFormatOnly: 'Hanya mendukung file format XLS',
    dataCannotBeRecoveredAfterDeletingTheRoomAreYouSureToDeleteIt:
      'Setelah kamar dihapus, data tidak dapat dipulihkan. Apakah Anda yakin ingin menghapusnya',
  },
  hotelTypedetail: {
    newHousingType: 'Buat tipe kamar baru',
    editRoomType: 'Edit tipe kamar',
    viewRoomType: 'Lihat tipe kamar',
    basicInformation3: 'Informasi dasar',
    squareMeter: 'Meter persegi',
    bedSize: 'Ukuran tempat tidur',
    extraBedCondition: 'Kondisi tempat tidur tambahan',
    internetAccess: 'Akses internet',
    roomTypeFacilities: 'Fasilitas tipe kamar',
    roomTypeStatus: 'Status tipe kamar',
    saveAndSubmit: 'Simpan dan kirim',
    roomTypeNameAMaximumOf30Characters: 'Nama tipe kamar maksimal 30 karakter',
    floorArea: 'Luas bangunan',
    roomTypeEnglishName: 'Nama tipe kamar (Inggris)',
    floorType: 'Jenis lantai',
    floor2: 'Lantai',
    pleaseEnter1511: 'Silakan masukkan -1, 5, 11',
    chineseRemarks: 'Catatan (Bahasa Mandarin)',
    capacity: 'Kapasitas',
    englishRemarks: 'Catatan (Bahasa Inggris)',
    externalRoomTypeCode2: 'Kode tipe kamar eksternal',
    extraBed: 'Tempat tidur tambahan',
    internetAccess2: 'Akses internet tersedia',
    roomInternetInformation: 'Informasi internet kamar',
    broadbandTariff: 'Tarif broadband',
    disposableToiletries: 'Perlengkapan mandi sekali pakai',
    bathroomType: 'Jenis kamar mandi',
    numberOfToilets: 'Jumlah kamar mandi',
    computer: 'Komputer',
    showerRoom: 'Ruang mandi',
    smokeFreeInformation: 'Informasi bebas rokok',
    bathroom: 'Kamar mandi',
    pleaseEnterAnIntegerWithNoMoreThanTwoDigits:
      'Silakan masukkan bilangan bulat maksimal dua digit',
    pleaseEnterAnIntegerGreaterThan0: 'Silakan masukkan bilangan bulat lebih besar dari 0',
    dataDuplicationPleaseConfirm: 'Data duplikat, silakan konfirmasi',
    pleaseEnterAValueOfAThreeDigitIntegerUpTo500:
      'Silakan masukkan bilangan bulat tiga digit maksimal 500',
    enterAMaximumOfTwoDecimalsAndAMaximumOf6Characters:
      'Maksimal dua angka desimal dan tidak lebih dari 6 karakter',
    pleaseEnterBuildingArea: 'Silakan masukkan luas bangunan',
    pleaseEnterTheCapacity: 'Silakan masukkan kapasitas',
    pleaseEnterAnIntegerOfUpToTwoDigits: 'Silakan masukkan bilangan bulat maksimal dua digit',
    roomTypeNameCannotBeEmpty: 'Nama tipe kamar tidak boleh kosong',
    theLengthOfRoomNameShouldNotExceed30ChineseCharacters:
      'Panjang nama tipe kamar tidak boleh melebihi 30 karakter',
    theLengthCannotExceed30Characters: 'Panjang tidak boleh melebihi 30 karakter',
    theTotalNumberOfRoomsCannotBeEmpty: 'Jumlah total kamar tidak boleh kosong',
    theLengthCannotExceed60Characters: 'Panjang tidak boleh melebihi 60 karakter',
    pleaseSelectBedSize: 'Silakan pilih ukuran tempat tidur',
    pleaseSelectWindowType: 'Silakan pilih jenis jendela',
    pleaseSelectRoomTypeStatus: 'Silakan pilih status tipe kamar',
    pleaseSelectExtraBedCondition: 'Silakan pilih kondisi tempat tidur tambahan',
    pleaseSelectWhetherYouCanAccessTheInternet: 'Silakan pilih apakah tersedia akses internet',
    pleaseSelectAPhone: 'Silakan pilih telepon',
    pleaseSelectDisposableToiletries: 'Silakan pilih perlengkapan mandi sekali pakai',
    pleaseSelectABathroomType: 'Silakan pilih jenis kamar mandi',
    pleaseSelectTheNumberOfBathrooms: 'Silakan pilih jumlah kamar mandi',
    pleaseSelectComputer: 'Silakan pilih komputer',
    pleaseSelectABathRoom: 'Silakan pilih ruang mandi',
    pleaseSelectSmokeFreeInformation: 'Silakan pilih informasi bebas rokok',
    pleaseSelectOther: 'Silakan pilih lainnya',
    pleaseSelectBathroom: 'Silakan pilih kamar mandi',
    commonFloor: 'Lantai umum',
    executiveFloor: 'Lantai eksekutif',
    businessFloor: 'Lantai bisnis',
    noExtraBed: 'Tidak tersedia tempat tidur tambahan',
    freeExtraBed: 'Tempat tidur tambahan gratis',
    payExtraBed: 'Tempat tidur tambahan berbayar',
    haveInternetAccess: 'Tersedia akses internet',
    someInternetAccess: 'Sebagian tersedia akses internet',
    noInternetAccess: 'Tidak tersedia akses internet',
    freeWireless: 'Wi-Fi gratis',
    tollWireless: 'Wi-Fi berbayar',
    freeWire: 'Kabel gratis',
    tollWire: 'Kabel berbayar',
    nationalTollCall: 'Panggilan jarak jauh domestik',
    internationalCall: 'Panggilan internasional',
    freeDomesticLongDistanceCalls: 'Panggilan jarak jauh domestik gratis',
    disposableToiletriesAreNotProvided: 'Perlengkapan mandi sekali pakai tidak disediakan',
    disposableToiletriesAreProvidedForFree: 'Perlengkapan mandi sekali pakai gratis',
    disposableToiletriesAreProvidedForAFee: 'Perlengkapan mandi sekali pakai berbayar',
    indoor: 'Dalam ruangan',
    commonality: 'Umum',
    aroom: 'Satu kamar',
    twoRooms: 'Dua kamar',
    moreThanTwoRooms: 'Lebih dari dua kamar',
    allRoomsChargeComputers: 'Semua kamar komputer berbayar',
    freeComputersInAllRooms: 'Semua kamar komputer gratis',
    freeComputersInSomeRooms: 'Sebagian kamar komputer gratis',
    nonSmokingRoomsAreNotAvailable: 'Kamar bebas rokok tidak tersedia',
    nonSmokingRoomsAvailable: 'Kamar bebas rokok tersedia',
    noSmoking: 'Dilarang merokok',
    partialWindow: 'Jendela sebagian',
    skylight: 'Jendela atap',
    closedWindow: 'Jendela tertutup',
    bayWindow: 'Jendela menjorok',
    roomTypeNameAndBedSizeAreUnderReview:
      'Nama tipe kamar dan ukuran tempat tidur sedang dalam peninjauan',
    roomTypeAddedSuccessfully: 'Tipe kamar berhasil ditambahkan',
    containsAMaximumOf7CharactersOnlyDigitsCanBeEntered:
      'Maksimal 7 karakter, hanya angka yang diperbolehkan',
    pleaseEnterAnIntegerAndEnsureItsLegalitySuchAs3SquareMeters5SquareMeters:
      'Silakan masukkan bilangan bulat yang valid, contoh: 3–5 meter persegi',
    personbed: 'Orang/kamar',
  },
  managementAccountList: {
    searchAccountAndEmployeeName: 'Cari akun atau nama karyawan',
    staffPosition: 'Jabatan karyawan',
    createAnAccount: 'Buat akun',
    employeeName: 'Nama karyawan',
    employeeRole: 'Peran karyawan',
    confirmTo: 'Konfirmasi untuk',
    user: 'Pengguna',
    areYouSureYouWantToDeleteThisUser: 'Apakah Anda yakin ingin menghapus pengguna ini',
    isThisMaterial: 'apakah item ini',
  },
  managementRoleList: {
    enterARoleName: 'Masukkan nama peran',
    newRole: 'Tambah peran',
    roleName: 'Nama peran',
    roleDescription: 'Deskripsi peran',
    editorRole: 'Edit peran',
    modifyPermission: 'Ubah izin',
    deletingARole: 'Hapus peran',
    areYouSureYouWantToDeleteThisRole: 'Apakah Anda yakin ingin menghapus peran ini',
  },
  componentsCreateaneditingrole: {
    roleName: 'Nama peran',
    roleDescription: 'Deskripsi peran',
    standardPostBased: 'Berdasarkan posisi standar',
    limitsOfAuthority: 'Hak akses',
    pleaseEnterARoleName: 'Silakan masukkan nama peran',
    modifyRole: 'Ubah peran',
    newRole: 'Tambah peran',
    succeededInModifyingTheRole: 'Peran berhasil diubah',
    creatingTheRoleSucceeded: 'Peran berhasil dibuat',
  },
  componentsPopupeditingpermission: {
    editPermission: 'Edit izin',
  },
  componentsUpdatematerial: {
    staffPosition: 'Jabatan karyawan',
    employeeRole: 'Peran karyawan',
    thePhoneNumberCannotBeEmpty: 'Nomor ponsel tidak boleh kosong',
    pleaseEnterYourConfirmationPassword: 'Silakan masukkan kata sandi konfirmasi',
    pleaseEnterEmployeeName: 'Silakan masukkan nama karyawan',
    pleaseSelectEmployeeStatus: 'Silakan pilih status karyawan',
    pleaseSelectAnEmployeePosition: 'Silakan pilih jabatan karyawan',
    modifyAccount: 'Ubah akun',
    viewInformation: 'Lihat informasi',
    addAnAccount: 'Tambah akun',
    theTwoPasswordEntriesAreDifferent: 'Dua kali input kata sandi tidak sama',
    modifyingTheMaterialInformationMayAffectTheInformationAboutStoredGoodsExerciseCautionWhenPerformingThisOperation:
      'Mengubah informasi material dapat memengaruhi data barang yang sudah tersimpan, harap berhati-hati',
    materialUnit: 'Satuan material',
    pleaseSelectTheMaterialType: 'Silakan pilih jenis material',
    pleaseFillInTheMaterialName: 'Silakan isi nama material',
    pleaseSelectMaterialUnit: 'Silakan pilih satuan material',
    modifyMaterial: 'Ubah material',
    newMaterial2: 'Tambah material',
    materialModificationSucceeded: 'Material berhasil diubah',
    newMaterialSuccessfully: 'Material berhasil ditambahkan',
  },
  smallwareMaterial: {
    newMaterial: 'Tambah material',
    thereIsInventoryUnderTheCurrentMaterialDoNotSupportToDeleteTheMaterialPleaseDeleteAfterTheWarehouse:
      'Masih ada stok pada material ini, tidak dapat dihapus. Silakan keluarkan dari gudang terlebih dahulu',
    areYouSureYouWantToDeleteThisMaterial: 'Apakah Anda yakin ingin menghapus material ini',
    confirmTo: 'Konfirmasi untuk',
    isThisMaterial: 'material ini',
  },
  smallwareRealtimestock: {
    saleStatus: 'Status penjualan',
    exportedInventory: 'Ekspor inventori',
    resumptionOfSale: 'Lanjutkan penjualan',
    banOnSale: 'Larangan penjualan',
    averagePurchasePriceyuan: 'Harga beli rata-rata ',
    sellingPriceyuan: 'Harga jual ',
    unmarketable: 'Tidak dapat dijual',
    vendibility: 'Dapat dijual',
    exportFileName: 'Daftar inventori real-time',
    areYouSureYouWantToStopSellingThisMaterial:
      'Apakah Anda yakin ingin menghentikan penjualan material ini',
    successfulClosure: 'Penghentian penjualan berhasil',
    successfulResumptionOfSale: 'Penjualan berhasil dilanjutkan',
  },
  smallwareStockshift: {
    undoSuccessfully: 'Pembatalan berhasil',
    outboundTime: 'Waktu keluar gudang',
    newDelivery2: 'Tambah pengeluaran',
    outboundMode: 'Metode pengeluaran',
    theNumberOfTheWarehouseReceipt: 'Kode dokumen pengeluaran',
    deliveryFromStorage: 'Pengeluaran dari gudang',
    cancel: 'Batalkan',
    exportFileList: 'Daftar ekspor file pengeluaran',
    doYouConfirmTheCancellation: 'Apakah Anda yakin ingin membatalkan',
  },
  smallwareStockunshift: {
    warehousingTime: 'Waktu masuk gudang',
    newStorage: 'Tambah pemasukan',
    theCodeOfTheEntrySlip: 'Kode dokumen pemasukan',
    purchasePriceyuan: 'Harga beli satuan ',
    importFileExportList: 'Daftar ekspor file pemasukan',
  },
  componentsAddnewstock: {
    adjustableQuantity: 'Jumlah dapat disesuaikan',
    purchasePrice: 'Harga beli',
    whetherToSell: 'Apakah dijual',
    unitSellingPrice: 'Harga jual satuan',
    pleaseFillInTheUnitPrice: 'Silakan isi harga jual satuan',
    pleaseFillInTheQuantityOfStorage: 'Silakan isi jumlah pemasukan',
    pleaseSelectTheMaterialType: 'Silakan pilih jenis material',
    pleaseSelectAMaterialName: 'Silakan pilih nama material',
    modifiedEntry: 'Ubah pemasukan',
    newStorage: 'Tambah pemasukan',
    createdSuccessfully2: 'Berhasil dibuat',
    theStorageQuantityCannotBe: 'Jumlah pemasukan tidak boleh',
    theModifiedQuantityCannotBeSmallerThanTheConsumedQuantity:
      'Jumlah setelah diubah tidak boleh lebih kecil dari jumlah yang sudah terpakai',
  },
  componentsAddoutstock: {
    selected: 'Dipilih',
    newDelivery2: 'Tambah pengeluaran',
    pleaseSelectOutgoingMaterials: 'Silakan pilih material yang akan dikeluarkan',
    pleaseSelectTheMaterialToBeShippedOut: 'Silakan pilih material untuk dikeluarkan',
    successfulDelivery: 'Pengeluaran berhasil',
  },
  componentsSellricedialog: {
    unitSellingPrice: 'Harga jual satuan',
    pleaseFillInThePrice: 'Silakan isi harga',
  },
  systemsetBase: {
    requireIdNumberEnabled: 'Fitur wajib memasukkan nomor identitas berhasil diaktifkan',
    requireIdNumberDisabled: 'Fitur wajib memasukkan nomor identitas berhasil dinonaktifkan',
    requireIdNumberForCheckin: 'Apakah perlu memasukkan nomor identitas saat check-in',
    enableAutomaticDepositRefund: 'Aktifkan pengembalian deposit otomatis',
    refundImmediatelyAfterCheckOut: 'Kembalikan segera setelah tamu check-out',
    refundAfter: 'Kembalikan setelah tamu check-out',
    hoursAutoRefund: 'Jam pengembalian otomatis',
    pleaseEnterDelayRefundHours: 'Silakan masukkan waktu tunda pengembalian deposit',
    delayRefundHoursRangeError:
      'Waktu tunda pengembalian deposit tidak boleh kurang dari 1 jam dan tidak boleh lebih dari 48 jam',
    depositConfigSuccess: 'Konfigurasi deposit check-in berhasil',
    tempMakeCardEnabled: 'Aktifkan pembuatan kartu sementara',
    tempMakeCardEnabledSuccess: 'Pembuatan kartu sementara diaktifkan',
    tempMakeCardDisabledSuccess: 'Pembuatan kartu sementara dinonaktifkan',
    hideCheckInRegisterRoomPrice: 'Sembunyikan harga kamar pada formulir check-in',
    hideCheckInRegisterRoomPriceEnabledSuccess: 'Harga kamar pada formulir check-in disembunyikan',
    hideCheckInRegisterRoomPriceDisabledSuccess: 'Harga kamar pada formulir check-in ditampilkan',
    weeHours: 'Dini hari',
    shiftPattern: 'Pola shift',
    messageVoiceReminder: 'Pengingat suara pesan',
    directConnectionSingleSettings: 'Pengaturan pesanan koneksi langsung',
    automaticHouseSetting: 'Pengaturan penjadwalan kamar otomatis',
    sameDayAdvanceOrders: 'Pesanan pra-kedatangan hari yang sama',
    allOrders: 'Semua pesanan',
    unreservedRoomOrderAutomaticRoomSchedulingPeriod:
      'Periode penjadwalan otomatis untuk pesanan tanpa kamar',
    inThisTimePeriodTheUnreservedRoomOrderWillBeAutomaticallyExecuted:
      'Dalam periode ini, pesanan tanpa kamar akan dijadwalkan otomatis',
    inventorySyncSetup: 'Pengaturan sinkronisasi inventori',
    orderSynchronizationSettings: 'Pengaturan sinkronisasi pesanan',
    nightAuditSetup: 'Pengaturan audit malam',
    nightTrialMethod: 'Metode audit malam',
    manualOperation: 'Manual',
    auto: 'Otomatis',
    storeOrdersHaveNotArrived: 'Pesanan toko pra-kedatangan belum tiba',
    preArrivalDepartureHandle: 'Pre-arrival & Pre-departure Order Handling',
    preArrivalDepartureHandleTip: 'Configure automatic handling for pre-arrival and pre-departure orders. The system will automatically execute the corresponding operations during night audit',
    preArrivalHandle: 'Pre-arrival Order Handling',
    preDepartureHandle: 'Pre-departure Order Handling',
    noHandle: 'No handling',
    autoCheckIn: 'Auto check-in',
    autoNoshow: 'Auto no-show',
    autoCheckOut: 'Auto check-out',
    autoExtendStay: 'Auto extend stay',
    shiftSetting: 'Pengaturan shift',
    noOverlapIsAllowedAndTheTotalTimeIntervalMustCover24HoursOfTheDay:
      'Waktu shift tidak boleh tumpang tindih dan total interval harus mencakup 24 jam penuh',
    morningShiftSetting: 'Pengaturan shift dini hari',
    shiftReportimprestMode: 'Laporan serah terima shift (mode kas kecil)',
    hourRoomCheckOutMessage: 'Pesan check-out kamar per jam',
    fullDayCheckOutMessage: 'Pesan check-out kamar harian',
    onlineChannelNewOrderAlerts: 'Peringatan pesanan baru kanal online',
    onlineChannelOrderCancellationAlerts: 'Peringatan pembatalan pesanan kanal online',
    hourCheckOutReminder: 'Pengingat check-out kamar per jam',
    fullDayCheckOutReminder: 'Pengingat check-out kamar harian',
    automaticOrderSettingWhenOversold: 'Pengaturan penerimaan pesanan otomatis saat oversold',
    hourRoomAutomaticOrderSetting: 'Pengaturan penerimaan otomatis kamar per jam',
    automaticRowHouseConfiguration: 'Konfigurasi penjadwalan kamar otomatis',
    automaticHouseRules: 'Aturan penjadwalan kamar otomatis',
    supportBillingTypes: 'Jenis penagihan yang didukung',
    '30MinutesBeforeCheckOut': '30 menit sebelum check-out',
    '15MinutesBeforeCheckOut': '15 menit sebelum check-out',
    atCheckOut: 'Saat check-out',
    pleaseEnterTheTime: 'Silakan masukkan waktu',
    automaticCancellation: 'Pembatalan otomatis',
    manualCancellation3: 'Pembatalan manual',
    automaticOverbookingSetReminders: 'Pengingat pengaturan penerimaan otomatis saat oversold',
    hourRoomAutomaticOrderSettingReminder: 'Pengingat pengaturan penerimaan otomatis kamar per jam',
    autoEnterArAccountText: 'Pesanan koneksi langsung otomatis masuk ke akun AR',
    pleaseSelectABusinessDay: 'Silakan pilih hari operasional',
    operationSuccessfulPleaseManuallyTriggerTheNightAudit:
      'Operasi berhasil, silakan jalankan audit malam secara manual',
    theStartTimeAndEndTimeOfTheMorningShiftCannotBeTheSame:
      'Waktu mulai dan berakhir shift dini hari tidak boleh sama',
    earlyMorningWatch: 'Shift dini hari',
    theAutomaticRowHouseIsSetSuccessfully: 'Pengaturan penjadwalan kamar otomatis berhasil',
    theEbRoomStatusIsAutomaticallyClosedWhenTheRoomIsFull:
      'Status kamar EB otomatis ditutup saat kamar penuh',
    supportSwitchOrderSynchronization: 'Mendukung sinkronisasi pesanan switch',
    inventoryAutomaticSynchronizationSystemInventory: 'Sinkronisasi otomatis inventori sistem',
    whenTheStoreOrderIsSetToautoCancelTheSystemWillAutomaticallyCancelTheStoreOrderForUnpaidOrdersAtNightAuditPleaseHandleTheCheckInInAdvanceToAvoidCancellation:
      'Perpanjangan menginap untuk pesanan pra-keberangkatan memiliki prioritas lebih tinggi daripada check-in pesanan pra-kedatangan. Jika tidak ada kamar tersedia saat sistem memproses check-in secara otomatis, sistem akan otomatis menandai NoShow; jika tidak ada kamar tersedia saat sistem memproses perpanjangan menginap secara otomatis, sistem akan otomatis melakukan check-out',
    whenTheStoreOrderIsSetTomanualCancelPleaseHandleTheCheckInOrCancelTheStorePreArrivalOrderInAdvanceToAvoidTheNightAuditNotPassing:
      'Perpanjangan menginap untuk pesanan pra-keberangkatan memiliki prioritas lebih tinggi daripada check-in pesanan pra-kedatangan. Jika tidak ada kamar tersedia saat sistem memproses check-in secara otomatis, sistem akan otomatis menandai NoShow; jika tidak ada kamar tersedia saat sistem memproses perpanjangan menginap secara otomatis, sistem akan otomatis melakukan check-out',
    whenTheRoomIsFullTheEbRoomStatusSwitchIsAutomaticallyTurnedOff:
      'Pengaturan sakelar status kamar EB otomatis dimatikan saat kamar penuh telah disimpan',
    inventoryAutomaticSynchronizationSystemInventorySwitchSettingsSaved:
      'Pengaturan sakelar sinkronisasi otomatis inventori sistem telah disimpan',
    atLeastOneMessageReminderSettingMustBeSelected:
      'Minimal satu pengaturan pengingat pesan harus dipilih',
    closeturnOnToAutomaticallySortRoomsAtNight:
      'Tutup (aktifkan untuk penjadwalan kamar otomatis sepanjang hari untuk pesanan baru)',
    crossBusinessDayShiftsYouCanSetTheNightShiftSeparatelyForAccountingPurposesTheNightShiftDoesNotParticipateInNormalShiftTimeCalculations:
      'Shift lintas hari operasional; shift dini hari dapat diatur terpisah untuk keperluan akuntansi dan tidak dihitung dalam waktu shift normal',
    dailyPredeparture: 'Pra-keberangkatan hari ini',
    theHotelSupportsSynchronousSwitchOrderChannelSettingsSaving:
      'Hotel mendukung penyimpanan sinkron pengaturan kanal pesanan switch',
    theNightAuditTimeMustBeBetween2100And0800TheNextDay:
      'Waktu audit malam harus antara 21:00 hingga 08:00 keesokan hari',
    theScheduleNeedsToCover24HoursADayPleaseReset:
      'Jadwal shift harus mencakup 24 jam penuh, silakan atur ulang',
    showMemberRechargeAmount:
      'Apakah menampilkan jumlah isi ulang anggota pada laporan serah terima shift',
    splitDeposit: 'Apakah memisahkan deposit pada laporan serah terima shift',
    splitArAccount: 'Apakah memisahkan akun AR pada laporan serah terima shift',
    allowTimeConflict: 'Izinkan konflik waktu penjadwalan kamar',
    selfCheckInDepositSetting: 'Pengaturan deposit check-in mandiri',
    depositConfig: 'Konfigurasi penarikan deposit',
    defaultDepositAmount: 'Jumlah deposit default',
    defaultDepositError: 'Input jumlah deposit default salah, silakan masukkan ulang',
    roomDepositError: 'Pengaturan tipe kamar “{roomName}” salah, silakan atur ulang',
    additionalRoomFeeSetting: 'Pengaturan biaya kamar tambahan',
    fulldayAddFeeRule: 'Aturan biaya tambahan kamar harian',
    fulldayAddFeeType: 'Jenis biaya tambahan kamar harian',
    memberRechargeSetting: 'Pengaturan penerimaan isi ulang anggota',
    noVerificationPayment: 'Pembayaran tanpa kode verifikasi',
    enforceAdditionalRoomCharge: 'Paksakan biaya kamar tambahan setelahnya',
    manualAdditionalRoomFee: 'Biaya kamar tambahan manual',
    halfDayAdditionalRoomFee: 'Biaya kamar tambahan setengah hari',
    fullDayAdditionalRoomFee: 'Biaya kamar tambahan satu hari penuh',
    morningOrderCheckInAddFee: 'Kenakan biaya kamar tambahan untuk check-in lebih awal',
    morningOrderAddFeeEnabled: 'Biaya kamar tambahan untuk check-in lebih awal telah diaktifkan',
    morningOrderAddFeeDisabled: 'Biaya kamar tambahan untuk check-in lebih awal telah dinonaktifkan',

    popUpMethodSetting: 'Pengaturan metode interaksi',
    newTab: 'Tab baru',
    originalTabRedirection: 'Redireksi tab asli',
    popupNotification: 'Popup',
    sidebar: 'Panel samping kanan',
    breakfastReportCtrl: 'Aturan statistik laporan sarapan',
    repotShowByUserNums: 'Statistik berdasarkan jumlah tamu yang sebenarnya menginap',
    repotShowByProductNums: 'Statistik berdasarkan jumlah sarapan yang termasuk dalam kamar',
    breakfastReportCtrlSuccessByUserNums: 'Aturan statistik laporan sarapan telah diatur ke "Statistik berdasarkan jumlah tamu yang sebenarnya menginap"',
    breakfastReportCtrlSuccessByProductNums: 'Aturan statistik laporan sarapan telah diatur ke "Statistik berdasarkan jumlah sarapan yang termasuk dalam kamar"'
  },
  systemsetConditionConfig: {
    unspaced: 'Tidak dipisah per baris',
    arrangeByFloorBranch: 'Susun per baris berdasarkan lantai',
    lineUpByRoomType: 'Susun per baris berdasarkan tipe kamar',
    theSizeOfTheCell: 'Ukuran sel status kamar',
    small: 'Kecil',
    inThe: 'Sedang',
    big: 'Besar',
    wide: 'Lebar',
    high: 'Tinggi',
    custom: 'Kustom',
    roomTypeFont: 'Font tipe kamar',
    size: 'Ukuran',
    colour: 'Warna',
    roomNumberFont: 'Font nomor kamar',
    whetherFullGuestNamesAreDisplayed: 'Apakah menampilkan nama lengkap tamu',
    alreadyRowHouseStatusDisplayContent: 'Konten tampilan status kamar yang sudah dijadwalkan',
    alreadyRowHouseStatusDetailsDisplayContent: 'Konten detail status kamar yang sudah dijadwalkan',
    noRowRoomStatusDetailsDisplayContent: 'Konten detail status kamar yang belum dijadwalkan',
    arrearsIncludeToday: 'Apakah tunggakan akan menghitung biaya kamar yang belum dibuat pada hari ini',
    bedType2: 'Tipe tempat tidur',
    restoreDefault: 'Pulihkan default',
    roomDiagramArrangement: 'Metode penataan diagram kamar',
    theAppletTakesEffectAtTheSameTime: 'Mini program berlaku bersamaan',
    cellColor: 'Warna sel status kamar',
    unarrangedRoomStatusContent: 'Konten status kamar yang belum dijadwalkan',
    powerSwitch: 'Saklar listrik',
    roomBalance: 'Saldo kamar',
    depositAmount: 'Jumlah deposit',
  },
  systemsetConfiguration: {
    changePriceRangeSettings: 'Pengaturan rentang perubahan harga',
    revaluationRange: 'Rentang perubahan harga',
    theSystemWillJudgeWhetherTheAveragePriceOfEachRoomTypeInThePast30DaysExceedsTheChangePriceRangeIfSoTheChangePriceWillBeEnteredIntoTheChangePriceAuditAndThePriceWillBeEffectiveAfterTheAuditTheChangePriceWillBeAutomaticallyRejectedAfter1HourIfItIsNotProcessed:
      'Sistem akan menilai apakah harga rata-rata tiap tipe kamar dalam 30 hari terakhir melebihi rentang perubahan harga. Jika melebihi, perubahan harga akan masuk ke audit dan berlaku setelah disetujui. Jika tidak diproses dalam 1 jam, perubahan harga akan otomatis ditolak',
  },
  systemsetLog: {
    operationRecord: 'Catatan operasi',
  },
  systemsetPrint: {
    documentType: 'Jenis dokumen',
    paperSize: 'Ukuran kertas',
    typeSize: 'Ukuran font',
    printingMode: 'Mode pencetakan',
    noticeToGuests: 'Pemberitahuan untuk tamu',
  },
  systemsetTarget: {
    monthlyGoalSetting: 'Pengaturan target bulanan',
    goal: 'Target',
    goalAchievementRate: 'Tingkat pencapaian target',
    intertargetNight: 'Target malam kamar',
    targetOccupancyRate: 'Target tingkat hunian',
    recommendedTargetValue: 'Nilai target yang disarankan',
    actualAchievement: 'Pencapaian aktual',
    reachedLastMonth: 'Tercapai bulan lalu',
    theSamePeriodLastYear: 'Periode yang sama tahun lalu',
    commitFailure: 'Gagal mengirim',
  },
  systemsetWarning: {
    earningsWarning: 'Peringatan pencapaian pendapatan',
    dailyWarning: 'Peringatan harian',
  },
  systemsetWifi: {
    commonality: 'Publik',
    batchModification: 'Ubah massal',
    pleaseCompleteTheWiFiAccountPassword: 'Silakan lengkapi akun dan kata sandi Wi-Fi',
    pleaseEnterAValidWifiName: 'Silakan masukkan nama Wi-Fi yang valid',
    noPasswordOrMobilePhoneAuthenticationOfTheWifiDoNotNeedToFillIn:
      'Wi-Fi tanpa kata sandi atau verifikasi ponsel tidak perlu diisi',
    pleaseFillInTheWiFiAccount: 'Silakan isi akun Wi-Fi',
    roomWifiSettings: 'Pengaturan Wi-Fi kamar',
    wifiName: 'Nama Wi-Fi',
    wifiPassword: 'Kata sandi Wi-Fi',
  },
  assemblyBindavailableproducts: {
    bindAvailableProducts: 'Ikat produk yang tersedia',
    bindAtLeastOneProduct: 'Ikat minimal satu produk',
  },
  componentsWarning: {
    byTheMonth: 'Bulanan',
    achievedOnDays: 'Hari tercapai',
    below: 'Di bawah',
    viewRemainingConditions: 'Lihat kondisi tersisa',
    newEarlyWarningItems: 'Tambah item peringatan',
    achieved: 'Tercapai',
    additionalCondition: 'Tambah kondisi',
    internightMoonTargetReachWarning: 'Peringatan pencapaian target malam kamar bulanan',
    earlyWarningOfMonthlyTargetOfRentalRate: 'Peringatan pencapaian target bulanan tingkat hunian',
    surplusRoom: 'Sisa kamar',
    pointScoring: 'Skor ulasan',
    gmvMonthlyTargetWarning: 'Peringatan tingkat pencapaian target GMV bulanan',
    revparMonthlyTargetWarning: 'Peringatan tingkat pencapaian target RevPAR bulanan',
  },
  componentsWarningday: {
    overallHotel: 'Keseluruhan hotel',
    everyday: 'Harian',
    theDayBefore: 'Hari sebelumnya',
    viewRemainingConditions: 'Lihat kondisi tersisa',
    newEarlyWarningItems: 'Tambah item peringatan',
    additionalCondition: 'Tambah kondisi',
    lessThan: 'Kurang dari',
    greaterThan: 'Lebih dari',
    pointScoring: 'Skor ulasan',
    surplusRoom: 'Sisa kamar',
  },
  payLehuipaySetting: {
    youHaveNotOpenedOnlinePayment: 'Anda belum mengaktifkan pembayaran online',
    contactOperationOrTechnicalSupportToEnableTheService:
      'Silakan hubungi tim operasional atau dukungan teknis untuk mengaktifkan layanan',
    lehuiPay: 'Lehui Pay',
    download: 'Unduh',
    inquire: 'Cek',
    withdraw: 'Tarik',
    withdrawalRecord: 'Riwayat penarikan',
    billDownload: 'Unduh tagihan',
    accountBalanceInquiry: 'Cek saldo akun',
    theWithdrawalAmountIsRequired: 'Jumlah penarikan wajib diisi',
    theAmountRangeIs: 'Rentang jumlah adalah',
    doYouWantToChangeThePaymentMethod: 'Apakah Anda yakin ingin mengubah metode pembayaran',
    modifyingThePaymentModeSucceeded: 'Berhasil mengubah metode pembayaran',
    pleaseFillInTheWithdrawalAmount: 'Silakan isi jumlah penarikan',
    ifTheWithdrawalFailsTheWithdrawalAmountCannotBeLessThan10Yuan:
      'Penarikan gagal, jumlah penarikan tidak boleh kurang dari 10',
  },
  foodLogin: {
    cashierSystem: 'Sistem Kasir Restoran',
    shopSystem: 'Sistem Toko Restoran',
    pleaseEnterYourAccount: 'Silakan masukkan akun Anda',
    noFoodSystemPermission: 'Anda tidak memiliki izin untuk mengakses {system}',
    systemConfigurationError: 'Kesalahan konfigurasi sistem, silakan hubungi dukungan teknis',
    loginFailed: 'Login gagal, silakan coba lagi nanti',
  },
  loginIndex: {
    hotelManagementSystem: 'Sistem Manajemen Hotel',
    qrCodeExpired: 'Kode QR kedaluwarsa',
    pleaseClickRefresh: 'Silakan klik segarkan',
    openWechatScanTheQrCode: 'Buka WeChat dan pindai kode QR',
    customerServiceNumber: 'Nomor layanan pelanggan',
    theAccountOrPasswordYouEnteredIsIncorrect: 'Akun atau kata sandi yang Anda masukkan salah',
    forgotPassword: 'Lupa kata sandi',
    verificationCodeSentToYourMobilePhoneValidFor5Minutes:
      'Kode verifikasi telah dikirim ke ponsel Anda, berlaku 5 menit',
    enter820CharactersIncludingLettersNumbersAndSymbolsOfTwoOrMoreTypes:
      'Masukkan 8–20 karakter, kombinasi minimal dua jenis: huruf, angka, simbol',
    submit2: 'Kirim',
    loginPasswordUpdateSuccessful: 'Pembaruan kata sandi login berhasil',
    reLogin: 'Masuk kembali',
    bind: 'Ikat',
    findPassword: 'Pulihkan kata sandi',
    pleaseEnterTheVerificationCode: 'Silakan masukkan kode verifikasi',
    mobilePhoneSmsVerificationCode: 'Kode verifikasi SMS',
    pleaseEnterTheMobilePhoneVerificationCode: 'Silakan masukkan kode verifikasi ponsel',
    pleaseVerifyTheNewPassword: 'Silakan verifikasi kata sandi baru',
    bindWechat: 'Ikat WeChat',
    pleaseEnterTheLoginPassword: 'Silakan masukkan kata sandi login',
    theTwoPasswordsEnteredAreInconsistent: 'Dua kata sandi yang dimasukkan tidak sama',
    pleaseEnterTheVerificationCode3: 'Silakan masukkan kode verifikasi gambar',
    loggingIn: 'Sedang masuk',
    acquire: 'Dapatkan',
    resendVerificationCode: 'Kirim ulang kode verifikasi',
    loginNow: 'Masuk sekarang',
    currentPhoneNumber: 'Nomor ponsel saat ini',
    changeSuccessful: 'Berhasil diubah',
    afterReGetting: 'setelah mendapatkan ulang',
    pleaseEnterCorrectAccount: 'Silakan masukkan akun yang benar',
  },
  accountIndex: {
    scope: 'Ruang lingkup aplikasi',
    confirmDelete: 'Apakah Anda yakin ingin menghapus set akun ini?',
    onlyDeleteDisabled: 'Hanya set akun berstatus nonaktif yang dapat dihapus',
    cancelDelete: 'Penghapusan dibatalkan',
  },
  accountsetMember: {
    accountSubject: 'Subjek akun',
    addCash: 'Tambah akun bayar tunai',
    roomAccount: 'Akun kamar',
    pleaseEnterTheExternalOrderNumber: 'Silakan masukkan nomor pesanan eksternal',
    consumptionStatement: 'Tagihan konsumsi',
    submitted: 'Telah dikirim',
    pleaseFillInTheAmountSpent: 'Silakan isi jumlah konsumsi',
    theAmountSpentMustBeGreaterThan: 'Jumlah konsumsi harus lebih besar dari',
    blanked: 'Telah dibatalkan',
    pleaseFillInTheRoomAccount: 'Silakan isi apakah ditagihkan ke akun kamar',
    pleaseSelectAnAccount: 'Silakan pilih akun',
    pleaseSelectASmallItem: 'Silakan pilih barang kecil',
    newSuccess: 'Berhasil ditambahkan',
    goAndCheck: 'Pergi dan lihat',
  },
  pcncomponentRoomtypesortingcomponent: {
    roomTypeRanking: 'Pengurutan tipe kamar',
  },
  activitySelfHelp: {
    selfHelpPromotionDescription: 'Deskripsi promosi mandiri',
    promotionalOffersAreAllBorneByTheMerchantDifferentChannelsOfSettlementMethodsAreDifferent:
      'Semua promo ditanggung oleh merchant, metode penyelesaian berbeda di tiap kanal',
    inCaseOfFalsePromotionTheConsequencesShallBeBorneByTheMerchant:
      'Jika terjadi promosi palsu, konsekuensi ditanggung oleh merchant',
    onceCreatedThePromotionWillTakeEffectAcrossAllChannels:
      'Setelah dibuat, promosi akan berlaku di semua kanal',
    promotionType: 'Jenis promosi',
    promotionalProduct: 'Produk promosi',
    effectiveChannel: 'Kanal yang berlaku',
    promotionStatus: 'Status promosi',
    noRegistrationIsAvailable: 'Belum ada aktivitas yang dapat didaftarkan',
    dailySpecial: 'Promo harian',
    tonightSpecial: 'Promo malam ini',
    firstStayDiscount: 'Diskon menginap pertama',
    travelSpecial: 'Promo perjalanan',
    festivalCoverage: 'Cakupan hari libur',
    studentOnly: 'Khusus pelajar',
    batchOffLine: 'Nonaktifkan massal',
    thereAreNoRegisteredActivities: 'Tidak ada aktivitas terdaftar',
    thereAreNoCanceledEvents: 'Tidak ada aktivitas dibatalkan',
    pleaseSelectThePostPromotionOperationBatchOfflineFeature:
      'Silakan pilih fitur nonaktifkan massal pasca promosi',
    massMerchantsSelfPromotionOffline: 'Nonaktifkan promosi mandiri merchant secara massal',
    allChannels: 'Semua kanal',
  },
  componentsPrintsettingdialog: {
    previewEditing: 'Pratinjau & edit',
    printTheFullIdNumber: 'Cetak nomor identitas lengkap',
    printGuestAddress: 'Cetak alamat tamu',
    printPaymentInformation: 'Cetak informasi pembayaran',
    modifySettings: 'Ubah pengaturan',
    documentType: 'Jenis dokumen',
    paperSize: 'Ukuran kertas',
    typeSize: 'Ukuran font',
    printingMode: 'Mode pencetakan',
    noticeToGuests: 'Pemberitahuan untuk tamu',
    thisContentWillBeDisplayedOnTheDocumentWhenPrintingPleaseBeSureToPrintATestAfterFillingInTheDocumentToAvoidTheDisplayEffectAffectedByTheNumberOfLinesOrExcessiveWords:
      'Konten ini akan ditampilkan pada dokumen saat dicetak. Pastikan mencetak uji coba setelah mengisi untuk menghindari masalah tampilan akibat jumlah baris atau kata yang berlebihan',
    defaultPrint: 'Cetak default',
    manualSelection: 'Pilih manual',
    standard: 'Standar',
    larger: 'Lebih besar',
    pleaseSelectPaperSize: 'Silakan pilih ukuran kertas',
    pleaseSelectAPrintingMethod: 'Silakan pilih metode pencetakan',
    pleaseSelectTheSize: 'Silakan pilih ukuran font',
  },
  assemblyAddprojectdialog: {
    addItem: 'Tambah item',
    projectName: 'Nama proyek',
    pleaseEnterAProjectName: 'Silakan masukkan nama proyek',
    copies: 'Jumlah',
    pleaseEnterTheNumberOfCopies: 'Silakan masukkan jumlah',
    pleaseEnterTheNameOfTheOffer: 'Silakan masukkan nama layanan',
    theNumberOfCopiesMustBeGreaterThan: 'Jumlah harus lebih besar dari',
  },
  viewsHomePageIndex: {
    commonFunctions: 'Fungsi umum',
    roomStatusOverview: 'Ikhtisar status kamar',
    todayData: 'Data hari ini',
    thisMonthData: 'Data bulan ini',
    dataAsOf: 'Data hingga:',
    todoList: 'Daftar tugas',
    allRead: 'Tandai semua dibaca',
    noTodos: 'Anda telah menyelesaikan semua tugas',
    efficientDay: 'Hari yang sangat efisien!',
    logUpdates: 'Pembaruan log',
    selectedFunctionsTitle: 'Fungsi terpilih',
    selectedFunctionsTip: 'Klik dan seret untuk mengatur urutan, pilih minimal 1 fungsi',
    maxSix: 'Maksimal 6 fungsi',
    allReadSuccess: 'Semua berhasil ditandai dibaca',
  },
  viewsReportFinanceOnlinePaymentReconciliation: {
    tradeDate: 'Tanggal transaksi',
    billType: 'Jenis tagihan',
    platform: 'Platform pembayaran',
    qzTradeNo: 'Nomor transaksi pembayaran',
    qzTradeNoPlaceholder: 'Silakan masukkan nomor transaksi pembayaran',
    amountTotal: 'Total jumlah',
    feeTotal: 'Total biaya',
    reportName: 'Laporan rekonsiliasi online',
    pleaseSelectAtLeastOneDateType: 'Silakan pilih minimal satu jenis tanggal',
    income: 'Penerimaan',
    alipay: 'Alipay',
    wechat: 'WeChat',
    merchantCode: 'Kode merchant',
    merchantName: 'Nama merchant',
    qzTradeNoColumn: 'Nomor transaksi pembayaran',
    externalOrderNo: 'Nomor pesanan eksternal',
    orderAmount: 'Jumlah pesanan',
    merchantRate: 'Tarif merchant',
    commission: 'Biaya layanan',
    billTypeColumn: 'Jenis tagihan',
    finishTime: 'Waktu selesai',
    oriQzTradeNo: 'Nomor pesanan penerimaan asli',
    platformColumn: 'Platform pembayaran',
  },
  appShop: {
    label1: '🔥「Hemat biaya komisi penerimaan hingga 25%」',
    label2: '💰「Wajib lihat merchant! Rahasia hemat ribuan per bulan」',
    label3: '⚠「Masih pusing dengan biaya penarikan yang tinggi？」',
    label4: '⏳「100 pendaftar pertama dapatkan kotak pemindai」',
    label5: '❓「Kenapa merek besar memilih metode ini？」',
    label6: '🛡「Keamanan setara bank｜Dipilih puluhan ribu merchant」',
    label7: '📞「Ajukan sekarang｜Tarif langsung turun 25%」',
    label8: '💼「Pemilik hotel berbagi: untung tambahan 3.000/bulan」',
  },
  settleDialog: {
    entryRoom: 'Kamar Pembukuan',
    selectEntryRoom: 'Silakan pilih kamar pembukuan',
    confirmTotalRoomRate: 'Konfirmasi total biaya kamar',
    preAuthorizationSettlement: 'Penyelesaian pra-otorisasi',
    completeCheckout: 'Selesaikan check-out',
    additionalChargeAmount: 'Jumlah biaya tambahan',
    hourlyRoomTip: 'Kamar per jam: silakan konfirmasi biaya kamar yang sebenarnya',
    fullDayRoomTip: 'Kamar harian penuh: masukkan biaya kamar tambahan',
    noAdditionalCharge: 'Tidak ada biaya tambahan',
    generateRoomFee: 'Hasilkan biaya kamar',
    hangAccount: 'Catat ke akun',
    hangToMaster: 'Catat ke pesanan induk',
    hangAccountReason: 'Alasan pencatatan',
    hangAccountTip: 'Pencatatan akan disimpan ke akun pesanan induk.',
    inputAdditionalAmount: 'Masukkan jumlah biaya tambahan',
    detail: 'Rincian',
    selectAtLeastOneRoom: 'Silakan pilih minimal satu pesanan kamar',
    transferBeforeHangAccount:
      'Silakan pindahkan kamar berstatus “akan check-in” terlebih dahulu sebelum melakukan pencatatan',
    pleaseAddRoomFee: 'Silakan tambahkan biaya kamar terlebih dahulu',
    noRoomOrderFound:
      'Tidak menemukan nomor pesanan kamar untuk check-out, silakan segarkan halaman dan coba lagi',
  },
  notUploadList: {
    searchPlaceholder: 'Masukkan nama, nomor kamar',
    uploadStatus: 'Status unggah',
    notUploaded: 'Belum diunggah',
    uploaded: 'Sudah diunggah',
    loggedOut: 'Telah check-out',
    downloadAllGuestInfo: 'Unduh semua data tamu',
    idAddress: 'Alamat identitas',
    uploadStatusColumn: 'Unggah ke kepolisian',
    downloadInfo: 'Unduh informasi',
    finishUpload: 'Selesai unggah',
  },
  notification: {
    markAllRead: 'Tandai semua dibaca',
    expand: 'Perluas ({count})',
    collapse: 'Ciutkan ({count})',
    ignore: 'Abaikan',
  },
  adjustFinance: {
    title: 'Penyesuaian keuangan',
    adjustAccount: 'Penyesuaian akun',
    balanceZeroWarning: 'Pastikan saldo 0 sebelum mengirim',
    addOneRecordWarning: 'Tambahkan minimal satu catatan pemasukan',
  },
  roomStatusStatistics: {
    details: 'Detail',
  },
  hotelStateDialog: {
    title: 'Statistik status kamar',
    checkIn: 'Dihuni',
    prepareCheckIn: 'Akan tiba',
    sold: 'Terjual',
    available: 'Tersedia',
    fetchError: 'Gagal mengambil data tipe kamar',
  },
  futureRoomIndex: {
    quickSearch: 'Pencarian cepat',
    reEnable: 'Aktifkan kembali',
    confirmChangeRoomTitle: 'Apakah ingin memindahkan kamar lama ke kamar baru?',
    originalRoom: 'Kamar asal',
    newRoom: 'Kamar baru',
    dragTargetInvalid: 'Gagal menyeret: sel tujuan tidak ditemukan',
    selectSameRoomTypeSameStayDate: 'Pilih kamar dengan tipe yang sama dan tanggal check-in/check-out yang sama',
    differentRoomTypeSwapNotSupported: 'Belum mendukung pertukaran dengan pesanan kamar yang sudah ada untuk tipe kamar berbeda',
    AVL: 'Sisa',
  },
  financePaymentIndex: {
    addPaymentSubject: 'Tambah kategori pembayaran',
    paymentSubjectName: 'Nama kategori pembayaran',
    symbol: 'Simbol',
    confirmDelete: 'Yakin ingin menghapus kategori ini?',
  },
  financeAccountDialog: {
    pleaseEnterSubject: 'Silakan masukkan kategori {type}',
    pleaseSelectCategoryType: 'Silakan pilih jenis kategori {type}',
    addTitle: 'Tambah kategori {type}',
    editTitle: 'Ubah kategori {type}',
    subjectName: 'Kategori {type}',
    subjectCategory: 'Jenis kategori {type}',
    isEnabled: 'Aktifkan',
  },
  financeConsumerAccount: {
    subjectCategory: 'Kategori konsumsi',
    addSubject: 'Tambah kategori konsumsi',
    subjectName: 'Nama kategori konsumsi',
    symbol: 'Simbol',
    confirmDelete: 'Yakin ingin menghapus kategori ini?',
  },
  financeSubjectSorting: {
    consumeSortTitle: 'Pengurutan kategori konsumsi',
    paySortTitle: 'Pengurutan kategori pembayaran',
    consumeSubjectName: 'Nama kategori konsumsi',
    paySubjectName: 'Nama kategori pembayaran',
    sortSuccess: 'Pengurutan berhasil',
  },
  aiPms: {
    common: {
      aiDriven: 'Didukung AI',
      justNow: 'Baru saja',
      minutesAgo: '{count} menit yang lalu',
      hoursAgo: '{count} jam yang lalu',
    },
    aiConfig: { pageTitle: 'AI Configuration', save: 'Save', hotelSection: 'Hotel Configuration', roomTypeSection: 'Room Type Configuration', priceGuard: 'Price Guardrail', enabled: 'Enabled', disabled: 'Disabled', hotelFloorPrice: 'Hotel Floor Price', hotelCeilingPrice: 'Hotel Ceiling Price', floorPrice: 'Floor Price (CNY)', ceilingPrice: 'Ceiling Price (CNY)', floorPricePlaceholder: 'Enter floor price', ceilingPricePlaceholder: 'Enter ceiling price', yuan: 'CNY', roomTypeName: 'Room Type Name', roomTypeCode: 'Room Type Code', amountNonNegative: ' amount must be greater than or equal to 0', floorGreaterThanCeiling: ' floor price cannot exceed ceiling price', hotelLabel: 'Hotel', roomTypeLabel: 'Room type “{name}”', noChanges: 'No configuration changes detected', saveSuccess: 'Saved successfully', pricingSelloutTimeTitle: 'Target Sellout Time Policy', pricingSelloutTimeTip: 'Used for same-day price increases, slow-selling price reductions, and peer-traffic urgency.', custom: 'Custom Policy', legalHoliday: 'Legal Holiday', weekend: 'Friday and Saturday', defaultDate: 'Other Dates (including Sunday)', selectTime: 'Select time', pricingSelloutTimeInvalid: 'The sellout time policy returned by the server is invalid. Explicitly handle it before saving.', pricingSelloutTimeRequired: 'All target sellout times must use HH:mm and be within 14:00–23:59 or 00:00–06:00.' },
    roomPricingReport: { reportTitle: 'Room Type Pricing Report', reportTip: 'AI recommendations, operating basis, and pricing factors', hotelInfo: 'Hotel Information', sellDate: 'Sale Date', metricDate: 'Metric Business Date', hotelOcc: 'Current Hotel OCC', hotelRevpar: 'Current Hotel RevPAR', currentPrice: 'Current Price', aiRecommendedPrice: 'AI Recommended Price', aiCurrentDelta: 'AI vs. Current Price', sameDayOcc: 'Same-day OCC', sameDayRevpar: 'Same-day RevPAR', confidence: 'AI Confidence', inventorySnapshot: 'Terjual / Tersedia (Overbooking) / Dinonaktifkan', operatingBasis: 'Room Type Operating Basis', aiDecision: 'AI Decision', tradeoff: 'Multi-factor Trade-off: ', aiFactors: 'AI Pricing Factors', historicalPrice: 'Historical Price', operation: 'Operating Data', market: 'Market Position', timeEvent: 'Time and Events', guardrailRisk: 'Guardrails and Risks', status: 'Status: ', priceImpact: 'Price Impact: ', conclusion: 'Conclusion: ', reason: 'Reason: ', evidence: 'Evidence: ', riskReminder: 'Risk Reminders', noRisk: 'No additional risk reminders', severity: 'Severity: ', suggestion: 'Suggested Action: ', used: 'Used', notUsed: 'Not Used', notAvailable: 'No Data Available', up: 'Supports Increase', hold: 'Hold', down: 'Supports Decrease', limit: 'Guardrail Limit', none: 'No Direct Impact', yes: 'Yes', no: 'No', yuan: 'CNY', priceAdjustment: 'Sesuaikan harga produk', priceAdjustmentDialogTitle: 'Harga cerdas: sesuaikan harga produk', noAdjustableProducts: 'Tidak ada produk yang dapat disesuaikan untuk tipe kamar ini', roomTypeName: 'Tipe kamar: ', roomTypeCode: 'Kode tipe kamar: ', roomTypeCurrentPrice: 'Harga tipe kamar saat ini', algorithmRecommendedPrice: 'Harga rekomendasi algoritme', aiAdjustmentDelta: 'Perubahan harga AI', currencySymbol: '¥', snapshotPriceNote: 'Rekomendasi AI didasarkan pada snapshot notifikasi harga cerdas ini.', product: 'Produk: ', channel: 'Kanal', channelId: 'ID kanal: {id}', channelCurrentPrice: 'Harga jual kanal saat ini', aiAdjustedPrice: 'Harga jual setelah penyesuaian AI', operationLabel: 'Tindakan', oneClickAdjustment: 'Sesuaikan harga', confirmGroupAdjustment: 'Sesuaikan harga untuk {count} kanal di produk ini?', confirmChannelAdjustment: 'Sesuaikan harga untuk produk kanal ini?', confirmAdjustmentTitle: 'Konfirmasi penyesuaian harga', confirm: 'Konfirmasi', cancel: 'Batal', adjustmentSuccess: 'Harga berhasil disesuaikan', bookingHourPreference: 'Preferensi pemesanan berdasarkan waktu (7 hari terakhir)', bookingHourNoData: 'Belum ada data pemesanan berdasarkan waktu', bookingHourDateRange: '{start} sampai {end}', bookingHourTooltip: '{hour}:00<br/>Porsi pemesanan: {value}%' },
    roomPricingFeedback: { button: 'Terima', dialogTitle: 'Kirim Umpan Balik', accept: 'Terima', reject: 'Tidak Menerima', rejectReasonPlaceholder: 'Masukkan alasan tidak menerima', actionRequired: 'Pilih hasil umpan balik', rejectReasonRequired: 'Masukkan alasan tidak menerima', rejectReasonTooLong: 'Alasan tidak menerima tidak boleh lebih dari 100 karakter', acceptSuccess: 'Rekomendasi diterima', rejectSuccess: 'Umpan balik penolakan telah dikirim' },
    roomPricing: {
      empty: 'Belum ada hasil penetapan harga yang dapat ditampilkan',
      roomTypeFallback: 'Tipe kamar {index}',
      decisionTitle: 'Penjelasan keputusan',
      riskLabel: 'Peringatan risiko:',
      modeLabel: 'Mode:',
      floorPriceLabel: 'Batas harga:',
      confidenceLabel: 'Tingkat keyakinan:',
      directionFlat: 'Saran harga tetap',
      directionUp: 'Saran naik harga',
      directionDown: 'Saran turun harga',
      priorityLow: 'Prioritas rendah',
      priorityMedium: 'Prioritas sedang',
      priorityHigh: 'Prioritas tinggi',
    },
    roomPricingCard: { pricingTime: 'Waktu penetapan harga: ', expand: 'Buka', collapse: 'Tutup' },
    noticeCenter: {
      unreadCount: '{count} belum dibaca',
      readAll: 'Tandai semua sudah dibaca',
      defaultTitle: 'Notifikasi AI',
      browserNotificationTitle: 'Pemberitahuan AI',
      browserNotificationBody: 'Anda menerima pemberitahuan AI baru.',
      browserPermissionGuide: 'Aktifkan untuk menerima pemberitahuan AI baru di browser saat berjalan di latar belakang.',
      enableBrowserNotification: 'Aktifkan pemberitahuan browser',
      skipBrowserNotification: 'Nanti saja',
      statusRead: 'Sudah dibaca',
      statusUnread: 'Belum dibaca',
      emptySummary: 'Tidak ada ringkasan notifikasi',
      like: 'Suka',
      dislike: 'Tidak suka',
      viewDetail: 'Lihat detail',
      markRead: 'Tandai sudah dibaca',
      emptyList: 'Tidak ada notifikasi',
      dislikeDialogTitle: 'Kirim alasan tidak suka',
      dislikePlaceholder: 'Silakan tinggalkan saran Anda',
      categoryAll: 'Semua',
      readAllSuccess: 'Semua notifikasi berhasil ditandai sudah dibaca',
      markReadSuccess: 'Berhasil ditandai sudah dibaca',
      likeSuccess: 'Terima kasih atas masukan Anda',
      dislikeReasonRequired: 'Silakan isi alasan tidak suka',
      dislikeSuccess: 'Berhasil dikirim',
      uncategorized: 'Belum dikategorikan',
    },
    noticeDetail: {
      back: 'Kembali ke notifikasi AI',
      sendTime: 'Waktu dibuat: ',
      businessType: 'Kategori utama: ',
      businessSubType: 'Kategori sekunder: ',
      sideLabel: 'Detail notifikasi',
      contentTitle: 'Isi notifikasi',
      contentTip: 'Tampilkan isi asli notifikasi dalam gaya markdown',
      badReviewTitle: 'Detail ulasan negatif',
      badReviewTip: 'Tampilkan isi ulasan dan balasan yang disarankan AI',
      badReviewContent: 'Isi ulasan',
      badReviewReply: 'Balasan yang disarankan',
      structuredTitle: 'Hasil terstruktur',
      structuredTip: 'Tampilkan data terstruktur dan analisis berdasarkan bagian laporan AI',
      structuredEmptyTip: 'Belum ada data terstruktur yang dapat ditampilkan dari konten ini',
      missingNoticeNo: 'noticeNo tidak ada',
    },
    smartPricing: {
      pageTitle: 'Harga cerdas',
      empty: 'Belum ada notifikasi harga cerdas terbaru',
      peerHotelMonitor: {
        title: 'Monitor Harga Penarik Pelanggan Pesaing',
        refresh: 'Segarkan',
        meituan: 'Meituan',
        empty: 'Belum ada data harga penarik pelanggan pesaing',
        unnamedHotel: 'Hotel pesaing tanpa nama',
        crawlSubmitted: 'Segarkan halaman nanti untuk melihat data.',
      },
    },
    futurePricing: { realtimeTab: 'Laporan Harga Waktu Nyata', futureTab: 'Laporan Harga Masa Depan', reportTitle: 'Laporan Harga Tipe Kamar Masa Depan', reportTip: 'Tampilkan rekomendasi dan analisis harga beku untuk 14 hari ke depan', empty: 'Tidak ada laporan harga masa depan', hotelOverview: 'Ringkasan Harga Masa Depan', priceSource: 'Sumber Harga', pricingBusinessDate: 'Tanggal Bisnis Harga', forecastDateRange: 'Rentang Tanggal Perkiraan', to: 'sampai', confidence: 'Keyakinan 14 Hari', dailyEmpty: 'Tidak ada hasil harga harian', analysis: 'Analisis', aiDecision: 'Keputusan AI', decisionSummary: 'Ringkasan Keputusan', pricingFactors: 'Faktor Harga', noFactor: 'Tidak ada detail faktor', status: 'Status', priceImpact: 'Dampak Harga', reason: 'Alasan', conclusion: 'Kesimpulan', tradeoff: 'Pertimbangan', riskReminder: 'Pengingat Risiko', noRisk: 'Tidak ada pengingat risiko', severity: 'Tingkat Keparahan', suggestion: 'Saran', sellDate: 'Tanggal Jual', algorithmReferencePrice: 'Harga Referensi Algoritme', aiRecommendedPrice: 'Harga Rekomendasi AI', historicalExpectedOcc: 'Perkiraan OCC Historis', historicalExpectedRevpar: 'Perkiraan RevPAR Historis', holidayEvent: 'Hari Libur / Acara', systemRisk: 'Risiko Sistem', yes: 'Ya', no: 'Tidak', legalHoliday: 'Hari Libur Resmi', weekendPeak: 'Puncak Akhir Pekan', normalDate: 'Tanggal Biasa', reportGeneratedAt: 'Waktu Pembuatan Laporan', listEmpty: 'Tidak ada laporan harga masa depan yang selesai', selectDate: 'Pilih tanggal', dailyAverageOrders: 'Rata-rata Pesanan Harian 7 Hari Terakhir', viewAllReports: 'Lihat Semua Laporan', backToAllReports: 'Kembali ke Daftar Laporan', realtimeListEmpty: 'Tidak ada laporan harga tipe kamar yang selesai' },
    futurePricingCalendar: { calendarTitle: 'Kalender Harga Tipe Kamar Masa Depan', roomType: 'Tipe Kamar', expectedOcc: 'OCC yang Diharapkan', expectedRevpar: 'RevPAR yang Diharapkan', pricingBasis: 'Dasar Penetapan Harga', dataIntegrityRisk: 'Pengingat Kelengkapan Data / Risiko', highRisk: 'Risiko Tinggi', calendarEmpty: 'Tidak ada data kalender harga masa depan', priceUp: 'Naikkan', priceDown: 'Turunkan', priceHold: 'Tetap', overallPricingBasis: 'Dasar Penetapan Harga Keseluruhan', roomOverallRisk: 'Pengingat Risiko Keseluruhan Tipe Kamar', dailyRiskReminder: 'Pengingat Risiko Harian' },
    storeManagerReport: {
      pageTitle: 'Laporan manajer toko',
      pageDesc: 'Lihat hasil laporan harian, mingguan, dan bulanan terbaru.',
      dailyButton: 'Harian',
      weeklyButton: 'Mingguan',
      monthlyButton: 'Bulanan',
      datePlaceholder: 'Pilih tanggal',
      empty: 'Belum ada laporan manajer toko terbaru untuk periode yang dipilih',
      contentTitle: 'Isi laporan',
      contentTip: 'Tampilkan isi laporan terbaru apa adanya',
      analysisTitle: 'Analisis terstruktur',
      analysisTip: 'Tampilkan laporan berdasarkan bagian terstruktur',
      monthLabel: '{year}-{month}',
      weekLabel: '{start} sampai {end}',
      dailyTitle: 'Laporan toko harian',
      weeklyTitle: 'Laporan toko mingguan',
      monthlyTitle: 'Laporan toko bulanan',
      periodLabel: 'Periode: {range}',
    },
    storeDiagnosis: {
      pageTitle: 'Diagnosis Toko',
      pageDesc: 'Satu laporan diagnosis toko setiap hari, dibuat otomatis dari data statis dan ulasan 31 hari terakhir. Pembuatan dibatasi 1 kali sehari. Halaman menampilkan hasil terbaru.',
      refresh: 'Segarkan',
      generate: 'Buat diagnosis',
      hotelInfoIncomplete: 'Informasi hotel belum lengkap. Pastikan sudah masuk dan memilih hotel.',
      emptyTitle: 'Belum ada laporan diagnosis',
      emptyDesc: 'Setelah profil hotel, tipe kamar, foto, dan data terkait lengkap, diagnosis AI dimulai otomatis. Setelah dibuat tidak dapat diulang.',
      emptyMeta: 'Kode hotel {hotelCode}  Batch {batchNo}',
      taskInfo: 'Tugas',
      batch: 'Batch',
      todayTask: 'Tugas hari ini',
      preparingData: 'Menyiapkan data',
      generating: 'Membuat diagnosis',
      failedNoRetry: 'Gagal. Tidak dapat dibuat lagi',
      generated: 'Sudah dibuat',
      notGenerated: 'Belum dibuat. Dapat dibuat manual',
      noReport: 'Belum ada laporan',
      latestDone: 'Laporan terakhir selesai',
      latestFailed: 'Laporan terakhir gagal',
      done: 'Selesai',
      failed: 'Pembuatan gagal',
      statusWait: '1 / Menunggu pemeriksaan',
      statusDiagnosing: '2 / Mendiagnosis',
      statusDone: '3 / Selesai',
      statusFailed: '4 / Gagal',
      metaStatus: 'Status',
      failSummary: 'Ringkasan kegagalan',
      currentStage: 'Tahap saat ini',
      crawlRetry: 'Percobaan penggabungan data',
      diagnoseDone: 'Diagnosis selesai',
      diagnosingStage: 'Membuat diagnosis',
      generateFailedShort: 'Pembuatan gagal',
      failTitle: 'Diagnosis belum selesai',
      failMessageToday: 'Penggabungan data atau pembuatan AI gagal. Tidak dapat dibuat lagi hari ini.',
      failMessageLatest: 'Diagnosis terakhir gagal. Laporan hari ini belum dibuat dan dapat dibuat secara manual.',
      failHintToday: 'Tidak dapat dibuat lagi hari ini. Coba lagi besok, atau hubungi operasional.',
      failHintLatest: 'Di atas adalah kegagalan terakhir. Laporan hari ini belum dibuat. Klik Buat diagnosis.',
      stepCrawl: '1. Mulai penggabungan data',
      stepSuccess: '2. Penggabungan data berhasil',
      stepSync: '3. Sinkronkan data',
      stepAdp: '4. Mulai diagnosis',
      progressDiagnosing: 'Penggabungan dan sinkronisasi data selesai. Laporan diagnosis sedang dibuat.',
      progressWait: 'Mengambil profil Meituan/Ctrip, tipe kamar, dan foto. Diagnosis dimulai otomatis setelah data siap.',
      reportPending: 'Laporan belum siap. Diagnosis dimulai otomatis setelah data siap. Anda dapat keluar dan kembali nanti.',
      reportGenerating: 'Sedang membuat laporan diagnosis. Mohon tunggu…',
      reportBody: 'Laporan diagnosis',
      reportEmpty: 'Isi laporan kosong',
      generateSuccess: 'Tugas diagnosis dibuat. Menyiapkan data',
      retryCount: '{count} / {max}',
    },
    structured: {
      channelAnalysis: 'Analisis kanal',
      roomTypeAnalysis: 'Analisis tipe kamar',
      commentAnalysis: 'Analisis ulasan',
      marketAnalysis: 'Panas pasar / distrik',
      momLabel: 'MoM: ',
      yoyLabel: 'YoY: ',
      dayMomLabel: 'Perbandingan periode: ',
      dayYoyLabel: 'Minggu ke minggu: ',
      weekMomLabel: 'Perbandingan periode: ',
      weekYoyLabel: 'Bulan ke bulan: ',
      monthMomLabel: 'Perbandingan periode: ',
      monthYoyLabel: 'Tahun ke tahun: ',
      channel: 'Kanal',
      revenue: 'Pendapatan',
      roomNight: 'Malam kamar',
      channelShare: 'Pangsa kanal',
      roomTypeName: 'Tipe kamar',
      totalRooms: 'Total kamar',
      soldRoomNights: 'Malam kamar terjual',
      totalRoomRevenue: 'Total pendapatan kamar',
      occupancyRate: 'Tingkat hunian',
      averageRoomRate: 'ADR',
      disabledRooms: 'Kamar nonaktif',
      commentType: 'Jenis ulasan',
      count: 'Jumlah',
      share: 'Porsi',
      goodMediumBad: 'Baik / Netral / Buruk',
      goodRate: 'Rasio ulasan positif',
      eventName: 'Nama peristiwa',
      eventFallback: 'Peristiwa',
      summaryAnalysis: 'Analisis keseluruhan',
      goodComment: 'Ulasan positif',
      mediumComment: 'Ulasan netral',
      badComment: 'Ulasan negatif',
      channelRevenueChart: 'Pendapatan per kanal',
      roomTypeRevenueChart: 'Pendapatan per tipe kamar',
    },
    revenueManager: {
      pageTitle: 'Manajer pendapatan',
      adviceTitle: 'Saran operasional AI',
      pendingCount: '{count} menunggu diproses',
      trafficTitle: 'Pemantauan trafik',
      trafficSubtitle: 'Prediksi AI · pembaruan real-time',
      selectDate: 'Pilih tanggal',
      todayShortcut: 'Hari ini',
      allDay: 'Sepanjang hari',
      timeLabel: 'Waktu',
      storeTrafficLabel: 'Trafik hotel',
      orderLabel: 'Pesanan',
      orderCount: '{count} pesanan',
      summaryNote: 'Kanal {channel} · diperbarui pada {time}',
      forecastLabel: 'Prediksi sepanjang hari (model AI)',
      meituanForecast: 'Prediksi trafik Meituan',
      ctripForecast: 'Prediksi trafik Ctrip',
      allDayVisit: 'Kunjungan sepanjang hari',
      occLabel: 'Tingkat hunian',
      roomNightLabel: 'Malam kamar',
      revenueLabel: 'Pendapatan',
      analysisTag: 'Analisis AI',
      defaultStrategyTag: 'Strategi harga',
      collapse: 'Tutup',
      expandMore: 'Lihat lebih banyak',
      badReviewLoading: 'Memuat balasan ulasan negatif...',
      badReviewReply: 'Balasan',
      badReviewEmpty: 'Tidak ada isi balasan ulasan negatif',
      realtimeTitle: 'Ikhtisar real-time',
      revenueForecastTitle: 'Prediksi pendapatan ({range})',
      occForecastTitle: 'Prediksi tingkat hunian ({range})',
      aiForecastBadge: 'AI Forecast',
      todayForecast: 'Prediksi hari ini {value}',
      peakLabel: 'Puncak',
      channelMeituan: 'Meituan',
      channelCtrip: 'Ctrip',
      hours1: '1 jam terakhir',
      hours3: '3 jam terakhir',
      hours5: '5 jam terakhir',
      hours12: '12 jam terakhir',
      yesterdayValue: 'Kemarin {value}',
      futureSevenDays: '7 hari ke depan',
      dailyAdviceTitle: 'Saran AI harian {date}',
      allDayAdviceTitle: 'Saran AI sepanjang hari',
      hoursAdviceTitle: 'Saran AI {hours} jam terakhir',
      adrForecastLabel: 'Prediksi ADR ',
      defaultAdviceDetail: 'Disarankan menyesuaikan harga kamar dan strategi distribusi sesuai permintaan saat ini.',
      displayDate: '{year}-{month}-{day}',
      roomNightValue: '{count} kamar',
      revenueInsightCollapse: 'Tutup penjelasan analisis pendapatan AI',
      revenueInsightExpand: 'Buka penjelasan analisis pendapatan AI',
      forecastForDate: 'Prediksi {date}: {value}',
      revenueInsightTitle: 'Penjelasan Analisis Pendapatan AI',
      revenueInsightJudgment: 'Penilaian pendapatan',
      revenueInsightKeySteps: 'Dasar utama',
      revenueInsightRisks: 'Peringatan risiko',
      revenueInsightRecommendations: 'Rekomendasi operasional',
      metricTips: {
        traffic: {
          meituan: { title: 'Penjelasan Trafik Meituan', p1: 'Trafik Meituan menunjukkan kunjungan ke hotel ini dari kanal Meituan dalam rentang waktu yang dipilih.', p2: 'Sistem mempertimbangkan kinerja historis, tren terbaru, kunjungan yang telah terjadi hari ini, hari libur, dan faktor terkait.', p3: 'Gunakan untuk menilai tren per waktu dan perubahan tidak biasa; ini bukan total akhir sepanjang hari.' },
          ctrip: { title: 'Penjelasan Trafik Ctrip', p1: 'Trafik Ctrip menunjukkan kunjungan ke hotel ini dari kanal Ctrip dalam rentang waktu yang dipilih.', p2: 'Sistem mengacu pada tanggal historis serupa, kinerja kanal terbaru, perubahan real-time hari ini, dan hari libur.', p3: 'Tinjau bersama perubahan pesanan untuk menilai apakah trafik berubah menjadi pemesanan.' },
          order: { title: 'Penjelasan Pesanan', p1: 'Pesanan menunjukkan perubahan pemesanan yang dihasilkan pada kanal, tanggal, dan rentang waktu saat ini.', p2: 'Metrik ini mencerminkan konversi pemesanan secara real-time sesuai filter aktif.', p3: 'Saat perubahan jangka pendek besar, tinjau prediksi sepanjang hari dan kinerja historis bersama-sama.' },
        },
        hotelForecast: {
          meituan: { title: 'Penjelasan Prediksi Trafik Meituan', p1: 'Ini adalah perkiraan total kunjungan kanal Meituan hari ini.', p2: 'Sistem menggunakan trafik historis, perubahan kanal terbaru, kinerja hari ini, hari libur, dan ritme operasional.', p3: 'Gunakan untuk mengantisipasi minat tamu dan mendukung perencanaan harga, persediaan kamar, serta operasional.' },
          ctrip: { title: 'Penjelasan Prediksi Trafik Ctrip', p1: 'Ini adalah perkiraan total kunjungan kanal Ctrip hari ini.', p2: 'Sistem mempertimbangkan tanggal historis serupa, tren terbaru, kinerja real-time hari ini, dan hari libur.', p3: 'Gunakan untuk menilai kekuatan permintaan potensial dan membandingkannya dengan prediksi Meituan.' },
          occ: { title: 'Penjelasan Tingkat Hunian', p1: 'Tingkat hunian adalah proporsi kamar yang diprediksi terjual hari ini.', p2: 'Sistem mempertimbangkan hunian historis, laju pemesanan terbaru, trafik dan pesanan hari ini, serta hari libur.', p3: 'Gunakan untuk menilai tekanan menginap, risiko kamar tidak terjual, serta arah harga atau promosi.' },
          roomNights: { title: 'Penjelasan Malam Kamar', p1: 'Malam kamar adalah jumlah malam kamar yang diprediksi dapat terjual hari ini.', p2: 'Sistem mengacu pada penjualan historis, laju pemesanan terbaru, trafik dan pesanan hari ini, serta hari libur.', p3: 'Tinjau bersama tingkat hunian untuk menilai kecepatan penyerapan persediaan kamar.' },
          adr: { title: 'Penjelasan ADR', p1: 'ADR adalah rata-rata harga harian kamar terjual yang diprediksi untuk hari ini.', p2: 'Sistem menggunakan harga historis, transaksi terbaru, permintaan hari ini, dan hari libur.', p3: 'Tinjau bersama tingkat hunian dan pendapatan agar tidak hanya mengejar tingkat hunian.' },
          revenue: { title: 'Penjelasan Pendapatan', p1: 'Pendapatan adalah perkiraan pendapatan penjualan kamar hari ini.', p2: 'Sistem menggabungkan malam kamar dan ADR yang diprediksi, kinerja historis, permintaan terbaru, serta hari libur.', p3: 'Gunakan untuk menilai pencapaian hasil usaha dan menemukan ruang peningkatan pendapatan.' },
        },
        futureRevenue: { title: 'Penjelasan Prediksi Pendapatan', p1: 'Prediksi pendapatan menunjukkan perkiraan pendapatan kamar harian untuk 7 hari ke depan.', p2: 'Sistem mempertimbangkan kinerja historis, pemesanan terbaru, trafik dan pesanan, kinerja hari ini, serta hari libur.', p3: 'Gunakan untuk mengidentifikasi tanggal permintaan tinggi dan rendah serta merencanakan harga, kamar, dan operasional.' },
        occRevenue: { title: 'Penjelasan Prediksi Tingkat Hunian', p1: 'Prediksi tingkat hunian menunjukkan proporsi kamar yang diperkirakan terjual setiap hari untuk 7 hari ke depan.', p2: 'Sistem mengacu pada hunian historis, pemesanan terbaru, trafik kanal, pesanan, perubahan hari ini, dan hari libur.', p3: 'Gunakan untuk mengidentifikasi risiko penuh atau hunian tidak mencukupi lebih awal serta merencanakan harga dan promosi.' },
      },
    },
  },
  route: {
    ai: 'AI',
    aiRevenueManager: 'Manajer pendapatan',
    aiSmartPricing: 'Harga cerdas',
    aiNoticeCenter: 'Pusat notifikasi',
    aiStoreManagerReport: 'Laporan manajer toko',
    aiStoreDiagnosis: 'Diagnosis Toko',
    aiNoticeDetail: 'Detail notifikasi',
    aiConfig: 'AI Configuration',
    businessLog: 'Log perubahan hari operasional',
    nightAuditLog: 'Log audit malam',
    turnoverSubmit: 'Hasil daripada operasi perniagaan',
    channelConfig: 'Konfigurasi kanal',
  },
  systemsetNotice: {
    systemMessageReminder: 'Pengingat pesan sistem',
    messageReminderSettingsAtLeastOneItem: 'Pengaturan pengingat pesan (pilih minimal satu)',
    hourlyRoomCheckoutMessage: 'Pesan check-out kamar per jam',
    fullDayCheckoutMessage: 'Pesan check-out kamar harian',
    messageVoiceReminder: 'Pengingat suara pesan',
    onlineChannelNewOrderReminder: 'Pengingat pesanan baru kanal online',
    onlineChannelOrderCancellationReminder: 'Pengingat pembatalan pesanan kanal online',
    hourlyRoomCheckoutReminder: 'Pengingat check-out kamar per jam',
    fullDayCheckoutReminder: 'Pengingat check-out kamar harian',
    operationFailed: 'Operasi gagal',
    thirtyMinutesBeforeCheckout: '30 menit sebelum check-out',
    fifteenMinutesBeforeCheckout: '15 menit sebelum check-out',
    atCheckoutTime: 'Saat check-out',
    checkoutTimeUpdated: 'Waktu pengingat check-out berhasil diperbarui',
    voiceSettingUpdated: 'Status pengingat suara berhasil diperbarui',
  },
  binding: {
    publicAccountMessageReminder: 'Pengingat pesan akun publik',
    scanToBindUser: 'Pindai untuk mengikat pengguna',
    cancelEdit: 'Batalkan',
    allMembers: 'Semua anggota',
    scanToBindTitle: 'Pindai untuk mengikat akun publik',
    scanWithWechat: 'Gunakan WeChat untuk memindai',
    qrCodeGenerateFail: 'Gagal menghasilkan kode QR, silakan coba lagi',
    unbindSuccess: 'Berhasil melepas ikatan!',
    unbindFail: 'Gagal melepas ikatan, silakan coba lagi',
    confirmCloseQrDialog: 'Yakin ingin menutup dialog kode QR?',
    orderCreate: 'Pesanan baru',
    orderCancel: 'Pembatalan pesanan',
    orderConfirm: 'Pesanan menunggu konfirmasi',
    orderCheckOutTip: 'Sebelum check-out',
    orderCheckOut: 'Check-out',
    orderCreateEbk: 'Pesanan EBK baru',
    orderCancelEbk: 'Pembatalan pesanan EBK',
    roomCleanDone: 'Pembersihan kamar selesai',
    ebAccountOffline: 'Akun EB offline',
    computerHardwareOffline: 'Perangkat keras komputer offline',
    ebWarnNotice: 'Peringatan overbooking',
  },
  writeDoorCardIndex: {
    preIssuedDoorCard: 'Kartu pintu pra-terbit',
    effectiveTime: 'Waktu berlaku',
    expiryTime: 'Waktu kedaluwarsa',
    viewPassword: 'Lihat kata sandi',
    passwordStatusNotSent: 'Belum dikirim',
    passwordStatusSending: 'Sedang dikirim',
    passwordStatusSent: 'Berhasil dikirim',
    passwordStatusFailed: 'Gagal dikirim',
    generatePasswordOnly: 'Hanya buat kata sandi',
    generateAndSendPassword: 'Buat dan kirim kata sandi',
    getLockInfoFailed: 'Gagal mendapatkan informasi kunci kamar',
    makeCardFailedPrefix: 'Gagal membuat kartu: ',
    deactivateFailedPrefix: 'Gagal menonaktifkan kartu: ',
    pleaseEnterValidPhoneNumber: 'Silakan masukkan nomor ponsel yang valid',
    passwordSendSuccess: 'Kata sandi berhasil dikirim',
    roomPasswordGeneratedAndSent:
      'Kata sandi kamar telah dibuat dan dikirim ke tamu, mohon ingatkan tamu untuk mengecek SMS',
    roomPasswordGenerated: 'Kata sandi kamar telah dibuat',
    invalidTimeString: 'String waktu tidak valid',
    temporaryMakeCard: 'Buat kartu sementara',
    validDoorCard: 'Kartu pintu valid saat ini',
    makeCardLogTitle: 'Catatan Pembuatan Kartu',
    makeType: 'Jenis Kartu',
    operationResult: 'Hasil Operasi',
    createTime: 'Waktu dibuat',
  },
  operating: {
    total: 'Total',
    index: 'No.',
    businessDay: 'Hari operasional',
    totalAccount: 'Total akun',
    totalOcc: 'Tingkat hunian total (%)',
    fullDayOcc: 'Tingkat hunian kamar harian (%)',
    hourDayOcc: 'Tingkat hunian kamar per jam (%)',
    avgPrice: 'Harga rata-rata kamar ',
    revPar: 'Total REVPAR ',
    totalRoomNight: 'Total malam kamar terjual (malam)',
    fullDayRoomNight: 'Malam kamar harian (malam)',
    busLongRoomNight: 'Malam kamar sewa jangka panjang (malam)',
    hourRoomNight: 'Malam kamar per jam (malam)',
    teamRoomNight: 'Malam kamar rombongan (malam)',
    freeRoomNight: 'Malam kamar gratis (malam)',
    // Part 32, lines 6201 to 6236
    privateRoomNight: 'Malam kamar penggunaan internal (malam)',
    houseRent: 'Total biaya kamar ',
    smallGoods: 'Barang kecil ',
    meals: 'Biaya makan ',
    serviceFee: 'Biaya layanan ',
    memberFee: 'Biaya keanggotaan ',
    otherFee: 'Biaya lainnya ',
    generalIncome: 'Total pendapatan operasional ',
    roomNight: 'Jumlah malam kamar (malam)',
    avgRoomPrice: 'Harga kamar rata-rata ',
    totalHouseRent: 'Total biaya kamar ',
    rentalRate: 'Tingkat hunian (%)',
    roomNightProportion: 'Proporsi malam kamar (%)',
    calcFormula: 'Rumus perhitungan',
    known: 'Saya mengerti',
  },
  incomeIncomesum: {
    pleaseCheckTheStartAndEndTimesOfTheSearch: 'Silakan periksa waktu mulai dan akhir pencarian',
    roomRateIncome: 'Pendapatan kamar',
    smallwareIncome: 'Pendapatan barang kecil',
    mealFeeIncome: 'Pendapatan makanan',
    reportTitle: 'Laporan ringkasan pendapatan',
    cooperationModel: 'Model kerja sama',
    status: 'Kontrak baru / Perpanjangan',
    roomsCount: 'Jumlah kamar fisik',
    startBusiness: 'Tanggal mulai operasional',
  },
  commonImportDialog: {
    tip: 'Silakan susun informasi sesuai persyaratan pada template',
    downloadTemplate: 'Unduh template',
    removeFileConfirm: 'Konfirmasi hapus',
    limitOneFile: 'Saat ini hanya dapat memilih 1 file, silakan hapus lalu tambahkan kembali',
    uploadError: 'Unggah gagal, silakan coba lagi',
    reupload: 'Unggah ulang',
  },
  orderAntiflyRoom: {
    powerOnTime: 'Waktu nyala',
    powerOffTime: 'Waktu mati',
    isAntifly: 'Apakah fly room?',
    powerDuration: 'Durasi nyala',
  },
  roomOccupiedDetail: {
    title: 'Detail Hunian Kamar',
    unassigned: 'Belum Dialokasikan',
    roomOrderNo: 'No. Pesanan Kamar',
    roomCount: 'Jumlah Kamar',
    roomType: 'Tipe Kamar',
    roomNo: 'No. Kamar',
    contact: 'Kontak',
    arrival: 'Kedatangan',
    departure: 'Keberangkatan',
    orderAndPayStatus: 'Status Pesanan (Pembayaran)',
    unpaidOrderNotAllowed: 'Pesanan yang belum dibayar tidak dapat diproses',
    invalidRoomOrderOperation:
      'Pesanan belum dibayar, menunggu check-in, atau belum dialokasikan tidak dapat diproses',
  },
  hardware: {
    smartRoomControl: 'Kontrol Kamar Pintar',
    smartRoomControlDesc: 'Mendukung kontrol jarak jauh perangkat pintar di kamar',
    smartRoomControlSetting: 'Pengaturan Kontrol Kamar Pintar',
    appKey: 'App Key',
    appKeyPlaceholder: 'Silakan masukkan App Key',
    appSecret: 'App Secret',
    appSecretPlaceholder: 'Silakan masukkan App Secret',
    thirdHotel: 'Hotel Pihak Ketiga',
    thirdHotelPlaceholder: 'Masukkan hotel pihak ketiga',
    thirdGroup: 'Grup Pihak Ketiga',
    thirdGroupPlaceholder: 'Masukkan grup pihak ketiga',
    enable: 'Aktif',
    disable: 'Nonaktif',
    deviceType: 'Jenis Perangkat',
    fullDayAutoOff: 'Pembuangan Otomatis Kamar Harian',
    hourAutoOff: 'Pembuangan Otomatis Kamar Per Jam',
  },
  lockpwd: {
    makeCardLogTitle: 'Log Pembuatan Kartu Kamar',
    operationType: 'Jenis Operasi',
    operationTime: 'Waktu Operasi',
    makeCard: 'Buat Kartu',
    cancelCard: 'Batalkan Kartu',
    roomTypeCode: 'Kode Tipe Kamar',
    roomTypeName: 'Nama Tipe Kamar',
    roomNumber: 'Nomor Kamar',
    lockBrandName: 'Merek Kunci Pintu',
    lockId: 'ID Kunci',
    orderRoomNo: 'Nomor Pesanan Kamar',
    operator: 'Operator',
    makeType: 'Jenis Kartu',
    validPeriod: 'Masa Berlaku Kartu',
    operationResult: 'Hasil Operasi',
    errorMessage: 'Pesan Kesalahan',
  },
  roomType: {
    createBundleRoomType: 'Buat Tipe Kamar Paket',
    roomTypeName: 'Nama Tipe Kamar',
    relatedRoomTypes: 'Tipe Kamar Terkait',
    relateRoom: 'Hubungkan Kamar',
    selectedRooms: 'Kamar Terpilih',
  },
  channelConfig: {
    noChannelConfigData: 'Tidak ada data konfigurasi kanal',
    directConnected: 'Terhubung langsung',
    notDirectConnected: 'Belum terhubung',
    roomTypeMatch: 'Pencocokan tipe kamar',
    bindNewAccount: 'Ikat akun baru',
    openDirectConnection: 'Aktifkan koneksi langsung',
    meituanHomestayStore: 'Toko Meituan Homestay',
    deleteAccount: 'Hapus akun',
    noBoundAccount: 'Belum ada akun terikat',
    breakDirectConnection: 'Putuskan koneksi',
    directConnectionStatus: 'Status koneksi',
    channelDiscount: 'Diskon kanal',
    channelCommission: 'Komisi kanal',
    qzCommission: 'Komisi Qingzhu',
    meituanRoomTypeId: 'ID tipe kamar Meituan',
    goodsTypeNormal: 'Produk standar',
    goodsTypeFree: 'Produk kamar gratis',
    goodsTypeOnlineHour: 'Kamar per jam online',
    goodsTypePresaleFullDay: 'Presale kamar harian',
    goodsTypePresaleHour: 'Presale kamar per jam',
    fetchChannelConfigFail: 'Gagal mengambil konfigurasi kanal',
    goodsTypePrefix: 'Jenis produk {type}',
    openDirectSuccess: 'Koneksi langsung berhasil diaktifkan',
    openDirectFail: 'Gagal mengaktifkan koneksi langsung',
    channelNotSupportRoomMatch: 'Kanal ini tidak mendukung pencocokan tipe kamar',
    fetchRoomMatchFail: 'Gagal mengambil data pencocokan tipe kamar',
    pleaseSelectRoomType: 'Silakan pilih tipe kamar Qingyingbao',
    pleaseSelectProduct: 'Silakan pilih produk Qingyingbao',
    bindFail: 'Pengikatan gagal',
    confirmUnbindRoomType: 'Yakin ingin melepas ikatan tipe kamar ini?',
    unbindFail: 'Gagal melepas ikatan',
    channelNotSupportAccountBind: 'Kanal ini tidak mendukung pengikatan akun',
    bindAccountSuccess: 'Akun berhasil diikat',
    bindAccountFail: 'Gagal mengikat akun',
    fetchAccountDetailFail: 'Gagal mengambil detail akun',
    confirmDeleteAccount: 'Yakin ingin menghapus akun ini?',
    confirmBreakDirect: 'Yakin ingin memutuskan koneksi langsung?',
    breakDirectSuccess: 'Berhasil diputuskan',
    breakDirectFail: 'Gagal memutuskan koneksi',
    turnoverSubmit: 'Penyetoran Pendapatan',
  },
  turnoverSubmit: {
    summaryLoadFailed: 'Gagal memuat data penyetoran kas. Operasi pada halaman ini dinonaktifkan.',
    reload: 'Muat ulang',
    initBeforeUse: 'Silakan inisialisasi saldo kasir saat ini sebelum penggunaan pertama.',
    initCashier: 'Inisialisasi Kasir',
    submitManage: 'Manajemen Penyetoran',
    summaryTipPrefix: 'Catatan: Data konsumsi dan penyelesaian yang dihitung di sini berasal dari',
    to: 'sampai',
    summaryTipSuffix: '',
    consumeSubject: 'Akun Konsumsi',
    paymentSubject: 'Akun Pembayaran',
    serialNumber: 'No.',
    subtotal: 'Subtotal',
    subject: 'Akun',
    amount: 'Jumlah',
    dataSummary: 'Ringkasan Data',
    lastBalanceSummary: 'Saldo kasir periode sebelumnya: {total} = Tunai({cash}) + Kartu Bank({bankCard}) + Lainnya({other})',
    currentAmountSummary: 'Jumlah kasir saat ini: {total} = Tunai({cash}) + Kartu Bank({bankCard}) + Lainnya({other})',
    currentCash: 'Tunai kasir saat ini:',
    currentBankCard: 'Kartu bank kasir saat ini:',
    currentOther: 'Lainnya kasir saat ini:',
    submitCash: 'Setor Tunai',
    submitBankCard: 'Setor Kartu Bank',
    submitOther: 'Setor Lainnya',
    cashBalance: 'Saldo Tunai:',
    bankCardBalance: 'Saldo Kartu Bank:',
    otherBalance: 'Saldo Lainnya:',
    remark: 'Catatan:',
    submit: 'Setor',
    submitHistory: 'Riwayat Penyetoran',
    submitTime: 'Waktu Penyetoran',
    startDate: 'Tanggal Mulai',
    endDate: 'Tanggal Selesai',
    operator: 'Operator',
    pleaseEnter: 'Silakan masukkan',
    search: 'Cari',
    export: 'Ekspor',
    lastCashierBalance: 'Saldo Kasir Periode Sebelumnya',
    cash: 'Tunai',
    bankCard: 'Kartu Bank',
    other: 'Lainnya',
    currentCashierAmount: 'Jumlah Kasir Periode Ini',
    currentSubmitAmount: 'Jumlah Setoran Periode Ini',
    currentCashierBalance: 'Saldo Kasir Periode Ini',
    initTipLine1: 'Silakan masukkan jumlah kasir aktual saat ini.',
    initTipLine2: 'Setelah inisialisasi, riwayat dengan catatan [Data Inisialisasi] akan dibuat.',
    currentCashierCash: 'Tunai Kasir Saat Ini',
    currentCashierBankCard: 'Kartu Bank Kasir Saat Ini',
    currentCashierOther: 'Lainnya Kasir Saat Ini',
    skipInit: 'Jangan Inisialisasi Sekarang',
    confirmInit: 'Konfirmasi Inisialisasi',
    pleaseEnterAmount: 'Silakan masukkan jumlah',
    invalidAmountFormat: 'Format jumlah tidak valid. Maksimal 2 angka desimal.',
    notGreaterThanCurrentCash: 'Tidak boleh melebihi [Tunai Kasir Saat Ini]',
    notGreaterThanCurrentBankCard: 'Tidak boleh melebihi [Kartu Bank Kasir Saat Ini]',
    notGreaterThanCurrentOther: 'Tidak boleh melebihi [Lainnya Kasir Saat Ini]',
    hotelHistoricalTotal: 'Total Historis Hotel',
    currentTime: 'Waktu Saat Ini',
    initBalanceCannotBeNegative: 'Saldo awal tidak boleh kurang dari 0',
    cashierInitSuccess: 'Kasir berhasil diinisialisasi',
    exportFailed: 'Ekspor gagal',
    checkSubmitAmount: 'Silakan periksa apakah jumlah setoran sudah benar',
    confirmSubmitMessage: 'Konfirmasi penyetoran pendapatan ini?',
    tip: 'Peringatan',
    submitSuccess: 'Setoran berhasil',
    submitFailed: 'Setoran gagal',
    total: 'Total',
    pushPriceLibrary: 'Kirim Harga & Stok',
    pushPriceLibrarySuccess: 'Harga dan stok berhasil dikirim',
    pushPriceLibraryFail: 'Gagal mengirim harga dan stok',
  },
  channelConfig: {
    noChannelConfigData: 'Tidak ada data konfigurasi kanal',
    directConnected: 'Terhubung langsung',
    notDirectConnected: 'Belum terhubung',
    roomTypeMatch: 'Pencocokan tipe kamar',
    bindNewAccount: 'Ikat akun baru',
    openDirectConnection: 'Aktifkan koneksi langsung',
    meituanHomestayStore: 'Toko Meituan Homestay',
    tujiaHomestayAccount: 'Akun Tujia Homestay',
    deleteAccount: 'Hapus akun',
    noBoundAccount: 'Belum ada akun terikat',
    breakDirectConnection: 'Putuskan koneksi',
    directConnectionStatus: 'Status koneksi',
    channelDiscount: 'Diskon kanal',
    channelCommission: 'Komisi kanal',
    qzCommission: 'Komisi Qingzhu',
    meituanRoomType: 'Tipe kamar Meituan',
    meituanRoomTypeId: 'ID tipe kamar Meituan',
    tujiaHouse: 'Rumah Tujia',
    tujiaHouseId: 'ID rumah Tujia',
    meituanHomestay: 'Meituan Homestay',
    tujiaHomestay: 'Tujia Homestay',
    homestay: 'Homestay',
    goodsTypeNormal: 'Produk standar',
    goodsTypeFree: 'Produk kamar gratis',
    goodsTypeOnlineHour: 'Kamar per jam online',
    goodsTypePresaleFullDay: 'Presale kamar harian',
    goodsTypePresaleHour: 'Presale kamar per jam',
    fetchChannelConfigFail: 'Gagal mengambil konfigurasi kanal',
    goodsTypePrefix: 'Jenis produk {type}',
    openDirectSuccess: 'Koneksi langsung berhasil diaktifkan',
    openDirectFail: 'Gagal mengaktifkan koneksi langsung',
    channelNotSupportRoomMatch: 'Kanal ini tidak mendukung pencocokan tipe kamar',
    fetchRoomMatchFail: 'Gagal mengambil data pencocokan tipe kamar',
    pleaseSelectRoomType: 'Silakan pilih tipe kamar Qingyingbao',
    pleaseSelectProduct: 'Silakan pilih produk Qingyingbao',
    bindFail: 'Pengikatan gagal',
    confirmUnbindRoomType: 'Yakin ingin melepas ikatan tipe kamar ini?',
    unbindFail: 'Gagal melepas ikatan',
    channelNotSupportAccountBind: 'Kanal ini tidak mendukung pengikatan akun',
    bindAccountSuccess: 'Akun berhasil diikat',
    bindAccountFail: 'Gagal mengikat akun',
    fetchAccountDetailFail: 'Gagal mengambil detail akun',
    confirmDeleteAccount: 'Yakin ingin menghapus akun ini?',
    confirmBreakDirect: 'Yakin ingin memutuskan koneksi langsung?',
    breakDirectSuccess: 'Berhasil diputuskan',
    breakDirectFail: 'Gagal memutuskan koneksi',
    pushPriceLibrary: 'Kirim Harga & Stok 90 Hari',
    pushPriceLibrarySuccess: 'Harga dan stok berhasil dikirim',
    pushPriceLibraryFail: 'Gagal mengirim harga dan stok',
    pushPriceLibrarySwitch: 'Sakelar Push Harga',
    pushSwitchOnSuccess: 'Sakelar push telah diaktifkan',
    pushSwitchOffSuccess: 'Sakelar push telah dinonaktifkan',
    pushSwitchChangeFail: 'Gagal mengubah sakelar push',
  },
  aiPmsRoomPricingSync: {
    hotelChannelSource: 'Sumber Harga', bookingHourOrderCountTitle: 'Jumlah Pesanan per Jam', bookingHourOrderCountNoData: 'Tidak ada data pesanan per jam yang tersedia', bookingHourOrderCountDateRange: '7 hari terakhir {start} sampai {end} | Hari ini {date}', bookingHourOrderCountDateOnly: 'Hari ini {date}', bookingHourOrderCountSevenDay: 'Pesanan 7 Hari Terakhir', bookingHourOrderCountToday: 'Pesanan Hari Ini', bookingHourOrderUnit: 'pesanan', bookingHourOrderAxis: 'Pesanan', viewTodayReports: 'Lihat Laporan Hari Ini', backToTodayReports: 'Kembali ke Laporan Hari Ini', backToLatestReport: 'Kembali ke Laporan Terbaru', historyEmpty: 'Laporan harga cerdas ini tidak tersedia', todayReportTitle: 'Laporan {date}', pricingTime: 'Waktu Penetapan Harga', reportTitle: 'Judul Laporan', pricingChannel: 'Kanal Penetapan Harga', viewDetail: 'Detail', todayReportEmpty: 'Tidak ada laporan penetapan harga tipe kamar yang selesai hari ini',
  },
  commonBook: {
    commonBooking: 'Reservasi Terpadu', fitBooking: 'Reservasi Individu', longStayBooking: 'Reservasi Jangka Panjang', teamBooking: 'Reservasi Grup', walkIn: 'Walk-in', ebkManualMove: 'Transfer Manual EBK',
    sourceType: 'Jenis Sumber', externalChannel: 'Saluran Eksternal', channelOrderNo: 'No. Pesanan Saluran', arrivalTime: 'Waktu Kedatangan', departureTime: 'Waktu Keberangkatan', retentionTime: 'Batas Penahanan', stayDuration: 'Durasi Menginap', days: 'Hari', contact: 'Kontak', contactPhone: 'Telepon Kontak', teamType: 'Jenis Grup', teamName: 'Nama Grup', contractNo: 'No. Kontrak',
    paymentInfo: 'Informasi Pembayaran', paymentMethod: 'Metode Pembayaran', amount: 'Jumlah', storedValueMember: 'Member Saldo', paymentCode: 'Kode Verifikasi Pembayaran', remark: 'Catatan', totalRooms: 'Jumlah Kamar', stayDays: 'Hari Menginap', taxAmount: 'Pajak', roomPrice: 'Harga Kamar', totalPrice: 'Total Harga', submitBooking: 'Konfirmasi Reservasi',
    addRoom: 'Tambah Kamar', addRoomType: 'Tambah Tipe Kamar', roomType: 'Tipe Kamar', roomStatus: 'Status Kamar', room: 'Kamar', loading: 'Memuat', noAvailableRoomType: 'Tidak ada tipe kamar tersedia', noAvailableRoom: 'Tidak ada kamar tersedia. Sesuaikan tipe atau status kamar.', noValidRoomType: 'Tidak ada tipe kamar yang valid', selectedRoomCount: '{count} kamar dipilih; pilih minimal 1', emptyClean: 'Kosong Bersih', emptyDirty: 'Kosong Kotor', selectRoomType: 'Pilih tipe kamar',
    availableRooms: 'Tersedia', breakfast: 'Sarapan', roomCount: 'Kamar', bookedRoomCount: 'Kamar Dipesan', walkInRoomCount: 'Jumlah Kamar Check-in', arrangeRoom: 'Tetapkan Kamar', dailyPrice: 'Harga Harian', unassignedRooms: '{count} kamar belum ditetapkan', assignedRoom: 'Ditetapkan {room}', selectedRoom: 'Dipilih {room}', delete: 'Hapus', to: 'sampai', addGuest: 'Tambah Tamu', channelRoomType: 'Tipe Kamar Saluran', currencyUnit: 'CNY', tax: 'Pajak',
    pleaseSelect: 'Silakan pilih', pleaseEnter: 'Silakan masukkan', enterChannelName: 'Masukkan nama saluran', cancel: 'Batal', confirm: 'Konfirmasi', close: 'Tutup', roomDetail: 'Detail Folio Kamar',
    selectSourceType: 'Pilih jenis sumber', selectMemberInfo: 'Pilih informasi member', selectCompany: 'Pilih akun perusahaan', selectStayType: 'Pilih jenis menginap', selectArrivalTime: 'Pilih waktu kedatangan', selectDepartureTime: 'Pilih waktu keberangkatan', enterContact: 'Masukkan kontak', selectTeamType: 'Pilih jenis grup', enterTeamName: 'Masukkan nama grup',
    basePriceMode: 'Mode Harga Dasar', sellingPriceMode: 'Mode Harga Jual', useEbkOrderInfo: 'Gunakan Informasi Pesanan EB', initializationFailed: 'Inisialisasi reservasi terpadu gagal. Tutup dan coba lagi.', dictionaryLoadFailed: 'Gagal memuat data reservasi', companyNotFound: 'Akun perusahaan terkait tidak ditemukan',
    minimumStayDays: 'Minimal menginap untuk skenario ini {count} hari', maximumStayDays: 'Maksimal menginap untuk skenario ini {count} hari', retentionBeforeArrival: 'Batas penahanan tidak boleh sebelum waktu kedatangan', retentionTooLate: 'Batas penahanan melebihi waktu terakhir yang diizinkan', retentionOutOfRange: 'Batas penahanan di luar rentang yang diizinkan',
    invalidBreakfast: 'Jumlah sarapan untuk {roomType} harus bilangan bulat 0–999 dan tidak boleh kosong', invalidRoomCount: 'Jumlah kamar untuk {roomType} harus bilangan bulat non-negatif dan tidak boleh kosong', enterExternalChannel: 'Masukkan nama saluran eksternal', invalidHourDuration: 'Durasi menginap harus bilangan bulat 1–12 jam', invalidStayDays: 'Hari menginap harus bilangan bulat {min}–{max}', incompleteStay: 'Periode menginap {roomType} tidak lengkap', arrivalBeforeBusinessDate: 'Kedatangan {roomType} tidak boleh sebelum tanggal bisnis saat ini', roomTypeStayRange: 'Masa menginap {roomType} harus 1–{max} hari', roomTypeDuplicateStay: 'Periode menginap duplikat tidak dapat ditambahkan untuk {roomType}',
    selectAtLeastOneRoomType: 'Pilih minimal satu tipe kamar yang dapat dipesan', selectMember: 'Pilih member', missingProductOrPrice: 'Tipe kamar terpilih tidak memiliki produk atau harga harian', roomCountExceedsAvailability: 'Jumlah kamar dipesan melebihi ketersediaan', walkInRequiresRoom: 'Walk-in harus memiliki kamar tertentu', guestRequiredPerRoom: 'Masukkan tamu untuk setiap kamar', completeGuestName: 'Lengkapi semua nama tamu', selectPaymentForDeposit: 'Pilih metode pembayaran saat menerima deposit', selectMemberForStoredValue: 'Pilih member untuk pembayaran saldo', insufficientMemberBalance: 'Saldo member {balance} CNY. Pilih metode pembayaran lain.', enterStoredValueCode: 'Masukkan kode verifikasi pembayaran saldo',
    bookingFailed: 'Reservasi gagal. Sesuaikan data dan coba lagi.', bookingSuccess: 'Reservasi berhasil', overOccupancyConfirmation: 'Jumlah tamu melebihi kapasitas maksimum kamar. Lanjutkan proses check-in?', overOccupancyPromptTitle: 'Pemberitahuan', walkInMissingMasterRoom: 'Walk-in berhasil, tetapi nomor folio kamar utama tidak dikembalikan', checkInSuccess: 'Check-in berhasil', createdWithoutOrderNo: 'Berhasil dibuat, tetapi nomor pesanan tidak dikembalikan. Catat pembayaran di halaman keuangan.', walkInWithoutMasterRoomForPayment: 'Check-in berhasil, tetapi nomor folio utama tidak dikembalikan. Catat pembayaran di halaman keuangan.', onlinePaymentFailed: 'Permintaan pembayaran online gagal', paymentStatusFailed: 'Gagal memeriksa status pembayaran',
    sameStayExists: 'Periode menginap yang sama sudah ada untuk tipe kamar ini', departureAfterArrival: 'Waktu keberangkatan harus setelah kedatangan', duplicateStayNotAllowed: 'Periode duplikat tidak diizinkan untuk tipe kamar yang sama', selectUnaddedRoom: 'Pilih kamar yang belum ditambahkan', keepOneWalkInRoom: 'Pertahankan minimal satu kamar untuk walk-in', ebkRoomCountMismatch: 'Jumlah kamar yang dipesan berbeda dengan pesanan saluran. Lanjutkan reservasi?', continueBooking: 'Lanjutkan Reservasi', modify: 'Ubah',
  },
  aiPmsRoomPricingSync: {
    hotelChannelSource: 'Sumber Harga', bookingHourOrderCountTitle: 'Jumlah Pesanan per Jam', bookingHourOrderCountNoData: 'Tidak ada data pesanan per jam yang tersedia', bookingHourOrderCountDateRange: '7 hari terakhir {start} sampai {end} | Hari ini {date}', bookingHourOrderCountDateOnly: 'Hari ini {date}', bookingHourOrderCountSevenDay: 'Pesanan 7 Hari Terakhir', bookingHourOrderCountToday: 'Pesanan Hari Ini', bookingHourOrderUnit: 'pesanan', bookingHourOrderAxis: 'Pesanan', viewTodayReports: 'Lihat Laporan Hari Ini', backToTodayReports: 'Kembali ke Laporan Hari Ini', backToLatestReport: 'Kembali ke Laporan Terbaru', historyEmpty: 'Laporan harga cerdas ini tidak tersedia', todayReportTitle: 'Laporan {date}', pricingTime: 'Waktu Penetapan Harga', reportTitle: 'Judul Laporan', pricingChannel: 'Kanal Penetapan Harga', viewDetail: 'Detail', todayReportEmpty: 'Tidak ada laporan penetapan harga tipe kamar yang selesai hari ini',
  },

  inventoryPhase1: {
    itemType: '物品类型',
    itemSpec: '物品规格',
    itemTypeName: '物品类型名称',
    itemSpecName: '物品规格名称',
    itemName: '物品名称',
    itemCode: '物品编码',
    enterItemName: '输入物品名称',
    itemUnit: '规格单位',
    itemSort: '物品排序',
    enterItemTypeName: '输入物品类型名称',
    enterItemSpecName: '输入物品规格名称',
    newType: '新建类型',
    newSpec: '新建规格',
    newItem: '新建物品',
    modifyItem: '修改物品',
    warningQty: '预警数量',
    warningQtyLabel: '库存预警数量',
    salePoint: '销售点',
    scene: '使用场景',
    guestRoom: '客房',
    fnb: '餐饮',
    meeting: '会议',
    sceneSale: '支持售卖',
    sceneClean: '支持房间打扫添加',
    sceneBorrow: '支持借用',
    selectType: '请选择物品类型',
    selectSpec: '请选择物品规格',
    fillItemName: '请填写物品名称',
    selectSalePoint: '请至少选择一个销售点',
    warningCloseHint: '0表示关闭预警',
    inboundType: '入库方式',
    outboundType: '出库方式',
    manualInbound: '手工入库',
    sale: '商品售卖',
    roomClean: '房间打扫添加',
    roomBorrow: '房间借用',
    manualOutbound: '手工出库',
    newOutbound: 'Tambah pengeluaran',
    selectOutboundType: 'Pilih jenis pengeluaran',
    createTime: '创建时间',
    catalogSource: '来源',
    groupCatalog: '集团底账',
    hotelCatalog: '本店',
    groupCatalogCannotEdit: '集团底账不能修改',
    groupCatalogCannotDelete: '集团底账不能删除',
    confirmDeleteType: '确认要删除该物品类型吗？',
    confirmDeleteSpec: '确认要删除该物品规格吗？',
    modifySuccess: '修改成功',
    createSuccess: '新建成功',
    filterSale: '可售卖',
    filterRoomClean: '房间打扫可添加',
    filterRoomBorrow: '可借用',
    availableSalePoint: '可用销售点',
    borrowReturn: '借用归还',
    saleVoid: '售卖冲账',
    sortOrder: '排序',
    fillWarningQty: '请填写库存预警数量',
    warningQtyInvalid: '库存预警数量须为不小于0的整数',
  },
  aiPmsCtripPeerSync: {
    ctrip: 'Ctrip',
    account: 'Akun',
    mobilePlaceholder: 'Masukkan nomor ponsel',
    code: 'Kode SMS',
    codePlaceholder: 'Masukkan kode SMS',
    login: 'Masuk',
    resend: 'Kirim ulang',
    send: 'Kirim kode',
    collectFailed: 'Gagal mengumpulkan harga pesaing Ctrip. Muat ulang nanti.',
    dataFailed: 'Gagal memuat data',
    relogin: 'Masuk kembali',
    unbind: 'Lepas tautan',
    updatedAt: 'Diperbarui: {time}',
    hotelName: 'Hotel',
    price: 'Harga',
    empty: 'Belum ada harga promosi pesaing {channel}',
    accountRequired: 'Masukkan akun Ctrip',
    codeRequired: 'Masukkan kode verifikasi SMS',
    loggingIn: 'Sedang masuk; harga pesaing Ctrip akan dikumpulkan setelah masuk',
    smsSent: 'Kode SMS dikirim. Masukkan kode',
    smsFailed: 'Gagal mengirim kode SMS. Kirim ulang',
    verifyFailed: 'Verifikasi SMS gagal. Masukkan ulang kode untuk masuk',
    loginFailed: 'Gagal masuk Ctrip. Kirim kode baru untuk masuk',
    deviceVerify: 'Selesaikan verifikasi perangkat akun Ctrip, lalu kirim kode baru untuk masuk',
    loginRequired: 'Kirim kode SMS untuk masuk kembali ke Ctrip',
    expired: 'Akun Ctrip kedaluwarsa. Silakan masuk',
    sending: 'Mengirim kode SMS…',
    collecting: 'Berhasil masuk. Mengumpulkan harga pesaing Ctrip…',
    today: 'Hari ini {time}',
    daysAgo: '{days} hari lalu',
    crawlSubmitted: 'Tugas pengumpulan hotel favorit Ctrip dikirim',
    smsSubmitted: 'Permintaan kode SMS dikirim',
    unbindConfirm: 'Lepas tautan akun Ctrip saat ini? Riwayat harga akan disimpan.',
    unbindTitle: 'Lepas tautan akun Ctrip',
    unbound: 'Tautan akun Ctrip dilepas',
  },
};
